// Spain
export const locale = {
  lang: 'es',
  data: {
    // Dashboard de ejemplo sin registro, /demo (#20261023-090014).
    DEMO: {
      TAG: 'Ejemplo',
      BAR: 'Estás viendo {{company}}, una empresa ficticia de {{employees}} empleados. Así quedaría la tuya.',
      BAR_SHORT: 'Estás viendo {{company}}, una empresa de ejemplo.',
      BAR_ARIA: 'Dashboard de ejemplo',
      NAV_ARIA: 'Páginas del dashboard de ejemplo',
      CREATE_SPACE: 'Crear mi espacio →',
      KEEP_EXPLORING: 'Seguir explorando',
      NOT_IN_DEMO: {
        TITLE: 'Esto lo verás en tu espacio',
        TEXT: 'El ejemplo enseña las páginas principales. Crea tu espacio para ver esta con los datos de tu empresa: un minuto, sin datos bancarios ni contratos.',
      },
      SAVE_BLOCKED: {
        TITLE: 'Para guardar, crea tu espacio',
        TEXT: 'Un minuto. Sin datos bancarios ni contratos. Todo lo que configures será tuyo.',
      },
    },
    // Interruptor «Ver con datos de ejemplo» de la cabecera (#20261023-090014).
    SAMPLE_DATA: {
      TOGGLE: 'Ver con datos de ejemplo',
      TAG: 'Datos de ejemplo',
      HOME_NOTE: 'Así se verá tu empresa con la plantilla en marcha.',
      TURN_OFF: 'Quitar',
    },
    // Prueba gratuita: banners, capa de bloqueo, etiqueta de la cabecera y confirmación al invitar (#20261023-090010).
    TRIAL: {
      BANNER: {
        WARNING: '<strong>Tu prueba acaba el {{date}}</strong> · quedan {{days}} días. Para seguir con WAIIS, completa tu cuenta.',
        WARNING_ONE: '<strong>Tu prueba acaba el {{date}}</strong> · queda 1 día. Para seguir con WAIIS, completa tu cuenta.',
        PARTNER: '<strong>Tu prueba acaba el {{date}}</strong> · quedan {{days}} días. {{partner}} se pondrá en contacto contigo para continuar.',
        PARTNER_ONE: '<strong>Tu prueba acaba el {{date}}</strong> · queda 1 día. {{partner}} se pondrá en contacto contigo para continuar.',
        COMPLETE: '<strong>Cuenta completa.</strong> El Plan Incentivos empieza el {{date}}, al acabar tu prueba.',
        ENDED: '<strong>Tu prueba terminó el {{date}}.</strong> Completa tu cuenta para volver a ver tu dashboard.',
        CTA: 'Completar cuenta',
      },
      LOCK: {
        TITLE: 'Tu prueba terminó el {{date}}',
        TEXT: 'Ponte en contacto con nosotros para seguir con <strong>{{company}}</strong>. Mientras tanto, tu plantilla puede seguir usando la app.',
        PARTNER_TEXT: '{{partner}} se pondrá en contacto contigo para activar el plan anual de <strong>{{company}}</strong>. Mientras tanto, tu plantilla puede seguir usando la app.',
        CONTACT_TITLE: 'Tu contacto en WAIIS',
        TEAM: 'Equipo',
        TEAM_NAME: 'Atención a empresas',
        EMAIL: 'Correo',
        PHONE: 'Teléfono',
        BOOK_CALL: 'Reservar llamada',
        COMPLETE_ACCOUNT: 'Completar mi cuenta',
        YOUR_COMPANY: 'tu empresa',
        MANAGER_TITLE: 'Tu gestor en {{partner}}',
        MANAGER_NAME: 'Nombre',
      },
      CALENDLY: {
        TITLE: 'Reservar llamada',
        FRAME_TITLE: 'Calendario para reservar una llamada con WAIIS',
        CLOSE: 'Cerrar',
      },
      TAG: {
        PRE_LAUNCH: 'Prueba · empieza al añadir empleados',
        DAYS_LEFT: 'Prueba · quedan {{days}} días',
        DAYS_LEFT_ONE: 'Prueba · queda 1 día',
        PLAN_FROM: 'Plan Incentivos · desde el {{date}}',
        ENDED: 'Prueba terminada',
        ACTIVE: 'Plan Incentivos · activo',
        PARTNER_DAYS_LEFT: 'Prueba · quedan {{days}} días · {{partner}}',
        PARTNER_DAYS_LEFT_ONE: 'Prueba · queda 1 día · {{partner}}',
        PARTNER_ENDED: 'Prueba terminada · {{partner}} te contactará',
        PARTNER_ACTIVE: 'Plan anual · gestionado por {{partner}}',
      },
      // Textos provisionales hasta los de Adri (título de la confirmación y caja verde).
      INVITE: {
        TITLE: 'Enviar la invitación a {{count}} personas',
        TITLE_ONE: 'Enviar la invitación a 1 persona',
        TEXT: 'Reciben el email con el enlace a la app.',
        TEXT_ONE: 'Recibe el email con el enlace a la app.',
        TRIAL_STARTS: 'Aquí empiezan tus 3 meses de prueba gratis, no antes. Sin compromiso ni permanencia.',
        CONFIRM: 'Enviar invitaciones',
        CANCEL: 'Todavía no',
        TRIAL_BOX: '<strong>3 meses</strong> de prueba ilimitada, sin compromiso.',
      },
    },
    // Tutorial de bienvenida (#20261023-090014). Textos de los pasos propios provisionales hasta los de Adri (E2).
    WELCOME_TOUR: {
      NEXT: 'Siguiente',
      PREV: 'Anterior',
      FINISH: 'Terminar',
      NOT_NOW: 'Ahora no',
      SKIP: 'Saltar',
      CLOSE: 'Cerrar el tutorial',
      STEP_OF: 'Paso {{n}} de {{total}}',
      CREATE_SPACE: 'Crear mi espacio',
      OWN: {
        INTRO: {
          TITLE: 'Te damos la bienvenida, {{company}}',
          META: 'Unos 5 minutos · Sin datos de facturación',
          TEXT: 'Te enseñamos dónde está cada cosa y los pasos para poner WAIIS en marcha en tu empresa.',
          START: 'Empezar configuración',
        },
      },
      DEMO: {
        INTRO: {
          TITLE: 'Te damos la bienvenida a {{company}}',
          META: 'Unos 2 minutos · Datos de ejemplo',
          TEXT: 'Una empresa ficticia de 350 empleados con WAIIS en marcha. Te enseñamos sus indicadores y dónde está cada cosa: así quedaría la tuya.',
          HERO_ALT: 'Una empleada sube al coche de un compañero para ir juntos al trabajo',
          START: 'Empezar',
        },
      },
      JOINUP: {
        INTRO: {
          TITLE: 'Te damos la bienvenida, {{company}}',
          META: 'Unos 2 minutos',
          TEXT: '{{partner}} ha preparado tu espacio y gestiona tu cuenta. Aquí sigues la participación de tu plantilla y sus resultados.',
          START: 'Ver mi espacio',
        },
      },
      STEPS: {
        PILLS: {
          TITLE: 'Tus indicadores, sobre el mapa',
          TEXT: 'De un vistazo: CO₂ evitado y viajes de los últimos 30 días, empleados vinculados, pasajeros por viaje y rutinas de las últimas 24 h, de toda la empresa o de una sede.',
        },
        HEADQUARTERS: {
          TITLE: 'Indica tu sede central',
          TEXT: 'Escribe su dirección y guárdala: así situamos tu empresa en el mapa.',
        },
        GUIDE: {
          TITLE: 'Tu puesta en marcha',
          TEXT: 'Tres pasos: tu sede central, tu plantilla y la participación. Se marcan solos al hacerlos y aquí ves cuántos llevas.',
        },
        EMPLOYEES: {
          TITLE: 'Da de alta a tu plantilla',
          TEXT: 'En Empleados subes un CSV con tu plantilla o añades a cada persona a mano. Reciben el enlace a la app.',
        },
        USAGE: {
          TITLE: 'La participación, en Uso',
          TEXT: 'Cuántos empleados usan WAIIS, cuántos viajes comparten y cómo evoluciona.',
        },
        TRAVEL: {
          TITLE: 'Los viajes de la plantilla',
          TEXT: 'Cada trayecto compartido, con su origen, su destino y quién viaja.',
        },
        OFFICES: {
          TITLE: 'Crea tus sedes',
          TEXT: 'En Ajustes das de alta tus centros de trabajo para seguir la participación de cada uno.',
        },
        DEMO_USAGE: {
          TITLE: 'Uso',
          TEXT: 'Cuánto se usa WAIIS en la empresa: usuarios activos, trayectos y kilómetros compartidos, y quién comparte más coche.',
        },
        DEMO_TAXI: {
          TITLE: 'Taxi / VTC',
          TEXT: 'Los viajes en taxi que paga la empresa y lo que cuestan, las reservas de grupo para eventos y la revisión de los viajes que no cuadran.',
        },
        DEMO_TRAVEL: {
          TITLE: 'Viajes',
          TEXT: 'Cuántos viajes se comparten, cuántos conductores y pasajeros hay y los km con pasajero; y a qué hora y qué día de la semana se viaja más.',
        },
        DEMO_EMPLOYEES: {
          TITLE: 'Empleados',
          TEXT: 'La plantilla de la empresa: quién se ha vinculado en la app y desde qué sede.',
        },
        FUNNEL: {
          TITLE: 'Funnel',
          TEXT: 'De la invitación al primer viaje compartido: dónde se quedan los empleados por el camino.',
        },
        PMST: {
          TITLE: 'PMST',
          TEXT: 'El plan de movilidad sostenible al trabajo, hecho con los datos de la empresa. ¿Lo quieres con los tuyos?',
        },
      },
    },
    // Guía «Puesta en marcha» de la empresa (#20261023-090014).
    LAUNCH_GUIDE: {
      PANEL_TITLE: 'Tus primeros pasos',
      PROGRESS: '{{done}} de {{total}} pasos hechos. Sigue con el siguiente.',
      ALL_DONE: 'Los tres pasos están hechos: tu empresa ya está en marcha.',
      STEP_DONE: 'Hecho',
      VIEW_TOUR: 'Ver el tutorial',
      LOADING: 'Cargando la puesta en marcha',
      STEPS: {
        HEADQUARTERS: {
          TITLE: '¿Dónde está tu sede central?',
          TEXT: 'Así situamos tu empresa en el mapa de Inicio y verás los trayectos de tu plantilla.',
          ACTION: 'Indicar la sede',
        },
        EMPLOYEES: {
          TITLE: 'Da de alta a tu plantilla',
          TEXT: 'Sube un CSV con tus empleados o añádelos a mano. Reciben el enlace a la app.',
          ACTION: 'Subir CSV',
        },
        PARTICIPATION: {
          TITLE: 'Mide la participación',
          TEXT: 'Cuando tus empleados se vinculen en la app, verás en Uso cuántos participan y cómo viajan.',
          ACTION: 'Ver Uso',
        },
      },
    },
    // Modalidad de transporte de fraude_pooling_route_labels (equipo de datos).
    FRAUD_DATA: {
      CURRENT_DECISION_HINT: "Vigente",
      ORIGIN: {
        MANUAL: "Manual",
        AUTO_SCORE: "Score automática",
        AUTO_SCORE_VALUE: "Score {{score}}",
        PVP_BONUS: "Bonificación PVP",
        UNKNOWN: "—",
      },
      INTRO_TITLE: 'Scores, señales y decisión sobre cada cuenta',
      INTRO_TEXT: 'Los scores y las señales los envía el equipo de datos. En la columna <strong>Decisión</strong> eliges qué hacer con la cuenta. Pulsa un usuario para abrir su ficha, o un viaje para ver su recorrido.',
      ADD_USER: 'Añadir usuario',
      ADD_SUBTITLE: 'Búscalo y elige su decisión. Aparecerá en Bloqueos.',
      CLOSE: 'Cerrar',
      ADD_SEARCH_PLACEHOLDER: 'Nombre, email o ID...',
      ADD_SEARCH_ARIA: 'Buscar usuario',
      SEARCHING_USERS: 'Buscando usuarios',
      NO_USER_MATCH: 'No hay ningún usuario con «{{term}}».',
      TABLE_ARIA: 'Tabla',
      TABS: {
        USERS: 'Usuarios',
        TRIPS: 'Viajes',
        PAIRS: 'Colusión',
        WHITELIST: "Lista blanca",
        REINFORCED: "Reforzada",
        REINFORCED_NO_COST: "Reforzada + sin coste 0",
        HISTORY: "Historial",
      },
      SEARCH_PLACEHOLDER: 'Usuario, email o ID...',
      SEARCH_ARIA: 'Buscar',
      FROM_TRIP: 'Viaje desde',
      FROM: 'Desde',
      TO: 'Hasta',
      MIN_SCORE: 'Score mín.',
      MAX_SCORE: 'Score máx.',
      SEGMENT: 'Segmento',
      DECISION: 'Decisión',
      SORT: 'Ordenar',
      HIGH_SIGNAL: "Solo riesgo alto",
      UNPAID_ONLY: 'Solo dinero sin pagar',
      GROUP_BY_USER: 'Agrupar por usuario',
      NO_SCORE: 'Sin score',
      ONLY_CURRENT_DECISION: 'Solo la decisión actual',
      ONLY_CURRENT_SCORE: 'Solo el score actual',
      MIN_COLLUSION: 'Colusión mín.',
      ONLY_CURRENT_PAIR: 'Solo el valor actual',
      CLEAR_FILTERS: 'Limpiar filtros',
      DATE_RANGE_INVALID: 'La fecha «Hasta» no puede ser anterior a «Desde».',
      SCORE_RANGE_INVALID: 'El score máximo no puede ser menor que el mínimo.',
      LOADING: 'Cargando…',
      COLS: {
        WITH: 'Con',
        COLLUSION: 'Colusión',
        TRIPS_TOGETHER: 'Viajes juntos',
        RECEIVED_AT: 'Fecha',
        USER: 'Usuario',
        SCORE_FROM: 'Score desde',
        SCORE: 'Score',
        SIGNALS: "Señales",
        SEGMENT: 'Segmento',
        DECISION: 'Decisión',
        DATE: 'Fecha',
        ROUTE: 'Trayecto',
        ROLE: 'Rol',
        PASSENGERS: 'Pasajeros',
        MONEY: 'Dinero',
        MODE: 'Modalidad',
        FINAL_DECISION: 'Decisión final',
        PERIOD: 'Periodo',
        DECIDED_BY: 'Decidido por',
        NOTE: 'Nota',
        SINCE: "Desde",
        ADDED_BY: "Añadido por",
        ORIGIN: "Origen",
      },
      HISTORY_UNTIL: 'Historial · hasta {{date}}',
      GROUP: 'Grupo {{group}}',
      TRIPS_COUNT_ONE: '{{count}} viaje',
      TRIPS_COUNT_OTHER: '{{count}} viajes',
      DRIVER: 'Conductor',
      PASSENGER: 'Pasajero',
      DRIVER_LABEL: 'Conductor:',
      NO_MATCH: 'Sin match',
      NO_PRICE: 'Sin precio',
      UNTIL: 'hasta {{date}}',
      FREE_TRIP: 'Viaje gratis',
      PAST_DECISION_HINT: 'Historial: su decisión actual está en otra fila',
      NO_END: 'sin fin',
      AUTOMATIC: 'Automático',
      PREV: 'Anterior',
      NEXT: 'Siguiente',
      RETRY: 'Reintentar',
      NO_RESULTS_FILTERS: 'No hay resultados con estos filtros.',
      NO_DATA: 'Todavía no hay datos.',
      NOT_CALCULATED: 'sin calcular',
      LOAD_ERROR: 'No se han podido cargar los datos.',
      ALL_M: 'Todos',
      ALL_F: 'Todas',
      SORT_RECENT: 'Más recientes',
      SORT_SIGNAL: "Más riesgo primero",
      SEGMENTS: {
        TRIP_IP_COLLUSION: 'Viaje + IP + colusión',
        TRIP_IP: 'Viaje + IP',
        TRIP_COLLUSION: 'Viaje + colusión',
        TRIP: 'Viaje',
        VALID: 'Válido',
      },
      DECISIONS: {
        ALLOW: 'No fraude',
        REINFORCED_VERIFICATION: 'Verificación reforzada',
        BLACKLIST: 'Lista negra',
        WHITELIST: "Lista blanca",
      },
      SIGNALS: {
        MOBILITY_GPS: {
          SHORT: "GPS",
          TITLE: "Cobertura GPS",
          LEGEND_TITLE: "Cobertura GPS",
          TEXT: "% de viajes conducidos con buena cobertura GPS (más del 70 % de los minutos con algún punto válido).",
        },
        COLLISION: {
          SHORT: "Colusión",
          TITLE: "Colusión",
          LEGEND_TITLE: "Colusión con los pasajeros",
          TEXT: "% de pasajeros de este conductor con los que no parecen personas independientes (colusión por encima de 90, con al menos 3 días de datos). En un viaje, es la media de sus parejas conductor-pasajero.",
        },
        COPRESENCE: {
          SHORT: "Co-presencia",
          TITLE: "Co-presencia",
          LEGEND_TITLE: "Co-presencia conductor-pasajero",
          TEXT: "% de viajes en los que todos los pasajeros acreditan que estaban con el conductor.",
        },
        NETWORK_IP: {
          SHORT: "Red/IP",
          TITLE: "Red / IP",
          LEGEND_TITLE: "IP compartida",
          TEXT: "% de viajes en los que el conductor comparte alguna IP con algún pasajero.",
        },
        ELIGIBLE_TRANSPORT: {
          SHORT: "Transporte",
          TITLE: "Transporte elegible",
          LEGEND_TITLE: "Transporte elegible",
          TEXT: "% de viajes hechos en un medio que da CAE, sobre los que tienen cobertura de mapa.",
        },
      },
      PANEL: {
        PAIRS_TITLE: 'Colusión por pareja',
        PAIRS_SUBTITLE: 'Parejas que, según el equipo de datos, no parecen personas independientes. Más alto = peor.',
        PAIRS_ITEMS: 'parejas',
        SCORES_TITLE: 'Usuarios con score de fraude',
        SCORES_SUBTITLE: 'Score y señales que envía el equipo de datos. Pulsa un usuario para abrir su ficha.',
        SCORES_ITEMS: 'usuarios',
        ROUTES_TITLE: 'Viajes con señales de fraude',
        ROUTES_SUBTITLE: 'Señales de cada viaje y estado de su dinero. Pulsa un viaje para ver su recorrido.',
        ROUTES_ITEMS: 'viajes',
        BLOCKS_TITLE: "Historial de decisiones",
        BLOCKS_SUBTITLE: "Todas las decisiones sobre cada cuenta, también las antiguas y los «No fraude»: qué, quién y cuándo.",
        BLOCKS_ITEMS: "decisiones",
        WHITELIST_TITLE: "Lista blanca",
        WHITELIST_SUBTITLE: "Cuentas protegidas: sabemos que hacen fraude pero les dejamos usar la app. Nunca pasan a verificación reforzada, ni a mano ni por su score.",
        WHITELIST_ITEMS: "usuarios",
        REINFORCED_TITLE: "Verificación reforzada",
        REINFORCED_SUBTITLE: "Quién está hoy en verificación reforzada y por qué.",
        REINFORCED_ITEMS: "usuarios",
        REINFORCED_NO_COST_TITLE: "Reforzada + sin coste 0",
        REINFORCED_NO_COST_SUBTITLE: "Quién está hoy en reforzada y además sin coste 0, y por qué: a mano o por cobrar la Bonificación PVP.",
        REINFORCED_NO_COST_ITEMS: "usuarios",
      },
      PAGINATION: 'Mostrando {{shown}} de {{total}} {{items}}',
      PAGINATION_NO_TOTAL: 'Mostrando {{shown}} {{items}}',
      PAYOUT: {
        PAID: 'Pagado',
        HELD: 'Retenido',
        UNPAID: 'Sin cobrar',
      },
      DECISION_LEGEND: {
        TITLE: "¿Qué significa cada decisión?",
        SUBTITLE: "Qué le pasa al usuario con cada opción del desplegable «Decisión».",
        NO_FRAUD: {
          TITLE: "No fraude",
          TEXT: "Sin restricciones: cobra sus viajes y retira como siempre, y puede invitar a coste 0. Si llega una score nueva igual o mayor que {{score}}, pasa a verificación reforzada.",
        },
        WHITELIST: {
          TITLE: "Lista blanca",
          TEXT: "Sabemos que hace fraude, pero se le deja. Usa la app como «No fraude» y nunca se le pone en verificación reforzada, ni a mano ni por su score.",
        },
        REINFORCED: {
          TITLE: "Verificación reforzada",
          TEXT: "Sus viajes se abonan al conductor {{tripDays}} días después de verificarse, las retiradas esperan {{withdrawalDays}} días y el mínimo para retirar es {{minPayout}}. Se pone a mano o sola con score ≥ {{score}}.",
        },
        REINFORCED_NO_COST: {
          TITLE: "Reforzada + sin coste 0",
          TEXT: "Lo mismo que la verificación reforzada y, además, no puede dar ni canjear viajes a coste 0.",
        },
      },
      ACTIVE_RULES: {
        TITLE: "Reglas activas",
        AUTO_ON: "Los usuarios con <strong>score ≥ {{score}}</strong> pasan solos a verificación reforzada (salvo la lista blanca).",
        AUTO_OFF: "La verificación reforzada automática por score está desactivada.",
        REINFORCED: "En reforzada, el viaje se abona al conductor a los {{tripDays}} días, las retiradas esperan {{withdrawalDays}} días y el mínimo para retirar es {{amount}}.",
        FREE_INVITE_ON: "Pueden seguir invitando a coste 0.",
        FREE_INVITE_OFF: "No pueden invitar a coste 0.",
        EDIT: "Cambiar en Configuración",
        REVIEW_DUE: "Hace {{days}} días que no se revisa la score mínima ({{score}}). Comprueba si hay que cambiarla.",
        REVIEW_NEVER: "La score mínima ({{score}}) no se ha revisado nunca. Comprueba si es la correcta.",
        REVIEWED_ON: "Score mínima revisada el {{date}}.",
        SUBTITLE: "Lo que manda hoy en la verificación reforzada. Se cambia en Configuración.",
        TILE_SCORE: "Reforzada automática",
        TILE_SCORE_HINT: "Con esta score o más, la cuenta pasa sola a reforzada (salvo la lista blanca).",
        TILE_SCORE_OFF_HINT: "Las scores nuevas no ponen a nadie en reforzada.",
        TILE_OFF: "Desactivada",
        TILE_TRIP: "Abono al conductor",
        TILE_TRIP_HINT: "Desde que se verifica el viaje.",
        TILE_WITHDRAWAL: "Retiradas",
        TILE_WITHDRAWAL_HINT: "Lo que espera una retirada antes de pagarse.",
        TILE_MIN: "Mínimo para retirar",
        TILE_MIN_HINT: "Mientras está en reforzada.",
        TILE_FREE: "Coste 0",
        TILE_FREE_ON: "Permitido",
        TILE_FREE_OFF: "Bloqueado",
        TILE_FREE_HINT: "«Reforzada + sin coste 0» lo bloquea siempre.",
        DAYS: "{{days}} días",
      },
      WHITELIST_ADD: {
        OPEN: "Añadir a la lista blanca",
        TITLE: "Añadir usuarios a la lista blanca",
        HELP: "Busca por nombre, email o ID y pulsa «Añadir»; cada uno pasa a «Lista blanca» desde ahora.",
        IDS_PLACEHOLDER: "0990e311-1ca9-4117-9a89-88bcf1f1019b\n85ab1ced-4260-486f-a0f9-93dff87617ec",
        IDS_ARIA: "IDs de usuario",
        NOTE_PLACEHOLDER: "Nota (opcional): por qué están en la lista blanca",
        COUNT: "{{count}} usuarios",
        SUBMIT: "Añadir a la lista blanca",
        ADDING: "Añadiendo…",
        ADDED: "Añadidos: {{count}}",
        ALREADY: "Ya estaban: {{count}}",
        NOT_FOUND: "No encontrados: {{count}}",
        NOT_FOUND_HINT: "Los IDs no encontrados se han quedado en la caja para revisarlos.",
        TOO_MANY: "Como máximo 1000 usuarios de una vez.",
        ERROR: "No se han podido añadir. Inténtalo de nuevo.",
        PICK: "Añadir",
        PICKED: "Elegido",
        ALREADY_IN: "Ya en lista blanca",
        REMOVE_ARIA: "Quitar a {{name}}",
        PASTE_TOGGLE: "O pega IDs",
        PASTE_HELP: "IDs de usuario, uno por línea (también valen comas o espacios).",
      },
      SIGNAL_RISK_TITLE: "{{signal}}: {{value}} ({{direction}})",
      SIGNAL_DIRECTION: {
        BETTER: "cuanto más alto, mejor",
        WORSE: "cuanto más alto, peor",
      },
      LEGEND: {
        BETTER_TAG: "↑ mejor",
        WORSE_TAG: "↑ peor",
        SCORE_NOTE: "La score es una prioridad de revisión, no una probabilidad: 90 o 100 = IP compartida (trip_ip); 70 u 80 = colusión (trip_collusion). El valor alto de cada par es cuando el CAE generado supera los 100 €.",
        TITLE: '¿Qué significa cada señal?',
        SUBTITLE: "Qué mide cada señal y cómo leer su %: en unas cuanto más alto es mejor y en otras, peor.",
        HIDE: 'Ocultar',
        SHOW: 'Ver detalle',
        SCALE_TITLE: "El color es el riesgo de cada señal, ya leída en su sentido:",
        LOW: "Bien",
        MEDIUM: "A revisar",
        HIGH: "Riesgo",
        NOT_CALCULATED: 'Sin calcular',
      },
      DECISION_SELECT: {
        ARIA: 'Decisión sobre {{name}}',
        NO_DECISION: 'Sin decisión',
        STATES: {
          NO_FRAUD: 'No fraude',
          REINFORCED: 'Verificación reforzada',
          REINFORCED_NO_COST: 'Reforzada + sin coste 0',
          BLACKLIST: 'Lista negra',
          WHITELIST: "Lista blanca",
          NO_COST_ONLY: 'Sin coste 0',
        },
        CONFIRM_TITLE: '¿Pasar a «{{label}}»?',
        NOTE_PLACEHOLDER: 'Nota (opcional): por qué tomas esta decisión',
        NOTE_ARIA: 'Nota opcional',
        CONFIRM: 'Sí, cambiar',
        CANCEL: 'Cancelar',
        SAVING: 'Guardando…',
        SAVED: 'Guardado',
        SAVE_ERROR: 'No se ha podido guardar la decisión. Inténtalo de nuevo.',
        WHITELIST_LOCKED: "Está en lista blanca: no se le puede poner en verificación reforzada. Pásale antes a otra decisión.",
        CONFIRM_RELIEF: "Sí, continuar",
        WARN_LEAVES_FRAUD: "Deja de estar en verificación reforzada: sus pagos y retiradas vuelven a ir como siempre.",
        WARN_LEAVES_FRAUD_AND_COST: "Deja de estar en verificación reforzada y podrá volver a usar el coste 0, aunque se le bloqueara por la Bonificación PVP.",
        WARN_REGAINS_COST: "Podrá volver a usar el coste 0, aunque se le bloqueara por la Bonificación PVP.",
      },
      TRANSPORT_MODE: {
        car: 'Coche',
        motorbike: 'Moto',
        bus: 'Autobús',
        train: 'Tren',
        metro: 'Metro',
        tram: 'Tranvía',
        bike: 'Bicicleta',
        scooter: 'Patinete',
        walk: 'A pie',
        taxi: 'Taxi',
        plane: 'Avión',
        unknown: 'Desconocida',
      },
    },
    // Mismas claves (y mismo casing en minúsculas) que `es.json` de la app
    // móvil, bajo `routines.route.tracking`. `alertMessageKey`/
    // `alertSuggestionKey` de la tarjeta de trayecto (support-chat) llegan ya
    // como esa ruta completa — hay que replicarla tal cual, no adaptarla al
    // convenio en mayúsculas del resto de este fichero, o `| translate` no
    // resuelve nada.
    routines: {
      route: {
        tracking: {
          rejection_reason: {
            location_data_missing: 'Tu móvil no compartió su ubicación durante el viaje.',
            origin_not_confirmed: 'No detectamos tu móvil en el punto de salida a la hora del viaje.',
            destination_not_confirmed: 'No detectamos tu llegada al destino.',
            location_trace_incomplete: 'Perdimos la señal de tu móvil a mitad del viaje.',
            route_not_compatible: 'El recorrido no parece hecho en coche.',
            copresence_not_confirmed: 'No pudimos confirmar que viajarais en el mismo coche.',
            multiple_devices: 'Este viaje se registró desde varios móviles a la vez.',
            mock_location: 'La ubicación que recibimos de tu móvil no era la real.',
            network_failed: 'La conexión de tu móvil no nos dejó comprobar dónde estabas.',
            trip_limit: 'Ya has llegado al máximo de viajes con bonificación de este periodo.',
            pattern_review: 'Estamos revisando este viaje porque no se parece a los que sueles hacer.',
            competitor_app: 'Tienes otra app de coche compartido instalada y un mismo viaje solo puede bonificarse en una.',
            shared_with_riders: 'No pudimos confirmar que tú y tus pasajeros hicierais el viaje juntos.',
            shared_with_driver: 'No pudimos confirmar que hicieras el viaje con tu conductor.',
            location_permission_missing: 'Tu móvil no tenía permiso para compartir la ubicación durante el viaje.',
          },
          rejection_suggestion: {
            location_data_missing: 'Para el próximo viaje, comprueba que WAIIS tenga el permiso de ubicación en «Siempre» y que tu móvil tenga conexión a internet.',
            origin_not_confirmed: 'Para el próximo viaje, comprueba que la ubicación esté activa en «Siempre» y que tengas conexión a internet antes de salir.',
            destination_not_confirmed: 'Para el próximo viaje, mantén la ubicación activa y la conexión a internet hasta llegar al destino.',
            location_trace_incomplete: 'Para el próximo viaje, evita cerrar la app o activar el ahorro de batería.',
            route_not_compatible: 'Recuerda que solo se bonifican los viajes hechos en coche.',
            copresence_not_confirmed: 'Recuerda que el conductor y los pasajeros deben tener la ubicación activa y conexión a internet durante todo el trayecto.',
            multiple_devices: 'Para el próximo viaje, usa un solo móvil por persona.',
            mock_location: 'Para el próximo viaje, desactiva las apps que simulan la ubicación.',
            network_failed: 'Para el próximo viaje, desactiva la VPN o el proxy en tu móvil.',
            trip_limit: 'Podrás volver a bonificar viajes cuando empiece el próximo periodo.',
            pattern_review: 'No tienes que hacer nada: te avisaremos cuando terminemos.',
            competitor_app: 'Desinstala la otra app para que podamos bonificar tus próximos viajes.',
            shared_with_riders: 'Recuerda que el conductor y los pasajeros deben tener la ubicación activa y conexión a internet durante todo el trayecto.',
            shared_with_driver: 'Recuerda que el conductor y los pasajeros deben tener la ubicación activa y conexión a internet durante todo el trayecto.',
            location_permission_missing: 'Para el próximo viaje, activa el permiso de ubicación de WAIIS en «Siempre» en los ajustes del móvil.',
            unknown: 'Si crees que es un error, escríbenos y lo revisamos.',
          },
          // Dos claves válidas según si el trayecto tenía o no conductor/
          // pasajeros asignados (`g` en route-tracking.page.ts:1481). No es
          // "una u otra": `alertTitleKey`/`alertMessageKey`/`alertSuggestionKey`
          // llegan YA resueltos por mensaje — aquí solo hace falta tener las
          // dos rutas cargadas y traducir dinámicamente lo que llegue
          // (`| translate` en el template), nunca fijar una de las dos.
          // Confirmado con el equipo de app: mismo título y descripción en
          // ambas rutas.
          no_match: {
            unrealized: {
              title: 'Trayecto no verificado',
              description: 'No hemos podido confirmar que este trayecto se realizara.',
            },
          },
          assigned: {
            unrealized: {
              title: 'Trayecto no verificado',
              description: 'No hemos podido confirmar que este trayecto se realizara.',
            },
          },
        },
      },
    },
    PARTNER_SECTION: {
      READ_ONLY_USER_TITLE: 'Tienes acceso de solo lectura',
      READ_ONLY_USER_TEXT: 'Puedes ver todo lo de las empresas de {{partner}}, pero no cambiar nada.',
      MANAGED_BY_TITLE: 'Esta sección la gestiona {{partner}}',
      MANAGED_BY_TEXT: 'Puedes verla, pero los cambios los hace {{partner}}.',
    },
    // Aviso de tickets de soporte creados por agentes (WS-2415).
    AGENT_TICKET_NOTICES: {
      TITLE_ONE: 'Nuevo ticket de soporte creado por un agente',
      TITLE_MANY: '<b>{{count}}</b> tickets de soporte de agentes sin ver',
      OPEN: 'Pulsa para abrirlo',
      BADGE: '{{count}} tickets de soporte de agentes sin ver',
    },
    SIDEBAR: {
      SESSION: 'Sesión',
      COLLAPSE_MENU: 'Plegar menú',
      EXPAND_MENU: 'Desplegar menú',
      CHANGE_COMPANY: 'Cambiar empresa',
      PARTNER_ADMIN: 'Partner admin',
      ALL_CENTERS: 'Todos los centros',
      MATCH_SECTION: 'Match',
      DASHBOARD: 'Tablero',
      ECONOMIC_DASHBOARD: 'Dashboard económico',
      ECONOMIC_REPORTS: 'Informes',
      ECONOMIC_MOVEMENTS: 'Movimientos',
      ECONOMIC_USERS: 'Usuarios Generales',
      ECONOMIC_COMPANIES: 'Empresas',
      CORPORATIONS: 'Empresas',
      PARTNERS: 'Partners',
      PARTNER_REQUESTS: 'Solicitudes',
      PARTNER_REQUESTS_NEW: '{{count}} solicitudes nuevas',
      MY_PARTNER: 'Mi partner',
      PARTNER_USERS: 'Usuarios',
      PARTNER_PAYMENTS: 'Condiciones de pago',
      ECONOMIC_COMPANY_USERS: 'Usuarios Empresa',
      CORPORATION_USERS: 'Usuarios Empresa',
      CORPORATION_OFFICES: 'Sedes',
      LAYOUT_BUILDER: 'Layout Builder',
      USERS: 'Usuarios',
      USERS_GENERIC: 'Usuarios',
      REPORTS_SECTION: 'Informes Waiis',
      FUNNEL: 'Funnel',
      FUNNEL_WAIIS: 'Funnel Waiis',
      TRAVEL: 'Viajes',
      TRAVELS: 'Viajes',
      PARKING: 'Parking',
      SUSTAINABILITY: 'Sostenibilidad',
      CONVERSION: 'Conversión',
      USAGE: 'Uso',
      CREDITS: 'Créditos',
      PROVIDERS: 'Proveedores',
      COUPONS: 'Tarjetas Regalo',
      GIFT_CARDS: 'Tarjetas Regalo',
      CODES: 'Códigos',
      PROMOTIONAL_CODES: 'Códigos Promocionales',
      PARKING_SECTION: 'Parking',
      PARKING_SPACES: 'Plazas Parking',
      PARKING_RESERVATIONS: 'Reservas Parking',
      PARKING_CREDITS: 'Créditos Parking',
      COMMUNICATION: 'Comunicación',
      PUSH: 'Push',
      NOTIFICATIONS: 'Notificaciones',
      TRAINING: 'Formación',
      TRAINING_RESOURCES: 'Recursos',
      TRAINING_LAUNCH: 'Lanzamiento Interno',
      INTERNAL_LAUNCH: 'Lanzamiento Interno',
      RESOURCES: 'Recursos',
      RESOURCES_POSTER: 'Carteles',
      POSTERS: 'Carteles',
      RESOURCES_VIDEO: 'Videos',
      VIDEOS: 'Videos',
      RESOURCES_GUIDE: 'Guías',
      GUIDES: 'Guías',
      RESOURCES_LAUNCH: 'Pack Promo Launch',
      PROMO_LAUNCH: 'Pack Promo Launch',
      RESOURCES_CAR: 'Pack Promo Car',
      PROMO_CAR: 'Pack Promo Car',
      RESOURCES_CHALLENGE: 'Pack Desafios',
      PROMO_CHALLENGES: 'Pack Desafios',
      ACTIVITY_MANAGEMENT: 'Gestión de actividad',
      ADMINISTRATION: 'Administración',
      MONEY: 'Dinero',
      INTERNAL_ADMIN: 'Admin interno',
      COMPANIES: 'Empresas',
      OFFICES: 'Sedes',
      SHIFTS: 'Turnos',
      INCENTIVES: 'Incentivos',
      INCIDENTS: 'Incidencias',
      COMPLAINTS: 'Incidencias',
      WAIIS_USERS: 'Usuarios WAIIS',
      FRAUD: 'Fraude',
      ADMIN_HOME: 'Inicio',
      TRAVEL_LIST: 'Viajes',
      RIDES: 'Rides VTC',
      RIDE_BOOKING_DESK: 'Reservas de grupo',
      PAYOUT_REVIEWS: 'Retiradas',
      SUPPORT: 'Soporte',
      AGENT_CONVERSATIONS: 'Historial de agentes',
      MARKETING: 'Marketing',
      MARKETING_USERS: 'Usuarios de Marketing',
      EMAILS: 'Correos',
      PUSH_NOTIFICATIONS: 'Notificaciones push',
      REFERRALS: 'Referidos',
      PVP_PROMOS: 'Promo PVP',
      PROMOS: 'Promociones',
      PROMOS_PVP: 'PVP (Fraude)',
      PROMOS_TRIPS: 'Por viajes',
      ZONE_ADS: 'Anuncios por zona',
      ZONE_ADS_SETTINGS: 'Ajustes',
      ZONE_ADS_IMBALANCE: 'Informe de desequilibrio',
      ZONE_ADS_DRAFTS: 'Borradores',
      ZONE_ADS_TEMPLATES: 'Plantillas',
      FOOTPRINT_SECTION: 'Huella',
      FOOTPRINT: 'Huella',
      FOOTPRINT_RAW: 'Huella en Bruto',
      TRAVEL_REVIEW: 'Revisión de viajes',
      CORRIDORS_REVIEW: 'Revisión de corredores',
      MATCH_REVIEW: 'Revisión de rutas',
      MATCHES_LISTING: 'Listado de matchs',
      MATCH_LIST: 'Variables de match',
      POIS: 'POIs',
      TAGS: 'Etiquetas',
      CONFIGURATIONS: 'Configuraciones',
      CREDIT_TYPES: 'Tipos de crédito',
      COMMISSIONS: 'Comisiones',
      SUBSIDIES: 'Subvenciones',
      PRICING_CONFIGS: 'Precios',
      SUBSIDY_CONSUMPTIONS: 'Subvenciones',
      POOLING_RUNNERS: 'Corredores',
      POOLING_RUNNERS_CONFIG: 'Corredores',
      CORP_SECTION_PRINCIPAL: 'PRINCIPAL',
      CORP_SECTION_CARPOOLING: 'CARPOOLING',
      CORP_SECTION_TAXI_VTC: 'TAXI / VTC',
      CORP_SECTION_PARKING: 'PARKING',
      CORP_SECTION_ACCOUNT: 'CUENTA',
      CORP_LAUNCH_GUIDE: 'Puesta en marcha · {{done}}/{{total}}',
      CORP_LAUNCH_GUIDE_TITLE: 'Puesta en marcha',
      CORP_SUSTAINABILITY: 'Sostenibilidad',
      CORP_HOME: 'Inicio',
      CORP_USAGE: 'Uso',
      CORP_EMPLOYEES: 'Empleados',
      CORP_TRAVEL: 'Viajes',
      CORP_FUNNEL: 'Funnel',
      CORP_INCENTIVES: 'Incentivos',
      CORP_PMST: 'PMST',
      CORP_SUBSIDY: 'Bonificación',
      CORP_FLEET: 'Flota',
      CORP_TAXI_RIDES: 'Viajes y gasto',
      CORP_TAXI_POLICY: 'Política',
      CORP_TAXI_BOOKINGS: 'Reservas',
      CORP_TAXI_REVIEW: 'Revisión',
      CORP_SETTINGS: 'Ajustes',
      CORP_WALLET: 'Cartera',
      CORP_PLAN: 'Plan',
      ONBOARDING_LOCKED_HINT: 'Completa la puesta en marcha para desbloquear',
      PLAN_READ_ONLY_HINT: 'Tu acceso es de solo lectura',
      PLAN_LOCKED_HINT: 'Esta función no está incluida en tu plan actual. Cambia de plan para desbloquearla.',
      PMST_DISABLED_HINT: 'Esta empresa no implanta el PMST con WAIIS. Puedes cambiar esta respuesta en los ajustes de la empresa.',
      PLAN_UPGRADE_MODAL: {
        TITLE: 'Función no disponible en tu plan',
        TEXT: 'Esta sección forma parte del <strong>Plan de Incentivos</strong>. Actualiza tu plan para desbloquearla y acceder a todas las ventajas del dashboard.',
        CONFIRM: 'Ver planes',
        CANCEL: 'Ahora no',
      },
      CORP_COMING_SOON: 'PRÓXIMAMENTE',
      CONFIG_VARIABLES: 'Variables de Configuración',
      APP_ANNOUNCEMENT: "Comunicado en la app",
      FRAUD_RULES: 'Reglas de fraude',
      TERMS_CONDITIONS: 'Términos y Condiciones de Uso',
      CONTRACT_TEMPLATES: 'Plantilla de contrato',
      DATA_PROCESSING_AGREEMENT: 'Contrato de encargo (DPA)',
      PMST_GOAL_CONFIG: 'Objetivos PMST',
      PMST_QUESTIONNAIRE_CONFIG: 'Formulario PMST',
      PMST_QUESTIONNAIRE_RESPONSES: 'Respuestas PMST',
      RIDES_CONFIG: 'Rides',
      RIDES_CONFIG_SETTINGS: 'Ajustes',
      RIDES_CONFIG_GUEST_PHONES: 'Teléfonos invitados',
      RIDES_CONFIG_PROVIDERS: 'Proveedores',
      RIDES_CONFIG_PROVIDER_ROUTING: 'Enrutado por etiqueta',
      RIDES_CONFIG_BOOKINGS: 'Reservas de grupo',
      RIDES_CONFIG_REVIEW: 'Revisión de viajes',
      FACE_VERIFICATION_CONFIG: 'Verificación facial',
      CRAFTED: 'Crafted',
      PAGES: 'Pages',
      PROFILE: 'Perfil',
      OVERVIEW: 'Resumen',
      PROJECTS: 'Proyectos',
      CAMPAIGNS: 'Campañas',
      DOCUMENTS: 'Documentos',
      CONNECTIONS: 'Conexiones',
      WIZARDS: 'Wizards',
      HORIZONTAL: 'Horizontal',
      VERTICAL: 'Vertical',
      ACCOUNTS: 'Cuentas',
      SETTINGS: 'Configuraciones',
      ERRORS: 'Errores',
      ERROR_404: 'Error 404',
      ERROR_500: 'Error 500',
      WIDGETS: 'Widgets',
      LISTS: 'Listas',
      STATISTICS: 'Estadísticas',
      CHARTS: 'Gráficas',
      MIXED: 'Mixto',
      TABLES: 'Tablas',
      FEEDS: 'Feeds',
      APPS: 'Apps',
      CHAT: 'Chat',
      PRIVATE_CHAT: 'Chat Privado',
      GROUP_CHAT: 'Chat Grupal',
      DRAWER_CHAT: 'Drawer Chat',
      USER_MANAGEMENT: 'Gestión de Usuarios',
      USERS_MANAGEMENT: 'Usuarios',
      ROLES: 'Roles',
      PERMISSIONS: 'Permisos',
      USER_ROLE_CORPORATIONS: 'Usuarios',
      AUTHORIZATION_DASHBOARD: 'Dashboard de Autorización',
      APP_SECTION: 'APP',
      VALORATION_LABELS: 'Valoraciones',
      LABELS: 'Etiquetas de usuarios y rutas',
      PERMISSIONS_ERROR: 'Error al cargar los permisos',
      RELOAD: 'Recargar',
      NO_ACCESS: 'Sin acceso a ninguna página',
      UNSEEN_CORPORATIONS: '{{count}} empresas nuevas sin revisar',
    },
    PAGES: {
      COMING_SOON: {
        ALT: 'Próximamente',
        TITLE: '¡Estamos trabajando en ello!',
        TEXT: 'Esta sección estará disponible próximamente.',
        THANKS: 'Gracias por tu paciencia.',
      },
      VISIT_SURVEY: {
        DEFAULT_WHO: 'Encuesta de movilidad al centro de trabajo',
        CENTER: 'Centro: {{name}}',
        TITLE: 'Encuesta de movilidad',
        LEAD: 'Para visitantes, clientes y proveedores. Nos ayuda a elaborar el Plan de Movilidad Sostenible al Trabajo (PMST) del centro, conforme a la Ley 9/2025. Te llevará menos de 2 minutos y es anónima.',
        Q1: '1. ¿Cuál es el motivo principal de su visita?',
        Q2: '2. ¿Con qué frecuencia visita nuestras instalaciones?',
        Q3: '3. ¿Desde qué código postal se desplaza habitualmente para llegar a nuestras instalaciones?',
        Q3_PLACEHOLDER: 'Ej.: 08025',
        Q3_HINT: 'No pedimos la dirección exacta, por privacidad.',
        Q4: '4. ¿Cuál es el medio principal de transporte utilizado para acceder al centro?',
        Q5: '5. ¿Ha encontrado alguna dificultad para acceder o desarrollar su actividad en nuestras instalaciones?',
        Q6: '6. ¿Qué medida considera que podría mejorar el acceso o la movilidad asociada a este centro?',
        SUBMIT: 'Enviar respuesta',
        THANKS_TITLE: '¡Gracias!',
        THANKS_TEXT: 'Tu respuesta se ha registrado y ayudará a mejorar la movilidad de este centro. Puedes cerrar esta ventana.',
        FOOT: 'WAIIS · Encuesta vinculada a la ATM para el PMST (Ley 9/2025). Datos tratados de forma agregada y anónima.',
        OPT: {
          CLIENT: 'Cliente',
          SUPPLIER: 'Proveedor',
          CARRIER: 'Transportista / Logística',
          PARTNER: 'Empresa colaboradora',
          MEETING: 'Reunión de trabajo',
          TECH: 'Servicio técnico / mantenimiento',
          OTHER_M: 'Otro',
          OTHER_F: 'Otra',
          FIRST_TIME: 'Primera vez',
          SEVERAL_YEAR: 'Varias veces al año',
          SEVERAL_MONTH: 'Varias veces al mes',
          WEEKLY: 'Semanalmente',
          DAILY: 'Diariamente o casi a diario',
          CAR: 'Coche',
          VAN: 'Furgoneta',
          TRUCK: 'Camión',
          MOTORBIKE: 'Moto',
          PUBLIC_TRANSPORT: 'Transporte público',
          CARPOOL: 'Coche compartido',
          BIKE: 'Bicicleta',
          SCOOTER: 'Patinete',
          WALK: 'A pie',
          NONE: 'Ninguna',
          TRAFFIC: 'Tráfico',
          NO_PARKING: 'Falta de aparcamiento',
          POOR_PT: 'Transporte público insuficiente',
          HARD_ACCESS: 'Accesos complicados',
          NO_LOADING: 'Falta de espacio para carga y descarga',
          WAITING: 'Tiempos de espera',
          BETTER_ACCESS: 'Mejor organización de accesos',
          MORE_PARKING: 'Más aparcamiento',
          BETTER_PT: 'Mejor conexión en transporte público',
          MORE_LOADING: 'Más espacio para carga y descarga',
          BETTER_SIGNS: 'Mejor señalización',
          LESS_WAITING: 'Reducción de tiempos de espera',
        },
      },
      DASHBOARD: {
        TITLE: 'Dashboard',
        CORPORATIONS_SECTION: 'Empresas',
        CORPORATION_OFFICES_SECTION: 'Sedes Corporativas',
        CREATE_CORPORATION_TITLE: 'Alta de nueva empresa',
        CREATE_CORPORATION_DESCRIPTION:
          'Crear una nueva compañía introduciendo los datos básicos. A continuación podrás seguir configurándola en el dashboard.',
        CREATE_CORPORATION_BUTTON: 'Crear empresa',
        NO_ACCESS: 'No tienes acceso a Empresas o Sedes',
        NO_ACCESS_SUBTITLE:
          'Contacta al administrador si crees que esto es un error',
        ROLE_LABEL: 'Rol:',
        ID_LABEL: 'ID:',
        COMPANY_LABEL: 'Empresa:',
        HUB: {
          TITLE: '¿Dónde quieres entrar?',
          SUBTITLE: 'Elige la administración de WAIIS o una de tus empresas y sedes.',
          ADMIN_SECTION: 'Administración',
          ADMIN_CARD_TITLE: 'Administración WAIIS',
          ADMIN_CARD_META: 'Gestión global de la plataforma',
          PARTNER_SECTION: 'Partner',
          PARTNER_CARD_META: 'Partner admin · {{count}} empresa(s)',
          CORPORATIONS_SECTION: 'Empresas',
          OFFICES_SECTION: 'Sedes',
          NEW_CORPORATION_SECTION: 'Nueva empresa',
          CREATE_CARD_TITLE: 'Crear empresa',
          CREATE_CARD_META: 'Registra una nueva empresa en la plataforma',
          EMPTY_TITLE: 'Sin acceso asignado',
          EMPTY_SUBTITLE: 'Contacta con tu administrador para obtener permisos.',
          NO_NAME: 'Sin nombre',
          UNKNOWN_CORPORATION: 'Empresa desconocida',
          ROLE_FALLBACK: 'Rol #{{id}}',
        },
      },
      CORPORATIONS_LIST: {
        TITLE: 'Empresas',
        LEGAL_NAME: 'Nombre Legal',
        TRADE_NAME: 'Nombre Comercial',
        TAX_ID: 'NIF/CIF',
        CONTACT_EMAIL: 'Email de Contacto',
        STATUS: 'Estado',
        REFRESH: 'Actualizar',
        LOADING: 'Cargando...',
        NO_CORPORATIONS: 'No hay empresas registradas.',
        ACTIVE: 'Activa',
        INACTIVE: 'Inactiva',
      },
      CORPORATIONS_LISTING: {
        SEARCH_PLACEHOLDER: 'Buscar empresa',
        COL_TRADE_NAME: 'Nombre Comercial',
        COL_LEGAL_NAME: 'Nombre Legal',
        COL_TAX_ID: 'NIF/CIF',
        COL_CONTACT_EMAIL: 'Email de Contacto',
        COL_ACTIVE: 'Activa',
        EXPORT_EMPTY_TEXT: 'No hay empresas para exportar.',
        IMPORT_SUCCESS_TEXT: 'Se han importado {{count}} empresas correctamente.',
      },
      CORPORATION_DETAIL: {
        ERR_NO_ID: 'No se proporcionó un ID de empresa',
        ERR_PARAMS: 'Error al obtener los parámetros de la URL',
        ERR_UPDATE: 'Error al actualizar la información de la empresa',
        ERR_TIMEOUT: 'La petición tardó demasiado tiempo (más de 10 segundos). Verifica tu conexión.',
        ERR_LOAD: 'Error al cargar la empresa: {{msg}}',
        ERR_UNKNOWN: 'Error desconocido',
        ERR_OFFICES_TIMEOUT: 'La carga de sedes tardó demasiado tiempo',
        ERR_OFFICES: 'Error al cargar las sedes: {{msg}}',
        ERR_ADMINS_TIMEOUT: 'La carga de administradores tardó demasiado tiempo',
        ERR_ADMINS: 'Error al cargar administradores: {{msg}}',
        ID: 'ID',
        CLOSE: 'Cerrar',
        EMAIL_PLACEHOLDER: 'usuario@ejemplo.com',
        TITLE: 'Detalle de Empresa',
        BACK_BUTTON: 'Volver',
        LOADING: 'Cargando información de la empresa...',
        ERROR: 'Error',
        TAB_OVERVIEW: 'Información',
        TAB_OFFICES: 'Oficinas',
        TAB_FUNNEL: 'Funnel',
        TAB_TRAVEL: 'Viajes',
        TAB_PARKING: 'Parking',
        TAB_SUSTAINABILITY: 'Sostenibilidad',
        TAB_CONVERSION: 'Conversión',
        TAB_USAGE: 'Uso',
        TAB_ADMINS: 'Administradores',
        TAB_KPIS: 'KPIs de Movilidad',
        GENERAL_INFORMATION: 'Información general',
        ADDITIONAL_INFORMATION: 'Información adicional',
        FISCAL_INFO: 'Información Fiscal',
        LEGAL_NAME: 'Nombre Legal:',
        TRADE_NAME: 'Nombre Comercial:',
        TAX_ID: 'NIF/CIF:',
        CONTACT_INFO: 'Información de Contacto',
        CONTACT_NAME: 'Nombre de Contacto:',
        CONTACT_PHONE: 'Teléfono de Contacto:',
        CONTACT_EMAIL: 'Email de Contacto:',
        FISCAL_ADDRESS_SECTION: 'Dirección fiscal',
        FISCAL_ADDRESS: 'Dirección Fiscal:',
        FISCAL_CITY: 'Ciudad Fiscal:',
        FISCAL_POSTAL_CODE: 'Código Postal Fiscal:',
        COMMERCIAL_ADDRESS_SECTION: 'Dirección comercial',
        COMMERCIAL_ADDRESS: 'Dirección Comercial:',
        COMMERCIAL_CITY: 'Ciudad Comercial:',
        COMMERCIAL_POSTAL_CODE: 'Código Postal Comercial:',
        STATUS_LABEL: 'Estado',
        CREATED_AT: 'Creado',
        UPDATED_AT: 'Actualizado',
        OFFICES: 'Sedes',
        NO_OFFICES: 'No hay sedes registradas',
        OFFICES_LOADING: 'Cargando sedes...',
        ADMINS_LOADING: 'Cargando administradores...',
        ADMINS_TITLE: 'Administradores',
        NO_ADMINS: 'No hay administradores asignados',
        ADMINS: 'Administradores',
        ADMIN_NAME: 'Nombre',
        ADMIN_EMAIL: 'Email',
        ADMIN_ROLE: 'Rol',
        ADD_ADMIN: 'Añadir administrador',
        ASSIGN_ADMIN: 'Asignar Administrador',
        ASSIGN_ADMIN_TITLE: 'Asignar Administrador de Empresa',
        ASSIGN_ROLE: 'Asignar rol',
        EMAIL_LABEL: 'Email',
        EMAIL_REQUIRED: 'El email es obligatorio',
        EMAIL_INVALID: 'Email no válido',
        SELECT_USER: 'Seleccionar Usuario',
        SELECT_ROLE: 'Seleccionar Rol',
        ASSIGN: 'Asignar',
        CANCEL: 'Cancelar',
        ASSIGNING: 'Asignando...',
        ADMIN_ASSIGNED_SUCCESS: 'Administrador asignado correctamente',
        ADMIN_ASSIGN_ERROR: 'Error al asignar administrador',
        ASSIGN_SUCCESS: 'Administrador asignado correctamente',
        ASSIGN_ERROR: 'Error al asignar administrador',
        USER_REQUIRED: 'Debe seleccionar un usuario',
        ROLE_REQUIRED: 'Debe seleccionar un rol',
        HEADING_OFFICES: 'Empleados',
        HEADING_FUNNEL: 'Funnel',
        HEADING_TRAVEL: 'Viajes',
        HEADING_PARKING: 'Reservas',
        HEADING_SUSTAINABILITY: 'Sostenibilidad',
        HEADING_CONVERSION: 'Subvención',
        HEADING_USAGE: 'Uso',
        HEADING_PRICING_CONFIGS: 'Políticas',
        HEADING_SUBSIDY_CONSUMPTIONS: 'Incentivos',
        HEADING_POOLING_RUNNERS: 'Flota',
        HEADING_ADMINS: 'Ajustes',
        EDIT_BUTTON: 'Editar',
        EDIT_MODAL_TITLE: 'Editar información general',
        FIELD_REQUIRED: 'Campo requerido',
        INVALID_TAX_ID: 'El CIF no es válido. Revisa la letra, los dígitos y el carácter de control.',
        ACTIVE_CHECKBOX: 'Corporación activa',
        CANCEL_BUTTON: 'Cancelar',
        SAVE_BUTTON: 'Guardar',
        SAVING: 'Guardando...',
        SUCCESS_TITLE: '¡Éxito!',
        UPDATE_SUCCESS_TEXT: 'La información general de la corporación ha sido actualizada correctamente.',
        ERROR_TITLE: 'Error',
      },
      CORPORATION_SETTINGS: {
        COMPANY_INFO: {
          TITLE: 'Datos de la empresa',
          SUBTITLE: 'Información fiscal y de contacto de la corporación',
          LOGO_LABEL: 'Logo de la empresa',
          LOGO_HINT: 'PNG, JPEG o WEBP. Máx. 4 MB.',
          LOGO_UPLOAD: 'Subir logo',
          LOGO_CHANGE: 'Cambiar logo',
          LOGO_REMOVE: 'Quitar',
          LOGO_ERROR_TYPE: 'Formato no admitido — usa PNG, JPEG o WEBP.',
          LOGO_ERROR_SIZE: 'El logo no puede superar los 4 MB.',
          LEGAL_NAME: 'Razón social',
          LEGAL_NAME_PLACEHOLDER: 'Nombre legal de la empresa',
          TAX_ID: 'CIF/NIF',
          INVALID_TAX_ID: 'El CIF, NIF o NIE no es válido. Revisa la letra, los dígitos y el carácter de control.',
          FISCAL_ADDRESS: 'Dirección fiscal',
          FISCAL_ADDRESS_PLACEHOLDER: 'Calle, número, piso',
          CITY: 'Ciudad',
          POSTAL_CODE: 'Código postal',
          CONTACT_NAME: 'Persona de contacto',
          CONTACT_NAME_PLACEHOLDER: 'Nombre y apellidos',
          CONTACT_EMAIL: 'Email de contacto',
          CONTACT_PHONE: 'Teléfono de contacto',
          NUM_EMPLOYEES: 'N.º de empleados',
          NUM_OFFICES: 'N.º de centros',
          PMST_ENABLED: 'Implantar el PMST con WAIIS',
          PMST_ENABLED_HINT: 'Si lo desactivas, la pantalla de PMST queda bloqueada para esta empresa.',
          SAVE: 'Guardar cambios',
          SAVING: 'Guardando...',
          SAVE_SUCCESS_TITLE: 'Cambios guardados',
          SAVE_ERROR_TITLE: 'No se pudieron guardar los cambios',
          SAVE_ERROR_TEXT: 'Revisa los datos e inténtalo de nuevo.',
        },
        CONTRACT_PREVIEW: {
          BUTTON: 'Ver contrato',
          MODAL_TITLE: 'Contrato de prestación de servicios',
          LOADING: 'Generando contrato...',
          CLOSE: 'Cerrar',
          RETRY: 'Reintentar',
          ERROR_403: 'No tienes permisos para ver el contrato de esta empresa.',
          ERROR_404: 'La empresa no existe.',
          ERROR_GENERIC: 'No se ha podido cargar el contrato. Inténtalo de nuevo.',
        },
        INVITE_CODE: {
          TITLE: 'Código de invitación',
          SUBTITLE: 'Compártelo para que los empleados se den de alta de forma autónoma',
          COPY: 'Copiar',
          COPIED: '¡Copiado!',
          EMPTY: 'Esta empresa no tiene código de invitación',
        },
        OFFICES: {
          TITLE: 'Sedes',
          SUBTITLE: 'Centros de trabajo de la corporación',
          CREATE: 'Crear sede',
          NOTE: 'Cada sede puede tener administradores y usuarios propios.',
          EXTRA_OFFICE_NOTE: 'Cada centro adicional suma 20 €/mes al Plan Incentivos.',
          EMPTY: 'Sin sedes registradas',
          ACTIVE: 'Activa',
          INACTIVE: 'Inactiva',
          TABLE_NAME: 'Nombre',
          TABLE_CITY: 'Ciudad',
          TABLE_CONTACT: 'Contacto',
          TABLE_ACTIVE: 'Estado',
          MISSING_PRE: 'Faltan',
          PENDING_SINGULAR: 'centro por crear',
          PENDING_PLURAL: 'centros por crear',
          MISSING_POST: 'de los',
          MISSING_SUFFIX: 'declarados. Créalas aquí.',
          DELETE: 'Eliminar sede',
          DELETE_CONFIRM_TITLE: '¿Eliminar esta sede?',
          DELETE_CONFIRM_TEXT: 'Se eliminará "{{name}}" de forma permanente. Esta acción no se puede deshacer.',
          DELETE_SUCCESS_TITLE: 'Sede eliminada',
          DELETE_ERROR_TITLE: 'No se pudo eliminar la sede',
        },
        OFFICE_MODAL: {
          NEW_TITLE: 'Nueva sede',
          NEW_SUBTITLE: 'Rellena los datos de la nueva sede',
          EDIT_SUBTITLE: 'Edita los datos de esta sede',
          NAME_LABEL: 'Nombre *',
          NAME_PLACEHOLDER: 'Sede Barcelona',
          CONTACT_NAME_LABEL: 'Persona de contacto *',
          CONTACT_NAME_PLACEHOLDER: 'Nombre y apellidos',
          CONTACT_PHONE_LABEL: 'Teléfono *',
          CONTACT_EMAIL_LABEL: 'Email de contacto *',
          ADDRESS_LABEL: 'Dirección *',
          ADDRESS_PLACEHOLDER: 'Calle, número, piso',
          CITY_LABEL: 'Ciudad *',
          POSTAL_CODE_LABEL: 'Código postal *',
          CANCEL: 'Cancelar',
          SAVE: 'Crear sede',
          SAVE_CHANGES: 'Guardar cambios',
          SAVING: 'Guardando...',
          ERROR_SAVE: 'No se pudo guardar la sede. Inténtalo de nuevo.',
        },
        WALLET: {
          TITLE: 'Mi cartera',
          BALANCE_LABEL: 'Saldo disponible',
          RECHARGE: 'Recargar',
          WITHDRAW: 'Retirar',
        },
        ADMINS: {
          TITLE: 'Administradores',
          SUBTITLE: 'Usuarios con permisos de administración sobre esta corporación',
          ADD: 'Añadir admin',
          EMAIL_LABEL: 'Email',
          EMAIL_PLACEHOLDER: 'Buscar usuario por email...',
          EMAIL_NOTICE: 'Solo los emails ya registrados en WAIIS podrán ser administradores de una empresa o sede.',
          ROLE_LABEL: 'Rol',
          ROLE_CORPORATION_ADMIN: 'Admin de empresa',
          ROLE_OFFICE_ADMIN: 'Admin de sede',
          OFFICE_LABEL: 'Sede',
          SELECT_OFFICE_PLACEHOLDER: 'Selecciona una sede',
          ADDING: 'Añadiendo...',
          CONFIRM: 'Confirmar',
          CANCEL: 'Cancelar',
          ERROR_TITLE: 'Ha ocurrido un error',
          ERROR_ADD: 'No se pudo añadir el administrador. Inténtalo de nuevo.',
          ERROR_EMAIL_NOT_FOUND: 'Solo se pueden añadir como administradores usuarios que ya estén registrados en WAIIS.',
          ALL_OFFICES: 'Todas las sedes',
          TABLE_USER: 'Usuario',
          TABLE_ROLE: 'Rol',
          TABLE_EMAIL: 'Email',
          REMOVE_TITLE: 'Eliminar permiso',
          EMPTY: 'Sin administradores asignados',
          ROLE_ADMIN_DISPLAY: 'Admin',
          ROLE_OFFICE_ADMIN_DISPLAY: 'Admin de oficina',
        },
        DELETE: {
          ZONE_TITLE: 'Eliminar empresa',
          ZONE_DESC: 'Se eliminará la empresa y todos sus datos. Esta acción no se puede deshacer.',
          CONFIRM_TITLE: '¿Eliminar empresa?',
          CONFIRM_HTML:
            'Vas a eliminar <strong>{{name}}</strong> y todos sus datos. Esta acción no se puede deshacer.<br><br>Escribe el nombre para confirmar:',
          CONFIRM_BUTTON: 'Eliminar definitivamente',
          CANCEL_BUTTON: 'Cancelar',
          NAME_MISMATCH: 'El nombre no coincide.',
          SUCCESS_TITLE: 'Empresa eliminada',
          ERROR_TITLE: 'No se pudo eliminar',
          ERROR_TEXT: 'Inténtalo de nuevo más tarde.',
        },
      },
      PMST: {
        FORM: {
          TITLE: 'Formulario de empresa · PMST',
          PROGRESS: '{{answered}} / {{total}} obligatorias respondidas',
          AUTOSAVE_HINT: 'Se guarda automáticamente al rellenar cada campo — puedes cerrarlo y continuar más adelante.',
          INHERITED: 'Estos son los valores guardados a nivel de empresa. Esta sede aún no tiene respuesta propia: en cuanto guardes, dejará de seguir a la empresa.',
          REQUIRED: 'Obligatoria',
          ADD_ROW: 'Añadir fila',
          UPLOADING: 'Subiendo…',
          SELECT_FILE: 'Seleccionar archivo',
          PREVIOUS: 'Anterior',
          SAVE_AND_EXIT: 'Guardar y salir',
          NEXT: 'Siguiente',
          FINISH: 'Finalizar',
          QUESTIONNAIRE: 'Cuestionario',
          VIEW_DOCUMENT: 'Ver documento',
          QR: 'QR',
          SEND_ERROR: 'No se ha podido enviar la respuesta',
          SELECT_OFFICE: 'Selecciona una sede',
          SELECT_OFFICE_TEXT: 'Tu cuenta necesita una sede concreta para rellenar el PMST.',
          MISSING_TITLE: 'Faltan preguntas obligatorias',
          MISSING_TEXT_ONE: 'Te queda 1 pregunta obligatoria por responder.',
          MISSING_TEXT_OTHER: 'Te quedan {{n}} preguntas obligatorias por responder.',
          DONE_TITLE: 'Formulario completado',
          DONE_TEXT: 'Ya puedes ver el documento generado.',
        },
        PMST_DISABLED: 'Esta empresa no tiene activado el PMST con WAIIS.',
        TOOLBAR: {
          MY_COMPANY: 'Mi empresa',
          ALL_CENTERS: 'Todos los centros',
        },
        HERO: {
          STATUS_BADGE: 'Plan en progreso',
          TITLE: 'Plan de Movilidad Sostenible al Trabajo',
          SUBTITLE: 'El PMST es una obligación legal para los centros de trabajo con más de 200 trabajadores o más de 100 por turno (Ley 9/2025). El plazo máximo para su implantación finaliza el {{deadline}} (RDL 7/2026).',
          DAYS_LABEL: 'días para el<br />{{deadline}}',
          PROGRESS_CAPTION: 'Registro actual · {{registered}} / {{total}} de la plantilla',
          LEGEND_YOU: 'Tú · {{percent}}',
          LEGEND_MIN: 'Mínimo PMST · {{percent}}% de la plantilla',
          LEGEND_GOAL: 'Meta empresa {{percent}}',
          ACTION_INVITE: 'Cargar e invitar empleados',
          ACTION_COMPLETE_DATA: 'Completar datos',
          ACTION_INCENTIVES: 'Gestionar incentivos',
          ACTION_ADD_DOC: 'Añadir documentación extra',
        },
        REQUIREMENTS: {
          SECTION_LABEL: 'REQUISITOS DEL PMST',
          COMPANY_DATA: 'Datos de empresa registrados',
          OFFICES: 'Oficinas y sedes registradas ({{count}} sedes)',
          MOBILITY_MEASURES: 'Medidas de movilidad compartida activas',
          STAFF_REGISTRATION: 'Registro de plantilla',
          STAFF_REGISTRATION_SUBTITLE: 'de la plantilla declarada',
          PMST_PENDING_OFFICES: 'Pendiente en: {{offices}}',
          PMST_DOCUMENT: 'Documento PMST generado y validado',
        },
        STATUS: {
          COMPLETED: 'Completado',
          PROGRESS: 'En progreso',
          PENDING: 'Pendiente',
        },
        EXTRA_DOCS: {
          SECTION_LABEL: 'DOCUMENTACIÓN EXTRA',
          DOWNLOAD: 'Descargar',
          DELETE: 'Eliminar',
          EMPTY: 'Aún no has añadido documentación extra.',
          UPLOAD_ERROR_TITLE: 'Error al subir el documento',
          UPLOAD_ERROR_TEXT: 'No se pudo subir el archivo. Comprueba el formato y el tamaño.',
        },
        EXTRA_DOCS_MODAL: {
          TITLE: 'Añadir documentación extra',
          DESC: 'Sube cualquier documento y dale un nombre para añadirlo a tu PMST.',
          NAME_LABEL: 'Nombre del documento',
          NAME_PLACEHOLDER: 'Ej.: Convenio de transporte 2026',
          FILE_LABEL: 'Archivo',
          FILE_PICKER: 'Seleccionar archivo desde tu equipo',
          FILE_HINT: 'Ej: encuestas, aparcamientos, convenios, etc.',
          SUBMIT: 'Añadir documento',
        },
        VISITORS: {
          TITLE: 'Encuesta de visitantes, clientes y proveedores',
          DESC: 'Comparte el <strong>formulario online</strong> con visitantes y proveedores habituales; sus respuestas, ligadas a tu empresa, alimentan el informe PMST.',
          LINK_LABEL: 'Enlace del formulario de tu empresa',
          COPY: 'Copiar',
          COPIED: 'Copiado',
          QR_ALT: 'Código QR del formulario',
          OPEN_FORM: 'Abrir formulario',
          SEND_EMAIL: 'Enviar por correo',
          PDF_VERSION: 'Versión PDF',
        },
      },
      PMST_GOAL_CONFIG: {
        TITLE: 'Objetivos de registro PMST',
        SUBTITLE: 'Selecciona una empresa (y opcionalmente una sede) para configurar el porcentaje mínimo exigido por ley y la meta propia de plantilla registrada para el PMST.',
        CORPORATION_LABEL: 'Empresa',
        CORPORATION_PLACEHOLDER: 'Selecciona una empresa',
        OFFICE_LABEL: 'Sede (opcional)',
        OFFICE_PLACEHOLDER: 'Toda la empresa',
        MIN_LABEL: 'Mínimo PMST (%)',
        MIN_HINT: 'Porcentaje mínimo de plantilla registrada exigido por ley.',
        TARGET_LABEL: 'Meta de empresa (%)',
        TARGET_HINT: 'Porcentaje que la empresa quiere alcanzar como objetivo propio.',
        CURRENT_STATUS: 'Registrados actualmente',
        SAVE: 'Guardar objetivos',
        SAVING: 'Guardando…',
        SAVED: 'Objetivos guardados correctamente.',
        ERROR_LOAD: 'No se pudo cargar la configuración de objetivos.',
        ERROR_SAVE: 'No se pudo guardar. Inténtalo de nuevo.',
        ERROR_TITLE: 'Error',
        ACCEPT: 'Aceptar',
        SECTION_SCOPE: 'Empresa y sede',
        SECTION_SCOPE_SUB: 'A quién se aplican los objetivos: a toda la empresa o a una de sus sedes.',
        SECTION_GOALS: 'Objetivos de plantilla registrada',
        SECTION_GOALS_SUB: 'Porcentajes de la plantilla que debe estar registrada en el PMST.',
        LOADING: 'Cargando la configuración…',
      },
      PMST_QUESTIONNAIRE_RESPONSES: {
        TITLE: 'Respuestas del cuestionario PMST',
        SUBTITLE: 'Selecciona una empresa (y opcionalmente una sede) para ver las respuestas que ha enviado cada persona empleada.',
        CORPORATION_LABEL: 'Empresa',
        CORPORATION_PLACEHOLDER: 'Selecciona una empresa',
        OFFICE_LABEL: 'Sede (opcional)',
        OFFICE_PLACEHOLDER: 'Toda la empresa',
        NO_RESPONSES: 'Todavía no hay ninguna respuesta enviada.',
        SUBMITTED_AT: 'Enviado:',
        UNANSWERED: 'Sin responder',
        ERROR_TITLE: 'Error',
        ERROR_LOAD: 'No se pudieron cargar las respuestas.',
        ERROR_FORBIDDEN: 'No tienes acceso a las respuestas de esta empresa.',
        ACCEPT: 'Aceptar',
        SECTION_SCOPE: 'Empresa y sede',
        SECTION_SCOPE_SUB: 'De qué empresa y, si quieres, de qué sede ver las respuestas.',
        LOADING: 'Cargando las respuestas…',
        ERROR_LOAD_TITLE: 'No se han podido cargar las respuestas',
      },
      CORPORATION_OFFICES_LIST: {
        TITLE: 'Sedes Corporativas',
        CORPORATION: 'Empresa',
        NAME: 'Nombre',
        CONTACT_NAME: 'Nombre de Contacto',
        CONTACT_EMAIL: 'Email de Contacto',
        CONTACT_PHONE: 'Teléfono de Contacto',
        CITY: 'Ciudad',
        STATUS: 'Estado',
        REFRESH: 'Actualizar',
        LOADING: 'Cargando...',
        NO_OFFICES: 'No hay sedes registradas.',
        ACTIVE: 'Activa',
        INACTIVE: 'Inactiva',
      },
      CORPORATION_OFFICES_LISTING: {
        SEARCH_PLACEHOLDER: 'Buscar sede',
        CREATE_OFFICE: 'Crear sede',
        COL_NAME: 'Nombre',
        COL_CONTACT: 'Contacto',
        COL_PHONE: 'Teléfono',
        COL_EMAIL: 'Email',
        COL_CITY: 'Ciudad',
        COL_ACTIVE: 'Activa',
        EXPORT_EMPTY_TEXT: 'No hay sedes para exportar.',
        IMPORT_SUCCESS_TEXT: 'Se han importado {{count}} sedes correctamente.',
      },
      CORPORATION_OFFICE_DETAIL: {
        TEXTS: {
          ERROR: 'Error',
          SUCCESS: 'Correcto',
          ACCEPT: 'Aceptar',
          ERR_UPDATE_OFFICE: 'Error al actualizar la información de la sede',
          ERR_CREATE_OFFICE: 'Error al crear la sede',
          USERS_LINKED: 'Usuarios vinculados correctamente',
          ERR_LINK_USERS: 'Error al vincular usuarios',
          OFFICE_NOT_FOUND: 'Sede no encontrada',
          OFFICE_TIMEOUT: 'Tiempo de espera agotado al cargar la sede',
          OFFICE_LOAD_ERROR: 'Error al cargar la sede',
          USERS_TIMEOUT: 'Tiempo de espera agotado al cargar los usuarios',
          USERS_LOAD_ERROR: 'Error al cargar los usuarios',
          INVALID_CSV: 'Por favor selecciona un archivo CSV válido',
          IMPORT_OK: 'Usuarios importados correctamente',
          IMPORT_ERROR: 'Error al importar usuarios del CSV',
          USER_UPDATED: 'Usuario actualizado correctamente',
          USER_UPDATE_ERROR: 'Error al actualizar el usuario',
          USER_ADDED: 'Usuario añadido correctamente',
          USER_ADD_ERROR: 'Error al crear el usuario',
          DT_SEARCH: 'Buscar:',
          DT_LENGTH: 'Mostrar _MENU_ registros',
          DT_ZERO: 'No se encontraron registros',
          DT_INFO: 'Mostrando de _START_ a _END_ de _TOTAL_ registros',
          DT_INFO_EMPTY: 'Mostrando 0 registros',
          DT_INFO_FILTERED: '(filtrado de _MAX_ registros totales)',
          DT_FIRST: 'Primero',
          DT_LAST: 'Último',
          DT_NEXT: 'Siguiente',
          DT_PREVIOUS: 'Anterior',
          COL_SPACE: 'Plaza',
          COL_TYPE: 'Tipo',
          COL_USER: 'Usuario',
          COL_RESERVED_DAYS: 'Días reservados',
          COL_SHIFT: 'Turno',
          COL_SHARING: 'Compartiendo',
          COL_ACTIVE_F: 'Activa',
          COL_ACTIVE: 'Activo',
          COL_LOCATION: 'Ubicación',
          COL_OFFICE: 'Sede',
          COL_ROLE: 'Rol',
          COL_CREDIT: 'Crédito',
          COL_EXPIRY: 'Caducidad',
          COL_CODE: 'Código',
          COL_ENTRY: 'Entrada',
          COL_EXIT: 'Salida',
          NOT_ASSIGNED: 'No asignado',
          YES: 'Sí',
          NO: 'No',
          BUSY: 'Ocupado',
          FREE: 'Libre',
          CLOSE: 'Cerrar',
          EMAIL_PLACEHOLDER: 'usuario@ejemplo.com',
        },
        TITLE: 'Detalle de Sede',
        BACK_BUTTON: 'Volver',
        TAB_OVERVIEW: 'Información general',
        TAB_USERS: 'Usuarios adscritos',
        TAB_MANAGERS: 'Gestores',
        TAB_KPIS: 'KPIs de Movilidad',
        GENERAL_INFORMATION: 'Información general',
        ADDITIONAL_INFORMATION: 'Información adicional',
        CONTACT_PERSON: 'Persona de Contacto',
        CONTACT_PHONE: 'Teléfono de Contacto',
        CONTACT_EMAIL: 'Email de Contacto',
        STATUS: 'Estado',
        COMMERCIAL_ADDRESS: 'Dirección Comercial',
        CITY: 'Ciudad',
        POSTAL_CODE: 'Código Postal',
        LOADING: 'Cargando información de la sede...',
        LOADING_USERS: 'Cargando usuarios...',
        ERROR: 'Error',
        USERS: 'Usuarios',
        USER_NAME: 'Nombre',
        USER_EMAIL: 'Email',
        USER_PHONE: 'Teléfono',
        USER_CORPORATE_EMAIL: 'Email Corporativo',
        USER_PERSONAL_EMAIL: 'Email Personal',
        USER_DNI: 'DNI',
        USER_DEPARTMENT: 'Departamento',
        USER_CORPORATE_PHONE: 'Teléfono Corporativo',
        USER_CONFIRMED: 'Confirmado',
        USER_ROLE: 'Rol',
        OFFICE_CODE: 'Código de Oficina',
        CORPORATION: 'Corporación',
        CREATED_AT: 'Creado:',
        UPDATED_AT: 'Actualizado:',
        NO_USERS: 'No hay usuarios en esta sede',
        WAIIS_LINK: 'Ver en WAIIS',
        DELETE_USER: 'Eliminar',
        DELETE_CONFIRMATION:
          '¿Está seguro de que desea eliminar a este usuario?',
        DELETE_CONFIRM_BUTTON: 'Sí, eliminar',
        DELETE_CANCEL_BUTTON: 'Cancelar',
        ACTIONS: 'Acciones',
        EDIT_USER: 'Editar usuario',
        ADD_USER: 'Añadir usuario',
        REQUIRED_FIELDS: 'Campos obligatorios',
        OPTIONAL_FIELDS:
          'Campos opcionales (al menos uno de ellos obligatorio)',
        NAME: 'Nombre',
        SURNAME: 'Apellidos',
        DEPARTMENT: 'Departamento',
        CORPORATE_EMAIL: 'Email corporativo',
        PERSONAL_EMAIL: 'Email personal',
        DNI: 'DNI',
        CORPORATE_PHONE: 'Teléfono corporativo',
        PERSONAL_PHONE: 'Teléfono personal',
        CONFIRMED: 'Confirmado',
        STATUS_PENDING: 'Pendiente',
        STATUS_REJECTED: 'Rechazado',
        STATUS_ACCEPTED: 'Aceptado',
        STATUS_ACTIVE: 'Activo',
        STATUS_INACTIVE: 'Inactivo',
        CANCEL: 'Cancelar',
        SAVE_USER: 'Guardar usuario',
        UPDATE_USER: 'Actualizar usuario',
        WAIT: 'Espera',
        UPLOAD_CSV: 'Subir CSV',
        UPLOADING: 'Subiendo...',
        LINK_USERS: 'Vincular usuarios',
        LINKING: 'Vinculando...',
        ERROR_REQUIRED_FIELD: 'Campo obligatorio',
        ERROR_INVALID_EMAIL: 'Email no válido',
        ERROR_MIN_LENGTH: 'Debe tener al menos 2 caracteres',
        ERROR_INVALID_FIELD: 'Campo no válido',
        MANAGERS_LOADING: 'Cargando gestores...',
        MANAGERS_TITLE: 'Gestores',
        NO_MANAGERS: 'No hay gestores asignados',
        MANAGERS: 'Gestores',
        MANAGER_NAME: 'Nombre',
        MANAGER_EMAIL: 'Email',
        MANAGER_ROLE: 'Rol',
        ADD_MANAGER: 'Añadir gestor',
        ASSIGN_MANAGER: 'Asignar Gestor',
        ASSIGN_MANAGER_TITLE: 'Asignar Administrador de Sede',
        ASSIGN_ROLE: 'Asignar rol',
        EMAIL_LABEL: 'Email',
        EMAIL_REQUIRED: 'El email es obligatorio',
        EMAIL_INVALID: 'Email no válido',
        SELECT_USER: 'Seleccionar Usuario',
        SELECT_ROLE: 'Seleccionar Rol',
        ASSIGN: 'Asignar',
        ASSIGNING: 'Asignando...',
        MANAGER_ASSIGNED_SUCCESS: 'Gestor asignado correctamente',
        MANAGER_ASSIGN_ERROR: 'Error al asignar gestor',
        ASSIGN_SUCCESS: 'Gestor asignado correctamente',
        ASSIGN_ERROR: 'Error al asignar gestor',
        USER_REQUIRED: 'Debe seleccionar un usuario',
        ROLE_REQUIRED: 'Debe seleccionar un rol',
        CREATE_OFFICE_TITLE: 'Crear Nueva Sede',
        CORPORATION_LABEL: 'Corporación *',
        SELECT_CORPORATION: 'Seleccionar Corporación',
        CREATE_OFFICE_NAME_LABEL: 'Nombre de la Sede *',
        CREATE_CONTACT_NAME_LABEL: 'Nombre de Contacto *',
        CREATE_CONTACT_PHONE_LABEL: 'Teléfono de Contacto *',
        CREATE_CONTACT_EMAIL_LABEL: 'Email de Contacto *',
        CREATE_COMMERCIAL_ADDRESS_LABEL: 'Dirección Comercial *',
        CREATE_CITY_LABEL: 'Ciudad *',
        CREATE_POSTAL_CODE_LABEL: 'Código Postal *',
        CREATE_ACTIVE_LABEL: 'Activa',
        YES: 'Sí',
        NO: 'No',
        CREATE_OFFICE_BUTTON: 'Crear Sede',
        CREATING: 'Creando...',
        VALIDATION_CORPORATION: 'Debe seleccionar una corporación.',
        VALIDATION_NAME: 'El nombre es obligatorio.',
        VALIDATION_CONTACT_NAME: 'El nombre de contacto es obligatorio.',
        VALIDATION_CONTACT_PHONE: 'El teléfono de contacto es obligatorio.',
        VALIDATION_CONTACT_EMAIL: 'El email de contacto es obligatorio y debe ser válido.',
        VALIDATION_COMMERCIAL_ADDRESS: 'La dirección comercial es obligatoria.',
        VALIDATION_CITY: 'La ciudad es obligatoria.',
        VALIDATION_POSTAL_CODE: 'El código postal es obligatorio.',
        CHECKLIST_TITLE: 'Orden de comprobación de criterios',
        CHECKLIST_DNI_LABEL: 'DNI',
        CHECKLIST_DNI_TEXT: ': el match se intenta si el documento del usuario coincide con el DNI del empleado corporativo.',
        CHECKLIST_PERSONAL_EMAIL_LABEL: 'Email personal',
        CHECKLIST_PERSONAL_EMAIL_TEXT: ': se comprueba si el email del usuario coincide con el email personal del empleado corporativo.',
        CHECKLIST_CORPORATE_EMAIL_LABEL: 'Email corporativo',
        CHECKLIST_CORPORATE_EMAIL_TEXT: ': se comprueba si el email del usuario coincide con el email corporativo del empleado.',
        CHECKLIST_PERSONAL_PHONE_LABEL: 'Teléfono personal',
        CHECKLIST_PERSONAL_PHONE_TEXT: ': se comprueba si el teléfono del usuario coincide con el teléfono personal del empleado corporativo.',
        CHECKLIST_CORPORATE_PHONE_LABEL: 'Teléfono corporativo',
        CHECKLIST_CORPORATE_PHONE_TEXT: ': se comprueba si el teléfono del usuario coincide con el teléfono corporativo del empleado.',
        SEARCH_PARKING_SPACE: 'Buscar Plaza Parking',
        SEARCH_PARKING_RESERVATION: 'Buscar Reserva Parking',
        SEARCH_USER: 'Buscar usuario',
        SEARCH_SHIFT: 'Buscar Turno',
        FILTERS: 'Filtros',
        APPLY_FILTERS: 'Aplicar filtros',
        CLEAR: 'Limpiar',
        CLOSE: 'Cerrar',
        CREATE_PARKING_SPACE: 'Crear Plaza Parking',
        RESERVE_PARKING_SPACE: 'Reservar Plaza Parking',
        ASSIGN_PARKING_CREDIT: 'Asignar cupón crédito parking',
        CREATE_SHIFT: 'Crear Turno',
        EDIT_BUTTON: 'Editar',
        EDIT_OFFICE_TITLE: 'Editar información general de la oficina',
        OFFICE_INFO_SECTION: 'Información de la oficina',
        CONTACT_INFO_SECTION: 'Información de contacto',
        COMMERCIAL_ADDRESS_SECTION: 'Dirección comercial',
        EDIT_OFFICE_NAME_LABEL: 'Nombre de la oficina',
        EDIT_CONTACT_NAME_LABEL: 'Nombre de contacto',
        EDIT_CONTACT_PHONE_LABEL: 'Teléfono de contacto',
        EDIT_CONTACT_EMAIL_LABEL: 'Email de contacto',
        EDIT_COMMERCIAL_ADDRESS_LABEL: 'Dirección comercial',
        EDIT_CITY_LABEL: 'Ciudad',
        EDIT_POSTAL_CODE_LABEL: 'Código postal',
        FIELD_REQUIRED: 'Campo requerido',
        EMAIL_INVALID_MODAL: 'Email inválido',
        OFFICE_ACTIVE: 'Oficina activa',
        CANCEL_BUTTON: 'Cancelar',
        SAVE_BUTTON: 'Guardar',
        SAVING: 'Guardando...',
        SUCCESS_TITLE: '¡Éxito!',
        ERROR_TITLE: 'Error',
        UPDATE_OFFICE_SUCCESS: 'La información de la oficina ha sido actualizada correctamente.',
        CREATE_OFFICE_SUCCESS: 'La sede ha sido creada correctamente.',
        DELETE_TITLE: 'Confirmar eliminación',
        DELETE_USER_SUCCESS: 'Usuario eliminado correctamente',
        DELETE_USER_ERROR: 'Error al eliminar el usuario',
      },
      CORPORATION_KPIS: {
        ERROR_TIMEOUT: 'La carga de los KPIs tardó demasiado tiempo',
        ERROR_LOAD: 'Error al cargar los KPIs de movilidad',
        PERIOD_CURRENT_MONTH: 'Mes actual',
        PERIOD_LAST_30_DAYS: 'Últimos 30 días',
        AS_OF: 'Actualizado a',
        LOADING: 'Cargando KPIs...',
        COMING_SOON: 'Próximamente',
        NO_PREVIOUS_DATA: 'Sin dato del mes anterior',
        REPARTO_MODAL_SOSTENIBLE: 'Reparto modal sostenible',
        CO2E_EVITADO: 'CO2e evitado',
        EMPLEADOS_COMPARTIENDO: 'Empleados compartiendo',
        CUESTIONARIO_MOVILIDAD: 'Cuestionario de movilidad',
        VIAJES_COMPARTIDOS: 'Viajes compartidos',
        KM_COMPARTIDOS: 'Km compartidos',
        USUARIOS_ACTIVOS: 'Usuarios activos',
        CONVERSION_CARPOOLING: 'Conversión a carpooling',
        OCUPACION_MEDIA_VEHICULO: 'Ocupación media del vehículo',
        AHORRO_ESTIMADO_EUR: 'Ahorro estimado',
        OCUPACION_PARKING: 'Ocupación de parking',
      },
      ROUTES_TOGGLE: {
        COUNT_LABEL: 'Rutinas · 24 h',
        SHOW: 'Mostrar rutinas',
        VISIBLE: 'Visibles en el mapa',
        HIDDEN: 'Ocultas en el mapa',
      },
      // Página Cartera: bolsa del mes, movimientos y cómo se paga la recarga mensual.
      CORPORATION_WALLET_PAGE: {
        RETRY: 'Reintentar',
        BAG: {
          LOADING: 'Cargando la bolsa…',
          LOAD_ERROR: 'No se ha podido cargar la bolsa.',
          MONTH_TITLE: 'Bolsa {{month}}',
          REMAINING: '{{remaining}} € quedan de {{total}} €',
          SPENT: 'Gastados {{amount}} €',
          RENEWS: 'Se renueva el {{date}}',
          MONTHLY_TITLE: 'Bolsa mensual de {{amount}} €',
          NEXT_CHARGE: 'Se recarga el {{date}}.',
          PENDING_PAYMENT: 'La recarga de este mes está pendiente: la bolsa se recarga al llegar el pago.',
          NOT_TOPPED_UP: 'La bolsa de este mes no se ha recargado porque el pago no ha llegado.',
          NONE_TITLE: 'Todavía no tienes bolsa',
          NONE_TEXT: 'Elige el importe y el método de pago',
          PARTNER_TITLE: 'Tu bolsa anual de movilidad',
          PARTNER_TEXT:
            'Tu bolsa sale del plan anual de {{partner}}: cada mes se recarga con su parte y lo que no se gasta se acumula.',
          PARTNER_PENDING_TEXT: 'La bolsa se activa cuando {{partner}} active tu plan anual.',
        },
        MOVEMENTS: {
          TITLE: 'Movimientos',
          SUBTITLE: 'Cada pago (−) y cada recarga (+) de la cartera.',
          EMPTY: 'Aquí verás cada pago y cada recarga.',
          LOAD_ERROR: 'No se han podido cargar los movimientos.',
          AMOUNT: '{{sign}}{{amount}} €',
          SHOW_ALL: 'Ver todos ({{count}})',
        },
        PAYMENT: {
          TITLE: 'Cómo se paga la bolsa',
          SUBTITLE: 'Se cobra el día 1 de cada mes por el importe de la bolsa.',
          AMOUNT_LABEL: 'Importe mensual',
          AMOUNT_HINT: 'En euros. Lo que no se gasta se acumula para el mes siguiente.',
          AMOUNT_ERROR: 'Escribe un importe mayor que 0.',
          AMOUNT_MAX_HINT: 'Hasta {{max}} € al mes.',
          AMOUNT_MAX_ERROR: 'El máximo es de {{max}} € al mes. Para un importe mayor, habla con WAIIS.',
          CONFIRM_TITLE: '¿Seguro que quieres una bolsa de {{amount}} € al mes?',
          CONFIRM_TEXT: 'Se cobrará el día 1 de cada mes.',
          CONFIRM_SAVE: 'Sí, guardar',
          METHOD_LABEL: 'Forma de pago',
          METHOD_HINT: 'La misma que la del plan.',
          CHANGE: 'Cambiar',
          CHOOSE_IN_PLAN: 'Elige la forma de pago en Plan',
          CARD: 'Tarjeta',
          CARD_LAST4: 'Tarjeta •••• {{last4}}',
          SEPA_DEBIT: 'Domiciliación bancaria (SEPA)',
          SEPA_DEBIT_LAST4: 'Domiciliación bancaria (SEPA) · •••• {{last4}}',
          BANK_TRANSFER: 'Transferencia con factura',
          DAY_ONE_NOTICE:
            'Si el pago no llega antes del día 1, la bolsa no se recarga hasta que entre. Te avisamos por correo 5 días antes.',
          ACTIVE: 'Recarga mensual activa',
          SAVE: 'Guardar',
          SAVING: 'Guardando…',
          SAVED: 'Bolsa mensual guardada',
          SAVE_ERROR: 'No se ha podido guardar. Inténtalo de nuevo.',
          DEACTIVATE: 'Desactivar la recarga mensual',
          DEACTIVATE_TITLE: '¿Desactivar la recarga mensual?',
          DEACTIVATE_TEXT: 'No se cobrará el próximo día 1. El saldo que tengas sigue en la cartera.',
          DEACTIVATE_CONFIRM: 'Desactivar',
          DEACTIVATING: 'Desactivando…',
          DEACTIVATED: 'Recarga mensual desactivada',
          PARTNER_MANAGED: 'El importe y el método los gestiona {{partner}}.',
        },
      },
      CORPORATION_WALLET: {
        BACK: 'Atrás',
        TITLE: 'Mi cartera',
        UPGRADE_TO_INCENTIVES_BANNER: 'Pásate al plan de incentivos para poder sacar el máximo rendimiento',
        AVAILABLE_BALANCE: 'SALDO DISPONIBLE',
        RETAINED_BALANCE: 'Saldo retenido',
        PAYMENT_SETTINGS: 'Métodos de pago y cobro',
        PAYMENT_METHODS_SECTION: 'Método de pago',
        PAYOUT_METHODS_SECTION: 'Método de cobro',
        TRANSACTIONS_HISTORY: 'Historial de transacciones',
        CHANGE_PAYMENT_METHOD: 'Cambiar método de pago',
        RECHARGE: 'Recargar',
        WITHDRAW: 'Retirar',
        RECHARGE_MODAL_TITLE: 'Recargar cartera',
        RECHARGE_AMOUNT: 'Importe a recargar',
        PAY_WITH: 'Pagar con',
        ADD_CARD: 'Añadir tarjeta',
        CANCEL: 'Cancelar',
        PROCESSING: 'Procesando...',
        CONTINUE: 'Continuar',
        WITHDRAW_MODAL_TITLE: 'Retirar saldo',
        AVAILABLE_BALANCE_LABEL: 'Saldo disponible',
        WITHDRAW_AMOUNT: 'Importe a retirar',
        DESTINATION_ACCOUNT: 'Cuenta de destino',
        ADD_BANK_ACCOUNT: 'Añadir cuenta bancaria',
        WITHDRAW_NOTE: 'El ingreso suele tardar 1-2 días hábiles.',
        REQUEST_WITHDRAWAL: 'Solicitar retirada',
        PAYMENT_METHOD: 'Método de pago',
        CHOOSE_CARD_HINT: 'Elige la tarjeta con la que recargar tu cartera.',
        EXPIRES: 'Caduca',
        REMOVE_CARD: 'Eliminar tarjeta',
        NO_SAVED_CARDS: 'Sin tarjetas guardadas',
        CLOSE: 'Cerrar',
        NEW_CARD_HINT: 'Introduce los datos de la nueva tarjeta.',
        STRIPE_SECURE_NOTE: 'Pago seguro gestionado por Stripe',
        SAVING: 'Guardando...',
        SAVE_CARD: 'Guardar tarjeta',
        BANK_ACCOUNT: 'Cuenta bancaria',
        CHOOSE_ACCOUNT_HINT: 'Elige la cuenta a la que retirar el saldo.',
        REMOVE_ACCOUNT: 'Eliminar cuenta',
        NO_SAVED_ACCOUNTS: 'Sin cuentas bancarias guardadas',
        ADD_BANK_ACCOUNT_SHORT: 'Añadir cuenta',
        NEW_ACCOUNT_HINT: 'Introduce los datos de la nueva cuenta bancaria.',
        IBAN: 'IBAN',
        ADDRESS: 'Dirección',
        ADDRESS_PLACEHOLDER: 'Calle, número, piso',
        CITY: 'Ciudad',
        POSTAL_CODE: 'Código postal',
        SAVE_ACCOUNT: 'Guardar cuenta',
        ACCOUNT_HOLDER: 'Titular (opcional)',
        ACCOUNT_HOLDER_PLACEHOLDER: 'Razón social de la empresa',
        ACCOUNT_HOLDER_HINT: 'Si lo dejas vacío, el titular es la razón social de la empresa.',
        KYB: {
          SECTION: 'Verificación',
          TITLE: 'Verificación de la empresa',
          STATUS_VERIFIED: 'Verificada',
          STATUS_PENDING: 'Pendiente',
          STATUS_VERIFIED_TEXT: 'Empresa verificada: ya puedes retirar saldo.',
          STATUS_PENDING_TEXT: 'Stripe aún no ha verificado la empresa: hasta entonces no se puede retirar saldo.',
          WITHDRAW_BLOCKED_TITLE: 'Falta verificar la empresa',
          WITHDRAW_BLOCKED_TEXT: 'Para poder transferir a tu cuenta, Stripe necesita saber quién representa y es titular de la empresa.',
          COMPLETE: 'Completar verificación',
          PERSONS_HINT: 'Declara a las personas que representan a la empresa, la administran o tienen más de un 25 % de ella. Cuando estén todas, confirma la lista.',
          NO_PERSONS: 'Aún no has declarado a nadie.',
          ADD_PERSON: 'Añadir persona',
          REMOVE_PERSON: 'Quitar persona',
          UNKNOWN_PERSON: 'Persona sin datos',
          ATTEST: 'Confirmar lista',
          ATTEST_HINT: 'Declara a Stripe que ya están todas las personas.',
          ATTESTED: 'Lista confirmada. Stripe puede tardar unos minutos en revisar los datos.',
          NEW_PERSON_HINT: 'Datos de la persona tal y como aparecen en su documento de identidad.',
          EDIT_PERSON_HINT: 'Revisa los datos de la persona.',
          FIRST_NAME: 'Nombre',
          LAST_NAME: 'Apellidos',
          DOB: 'Fecha de nacimiento',
          HOME_ADDRESS: 'Domicilio',
          ROLES: 'Cargo en la empresa',
          ROLES_REQUIRED: 'Marca al menos un cargo.',
          ROLE_REPRESENTATIVE: 'Representante legal',
          ROLE_REPRESENTATIVE_HINT: 'Puede actuar en nombre de la empresa.',
          ROLE_DIRECTOR: 'Administrador',
          ROLE_DIRECTOR_HINT: 'Forma parte del órgano de administración.',
          ROLE_EXECUTIVE: 'Directivo',
          ROLE_EXECUTIVE_HINT: 'Tiene un cargo de dirección (CEO, director general…).',
          ROLE_OWNER: 'Titular',
          ROLE_OWNER_HINT: 'Tiene participación en la empresa.',
          OWNERSHIP: 'Participación',
          OWNERSHIP_REQUIRED: 'Indica el porcentaje de participación del titular.',
          FORM_INCOMPLETE: 'Completa todos los campos.',
          SAVE_PERSON: 'Guardar persona',
          PERSON_UNVERIFIED: 'Sin verificar',
          PERSON_PENDING: 'En revisión',
          PERSON_VERIFIED: 'Verificada',
          ERROR_LOAD: 'No se han podido cargar las personas.',
          ERROR_SAVE: 'No se ha podido guardar la persona.',
          ERROR_DELETE: 'No se ha podido quitar la persona.',
          ERROR_ATTEST: 'No se ha podido confirmar la lista.',
          ERROR_NO_STRIPE_ACCOUNT: 'Primero añade una cuenta bancaria: es la que crea la cuenta de Stripe de la empresa.',
          ERROR_RECORDING_FAILED: 'La persona se ha enviado a Stripe, pero no se ha podido guardar. No lo intentes de nuevo y contacta con soporte.',
          ERROR_NO_PERSONS: 'Declara al menos una persona antes de confirmar la lista.',
          ERROR_PERSON_NOT_FOUND: 'Esta persona ya no existe.',
          ERROR_STRIPE_REJECTED: 'Stripe no ha aceptado los datos. Revísalos e inténtalo de nuevo.',
          DOCUMENT_MISSING: 'Falta documento',
          UPLOAD_DOCUMENT: 'Subir documento de identidad',
          DOCUMENT_HINT: 'Documento de identidad de {{name}}: DNI, NIE o pasaporte, por las dos caras si las tiene.',
          DOCUMENT_FRONT: 'Anverso',
          DOCUMENT_BACK: 'Reverso (opcional)',
          DOCUMENT_BACK_HINT: 'Obligatorio para DNI y NIE. El pasaporte no lo necesita.',
          DOCUMENT_PICK: 'Elegir fichero',
          DOCUMENT_FORMATS: 'JPG, PNG o PDF · máx. 10 MB',
          DOCUMENT_REMOVE: 'Quitar fichero',
          DOCUMENT_PRIVACY: 'Se envía directamente a Stripe: WAIIS no guarda el documento.',
          DOCUMENT_SEND: 'Enviar documento',
          DOCUMENT_SENDING: 'Enviando…',
          DOCUMENT_SENT: 'Documento enviado. Stripe puede tardar unos minutos en verificarlo.',
          DOCUMENT_INVALID_TYPE: 'Formato no admitido: usa JPG, PNG o PDF.',
          DOCUMENT_TOO_BIG: 'El fichero pesa más de 10 MB.',
          ERROR_DOCUMENT: 'No se ha podido enviar el documento.',
          ERROR_DOCUMENT_REJECTED: 'Stripe ha rechazado el documento. Comprueba que se lee bien y que es un DNI, NIE o pasaporte válido.',
        },
        TRANSACTIONS_SUBTITLE: 'Movimientos de la cartera WAIIS de tu empresa.',
        NO_TRANSACTIONS: 'Sin transacciones registradas',
        RECHARGE_ERROR: 'Error al recargar la cartera',
        RECHARGE_PENDING: 'La recarga se ha cobrado. El saldo se actualizará en unos minutos.',
        WITHDRAW_ERROR: 'Error al solicitar la retirada',
        WITHDRAW_INSUFFICIENT_BALANCE: 'Saldo insuficiente',
        WITHDRAW_SUBSCRIPTION_BALANCE: 'No puedes retirar el saldo adquirido por la suscripción',
        SELECT_CARD_ERROR: 'Error al seleccionar la tarjeta',
        REMOVE_CARD_ERROR: 'Error al eliminar la tarjeta',
        STRIPE_KEY_MISSING: 'Falta configurar la clave pública de Stripe.',
        START_CARD_ERROR: 'Error al iniciar el alta de tarjeta',
        CONFIRM_CARD_ERROR: 'Error al confirmar la tarjeta',
        SAVE_CARD_ERROR: 'Error al guardar la tarjeta',
        REMOVE_ACCOUNT_ERROR: 'Error al eliminar la cuenta',
        SAVE_ACCOUNT_ERROR: 'Error al guardar la cuenta bancaria',
        TODAY: 'Hoy',
        YESTERDAY: 'Ayer',
      },
      ROUTES_MAP: {
        OFFICE: 'Sede',
        OFFICE_LABEL: 'Sede',
        ALL_OFFICES: 'Todos los centros',
        NO_OFFICE_ACCESS: 'Sin acceso a ninguna sede',
        CO2_AVOIDED: 'CO₂ evitado',
        CO2_VALUE: '{{value}} kg CO₂e',
        PERIOD_30_DAYS: '30 días',
        LINKED_EMPLOYEES: 'Vinculados',
        PASSENGERS_PER_TRIP: 'Pasajeros por viaje',
        TRIPS_LAST_MONTH: 'Viajes · 30 días',
        HEADQUARTERS: {
          TITLE: '¿Dónde está tu sede central?',
          TEXT: 'Así situamos tu empresa en el mapa y verás los trayectos de tu plantilla.',
          PLACEHOLDER: 'Calle, número, ciudad',
          ADDRESS_LABEL: 'Dirección de la sede central',
          SAVE: 'Guardar',
          SAVING: 'Guardando…',
          ERROR: 'No se ha podido guardar la sede central.',
        },
        LEGEND: {
          LABEL: 'Leyenda del mapa',
          OFFICE: 'Sede',
          ROUTE: 'Trayecto · últimas 24 h',
        },
        NO_ROUTINES: {
          TITLE: 'Todavía no hay rutinas',
          TEXT: 'Aparecerán aquí cuando tu plantilla cree sus trayectos en la app.',
        },
      },
      COMPANY_OFFICE_DETAILS: {
        BACK: 'Volver',
        TITLE: 'Detalles Sede empresa',
        BASIC_INFO: 'Información básica',
        OFFICE_NAME: 'Nombre de la sede',
        CONTACT_PERSON: 'Persona de contacto',
        CONTACT_PHONE: 'Telefono de contacto',
        CONTACT_EMAIL: 'Email de contacto',
        ADDRESS: 'Dirección',
        CITY: 'Ciudad',
        POSTAL_CODE: 'Código postal',
        LOADING: 'Cargando...',
      },
      OFFICES_LISTING: {
        SEARCH_PLACEHOLDER: 'Buscar Sede',
        CREATE: 'Crear sede',
        EDIT_TITLE: 'Editar Sede',
        CREATE_TITLE: 'Crear Sede',
        COL_OFFICE: 'Sede',
        COL_LOCATION: 'Ubicación',
        COL_EMPLOYEES: 'Empleados',
        COL_LINKED: 'Vinculados',
        COL_ACTIVE: 'Activa',
        IMPORT_UNAVAILABLE_TITLE: 'Importación no disponible',
        IMPORT_UNAVAILABLE_TEXT: 'La importación masiva por CSV todavía no está disponible. No se ha guardado ningún dato.',
        UPDATE_SUCCESS_TEXT: 'Se ha modificado correctamente la sede',
        CREATE_SUCCESS_TEXT: 'Se ha creado correctamente la sede',
      },
      PRICING_CONFIG_FORM: {
        CREATE_TITLE: 'Crear configuración de precios',
        EDIT_TITLE: 'Editar configuración de precios',
        INTRO_TITLE: 'Configuración de precios tipo A',
        INTRO_TEXT:
          'Esta configuración define cuánto subvenciona la empresa, si WAIIS cofinancia, a quién aplica y qué límites tiene. Los importes fijos y límites por importe se envían en céntimos.',
        GUIDE_SUMMARY: 'Guía de campos y ejemplos',
        SUBSIDY_SECTION: 'Configuración de subvención',
        SUBSIDY_TYPE: 'Tipo de subvención',
        SUBSIDY_TYPE_HINT:
          '<strong>fixed</strong>: importe fijo en céntimos. <strong>percentage</strong>: porcentaje entero sobre el precio.',
        SUBSIDY_VALUE: 'Valor de subvención',
        SUBSIDY_VALUE_HINT:
          'Valor que aporta la corporación. Si el tipo es <strong>fixed</strong>, se informa en céntimos. Si es <strong>percentage</strong>, se informa como porcentaje entero.',
        WAIIS_SECTION: 'Cofinanciación de WAIIS',
        WAIIS_CONTRIBUTES: 'WAIIS contribuye',
        WAIIS_CONTRIBUTES_HINT:
          'Indica si WAIIS participa en la subvención junto con la empresa.',
        CONTRIBUTION_TYPE: 'Tipo de contribución',
        CONTRIBUTION_TYPE_HINT:
          'Define si la aportación de WAIIS es fija en céntimos o un porcentaje entero.',
        SELECT_TYPE: 'Seleccionar tipo',
        CONTRIBUTION_VALUE: 'Valor de contribución',
        CONTRIBUTION_VALUE_HINT:
          'Valor de la cofinanciación de WAIIS según el tipo seleccionado.',
        PRICE_SECTION: 'Configuración de precio',
        FINAL_PRICE_ZERO: 'Precio final cero',
        FINAL_PRICE_ZERO_HINT:
          'Si se activa, el precio final para la persona usuaria será 0.',
        RESTRICTIONS_SECTION: 'Restricciones',
        EMPLOYEES_ONLY: 'Solo empleados',
        EMPLOYEES_ONLY_HINT:
          'Restringe esta configuración a empleados de la corporación.',
        LIMIT_TYPE: 'Tipo de límite',
        LIMIT_TYPE_HINT:
          '<strong>none</strong>: sin límite. <strong>date</strong>: hasta una fecha concreta. <strong>amount</strong>: hasta consumir un importe máximo en céntimos.',
        LIMIT_DATE: 'Fecha límite',
        LIMIT_DATE_HINT:
          'Fecha máxima en la que esta configuración seguirá aplicando.',
        LIMIT_AMOUNT: 'Importe límite',
        LIMIT_AMOUNT_HINT:
          'Importe total máximo subvencionable para esta configuración, expresado en céntimos.',
        OTHER_SECTION: 'Otras opciones',
        BASE_PRICE_RECIPIENT: 'Receptor del precio base',
        BASE_PRICE_RECIPIENT_HINT:
          'Indica sobre qué precio base se calcula la subvención. En este modelo el valor esperado es <strong>route_driver</strong>.',
        ACTIVE: 'Activo',
        ACTIVE_HINT:
          'Permite activar o desactivar la configuración sin eliminarla.',
        REFUND_CREDITS: 'Devolver créditos',
        REFUND_CREDITS_HINT:
          'Define si los créditos deben devolverse cuando corresponda según la lógica del modelo económico.',
        CANCEL: 'Cancelar',
        CREATE: 'Crear',
        UPDATE: 'Actualizar',
        FIELD_GUIDE:
          '# Guía de Campos - Configuración de Precios Corporativos\n\n**Programa de subsidios de empresa para reducir el precio de viajes de sus usuarios.**\n\n---\n\n## Campos\n\n| Campo | Descripción |\n|-------|-------------|\n| **Corporation** | La empresa que corre con el subsidio. Identifica a quién pertenece esta configuración. |\n| **Active** | ✅ Activada / ❌ Inactiva. Las inactivas no aplican a ningún viaje. |\n| **Subsidy Type** | Tipo de descuento: `fixed` (cantidad fija: 250 = 2,50€) o `percentage` (porcentaje: 50 = 50%). |\n| **Subsidy Value** | Monto del descuento. Si `fixed`: céntimos. Si `percentage`: 0-100. Ej: 300 céntimos = 3€. |\n| **Waiis Contributes** | ✅ WAIIS añade dinero adicional / ❌ No. Úsalo para forzar precio 0€ si es necesario. |\n| **Waiis Contribution Type** | Solo si contribuye WAIIS y el precio final no es 0: `fixed` o `percentage`. Ej: 400 céntimos = 4€ adicionales. |\n| **Waiis Contribution Value** | Cantidad que aporta WAIIS. Mismo formato que Subsidy Value. |\n| **Final Price Zero** | ✅ Fuerza precio = 0€ / ❌ No. Si activado y el subsidio no cubre 100%, WAIIS completa automáticamente. |\n| **Applies to Employees Only** | ✅ Solo empleados verificados / ❌ Cualquier usuario. |\n| **Limit Type** | Tipo de límite: `none` (sin límite), `date` (hasta fecha), `amount` (máximo gasto en €). |\n| **Limit Date** | Válido si `Limit Type = date`. Fecha hasta la que aplica el subsidio (ej: 2026-12-31). |\n| **Limit Amount** | Válido si `Limit Type = amount`. Gasto máximo en céntimos (ej: 500000 = 5.000€). |\n| **Consumed Amount** | Solo lectura. Gasto actual acumulado. Cuando llega a `Limit Amount`, se desactiva. |\n| **Base Price Recipient** | Quién recibe el precio base: normalmente `route_driver` (el conductor del viaje). |\n| **Refund Credits** | ✅ Acumular créditos post-viaje / ❌ Descuento directo. Ej: viaje 10€, descuento 3€ -> paga 7€ + 3€ créditos vs solo 7€. |\n| **Runners** | Corredores (rutas) donde aplica. Ej: Barcelona-Sabadell, Barcelona-Terrassa. Si vacío, no aplica. |\n\n---\n\n## Ejemplos rápidos\n\n### ✅ Subsidio simple (25% para empleados Telefónica)\n- **Subsidy Type:** `percentage` | **Value:** `25`\n- **Applies to Employees Only:** ✅ Sí\n- **Limit Type:** `none`\n- **Runners:** Barcelona-Sabadell, Barcelona-Terrassa\n- **Resultado:** Empleados pagan 25% menos, sin límite de gasto.\n\n### ✅ Viajes gratis (empresa 6€ + WAIIS 4€)\n- **Subsidy Type:** `fixed` | **Value:** `600`\n- **Waiis Contributes:** ✅ Sí | **Type:** `fixed` | **Value:** `400`\n- **Final Price Zero:** ✅ Sí\n- **Applies to Employees Only:** ✅ Sí\n- **Limit Type:** `date` | **Date:** `2026-12-31`\n- **Resultado:** Empleados Google pagan 0€ hasta fin de año.\n\n### ✅ Centro logístico (30% para cualquiera, máx 5.000€)\n- **Subsidy Type:** `percentage` | **Value:** `30`\n- **Applies to Employees Only:** ❌ No\n- **Limit Type:** `amount` | **Amount:** `500000` (céntimos)\n- **Runners:** Barcelona-CentroATM, CentroATM-Barcelona\n- **Resultado:** Cualquiera recibe 30% descuento, hasta agotar 5.000€.\n\n### ✅ Fidelización con créditos (10% para empleados)\n- **Subsidy Type:** `percentage` | **Value:** `10`\n- **Refund Credits:** ✅ Sí\n- **Applies to Employees Only:** ✅ Sí\n- **Limit Type:** `none`\n- **Resultado:** Empleados pagan 10% menos y reciben ese descuento como créditos regalados.',
      },
      PRICING_CONFIGS_LIST: {
        HOW_TO_READ_TITLE: 'Cómo leer este listado',
        HOW_TO_READ_TEXT:
          'Los valores fijos y límites por importe se muestran en céntimos. Los porcentajes se muestran como enteros. Cada fila representa una regla de subvención aplicable a una corporación y, opcionalmente, a corredores concretos.',
        GUIDE_SUMMARY: 'Guía de campos y ejemplos',
        CREATE_CONFIG: 'Crear configuración',
        LOADING: 'Cargando...',
        EMPTY:
          'No se han encontrado configuraciones de precios. Cree una para empezar.',
        COL_SUBSIDY_TYPE: 'subsidy_type',
        COL_SUBSIDY_VALUE: 'subsidy_value',
        COL_WAIIS_CONTRIBUTES: 'waiis_contributes',
        COL_WAIIS_CONTRIBUTION_TYPE: 'waiis_contribution_type',
        COL_WAIIS_CONTRIBUTION_VALUE: 'waiis_contribution_value',
        COL_FINAL_PRICE_ZERO: 'final_price_zero',
        COL_APPLIES_TO_EMPLOYEES_ONLY: 'applies_to_employees_only',
        COL_LIMIT_TYPE: 'limit_type',
        COL_LIMIT_DATE: 'limit_date',
        COL_LIMIT_AMOUNT: 'limit_amount',
        COL_BASE_PRICE_RECIPIENT: 'base_price_recipient',
        COL_CONSUMED_AMOUNT: 'consumed_amount',
        COL_REFUND_CREDITS: 'refund_credits',
        COL_ACTIVE: 'active',
        COL_ACTIONS: 'Acciones',
        YES: 'Sí',
        NO: 'No',
        EDIT_RUNNERS: 'Editar corredores',
        EDIT_CONFIG: 'Editar configuración',
        DELETE_CONFIG: 'Eliminar configuración',
        LOAD_ERROR_TITLE: 'Error',
        LOAD_ERROR_TEXT: 'No se han podido cargar las configuraciones de precios',
        CREATE_SUCCESS_TITLE: 'Éxito',
        CREATE_SUCCESS_TEXT: 'Configuración de precios creada correctamente',
        CREATE_ERROR_TEXT: 'No se ha podido crear la configuración de precios',
        UPDATE_SUCCESS_TITLE: 'Éxito',
        UPDATE_SUCCESS_TEXT: 'Configuración de precios actualizada correctamente',
        UPDATE_ERROR_TEXT: 'No se ha podido actualizar la configuración de precios',
        DELETE_CONFIRM_TITLE: '¿Eliminar configuración?',
        DELETE_CONFIRM_TEXT:
          '¿Está seguro de que desea eliminar esta configuración de precios?',
        DELETE_CONFIRM_BUTTON: 'Eliminar',
        DELETE_CANCEL_BUTTON: 'Cancelar',
        DELETE_SUCCESS_TITLE: 'Eliminada',
        DELETE_SUCCESS_TEXT: 'Configuración de precios eliminada correctamente',
        DELETE_ERROR_TEXT: 'No se ha podido eliminar la configuración de precios',
      },
      PRICING_RUNNERS_MODAL: {
        TITLE: 'Gestionar corredores de la configuración de precios',
        LOADING: 'Cargando...',
        SEARCH_PLACEHOLDER: 'Buscar corredores...',
        NO_RUNNERS: 'No se han encontrado corredores.',
        RUNNER_ID: 'ID: {{id}}',
        SELECTED_COUNT: 'Seleccionados: {{selected}} de {{total}}',
        CLEAR_ALL: 'Limpiar todo',
        CANCEL: 'Cancelar',
        SAVE_RUNNERS: 'Guardar corredores',
        MISSING_ID_TITLE: 'Error',
        MISSING_ID_TEXT: 'Falta el id de la configuración de precios',
        LOAD_ERROR_TITLE: 'Error',
        LOAD_ERROR_TEXT:
          'No se han podido cargar los corredores. La solicitud puede haber caducado o devuelto una respuesta inesperada.',
        SAVE_SUCCESS_TITLE: 'Éxito',
        SAVE_SUCCESS_TEXT: 'Corredores sincronizados correctamente',
        SAVE_ERROR_TITLE: 'Error',
        SAVE_ERROR_TEXT: 'No se han podido sincronizar los corredores',
      },
      SUBSIDY_FORM: {
        CREATE_TITLE: 'Crear subvención',
        EDIT_TITLE: 'Editar subvención',
        MODE: 'Modo',
        SELECT_MODE: 'Seleccionar modo',
        MODE_REQUIRED: 'El modo es obligatorio',
        AMOUNT: 'Importe',
        AMOUNT_REQUIRED: 'El importe es obligatorio',
        MAX_SUBSIDY: 'Subvención máxima',
        MAX_SUBSIDY_REQUIRED: 'La subvención máxima es obligatoria',
        MAX_SUBSIDY_PER_USER: 'Subvención máxima por usuario',
        MAX_SUBSIDY_PER_USER_REQUIRED: 'El máximo por usuario es obligatorio',
        CANCEL: 'Cancelar',
        CREATE: 'Crear',
        UPDATE: 'Actualizar',
      },
      SUBSIDIES_LIST: {
        TITLE: 'Subvenciones',
        CREATE_SUBSIDY: 'Crear subvención',
        LOADING: 'Cargando...',
        EMPTY: 'No se han encontrado subvenciones. Cree una para empezar.',
        COL_MODE: 'Modo',
        COL_AMOUNT: 'Importe',
        COL_MAX_SUBSIDY: 'Subvención máxima',
        COL_MAX_PER_USER: 'Máximo por usuario',
        COL_ACTIONS: 'Acciones',
        LOAD_ERROR_TITLE: 'Error',
        LOAD_ERROR_TEXT: 'No se han podido cargar las subvenciones',
        LIMIT_TITLE: 'Límite alcanzado',
        LIMIT_TEXT: 'Solo se permite una subvención por corporación',
        CREATE_SUCCESS_TITLE: 'Éxito',
        CREATE_SUCCESS_TEXT: 'Subvención creada correctamente',
        CREATE_ERROR_TEXT: 'No se ha podido crear la subvención',
        UPDATE_SUCCESS_TITLE: 'Éxito',
        UPDATE_SUCCESS_TEXT: 'Subvención actualizada correctamente',
        UPDATE_ERROR_TEXT: 'No se ha podido actualizar la subvención',
        DELETE_CONFIRM_TITLE: '¿Eliminar subvención?',
        DELETE_CONFIRM_TEXT:
          '¿Está seguro de que desea eliminar esta subvención?',
        DELETE_CONFIRM_BUTTON: 'Eliminar',
        DELETE_CANCEL_BUTTON: 'Cancelar',
        DELETE_SUCCESS_TITLE: 'Eliminada',
        DELETE_SUCCESS_TEXT: 'Subvención eliminada correctamente',
        DELETE_ERROR_TEXT: 'No se ha podido eliminar la subvención',
      },
      SUBSIDY_CONSUMPTION_FORM: {
        CREATE_TITLE: 'Crear consumo',
        EDIT_TITLE: 'Editar consumo',
        USER_ID: 'ID de usuario',
        USER_ID_PLACEHOLDER: 'Introduzca el ID de usuario (UUID)',
        USER_ID_REQUIRED: 'El ID de usuario es obligatorio',
        ROUTE_ID: 'ID de ruta de pooling',
        ROUTE_ID_PLACEHOLDER: 'Introduzca el ID de ruta (UUID)',
        ROUTE_ID_REQUIRED: 'El ID de ruta es obligatorio',
        AMOUNT: 'Importe',
        AMOUNT_REQUIRED: 'El importe es obligatorio',
        WAIIS_AMOUNT: 'Importe WAIIS',
        WAIIS_AMOUNT_REQUIRED: 'El importe WAIIS es obligatorio',
        CANCEL: 'Cancelar',
        CREATE: 'Crear',
        UPDATE: 'Actualizar',
      },
      SUBSIDY_CONSUMPTIONS_LIST: {
        TITLE: 'Consumos de subvención',
        CREATE_CONSUMPTION: 'Crear consumo',
        SELECT_CONFIG_LABEL: 'Seleccionar configuración de precios',
        SELECT_CONFIG_PLACEHOLDER: '-- Seleccione una configuración --',
        LOADING: 'Cargando...',
        EMPTY:
          'No se han encontrado consumos para esta configuración. Cree uno para empezar.',
        COL_USER_ID: 'ID de usuario',
        COL_ROUTE_ID: 'ID de ruta',
        COL_AMOUNT: 'Importe',
        COL_WAIIS_AMOUNT: 'Importe WAIIS',
        COL_ACTIONS: 'Acciones',
        EDIT: 'Editar',
        DELETE: 'Eliminar',
        LOAD_ERROR_TITLE: 'Error',
        LOAD_ERROR_TEXT: 'No se han podido cargar los consumos',
        CREATE_SUCCESS_TITLE: 'Éxito',
        CREATE_SUCCESS_TEXT: 'Consumo creado correctamente',
        CREATE_ERROR_TEXT: 'No se ha podido crear el consumo',
        UPDATE_SUCCESS_TITLE: 'Éxito',
        UPDATE_SUCCESS_TEXT: 'Consumo actualizado correctamente',
        UPDATE_ERROR_TEXT: 'No se ha podido actualizar el consumo',
        DELETE_CONFIRM_TITLE: '¿Eliminar consumo?',
        DELETE_CONFIRM_TEXT:
          '¿Está seguro de que desea eliminar este registro de consumo?',
        DELETE_CONFIRM_BUTTON: 'Eliminar',
        DELETE_CANCEL_BUTTON: 'Cancelar',
        DELETE_SUCCESS_TITLE: 'Eliminado',
        DELETE_SUCCESS_TEXT: 'Consumo eliminado correctamente',
        DELETE_ERROR_TEXT: 'No se ha podido eliminar el consumo',
        PAGE_NAME: 'Bonificación',
        SUBTITLE:
          'Configura la aportación económica por trayecto compartido para tus empleados.',
        BOX_LABEL: 'Bonificación que la empresa aporta por trayecto',
        PER_TRIP: '€/trayecto',
        EDIT_PRICE: 'Editar precio',
        STATUS_ACTIVE: 'Bonificación activa',
        EXPLANATION:
          'Este precio es el que se le aplica como bonificación a los viajes que hagan los empleados de {{scope}}.',
        ALL_OFFICES: 'Todos los centros',
        WHOLE_COMPANY: 'toda la empresa',
        CANCEL: 'Cancelar',
        SAVE_CONFIG: 'Guardar configuración',
        SAVE_SUCCESS_TITLE: 'Guardado',
        SAVE_SUCCESS_TEXT: 'Bonificación guardada con éxito',
        SAVE_ERROR_TITLE: 'Error',
        SAVE_ERROR_TEXT: 'No se pudo guardar la bonificación',
        OFFICES_HEADER: 'Bonificación por sede',
        NO_OFFICE_CONFIG: 'Sin configurar (aplica la de empresa)',
        BLOCKED_WARNING: 'Bonificación bloqueada por impago. Se desbloqueará automáticamente al saldarse la deuda.',
      },
      POOLING_RUNNERS: {
        PER_MONTH: '{{amount}} €/mes',
        TITLE: 'Configuración de corredores',
        LOADING: 'Cargando...',
        EMPTY: 'No hay corredores asociados a esta corporación.',
        LOAD_ERROR_TEXT: 'No se han podido cargar los corredores',
        COL_NAME: 'name',
        COL_DESCRIPTION: 'description',
        COL_COLOR: 'color',
        COL_CREATED_AT: 'created_at',
        COL_UPDATED_AT: 'updated_at',
        MODAL_TITLE: 'Editar corredor',
        NAME_LABEL: 'name',
        NAME_REQUIRED: 'El nombre es obligatorio.',
        DESCRIPTION_LABEL: 'description',
        COLOR_LABEL: 'color',
        COLOR_INVALID:
          'El color debe tener formato hexadecimal, por ejemplo #009640.',
        CANCEL: 'Cancelar',
        SAVE: 'Guardar cambios',
        SAVE_SUCCESS_TITLE: 'Éxito',
        SAVE_SUCCESS_TEXT: 'Corredor actualizado correctamente',
        SAVE_ERROR_TITLE: 'Error',
        SAVE_ERROR_TEXT: 'No se ha podido actualizar el corredor',
        FLEET_PAGE_NAME: 'Flota',
        FLEET_MOCK_MODE: 'Datos de ejemplo',
        FLEET_REAL_MODE: 'Datos reales',
        FLEET_ALL_OFFICES: 'Todos los centros',
        FLEET_HEADER_TITLE: 'Flota',
        FLEET_HEADER_DESC:
          'Control económico de los vehículos y modelo de retorno de tu corporación.',
        FLEET_KPI_REVENUE_GENERATED: 'Ingresos generados (mes pasado)',
        FLEET_KPI_TOTAL_REVENUE: 'Ingresos totales acumulados',
        FLEET_RETURN_MODEL_TITLE: 'Modelo de retorno de la flota',
        FLEET_RETURN_MODEL_TOOLTIP: 'Configuración de CAEs y retorno',
        FLEET_RETURN_MODEL_DESC:
          'Elige el porcentaje del retorno económico que recibirá la empresa por cada viaje. Un retorno del 50% equivale a asignar a la empresa el 100% del valor generado por los Certificados de Ahorro Energético (CAEs).',
        FLEET_SLIDER_LABEL:
          'Porcentaje que se queda la empresa de cada pasajero',
        FLEET_INCOME_LABEL: 'Ingreso estimado con este porcentaje',
        FLEET_SAVE_MODEL_BUTTON: 'Guardar modelo',
        FLEET_VEHICLES_TITLE: 'Vehículos de la flota',
        FLEET_UPLOAD_CSV_BUTTON: 'Subir CSV',
        FLEET_ADD_VEHICLE_BUTTON: 'Añadir vehículo',
        FLEET_COL_VEHICLE: 'VEHÍCULO',
        FLEET_COL_OFFICE: 'SEDE ASIGNADA',
        FLEET_COL_DRIVER: 'CONDUCTOR',
        FLEET_COL_CAES: 'CAES GENERADOS',
        FLEET_ASSIGN_DRIVER_LINK: 'Asignar conductor',
        FLEET_EDIT_TOOLTIP: 'Editar',
        FLEET_DELETE_TOOLTIP: 'Eliminar',
        FLEET_EMPTY_VEHICLES: 'No hay vehículos en esta flota.',
        FLEET_LOADING_VEHICLES: 'Cargando vehículos...',
        FLEET_VEHICLE_MODAL_EDIT_TITLE: 'Editar vehículo',
        FLEET_VEHICLE_MODAL_ADD_TITLE: 'Añadir vehículo',
        FLEET_LICENSE_PLATE_LABEL: 'Matrícula',
        FLEET_LICENSE_PLATE_PLACEHOLDER: '0000 XYZ',
        FLEET_BRAND_LABEL: 'Marca',
        FLEET_BRAND_PLACEHOLDER: 'Toyota',
        FLEET_MODEL_LABEL: 'Modelo',
        FLEET_MODEL_PLACEHOLDER: 'Corolla',
        FLEET_COLOR_LABEL: 'Color',
        FLEET_SEATS_LABEL: 'Plazas disponibles',
        FLEET_FUEL_TYPE_LABEL: 'Combustible',
        FLEET_FUEL_TYPE_GASOLINE: 'Gasolina',
        FLEET_FUEL_TYPE_DIESEL: 'Diésel',
        FLEET_FUEL_TYPE_ELECTRIC: 'Eléctrico',
        FLEET_FUEL_TYPE_HYBRID: 'Híbrido',
        FLEET_OFFICE_LABEL: 'Sede asignada',
        FLEET_SELECT_OFFICE_PLACEHOLDER: 'Selecciona una sede',
        FLEET_DRIVER_LABEL: 'Conductor',
        FLEET_DRIVER_SEARCH_MIN_CHARS: 'Escribe al menos 2 letras...',
        FLEET_DRIVER_SEARCH_PLACEHOLDER: 'Buscar empleado...',
        FLEET_IMPORT_MODAL_TITLE: 'Importar vehículos por CSV',
        FLEET_OFFICE_ONLY_LABEL: 'Sede',
        FLEET_CSV_FILE_LABEL: 'Archivo CSV',
        FLEET_DOWNLOAD_TEMPLATE: 'Descargar plantilla de ejemplo',
        FLEET_DOWNLOADING_TEMPLATE: 'Descargando plantilla...',
        FLEET_IMPORT_BUTTON: 'Importar',
        FLEET_MISSING_DATA_TITLE: 'Faltan datos',
        FLEET_MISSING_DATA_TEXT: 'Completa matrícula, sede y las características del vehículo (marca, modelo, color, plazas y combustible)',
        FLEET_MISSING_OFFICE_TITLE: 'Falta la sede',
        FLEET_MISSING_OFFICE_TEXT: 'Debes seleccionar una sede',
        FLEET_MISSING_FILE_TITLE: 'Falta el archivo',
        FLEET_MISSING_FILE_TEXT: 'Debes seleccionar un archivo CSV',
        FLEET_MOCK_IMPORT_TITLE: 'Simulación',
        FLEET_MOCK_IMPORT_TEXT:
          'En modo datos de ejemplo la importación no se envía al backend.',
        FLEET_SAVED_TITLE: 'Guardado',
        MODEL_SAVED_TEXT: 'Modelo de retorno guardado correctamente',
        MODEL_SAVE_ERROR_TEXT: 'No se pudo guardar el modelo de retorno',
        FLEET_VEHICLE_SAVED_TEXT: 'Vehículo guardado con éxito',
        FLEET_VEHICLE_SAVE_ERROR_TEXT: 'No se pudo guardar el vehículo',
        FLEET_DELETE_CONFIRM_TITLE: '¿Eliminar vehículo?',
        FLEET_DELETE_CONFIRM_TEXT: 'Se eliminará el vehículo {{plate}}.',
        FLEET_DELETE_CONFIRM_BUTTON: 'Eliminar',
        FLEET_DELETED_TITLE: 'Eliminado',
        FLEET_VEHICLE_DELETED_TEXT: 'Vehículo eliminado',
        FLEET_VEHICLE_DELETE_ERROR_TEXT: 'No se pudo eliminar el vehículo',
        FLEET_IMPORTED_TITLE: 'Importado',
        FLEET_IMPORTED_TEXT: 'Vehículos importados con éxito',
        FLEET_IMPORT_ERROR_TEXT: 'No se pudo importar el archivo CSV',
      },
      SHIFTS_LIST: {
        SELECT_OFFICE: 'Selecciona una sede:',
        SEARCH_PLACEHOLDER: 'Buscar Turno',
        FILTERS: 'Filtros',
        FILTERS_TITLE: 'Filtros',
        CLOSE: 'Cerrar',
        DATE_PLACEHOLDER: 'Seleccione fecha',
        APPLY_FILTERS: 'Aplicar filtros',
        CLEAR: 'Limpiar',
        EXPORT_CSV: 'Exportar CSV',
        CREATE_SHIFT: 'Crear Turno',
        COL_CODE: 'Código',
        COL_SHIFT: 'Turno',
        COL_START: 'Entrada',
        COL_END: 'Salida',
        COL_ACTIVE: 'Activo',
        EDIT_TITLE: 'Editar Turno',
        CREATE_TITLE: 'Crear Turno',
      },
      SHIFT_DETAILS: {
        BACK: 'Volver',
        TITLE: 'Detalles Turno',
        ID: 'Id',
        CODE: 'Código',
        NAME: 'Nombre del turno',
        START_TIME: 'Hora de entrada',
        END_TIME: 'Hora de salida',
        OFFICE: 'Sede',
        LOADING: 'Cargando...',
      },
      SHIFT_FORM: {
        CLOSE: 'Cerrar',
        CANCEL: 'Cancelar',
        ACCEPT: 'Aceptar',
        ACTIVE: 'Activo',
        NAME_LABEL: 'Nombre del turno',
        NAME_REQUIRED: 'El nombre es obligatorio',
        START_TIME_LABEL: 'Hora de entrada',
        TIME_PLACEHOLDER: 'HH:MM',
        START_TIME_REQUIRED: 'La hora de entrada es obligatoria',
        END_TIME_LABEL: 'Hora de salida',
        END_TIME_REQUIRED: 'La hora de salida es obligatoria',
        WAIT: 'Espera por favor...',
        LOADING: 'Cargando...',
        SUCCESS_TITLE: '¡Correcto!',
        UPDATE_SUCCESS_TEXT: 'Turno actualizado correctamente',
        CREATE_SUCCESS_TEXT: 'Turno creado correctamente',
        ERROR_TITLE: 'Error',
      },
      GETTING_STARTED: {
        STEP_EMPLOYEES: {
          METHOD_AUTONOMOUS_NAME: 'Registro autónomo',
          METHOD_AUTONOMOUS_DESC: 'No necesitas subir ningún archivo. Comparte el enlace y el código; tu equipo se vincula solo a este dashboard al registrarse.',
          METHOD_TEMPLATE_NAME: 'Cargar plantilla',
          METHOD_TEMPLATE_DESC: 'Si prefieres pre-cargar tu lista de empleados antes de que se registren, para controlar quién tiene acceso.',
          SHARE_CODE_LABEL: 'Código de empresa',
          COPY_CODE_BUTTON: 'Copiar código',
          SHARE_CODE_HELP: 'Cada empleado lo introduce al registrarse desde su perfil para vincularse a este dashboard.',
          SHARE_LINK_LABEL: 'Enlace de invitación',
          COPY_LINK_BUTTON: 'Copiar enlace',
          SHARE_LINK_HELP: 'Enlace directo que abre la app de WAIIS con el código de empresa ya precargado.',
          INVITE_MESSAGE_LABEL_ALT: 'Mensaje de invitación',
          COPY_MESSAGE_BUTTON: 'Copiar mensaje de invitación',
          COPY_MESSAGE_HELP: 'Puedes editar el texto antes de copiarlo. Se pegará en Slack, WhatsApp, Teams o correo con el enlace y el código ya incluidos.',
          INVITE_UNAVAILABLE: 'El código de empresa y el enlace de invitación no están disponibles ahora mismo. Vuelve a intentarlo en unos minutos o contacta con soporte.',
          COPIED_SUFFIX: 'copiado',
          INVITE_MESSAGE_BODY: '¡Hola!\n\nDesde **{{company}}** hemos activado **WAIIS**, la app para compartir coche con compañeros en el trayecto al trabajo: ahorras dinero, vas más cómodo y reduces emisiones.\n\n**Unirte lleva menos de 2 minutos:**\n\n**1.** Descarga la app WAIIS en tu móvil (disponible en App Store y Google Play).\n\n**2.** Desde el móvil, pulsa este enlace para vincularte a la empresa automáticamente y recibir ventajas en WAIIS:\n\n{{link}}\n\n¿El enlace no se abre o ya tenías la app? Abre WAIIS, regístrate y en **Perfil → Mi organización** introduce este código de empresa:\n\n{{code}}\n\n¡Y listo! Ya puedes empezar a compartir trayecto con quien viva o trabaje cerca de ti.\n\n¿Tienes alguna duda? Escríbenos mediante el chat de soporte en la app.\n\n¡Nos vemos en **WAIIS**!',
          INVITE_MESSAGE_COMPANY_FALLBACK: 'tu empresa',
        },
        STEP_PAYMENT: {
          ADD_CARD_BUTTON: 'Añadir tarjeta de pago',
          CARD_DATA_LABEL: 'Datos de la tarjeta',
          SAVE_CARD: 'Guardar tarjeta',
          SAVING_CARD: 'Guardando...',
          CANCEL_CARD: 'Cancelar',
          LOADING_CARDS: 'Cargando tarjetas...',
          DEFAULT_BADGE: 'Predeterminada',
          SET_DEFAULT: 'Hacer predeterminada',
          REMOVE: 'Eliminar',
          STRIPE_MISCONFIGURED: 'La pasarela de pago no está configurada (falta la clave pública de Stripe). Contacta con soporte.',
          SETUP_INTENT_ERROR: 'No se ha podido iniciar el alta de la tarjeta. Inténtalo de nuevo.',
          CARD_INIT_ERROR: 'No se ha podido cargar el formulario de tarjeta.',
          CARD_DECLINED: 'No se ha podido validar la tarjeta. Revisa los datos e inténtalo de nuevo.',
          ATTACH_ERROR: 'La tarjeta se validó pero no se pudo asociar a la empresa. Inténtalo de nuevo.',
        },
      },
      SUBSCRIPTION_FEATURES: {
        OVERVIEW: 'Resumen general',
        OFFICE_BREAKDOWN: 'Desglose por sede',
        CAE_CARPOOLING: 'CAE de movilidad',
        CAE_FLEET: 'CAE de Flota',
        INCENTIVES: 'Gestión de incentivos',
        WALLET: 'Wallet / fondo de incentivos',
        TRIP_BONIFICATION: 'Bonificación por trayecto',
        PSMT_DRAFT: 'Borrador PMST / PDE',
        ADVANCED_REPORTS: 'Informes avanzados',
        USER_MANAGEMENT: 'Gestión de usuarios',
        ADD_OFFICES: 'Alta de sedes adicionales',
        BILLING: 'Facturación e historial de pagos',
        NEW_DASHBOARD_FEATURES: 'Nuevas funciones del dashboard',
      },
      CORPORATION_PLAN: {
        TITLE: 'Plan',
        SUBTITLE: 'Plan contratado por tu empresa y sus condiciones.',
        LOADING: 'Cargando plan...',
        DEADLINE_LABEL: 'Fecha límite:',
        ACCESS_BLOCKED: 'El acceso al dashboard está bloqueado: no hay ninguna suscripción activa. Elige un plan para reactivarlo.',
        STATUS_LABEL: 'Estado:',
        DAYS_REMAINING_LABEL: 'Días restantes:',
        ENDS_AT_LABEL: 'Vence:',
        CURRENT_PLAN_BADGE: 'PLAN ACTUAL',
        PREVIEW_CALCULATING: 'Calculando cambios...',
        PREVIEW_DOWNGRADE: 'Este cambio es un downgrade',
        PREVIEW_UPGRADE: 'Este cambio es una mejora de plan',
        PREVIEW_GAIN: 'Ganas',
        PREVIEW_LOSS: 'Pierdes',
        CARD_SECTION_TITLE: 'Añade una tarjeta de crédito',
        CARD_SECTION_TEXT: 'El Plan de Incentivos requiere una tarjeta de crédito registrada.',
        CONFIRM_BUTTON: 'Confirmar cambio de plan',
        CANCEL_BUTTON: 'Dar de baja la suscripción',
        PLAN_NOT_AVAILABLE_TITLE: 'Plan no disponible',
        CARD_REQUIRED_TITLE: 'Falta la tarjeta de crédito',
        CARD_REQUIRED_TEXT: 'Añade una tarjeta de crédito para poder continuar con el Plan de Incentivos.',
        UPDATE_SUCCESS_TITLE: 'Plan actualizado',
        UPDATE_SUCCESS_TEXT: 'El cambio de plan se ha aplicado correctamente.',
        UPDATE_ERROR_TITLE: 'No se pudo cambiar el plan',
        UPDATE_ERROR_GENERIC: 'No se ha podido cambiar el plan. Inténtalo de nuevo.',
        CANCEL_CONFIRM_TITLE: '¿Dar de baja la suscripción?',
        CANCEL_CONFIRM_TEXT: 'La empresa dejará de tener un plan activo. Podrás elegir uno nuevo cuando quieras.',
        CANCEL_CONFIRM_BUTTON: 'Dar de baja',
        CANCEL_CANCEL_BUTTON: 'Cancelar',
        CANCEL_SUCCESS_TITLE: 'Suscripción dada de baja',
        CANCEL_ERROR_TITLE: 'Error',
        CANCEL_ERROR_GENERIC: 'No se ha podido dar de baja la suscripción.',
        LOAD_ERROR: 'No se ha podido cargar el plan.',
        RETRY: 'Reintentar',
        TRIAL_CARD: {
          PRE_LAUNCH_TITLE: 'Prueba gratuita de 3 meses',
          PRE_LAUNCH_TAG: 'Empieza al añadir empleados',
          NO_COMMITMENT: 'Sin compromiso · sin permanencia',
          TRIAL_TITLE: 'Prueba gratuita · quedan {{days}} días',
          TRIAL_TITLE_ONE: 'Prueba gratuita · queda 1 día',
          TRIAL_TEXT: 'Termina el {{date}}. No se cobra nada hasta entonces.',
          TRIAL_TEXT_COMPLETE: 'Termina el {{date}}. Después empieza el Plan Incentivos.',
          TRIAL_DAY_TAG: 'Día {{day}} de {{total}}',
          LOCKED_TITLE: 'Tu prueba terminó el {{date}}',
          LOCKED_TEXT: 'El dashboard está bloqueado hasta que completes tu cuenta. La app de tu plantilla sigue funcionando.',
          LOCKED_TAG: 'Bloqueado',
          ACTIVE_TITLE: 'Plan Incentivos · activo',
          ACTIVE_TAG: 'Activo',
          PARTNER_PRE_LAUNCH_TITLE: 'Prueba gratuita',
          PARTNER_TRIAL_TEXT: 'Termina el {{date}}. {{partner}} se pondrá en contacto contigo para activar tu plan anual.',
          PARTNER_LOCKED_TEXT: '{{partner}} está preparando tu contrato y se pondrá en contacto contigo.',
          PARTNER_ACTIVE_TITLE: 'Plan anual',
          PARTNER_ACTIVE_TEXT: 'Tu bolsa de movilidad sale de este plan: cada día 1 entra en tu cartera 1/12 y lo que no se gasta se acumula.',
          PARTNER_TAG: 'Gestionado por {{partner}}',
          PARTNER_MANAGED: 'Tu plan, la facturación y el contrato los gestiona {{partner}}.',
          ANNUAL_ACTIVE_SINCE: 'Activo desde el {{date}}.',
          ANNUAL_RENEWS_ON: 'Se renueva el {{date}}.',
          ANNUAL_PENDING_PAYMENT: 'Pendiente de pago: {{partner}} te enviará cómo pagarlo.',
          ANNUAL_DRAFT: '{{partner}} está preparando tu plan anual.',
        },
        MANAGER: {
          TITLE: 'Tu gestor en {{partner}}',
          NAME: 'Nombre',
          EMAIL: 'Correo',
          PHONE: 'Teléfono',
        },
        ACCOUNT: {
          TITLE: 'Completa tu cuenta',
          SUB_TRIAL: 'Cuando quieras durante la prueba. No se cobra nada hasta que acabe.',
          SUB_LOCKED: 'Es lo único que falta para volver a editar.',
          COUNT: '{{done}} de {{total}}',
          BILLING_TITLE: 'Datos de facturación',
          BILLING_TEXT: 'Razón social, CIF, dirección y email de facturación.',
          BILLING_ACTION: 'Completar',
          BILLING_DONE: '{{name}} · {{taxId}}',
          PAYMENT_TITLE: 'Método de pago',
          PAYMENT_TEXT: 'Domiciliación SEPA, tarjeta o transferencia con factura.',
          PAYMENT_ACTION: 'Elegir',
          CONTRACT_TITLE: 'Contrato',
          CONTRACT_TEXT: 'Léelo y acéptalo aquí mismo, con tu nombre y cargo.',
          CONTRACT_ACTION: 'Leer y aceptar',
          CONTRACT_DISABLED: 'Primero completa facturación y pago.',
          EDIT: 'Editar',
          COMPLETE_TITLE: 'Tu cuenta está completa',
          COMPLETE_SIGNED: 'Contrato aceptado por {{name}}, {{position}} · {{date}}',
          VIEW_CONTRACT: 'Ver contrato',
          SUMMARY_PLAN: 'Plan',
          SUMMARY_TIER: 'Tarifa',
          SUMMARY_AMOUNT: 'Importe',
          SUMMARY_STARTS: 'Empieza',
          SUMMARY_PAYMENT: 'Pago',
        },
        PAYMENT_LABEL: {
          CARD: 'Tarjeta',
          CARD_LAST4: 'Tarjeta •••• {{last4}}',
          SEPA_DEBIT: 'Domiciliación SEPA',
          BANK_TRANSFER: 'Transferencia con factura',
        },
        COACHING: {
          TITLE: 'Acompañamiento semanal',
          TEXT: 'Una sesión de 45 minutos a la semana con nuestro equipo durante la prueba. Incluida y opcional.',
          ACTION: 'Reservar sesión',
        },
        PRICE: {
          EUR: '{{amount}} €',
          PER_MONTH: '{{amount}} €/mes',
          MONTH_AMOUNT: '{{amount}} € al mes',
          ADVISOR: 'A consultar con un asesor',
        },
        TIER: {
          BELOW: 'Menos de {{max}}',
          RANGE: '{{min}} – {{max}}',
          ABOVE: 'Más de {{min}}',
        },
        TARIFFS: {
          TITLE: 'Tarifas del Plan Incentivos',
          SUB: 'Mensual por empresa, según el tamaño del centro principal.',
          YOUR_TIER: 'Tu tramo',
          EXTRA_OFFICE: '+{{amount}} €/mes por cada centro adicional',
          EXTRA_OFFICE_OFFICES: '+{{amount}} €/mes por cada centro adicional · tienes {{offices}} sedes',
          REFERENCE: 'Se toma como referencia el centro con mayor número de trabajadores.',
        },
        BILLING_MODAL: {
          TITLE: 'Datos de facturación',
          SUB: 'Los que irán en el contrato y en las facturas.',
          LEGAL_NAME: 'Razón social',
          TAX_ID: 'CIF',
          ADDRESS: 'Dirección fiscal',
          ADDRESS_PLACEHOLDER: 'Calle, número, piso',
          POSTAL_CODE: 'Código postal',
          CITY: 'Ciudad',
          EMAIL: 'Email de facturación',
          REQUIRED: 'Este campo es obligatorio.',
          POSTAL_CODE_INVALID: 'Escribe un código postal de 5 dígitos.',
          EMAIL_INVALID: 'Escribe un correo válido.',
          TAX_ID_INVALID: 'CIF no válido',
          ERROR: 'No se han podido guardar los datos de facturación.',
        },
        PAYMENT_MODAL: {
          TITLE: 'Método de pago',
          SUB: 'Se usa a partir del {{date}}. Hasta entonces no se cobra nada.',
          SEPA: 'Domiciliación bancaria',
          CARD: 'Tarjeta',
          TRANSFER: 'Transferencia con factura',
          IBAN: 'IBAN',
          SEPA_HINT: 'Firmas el mandato SEPA al guardar.',
          CARD_HINT: 'Se guarda de forma segura en Stripe.',
          STRIPE_ERROR: 'No se ha podido cargar el formulario de Stripe. Inténtalo de nuevo.',
          ERROR: 'No se ha podido guardar el método de pago.',
        },
        CONTRACT_MODAL: {
          TITLE: 'Contrato de prestación de servicios',
          SUB: 'Aceptación electrónica desde el dashboard. Queda guardado con fecha, nombre y cargo.',
          CLIENT: 'Cliente',
          PLAN: 'Plan',
          TIER: 'Tarifa',
          AMOUNT: 'Importe',
          START: 'Inicio',
          DURATION: 'Duración',
          PAYMENT: 'Pago',
          TODAY: 'Hoy',
          AT_TRIAL_END: 'Al terminar la prueba',
          TIER_TEXT: 'Tramo {{tier}} empleados · {{price}} €/mes',
          TIER_TEXT_EXTRA_ONE: 'Tramo {{tier}} empleados · {{price}} €/mes + 1 centro adicional ({{extra}} €)',
          TIER_TEXT_EXTRA: 'Tramo {{tier}} empleados · {{price}} €/mes + {{count}} centros adicionales ({{extra}} €)',
          TIER_TEXT_ADVISOR: 'Tramo {{tier}} empleados · a consultar con un asesor',
          READ_PDF: 'Leer el contrato completo (PDF)',
          NAME: 'Tu nombre',
          POSITION: 'Cargo',
          CONFIRM: 'He leído el contrato y tengo poderes para aceptarlo en nombre de {{company}}.',
          ACCEPT: 'Acepto y firmo',
          ACCEPTING: 'Firmando…',
          ERROR: 'No se ha podido aceptar el contrato.',
        },
        CONTRACT_PDF: {
          TITLE: 'Contrato de prestación de servicios',
          LOADING: 'Cargando el contrato…',
          ERROR: 'No se ha podido cargar el contrato.',
          FRAME_TITLE: 'Contrato en PDF',
        },
        MODAL: {
          SAVE: 'Guardar',
          SAVING: 'Guardando…',
          CANCEL: 'Cancelar',
          CLOSE: 'Cerrar',
        },
        COMPARISON: {
          CATEGORY_DASHBOARD: 'La app y el dashboard',
          CATEGORY_CAE: 'Ingresos por CAE',
          CATEGORY_INCENTIVES: 'Incentivos a la plantilla',
          CATEGORY_COMPLIANCE: 'Cumplimiento',
          CATEGORY_ACCOUNT: 'Gestión de la cuenta',
          CATEGORY_LIMITS: 'Límites',
          LIMIT_DURATION: 'Duración',
          LIMIT_DURATION_TRIAL: '3 meses',
          LIMIT_DURATION_UNLIMITED: 'Indefinida',
          LIMIT_TEAM_SIZE: 'Tamaño de plantilla',
          LIMIT_UNLIMITED: 'Sin límite',
          LIMIT_ACTIVE_USERS: 'Usuarios activos',
          LIMIT_REQUIRES_CARD: 'Requiere tarjeta',
          YES: 'Sí',
          NO: 'No',
          SELECT_PLAN: 'Seleccionar',
          NOT_ELIGIBLE_BADGE: 'No elegible',
          TRIAL_COLUMN: 'Prueba 3 meses',
          TRIAL_PRICE_NOTE: 'durante 3 meses',
          INCENTIVES_COLUMN: 'Plan Incentivos',
          INCENTIVES_PRICE_NOTE: 'al mes · tramo {{tier}}',
          INCENTIVES_PRICE_NOTE_NO_TIER: 'al mes',
          RECOMMENDED: 'Recomendado',
          YOUR_PLAN: 'Tu plan',
          INCLUDED: 'Incluido',
          NOT_INCLUDED: 'No incluido',
        },
      },
      CORPORATION_RIDE_POLICY: {
        NOTE_COMMISSION: 'La comisión de la plataforma se aplica igual que en un viaje normal.',
        NOTE_REASON: 'El empleado indica siempre el motivo del viaje.',
        LOADING: 'Cargando la política…',
        LOAD_ERROR: 'No se ha podido cargar la política.',
        RETRY: 'Reintentar',
        CREATE_GROUP: 'Crear grupo',
        CREATE_GROUP_LONG: 'Crear un grupo con sus propias reglas',
        OFF_TITLE: 'Pago de empresa desactivado',
        OFF_TEXT: 'Ningún grupo puede pagar viajes con la empresa desde la app. Actívalo en «Pago de empresa».',
        GROUPS_TITLE: 'Grupos',
        GROUPS_SUB: 'Cada grupo tiene sus propias reglas. Quien no está en otro grupo usa las de «Todos los empleados».',
        GROUPS_ERROR: 'No se han podido cargar los grupos.',
        DEFAULT_GROUP_NAME: 'Todos los empleados',
        DEFAULT_BADGE: 'Predeterminado',
        DEFAULT_WHO: 'quien no está en otro grupo',
        MEMBERS_ONE: '{{count}} persona',
        MEMBERS_MANY: '{{count}} personas',
        EDIT_GROUP: 'Editar',
        SPEND_ONE: '{{amount}} en {{count}} viaje · últimos 30 días',
        SPEND_MANY: '{{amount}} en {{count}} viajes · últimos 30 días',
        SPEND_NONE: 'Sin viajes en los últimos 30 días',
        SPEND_UNAVAILABLE: 'No se ha podido leer el gasto de los últimos 30 días',
        RULES: {
          NO_COMPANY_PAY: 'Sin pago con la empresa',
          LIMIT: 'Hasta {{amount}} / viaje',
          ANY_TIME: 'Cualquier día y hora',
          CATEGORY: {
            economy: 'Económico',
            executive: 'Hasta ejecutivo',
            any: 'Cualquier categoría',
          },
          SERVICE: {
            any: 'Taxi o VTC',
            taxi: 'Solo taxi',
            vtc: 'Solo VTC',
          },
        },
        CATEGORY: {
          economy: 'Económico',
          executive: 'Ejecutivo',
          any: 'Cualquiera',
        },
        SERVICE: {
          any: 'Taxi o VTC',
          taxi: 'Taxi',
          vtc: 'VTC',
        },
        DAYS: {
          MON: 'L',
          TUE: 'M',
          WED: 'X',
          THU: 'J',
          FRI: 'V',
          SAT: 'S',
          SUN: 'D',
          EVERY_DAY: 'Todos los días',
          WEEKDAYS: 'L–V',
        },
        GROUP_CREATED: 'Grupo «{{name}}» creado con {{count}} personas',
        GROUP_CREATED_ONE: 'Grupo «{{name}}» creado con 1 persona',
        GROUP_SAVED: 'Grupo «{{name}}» guardado',
        GROUP_APPLIES_SOON: 'Las reglas se aplican en la app en unos minutos.',
        GROUP_MOVED: '{{moved}} personas cambian de grupo.',
        GROUP_MOVED_ONE: '1 persona cambia de grupo.',
        PAYMENT_TITLE: 'Pago de empresa',
        PAYMENT_SUB: 'Común a todos los grupos: si se puede pagar con la empresa, el presupuesto del mes y la recarga del wallet.',
        NEVER_SUBSCRIBED_TITLE: 'Tu empresa todavía no tiene plan',
        NEVER_SUBSCRIBED_TEXT: 'Puedes guardar la política, pero la app no ofrecerá el pago de empresa hasta que contratéis un plan que lo incluya.',
        ACTIVE_LABEL: 'Pago de empresa activo',
        ACTIVE_HINT: 'Desactivado, ningún grupo puede pagar viajes con la empresa.',
        BUDGET_TITLE: 'Presupuesto mensual',
        BUDGET_LABEL: 'Limitar el gasto de empresa al mes',
        BUDGET_HINT: 'Común a todos los grupos. Aviso al 80 % y bloqueo al 100 %: al agotarse, nadie puede pagar con la empresa hasta el mes siguiente.',
        BUDGET_AMOUNT_LABEL: 'Presupuesto al mes (€)',
        BUDGET_AMOUNT_HINT: 'Mínimo 100 €.',
        USAGE_LABEL: 'Consumido este mes',
        USAGE_TEXT: '{{consumed}} de {{budget}} · mes en curso',
        USAGE_WARNING: 'Se ha consumido el 80 % del presupuesto de este mes.',
        USAGE_EXHAUSTED: 'Presupuesto agotado: el pago de empresa queda bloqueado hasta el mes que viene.',
        TOPUP_TITLE: 'Recarga automática',
        TOPUP_LABEL: 'Importe de la recarga (€)',
        TOPUP_HINT: 'Si no hay saldo, el wallet se recarga al menos con este importe desde la tarjeta de la empresa. Mínimo 10 €.',
        SAVE: 'Guardar cambios',
        SAVING: 'Guardando…',
        SAVE_DISABLED_HINT: 'Revisa los campos marcados para poder guardar',
        SAVED: 'Política guardada',
        SAVE_ERROR: 'No se ha podido guardar la política',
        ACCEPT: 'Aceptar',
        CANCEL: 'Cancelar',
        DEACTIVATE_TITLE: 'Desactivar el pago de empresa',
        DEACTIVATE_TEXT: 'Ningún grupo verá «Pago de empresa» en la app. Los viajes ya hechos no cambian.',
        DEACTIVATE_CONFIRM: 'Desactivar',
        DEACTIVATING: 'Desactivando…',
        DEACTIVATED: 'Desactivado',
        HOW_TITLE: 'Cómo se aplican las reglas',
        HOW_GROUPS_TITLE: 'Cada persona, en un solo grupo',
        HOW_GROUPS_TEXT: 'Si la añades a otro grupo, pasa a ese grupo. Si la quitas, vuelve a «Todos los empleados».',
        HOW_LIMIT_TITLE: 'Si un viaje supera el límite',
        HOW_LIMIT_TEXT: 'La empresa paga hasta el límite de su grupo y el resto se cobra a la tarjeta del empleado. Lo ve antes de confirmar.',
        HOW_TRIP_TITLE: 'En cada viaje',
        HOW_WAIIS_TITLE: 'Qué no decide la empresa',
        HOW_WAIIS_TEXT: 'Los proveedores (Uber, Cabify, Bolt) y los precios los gestiona WAIIS.',
        BILLING_TITLE: 'Cómo se cobra',
        BILLING_SUB: 'Los viajes se pagan con el wallet de la empresa. Si falta saldo, se recarga con la tarjeta por defecto.',
        WALLET_BALANCE: 'Saldo del wallet',
        COMPANY_CARD: 'Tarjeta de la empresa',
        CARD_VALUE: '{{brand}} •••• {{last4}}',
        NO_CARD: 'Sin tarjeta',
        NO_CARD_WARNING: 'Sin tarjeta, cuando no haya saldo el pago de empresa fallará.',
        GO_TO_SETTINGS: 'Recargar o añadir tarjeta en Ajustes',
        PREVIEW: {
          TITLE: 'Así lo ve el empleado',
          SUB: 'La hoja «Elige cómo moverte» de la app con las reglas del grupo y lo guardado en «Pago de empresa».',
          VIEW_AS: 'Ver como',
          EDITOR_TITLE: 'Así lo verán en la app',
          PHONE_ARIA: 'Vista previa de la app',
          SHEET_TITLE: 'Elige cómo moverte',
          PERSONAL_CARD: 'Tarjeta del empleado',
          COMPANY_NAME: 'Tu empresa',
          COMPANY_ROW_SUBTITLE: 'Pago de empresa · hasta {{limit}}',
          SELECT: 'Seleccionar',
          CLOCK: 'Con la hora actual de Madrid ({{time}})',
          PRODUCT: {
            go: 'VTC económico',
            premium: 'VTC ejecutivo',
            xl: 'VTC XL',
            taxi: 'Taxi',
          },
        },
        EDITOR: {
          NEW_TITLE: 'Nuevo grupo',
          NEW_SUB: 'Empieza con las reglas de «Todos los empleados». Ajústalas y añade a las personas.',
          DEFAULT_SUB: 'Reglas comunes para quien no está en otro grupo',
          GROUP_SUB: '{{count}} personas con estas reglas',
          GROUP_SUB_ONE: '1 persona con estas reglas',
          CLOSE: 'Cerrar',
          NAME_LABEL: 'Nombre del grupo',
          NAME_PLACEHOLDER: 'Ej.: Directivos, Comercial, Turno de noche',
          TAB_RULES: 'Reglas',
          TAB_MEMBERS: 'Miembros',
          COMPANY_PAYS: 'Pueden pagar con la empresa',
          COMPANY_PAYS_HINT: 'Si lo desactivas, este grupo no verá «Pago de empresa» en la app.',
          LIMIT_LABEL: 'Límite por viaje (€)',
          LIMIT_HINT: 'El resto lo paga el empleado. Mínimo 5 €.',
          CATEGORY_LABEL: 'Categoría máxima',
          SERVICE_LABEL: 'Servicio',
          SCHEDULE: 'Solo en horario',
          SCHEDULE_HINT: 'Fuera del horario, la app no ofrece el pago de empresa.',
          FROM: 'Desde',
          TO: 'Hasta',
          CROSSES_MIDNIGHT: 'Cruza la medianoche: acaba al día siguiente.',
          DAYS_LABEL: 'Días',
          DEFAULT_MEMBERS_NOTE: 'Este grupo no se edita a mano: incluye a todos los que no están en otro grupo. Para dar otras reglas a alguien, añádelo a un grupo.',
          SEARCH: 'Buscar empleado…',
          MEMBERS_HINT: 'Cada persona está en un solo grupo: si eliges a alguien de otro grupo, sale de ese grupo.',
          IN_GROUP: 'en «{{name}}»',
          LEAVES_GROUP: 'sale de «{{name}}»',
          NO_RESULTS: 'Sin resultados.',
          NO_EMPLOYEES: 'La empresa todavía no tiene empleados vinculados.',
          EMPLOYEES_ERROR: 'No se han podido cargar los empleados.',
          DELETE: 'Eliminar grupo',
          DELETE_TITLE: 'Eliminar el grupo «{{name}}»',
          DELETE_TEXT: 'Sus {{count}} personas vuelven a «Todos los empleados».',
          DELETE_TEXT_ONE: 'La persona del grupo vuelve a «Todos los empleados».',
          DELETE_TEXT_NONE: 'El grupo no tiene personas.',
          DELETE_CONFIRM: 'Eliminar grupo',
          DELETING: 'Eliminando…',
          DELETED: 'Eliminado',
          DELETE_ERROR: 'No se ha podido eliminar el grupo',
          CREATE: 'Crear grupo',
          SAVE: 'Guardar',
          SAVE_ERROR: 'No se ha podido guardar el grupo',
          SAVE_DISABLED_HINT: 'Completa los campos obligatorios (*) para poder guardar',
        },
        VALIDATION: {
          REQUIRED: 'Este campo es obligatorio.',
          MIN: 'El importe mínimo es {{min}} €.',
          MAX_LENGTH: 'Como mucho {{max}} caracteres.',
          SAME_TIMES: 'La hora de fin tiene que ser distinta de la de inicio.',
          DAYS_REQUIRED: 'Elige al menos un día.',
        },
      },
      CORPORATION_RIDES: {
        TITLE: 'Viajes y gasto en taxi',
        ALL_OFFICES: 'Todos los centros',
        OFFICE_ARIA: 'Centro',
        PERIOD: {
          ARIA: 'Periodo',
          LAST_30_DAYS: 'Últimos 30 días',
          LAST_90_DAYS: 'Últimos 90 días',
          THIS_YEAR: 'Este año',
        },
        EXPORT_CSV: 'Exportar CSV',
        EXPORTING: 'Exportando…',
        EXPORT_ERROR: 'No se ha podido exportar el CSV.',
        EXPORT_EMPTY: 'No hay viajes en el periodo.',
        EXPORT_DONE: 'CSV exportado · {{count}} viajes',
        LOAD_ERROR: 'No se han podido cargar los viajes.',
        FORBIDDEN: 'No tienes permiso para ver los viajes de esta empresa.',
        RETRY: 'Reintentar',
        ACCEPT: 'Aceptar',
        TODAY: 'Hoy',
        YESTERDAY: 'Ayer',
        NO_COST: 'Sin coste',
        PAGINATION: 'Mostrando {{shown}} de {{total}} viajes',
        PREVIOUS: 'Anterior',
        NEXT: 'Siguiente',
        KPI: {
          SPEND: 'Gasto empresa',
          VS_PREVIOUS: 'frente a {{value}} el periodo anterior',
          NO_PREVIOUS: 'Sin periodo anterior comparable',
          RIDES: 'Viajes de empleados',
          RIDES_HINT: 'Completados en el periodo',
          AWAITING_RECEIPT: '{{count}} pendientes de recibo',
          AVERAGE: 'Importe medio por viaje',
          AVERAGE_HINT: 'Lo que paga la empresa',
          EMPLOYEES: 'Empleados que lo han usado',
          EMPLOYEES_HINT: 'Con algún viaje completado',
          ELIGIBLE: 'de {{count}} con pago empresa',
        },
        WEEKS: {
          TITLE: 'Gasto por semana',
          Q: 'Lo que ha pagado la empresa en las últimas 8 semanas',
          TOTAL: '{{value}} en 8 semanas',
          CURRENT: 'Semana en curso',
          TIP: 'Gasto empresa',
          EMPTY: 'Sin gasto en las últimas 8 semanas.',
          TABLE: 'Ver los datos',
          WEEK: 'Semana',
          TOTAL_ROW: 'Total',
        },
        RECLAIM: {
          LINE: 'Reclamado al empleado tras el rechazo',
          STATUS: {
            WAITING: 'Esperando al cierre del cobro',
            REQUESTED: 'Reclamando',
            PENDING_DEBT: 'En deuda del empleado',
            RECLAIMED: 'Reclamado',
            NOT_NEEDED: 'Nada que reclamar',
            FAILED: 'Fallido: gestión manual',
          },
        },
        TABLE: {
          TITLE: 'Detalle de viajes',
          SUB: 'Los viajes del periodo y el centro elegidos, del más reciente al más antiguo.',
          SEARCH: 'Empleado, origen o destino…',
          STATE: 'Estado',
          REVIEW: 'Revisión',
          EMPLOYEE: 'Empleado',
          DATE: 'Fecha',
          ROUTE: 'Trayecto',
          COMPANY_AMOUNT: 'Importe empresa',
          OPEN: 'Abrir',
          PLUS_EMPLOYEE: '+ {{value}} empleado',
        },
        REVIEW_FILTER: {
          ALL: 'Todas las revisiones',
          PENDING: 'Pendientes de revisar',
        },
        STATE_FILTER: {
          ALL: 'Todos los estados',
          IN_PROGRESS: 'En curso',
          COMPLETED: 'Completados',
          CANCELLED: 'Cancelados',
          REJECTED: 'Rechazados',
        },
        STATE_GROUP: {
          IN_PROGRESS: 'En curso',
          COMPLETED: 'Completado',
          CANCELLED: 'Cancelado',
        },
        AMOUNT_STATUS: {
          AWAITING_RECEIPT: 'Pendiente de recibo',
          WALLET_SYNC_PENDING: 'Cobro al wallet pendiente',
        },
        EMPTY: {
          TITLE: 'Sin viajes',
          FILTERED: 'Nada coincide con el filtro.',
          NONE: 'Cuando un empleado autorizado pague un viaje con la empresa, aparecerá aquí.',
        },
        REASON: {
          COMMUTE: 'Ida/vuelta al trabajo',
          CLIENT_VISIT: 'Visita a cliente',
          BETWEEN_OFFICES: 'Desplazamiento entre sedes',
          LATE_EXIT: 'Salida tarde',
          CORPORATE_EVENT: 'Evento corporativo',
          OTHER: 'Otro',
        },
        DETAIL: {
          CLOSE: 'Cerrar',
          LOAD_ERROR: 'No se ha podido cargar el viaje',
          NOT_FOUND: 'El viaje ya no existe o no lo paga la empresa',
          TRIP: 'Viaje',
          REASON: 'Motivo declarado',
          JUSTIFICATION: 'Justificación',
          NO_JUSTIFICATION: 'No aportada',
          REVIEW: 'Revisión',
          STATE: 'Estado',
          DEPARTMENT: 'Departamento',
          REQUESTED_AT: 'Pedido',
          SCHEDULED_AT: 'Programado para',
          ACCEPTED_AT: 'Aceptado',
          ENDED_AT: 'Finalizado',
          RECEIPT: 'Recibo del proveedor',
          RECEIPT_YES: 'Recibido',
          RECEIPT_NO: 'Todavía no',
          SPLIT: 'Reparto del pago',
          COMPANY: 'Empresa',
          COMPANY_UP_TO: 'Empresa · hasta {{limit}} por viaje',
          EMPLOYEE_OVER_LIMIT: 'Tarjeta del empleado · exceso sobre el límite',
          AWAITING_RECEIPT_NOTE: 'El proveedor aún no ha enviado el recibo: el importe se cobra al wallet cuando llegue.',
          WALLET_SYNC_NOTE: 'No se ha podido cobrar este importe del wallet de la empresa. Se cobrará cuando haya saldo.',
          CANCELLATION: 'Cancelación',
          PENALTY: 'Penalización',
          PENALTY_COMPANY: 'A cargo de la empresa',
          PENALTY_EMPLOYEE: 'A cargo del empleado',
          PRICE: 'Desglose del precio',
          CONCEPT: 'Concepto',
          ESTIMATED: 'Estimado',
          FINAL: 'Final',
          PROVIDER_PRICE: 'Precio de {{provider}}',
          COMMISSION: 'Comisión WAIIS',
          COMMISSION_PCT: 'Comisión WAIIS ({{pct}} %)',
          TOTAL: 'Total',
        },
        CSV: {
          DATE: 'Fecha',
          TIME: 'Hora',
          EMPLOYEE: 'Empleado',
          DEPARTMENT: 'Departamento',
          OFFICE: 'Sede',
          PICKUP: 'Origen',
          DROPOFF: 'Destino',
          PROVIDER: 'Proveedor',
          PRODUCT: 'Categoría',
          TOTAL: 'Importe total',
          COMPANY: 'Importe empresa',
          EMPLOYEE_AMOUNT: 'Importe empleado',
          REASON: 'Motivo',
          STATE: 'Estado',
          REVIEW: 'Revisión',
        },
      },
      EMPLOYEES_GATE: {
        TITLE: 'Activa tu cuenta para gestionar empleados',
        TEXT: 'Introduce tu tarjeta de crédito de forma segura para activar tu cuenta, añadir a tus empleados y comenzar a ver tus datos reales. No se realizará ningún cargo en este momento (verificación de 0€).',
        ZERO_CHARGE_BADGE: 'Pago seguro · Verificación de 0€ · Sin cargo ahora',
      },
      PMST_QUESTIONNAIRE_CONFIG: {
        PREVIEW: 'Vista previa',
        RESTORE: 'Restaurar ejemplo',
        SUMMARY: '{{steps}} pasos · {{questions}} preguntas · {{required}} obligatorias',
        LOADING_BACKEND: 'Cargando la versión vigente del backend…',
        STEP_TITLE: 'Paso {{n}}',
        STEP_TITLE_LABEL: 'Título del paso',
        QUESTIONS_COUNT: '{{count}} preguntas',
        SAVE_TITLE: 'Guardar título',
        CANCEL: 'Cancelar',
        MOVE_UP: 'Subir',
        MOVE_DOWN: 'Bajar',
        RENAME: 'Renombrar',
        DELETE_STEP: 'Eliminar paso',
        NO_STATEMENT: '(sin enunciado)',
        NO_TEXT: '(sin texto)',
        REQUIRED: 'Obligatoria',
        OPTIONAL: 'Opcional',
        CONDITIONAL: 'Condicional',
        EDIT: 'Editar',
        DELETE: 'Eliminar',
        EMPTY_STEP: 'Este paso todavía no tiene preguntas.',
        ADD_QUESTION: 'Añadir pregunta',
        ADD_STEP: 'Añadir paso',
        SYNCING: 'Sincronizando con el backend…',
        SYNCED: 'Sincronizado con el backend',
        SYNC_ERROR: 'No se pudo sincronizar con el backend — el guardado local sí se hizo',
        SAVING: 'Guardando…',
        SAVE_CHANGES: 'Guardar cambios',
        SAVED: 'Guardado',
        NEW_QUESTION: 'Nueva pregunta',
        EDIT_QUESTION: 'Editar pregunta',
        SECTION_QUESTION: 'Pregunta',
        STATEMENT: 'Enunciado',
        STATEMENT_PLACEHOLDER: 'Texto de la pregunta',
        ANSWER_TYPE: 'Tipo de respuesta',
        REQUIREDNESS: 'Obligatoriedad',
        UNIT: 'Unidad (opcional)',
        UNIT_PLACEHOLDER: 'p. ej. €/año, plazas, km/año',
        SECTION_OPTIONS: 'Opciones',
        OPTION_N: 'Opción {{n}}',
        REMOVE: 'Quitar',
        ADD_OPTION: 'Añadir opción',
        SECTION_COLUMNS: 'Columnas de la tabla',
        COLUMN_N: 'Columna {{n}}',
        ADD_COLUMN: 'Añadir columna',
        SECTION_CONDITION: 'Condición',
        IS_CONDITIONAL: 'Es una pregunta condicional («solo si aplica»)',
        DEPENDS_ON: 'Depende de',
        DEPENDS_ON_NOTE: '(opcional — deja en blanco si la pregunta origen no existe todavía)',
        UNLINKED: '— Sin enlazar —',
        TRIGGER_VALUE: 'Valor que activa la pregunta',
        TRIGGER_VALUE_PLACEHOLDER: 'Valor exacto de la respuesta',
        NOTE: 'Nota explicativa',
        NOTE_HINT: '(se muestra siempre junto a la pregunta)',
        NOTE_PLACEHOLDER: 'p. ej. Solo si la empresa tiene flota propia',
        SAVE_QUESTION: 'Guardar pregunta',
        DELETE_STEP_TITLE: '¿Eliminar este paso?',
        DELETE_STEP_TEXT: 'Se eliminará «{{title}}» y sus {{count}} preguntas.',
        DELETE_QUESTION_TITLE: '¿Eliminar esta pregunta?',
        MISSING_STATEMENT_TITLE: 'Falta el enunciado',
        MISSING_STATEMENT_TEXT: 'Escribe el texto de la pregunta antes de guardar.',
        PREVIEW_WINDOW_TITLE: 'Vista previa · Formulario PMST',
        RESTORE_TITLE: '¿Restaurar el cuestionario de ejemplo?',
        RESTORE_TEXT: 'Se sustituirán los pasos y preguntas actuales por los 81 de ejemplo (11 pasos).',
        RESTORE_CONFIRM: 'Restaurar',
        TYPE: {
          short_text: 'Respuesta corta',
          long_text: 'Respuesta abierta (texto libre)',
          single_choice: 'Opción única',
          multiple_choice: 'Varias opciones',
          table: 'Tabla',
          integer: 'Número entero',
          number: 'Número',
          percentage: 'Porcentaje (%)',
          currency: 'Importe en €',
          file: 'Adjuntar archivo',
          date: 'Fecha',
        },
      },
    },
    MOCK_MODE: {
      DEMO_BADGE: 'Entorno de demostración · datos simulados',
    },
    EMPLOYEES_BANNER: {
      TITLE: '¿Aún no tienes empleados añadidos?',
      TEXT: 'Mientras tanto, puedes ir investigando cómo funcionan las secciones de Uso, Funnel y Viajes: de momento muestran datos ficticios de ejemplo, a modo de demostración, para que veas qué información vas a poder consultar. En cuanto añadas tu plantilla, esos datos pasarán a reflejar la actividad real de tus empleados. Para ver datos reales,',
      MOCK_NOTICE: 'Los datos que ves ahora son simulados hasta que añadas empleados.',
      CTA: 'carga tus empleados',
    },
    TRANSLATOR: {
      SELECT: 'Elige tu idioma',
    },
    MENU: {
      NEW: 'nuevo',
      ACTIONS: 'Comportamiento',
      CREATE_POST: 'Crear nueva publicación',
      PAGES: 'Pages',
      FEATURES: 'Caracteristicas',
      APPS: 'Aplicaciones',
      DASHBOARD: 'Tablero',
    },
    ECOMMERCE: {
      COMMON: {
        SELECTED_RECORDS_COUNT: 'Selected records count: ',
        ALL: 'All',
        SUSPENDED: 'Suspended',
        ACTIVE: 'Active',
        FILTER: 'Filter',
        BY_STATUS: 'by Status',
        BY_TYPE: 'by Type',
        BUSINESS: 'Business',
        INDIVIDUAL: 'Individual',
        SEARCH: 'Search',
        IN_ALL_FIELDS: 'in all fields',
      },
      ECOMMERCE: 'eCommerce',
      CUSTOMERS: {
        CUSTOMERS: 'Customers',
        CUSTOMERS_LIST: 'Customers list',
        NEW_CUSTOMER: 'New Customer',
        DELETE_CUSTOMER_SIMPLE: {
          TITLE: 'Customer Delete',
          DESCRIPTION: 'Are you sure to permanently delete this customer?',
          WAIT_DESCRIPTION: 'Customer is deleting...',
          MESSAGE: 'Customer has been deleted',
        },
        DELETE_CUSTOMER_MULTY: {
          TITLE: 'Customers Delete',
          DESCRIPTION: 'Are you sure to permanently delete selected customers?',
          WAIT_DESCRIPTION: 'Customers are deleting...',
          MESSAGE: 'Selected customers have been deleted',
        },
        UPDATE_STATUS: {
          TITLE: 'Status has been updated for selected customers',
          MESSAGE: 'Selected customers status have successfully been updated',
        },
        EDIT: {
          UPDATE_MESSAGE: 'Customer has been updated',
          ADD_MESSAGE: 'Customer has been created',
        },
      },
    },
    // Cabecera común de las páginas del menú (app-bo-page-header): qué se hace
    // en cada página, en una frase.
    PAGE_HEADER: {
      PARTNER_REQUESTS: 'Solicitudes de grandes cuentas de todos los partners: reasígnalas a otro partner o crea su empresa.',
      PARTNERS: 'Distribuidores que traen sus propias empresas. Para cada uno se decide qué gestiona el partner y qué ve la empresa.',
      CORP_LAUNCH_GUIDE: 'Los tres pasos para poner WAIIS en marcha en tu empresa. Cada uno se marca solo cuando lo haces.',
      CORP_PLAN: 'Tu prueba, lo que falta para seguir con WAIIS y el precio del Plan Incentivos.',
      CORP_PLAN_PARTNER: 'Tu prueba gratuita y tu plan anual.',
      CORP_WALLET:
        'La bolsa del mes, sus movimientos y cómo se recarga; el saldo, las recargas a mano y las retiradas.',
      CORP_TAXI_RIDES:
        'Solo los viajes que paga la empresa: cuánto se gasta, quién los hace y el detalle de cada uno. Los viajes personales nunca aparecen.',
      CORP_TAXI_POLICY:
        'Pago de empresa en taxi y VTC por grupos: reglas de cada grupo, presupuesto mensual y cómo se cobra.',
      CORP_TAXI_BOOKINGS:
        'Reservas de varios vehículos para un evento, una visita o un grupo. Se reservan solas como viajes de Uber, Cabify o Bolt y la empresa paga.',
      CORP_TAXI_REVIEW: 'WAIIS compara cada viaje pagado por la empresa con el patrón habitual del empleado y solo te muestra los que necesitan tu atención.',
      RIDE_BOOKING_DESK: 'Reservas de grupo de las empresas: las ves y las cancelas; los vehículos se reservan solos.',
      RIDE_BOOKING_DESK_DETAIL: 'Una reserva de grupo: la empresa, el trayecto, el importe, los vehículos y su historial, con las acciones de su estado.',
      RIDES_CONFIG_BOOKINGS: 'Reglas de las reservas de grupo de las empresas: antelación, cancelación, plazas por vehículo y avisos a WAIIS.',
      RIDES_CONFIG_REVIEW: 'Puntos, niveles, coste, distancias y lugares con los que se revisan los viajes que pagan las empresas.',
      RIDES: 'Viajes VTC pedidos a Uber, Bolt y Cabify: estado, importes e incidencias de cobro.',
      RIDE_DETAIL: 'Un ride VTC: quién lo pidió, trayecto, importes, cobro y los datos que envía el proveedor.',
      ADMIN_HOME:
        'Mapa con las rutinas recorridas en las últimas 24 horas y cuántas son.',
      TRAVEL_LIST:
        'Viajes compartidos de la plataforma y su verificación. Filtra por fechas, estado, distancia o empresa.',
      WAIIS_USERS:
        'Todas las personas registradas en la app. Busca por nombre, email, teléfono o ID y haz clic en una fila para ver su ficha, sus viajes y los movimientos de su wallet.',
      FRAUD:
        'Scores y señales de fraude que envía el equipo de datos, y qué se decide con cada cuenta.',
      PAYOUT_REVIEWS:
        'Retiradas de dinero pendientes de revisar: riesgo, señales y la decisión de pagarlas o no.',
      SUPPORT_CHAT:
        'Conversaciones con los usuarios en tiempo real. Abre varias a la vez en pestañas y responde desde aquí.',
      AGENT_CONVERSATIONS:
        'Historial de conversaciones de los agentes por app, WhatsApp y llamada, con su resultado.',
      RECLAMATIONS:
        'Reclamaciones de los usuarios por categoría y estado. Abre una para revisarla y marcarla como procesada.',
      RECLAMATION_TAXONOMY:
        'Categorías y subcategorías con las que se clasifican las reclamaciones. Crea o edita las que necesites.',
      CORPORATIONS:
        'Empresas cliente con sus sedes, empleados, viajes y plan. Abre una para ver su ficha o entra en su dashboard.',
      EMAILS: 'Los correos que envía WAIIS y su cabecera y pie, con su estado en cada idioma. Elige uno para editarlo.',
      PUSH_NOTIFICATIONS: 'Envía una notificación push escrita a mano a uno o varios usuarios de la app.',
      EMAIL_EDITOR: 'Edita el asunto y el contenido de un correo en un idioma, mira cómo queda y publícalo.',
      EMAIL_LAYOUT_EDITOR: 'Edita la cabecera o el pie de todos los correos en un idioma, mira cómo queda y publícalo.',
      MARKETING_USERS:
        'Usuarios registrados: verificación, CAE y actividad de pooling. Filtra y elige qué columnas ver.',
      REFERRALS:
        'Quién ha creado links de invitación, cómo avanza su embudo y cuánto paga cada link.',
      PVP_PROMOS:
        'Usuarios con la bonificación precio completo activada: su progreso de viajes y si ya se les ha ingresado. Busca y filtra por estado.',
      PROMOS:
        'Promociones del backoffice: la bonificación precio completo (con consecuencia de fraude) y la promo por viajes. Cada pestaña con su progreso y si ya se ha ingresado.',
      ZONE_AD_IMBALANCE:
        'Celdas H3 con desequilibrio entre conductores y pasajeros. Filtra, mira el mapa y crea un borrador de anuncio para una celda.',
      ZONE_AD_DRAFTS:
        'Borradores de anuncios en Meta por zona. Filtra por estado o destinatario y ábrelos para revisarlos.',
      ZONE_AD_DRAFT:
        'Revisa un borrador: edítalo mientras está en borrador, apruébalo, recházalo o publícalo en Meta.',
      ZONE_AD_TEMPLATES:
        'Imagen y textos de los anuncios por zona. Crea, edita, activa o elimina plantillas.',
      ZONE_AD_SETTINGS:
        'Cómo se generan los borradores de anuncios en Meta para las zonas con rutinas sin match: cuándo, con qué valores y con qué datos de publicación.',
      ROLES:
        'Roles de acceso al backoffice. Crea o edita roles y revisa sus acciones, permisos y páginas.',
      ROLE_ACTIONS:
        'Acciones que puede realizar este rol. Añade, edita o quita acciones.',
      ROLE_PERMISSIONS:
        'Operaciones de la API que este rol tiene permitidas. Añade, cambia o quita permisos.',
      ROLE_PAGES:
        'Pantallas del backoffice que puede ver este rol. Añade, cambia o quita páginas.',
      USER_ROLE_CORPORATIONS:
        'Qué rol tiene cada usuario y en qué empresa o sede. Añade o quita asignaciones.',
      CORPORATION_USERS:
        'Todos los usuarios de las empresas en un solo listado. Búscalos por nombre o email, o crea uno nuevo.',
      POOLING_RUNNERS:
        'Corredores de pooling con su nombre, descripción y color. Abre uno para ver y editar sus paradas.',
      CREDIT_PROVIDERS:
        'Empresas que ofrecen tarjetas regalo, su contacto y cuántas tarjetas tienen disponibles.',
      GIFT_CARDS:
        'Tarjetas regalo por proveedor: su valor en créditos y en euros, la fecha de caducidad y si están activas.',
      CODES:
        'Códigos de cada tarjeta regalo, a qué usuario se asignaron y cuándo caducan. Puedes importarlos desde CSV.',
      PROMOTIONAL_CODES:
        'Códigos de descuento para los viajes: tipo y valor, viajes gratis, fechas de validez y estado.',
      PARKING_SPACES:
        'Plazas de parking de la empresa: tipo, ubicación, sede y disponibilidad por turno.',
      PARKING_RESERVATIONS:
        'Reservas de plazas de parking: quién reserva, qué días y turno, en qué sede y si la comparte.',
      PARKING_CREDITS:
        'Créditos de parking de cada usuario: días y turno reservados, saldo disponible y fecha de caducidad.',
      FOOTPRINT_USERS:
        'Usuarios con su última huella y último segmento registrados. Filtra por fecha y abre la revisión de sus viajes.',
      FOOTPRINT_RAW:
        'Huella en bruto de un usuario sobre el mapa. Elige el usuario y un intervalo de fechas para cargar sus puntos.',
      TRAVEL_REVIEW:
        'Viajes de un usuario día a día, en calendario y mapa. Revísalos y clasifícalos uno a uno.',
      CORRIDORS_REVIEW:
        'Corredores de las rutas compartidas sobre el mapa. Añade rutinas o polilíneas para ver dónde coinciden.',
      TAGS:
        'Etiquetas para clasificar los viajes al revisarlos, con su categoría y color. Créalas, edítalas y actívalas.',
      VALORATION_LABELS:
        'Parejas de etiquetas positiva y negativa con las que conductores y pasajeros valoran sus viajes.',
      LABELS:
        'Etiquetas para marcar usuarios y rutas de pooling, como «VIP». Decide en qué fichas se pueden asignar.',
      MATCH_REVIEW:
        'Compara en el mapa las rutinas de conductores y pasajeros para ver si sus trayectos encajan.',
      MATCHES_LISTING:
        'Matchs generados entre conductores y pasajeros. Filtra por estado, conductor o fechas.',
      MATCH_CONFIG_VARIABLES:
        'Variables que ajustan cómo se emparejan conductores y pasajeros. Edita cada valor en la tabla.',
      POIS:
        'Puntos de recogida y bajada por categoría. Revísalos en el mapa o sube un nuevo listado.',
      CREDIT_TYPES:
        'Tipos de crédito disponibles, con su descripción y valor. Puedes editarlos o crear nuevos.',
      COMMISSIONS:
        'Comisiones que aplica Waiis, con su descripción e importe. Puedes editarlas o crear nuevas.',
      FRAUD_RULES:
        'Umbrales que marcan un viaje como sospechoso y aviso que ve el conductor en verificación reforzada.',
      CONFIG_VARIABLES:
        'Variables que ajustan el comportamiento de la plataforma. Créalas, edítalas, impórtalas o expórtalas en CSV y activa los logs.',
      APP_ANNOUNCEMENT:
        "Comunicado que ve la gente al abrir la app hasta que pulsa el botón. Actívalo, escribe los textos en cada idioma y publícalo.",
      TERMS_CONDITIONS:
        'Texto de los términos y condiciones que acepta la gente en el panel y en la app. Edita y publica una versión nueva.',
      CONTRACT_TEMPLATES:
        'Plantilla del contrato que se genera para las empresas. Edítala y guárdala como nueva versión.',
      DATA_PROCESSING_AGREEMENT:
        'Contrato de encargo de tratamiento de datos (DPA) que aceptan las empresas al darse de alta. Al guardar se publica.',
      PMST_GOAL:
        'Porcentaje mínimo legal y meta propia de plantilla registrada para el PMST, por empresa o sede.',
      PMST_QUESTIONNAIRE:
        'Pasos y preguntas del formulario PMST que rellenan las empresas. Reordénalos, edítalos y revisa la vista previa.',
      PMST_QUESTIONNAIRE_RESPONSES:
        'Respuestas al cuestionario PMST que ha enviado cada empresa. Filtra por empresa y, si quieres, por sede.',
      FACE_VERIFICATION:
        'Cuándo se pide la verificación facial a los usuarios y con qué umbrales de Rekognition se da por superada.',
      RIDES_SETTINGS:
        'Ajustes generales de los viajes: activar VTC, comisión, penalización por cancelación y ajustes por tarifa real o recibo.',
      RIDES_GUEST_PHONES:
        'Teléfonos dados de alta como invitados para los viajes. Añádelos, edítalos o desactívalos.',
      RIDES_PROVIDER_ROUTING:
        'Qué proveedor ve en estimates un usuario según su etiqueta. Las etiquetas las asigna el equipo de datos.',
      RIDES_PROVIDERS:
        'Productos de viaje que ve el rider y su equivalencia con los productos de cada proveedor, por orden de aparición.',
      SUPPORT_SNIPPETS:
        'Textos que el equipo de soporte inserta desde el chat. Arrastra las filas para cambiar el orden en el que aparecen.',
    },
    WAIIS: {
      // Marketing › Correos: listado de plantillas, cabecera y pie.
      EMAILS: {
        LAYOUTS_TITLE: 'Cabecera y pie',
        LAYOUTS_SUB: 'Las piezas comunes a todos los correos.',
        HEADER: 'Cabecera',
        FOOTER: 'Pie',
        TEMPLATES_TITLE: 'Plantillas',
        TEMPLATES_SUB: 'Cada correo con el estado de sus idiomas. Pulsa un idioma para abrir su editor.',
        COL_PIECE: 'Pieza',
        COL_EMAIL: 'Correo',
        COL_LOCALES: 'Idiomas',
        SEARCH: 'Buscar por nombre o código…',
        SEARCH_ARIA: 'Buscar correos',
        STATE_PUBLISHED: 'Publicado',
        STATE_DRAFT: 'Borrador',
        STATE_EMPTY: 'Sin contenido',
        STATE_ARCHIVED: 'Archivado',
        PUBLISHED_VERSION: 'Versión publicada: v{{version}}',
        OPEN_LOCALE: 'Abrir {{name}} en {{locale}}',
        NO_MATCH: 'Ningún correo coincide con la búsqueda',
        EMPTY: 'No hay correos editables.',
        LOAD_ERROR_TEMPLATES: 'No se han podido cargar los correos.',
        LOAD_ERROR_LAYOUTS: 'No se han podido cargar la cabecera y el pie.',
        RETRY: 'Reintentar',
        HEALTH_COUNT: 'Problemas: {{count}}',
        HEALTH_LOCALES: 'Problemas en la versión publicada de: {{locales}}',
        EDITOR: {
          TITLE: 'Editor de correo',
          ALIAS: 'Alias',
          ALIAS_ADD: 'Poner alias',
          ALIAS_EDIT: 'Cambiar alias',
          ALIAS_SAVE: 'Guardar alias',
          ALIAS_CANCEL: 'Cancelar',
          ALIAS_HINT: 'El nombre que se ve en Correos. Déjalo vacío para usar el nombre interno.',
          ALIAS_SAVED: 'Alias guardado',
          ALIAS_ERROR: 'No se ha podido guardar el alias',
          HEALTH_TITLE: 'La versión publicada v{{version}} tiene problemas',
          HEALTH_SUB: 'Corrige lo que se indica abajo, guarda y publica. Este aviso no impide guardar ni publicar.',
          LOCALE: 'Idioma',
          UNSAVED: 'Cambios sin guardar',
          CONTENT_TITLE: 'Contenido',
          CONTENT_SUB: 'El asunto, el preheader y el cuerpo del correo en este idioma.',
          SUBJECT: 'Asunto',
          PREHEADER: 'Preheader',
          PREHEADER_HINT: 'El texto que la bandeja de entrada enseña junto al asunto. Opcional.',
          BODY_HTML: 'Contenido (HTML)',
          BODY_BLOCKS: 'Contenido (bloques en JSON)',
          JSON_INVALID: 'JSON no válido',
          SAVE: 'Guardar borrador',
          SAVING: 'Guardando…',
          SAVED: 'Borrador guardado',
          SAVE_ERROR: 'No se ha podido guardar el borrador',
          DISCARD: 'Descartar borrador',
          DISCARD_TITLE: 'Descartar el borrador',
          DISCARD_TEXT: 'Se borra el borrador y el editor vuelve a la versión publicada.',
          DISCARD_CONFIRM: 'Descartar',
          DISCARD_SAVING: 'Descartando…',
          DISCARD_DONE: 'Descartado',
          DISCARD_ERROR: 'No se ha podido descartar el borrador',
          PUBLISH: 'Publicar',
          PUBLISH_TITLE: 'Publicar el borrador',
          PUBLISH_TEXT: 'Los correos que se envíen desde ahora en este idioma usarán esta versión.',
          PUBLISH_CONFIRM: 'Publicar',
          PUBLISH_SAVING: 'Publicando…',
          PUBLISH_DONE: 'Publicado',
          PUBLISH_ERROR: 'No se ha podido publicar',
          PUBLISH_NEEDS_SAVE: 'Guarda el borrador antes de publicar',
          TEST_SEND: 'Enviar prueba',
          TEST_SENDING: 'Enviando…',
          TEST_SENT: 'Enviado a {{email}}',
          TEST_ERROR: 'No se ha podido enviar la prueba',
          TEST_NEEDS_SAVE: 'Guarda el borrador para enviarte una prueba',
          PREVIEW: 'Vista previa',
          PREVIEW_TITLE: 'Vista previa',
          PREVIEW_SUB: 'Cómo se ve lo que hay en el editor.',
          PREVIEW_VERSION: 'La versión {{version}}, tal como se guardó.',
          PREVIEW_EMPTY: 'Pulsa «Vista previa» para ver el correo.',
          PREVIEW_ERROR: 'No se ha podido generar la vista previa.',
          DEVICE: 'Dispositivo',
          DESKTOP: 'Escritorio',
          MOBILE: 'Móvil',
          SCHEME: 'Tema',
          LIGHT: 'Claro',
          DARK: 'Oscuro',
          VERSIONS_TITLE: 'Versiones',
          VERSIONS_SUB: 'Elige una para ver cómo era; puedes volver a ella.',
          VERSIONS_ERROR: 'No se han podido cargar las versiones.',
          VERSIONS_EMPTY: 'Todavía no hay versiones guardadas.',
          EDITING: 'Lo que estás editando',
          ACTIVE: 'Activa',
          ROLLBACK: 'Revertir a esta versión',
          ROLLBACK_TITLE: 'Revertir a la versión {{version}}',
          ROLLBACK_TEXT: 'Se crea un borrador nuevo con el contenido de esa versión. Lo que no hayas guardado se pierde.',
          ROLLBACK_CONFIRM: 'Revertir',
          ROLLBACK_SAVING: 'Revirtiendo…',
          ROLLBACK_DONE: 'Borrador creado',
          ROLLBACK_ERROR: 'No se ha podido revertir a esa versión',
          VARIABLES_TITLE: 'Variables',
          VARIABLES_SUB: 'Lo que puedes usar en el asunto, el preheader y el contenido.',
          VARIABLES_EMPTY: 'Este correo no tiene variables.',
          MUST_APPEAR: 'Tiene que aparecer',
          UNSAVED_TITLE: 'Tienes cambios sin guardar',
          UNSAVED_TEXT: 'Si sigues, se pierden.',
          UNSAVED_LEAVE: 'Seguir sin guardar',
          CANCEL: 'Cancelar',
          ACCEPT: 'Aceptar',
          LOAD_ERROR: 'No se ha podido cargar el correo.',
          BACK: 'Volver al listado',
        },
        // Editor de la cabecera y el pie.
        LAYOUT_EDITOR: {
          TITLE: '{{piece}} · {{locale}}',
          NOT_FOUND_TITLE: 'Pieza no encontrada',
          NOT_FOUND: 'Esa pieza o ese idioma no existen.',
          LOAD_ERROR: 'No se ha podido cargar la pieza.',
          CONTENT_SUB: 'Lo que llevan todos los correos en este idioma.',
          ALLOWED_BLOCKS: 'Bloques que admite: {{types}}.',
        },
      },
      AGENT_CONVERSATIONS: {
        CHANNELS: {
          IN_APP: 'In-app',
          WHATSAPP: 'WhatsApp',
          CALL: 'Llamadas',
        },
        CHANNEL_SUBTITLES: {
          IN_APP: 'Chats de los usuarios con los agentes de IA dentro de la app. Elige una para ver el hilo completo.',
          WHATSAPP: 'Conversaciones de los agentes de IA por WhatsApp. Elige una para ver el hilo completo.',
          CALL: 'Llamadas atendidas por los agentes de IA, con su transcripción. Elige una para verla completa.',
        },
        OUTCOMES: {
          RESOLVED: 'Resuelta',
          ESCALATED: 'Escalada',
          UNRESOLVED: 'Sin resolver',
          UNKNOWN: 'Sin clasificar',
        },
        NOTES: {
          RESOLVED_HUMAN: 'Conversación resuelta con intervención humana',
          RESOLVED_AUTO: 'Conversación resuelta automáticamente',
          ESCALATED: 'Conversación escalada al equipo de soporte',
          UNRESOLVED: 'Conversación sin resolver',
          UNKNOWN: 'Resultado sin clasificar',
        },
        USER_FALLBACK: 'Usuario',
        FIRST_NAME_FALLBACK: 'la persona usuaria',
        TODAY: 'Hoy',
        YESTERDAY: 'Ayer',
        CHANNEL_ARIA: 'Canal',
        SEARCH_PLACEHOLDER: 'Buscar conversación, usuario o agente...',
        SEARCH_ARIA: 'Buscar conversaciones',
        PERIOD_ARIA: 'Periodo',
        AGENT_ARIA: 'Agente',
        OUTCOME_ARIA: 'Resultado',
        CLEAR_FILTERS: 'Limpiar filtros',
        LIST_ARIA: 'Conversaciones',
        LOADING: 'Cargando conversaciones',
        RETRY: 'Reintentar',
        EMPTY: 'No hay conversaciones de {{channel}} que coincidan con los filtros.',
        LOADING_MORE: 'Cargando más conversaciones...',
        LOAD_MORE: 'Cargar más',
        THREAD_ARIA: 'Conversación',
        PERIOD: {
          D7: 'Periodo: 7 días',
          D30: 'Periodo: 30 días',
          D90: 'Periodo: 90 días',
          ALL: 'Periodo: todo',
        },
        OUTCOME_ALL: 'Resultado: todos',
        OUTCOME_OPTION: 'Resultado: {{label}}',
        AGENT_ALL: 'Agente: todos',
        AGENT_OPTION: 'Agente: {{name}}',
        LOAD_ERROR: 'No se ha podido cargar el historial de conversaciones.',
        DETAIL_ERROR: 'No se ha podido cargar la conversación.',
        PANEL_CALLS: 'Llamadas con agentes',
        PANEL_CHANNEL: 'Conversaciones de {{channel}}',
        COUNT_ONE: '1 conversación',
        COUNT_OTHER: '{{count}} conversaciones',
        SHOWING: 'Mostrando {{shown}} de {{total}} conversaciones',
        THREAD: {
          SELECT_TITLE: 'Selecciona una conversación',
          SELECT_TEXT: 'Elige una conversación del listado para ver cómo la atendió el agente.',
          REF_COPIED: 'Referencia copiada',
          COPY_REF: 'Copiar referencia',
          OPENS_NEW_TAB: 'Se abre en otra pestaña',
          VIEW_PROFILE_OF: 'Ver ficha de {{name}}',
          CHANNEL: 'Canal',
          MESSAGES: 'Mensajes',
          DURATION: 'Duración',
          INTERVENTION: 'Intervención',
          RECORDING_UNAVAILABLE: 'Grabación de la llamada no disponible en backoffice.',
          NO_TRANSCRIPT: 'Todavía no hay transcripción de esta llamada.',
          NO_MESSAGES: 'Esta conversación no tiene mensajes.',
          OUTCOME_PENDING_TEXT: 'El sistema aún no ha indicado si esta conversación se resolvió, se escaló o quedó sin resolver.',
          CALL_SUMMARY: 'Resumen de la llamada',
          DETECTED_REASON: 'Motivo detectado',
          MESSAGES_ONE: '1 mensaje',
          MESSAGES_OTHER: '{{count}} mensajes',
          WITH_HUMAN: 'Con intervención humana',
          WITHOUT_HUMAN: 'Sin intervención humana',
          TRANSCRIPT: 'Transcripción',
        },
      },
      COMPLAINTS: {
        SEARCH_CODE: 'Buscar código',
        FILTERS: 'Filtros',
        CLOSE: 'Cerrar',
        SELECT_DATE: 'Selecciona una fecha',
        APPLY_FILTERS: 'Aplicar filtros',
        CLEAR: 'Limpiar',
        EXPORT_CSV: 'Exportar CSV',
        ADD: 'Añadir incidencia',
        CREATE_TITLE: 'Crear incidencia',
        EDIT_TITLE: 'Editar incidencia',
        FIELDS: {
          CONTEXT: 'Contexto',
          TYPE: 'Tipo',
          REASON: 'Motivo',
          REPORTER: 'Reportante',
          REPORTED: 'Reportado',
          ASSIGN_TO: 'Asignar a',
          DESCRIPTION: 'Descripción',
          DATE: 'Fecha',
          STATUS: 'Estado',
          ASSIGNED_TO: 'Asignado a',
          LAST_UPDATE: 'Última actualización',
          COMMENT: 'Comentario',
        },
        REQUIRED: {
          CONTEXT: 'El contexto es obligatorio',
          TYPE: 'El tipo es obligatorio',
          REASON: 'El motivo es obligatorio',
          REPORTER: 'El reportante es obligatorio',
          REPORTED: 'El reportado es obligatorio',
          DESCRIPTION: 'La descripción es obligatoria',
          COMMENT: 'El comentario es obligatorio',
        },
        CANCEL: 'Cancelar',
        ACCEPT: 'Aceptar',
        WAIT: 'Espera...',
        SUCCESS_TITLE: 'Correcto',
        ERROR_TITLE: 'Error',
        CREATED: 'Se ha creado correctamente la incidencia',
        UPDATED: 'Se ha modificado correctamente la incidencia',
        ASSIGNED: 'Se ha asignado correctamente la incidencia',
        STATUS: {
          PENDING: 'Pendiente',
          ASSIGNED: 'Asignada',
          IN_PROGRESS: 'En curso',
          RESOLVED: 'Resuelta',
        },
        CONTEXT: {
          TRAVEL: 'Finalizar viaje',
          UNMATCH: 'Realización de unmatch',
          TRAVEL_LINK: 'Enlace en el viaje',
          PROFILE_LINK: 'Enlace al perfil',
        },
        TYPE: {
          UNMATCH: 'Unmatch',
          TRAVEL: 'Viaje',
        },
        REASON: {
          CLEANLINESS: 'Limpieza',
          DELAY: 'Retraso',
          SAFETY: 'Seguridad',
          BEHAVIOUR: 'Comportamiento',
        },
        DETAIL: {
          BACK: 'Volver',
          PROBLEM_INFO: 'Información del problema',
          ASSIGN: 'Asignar incidencia',
          MANAGE: 'Gestionar incidencia',
          TYPE: 'Tipo:',
          REASON: 'Motivo:',
          STATUS: 'Estado:',
          EXPLANATION: 'Explicación:',
          ASSIGNED_TO: 'Asignado a:',
          COMMENT: 'Comentario:',
          TRIP_INFO: 'Información del viaje',
          TRIP_ID: 'Id del viaje:',
          DATE: 'Fecha:',
          ORIGIN: 'Origen:',
          DESTINATION: 'Destino:',
          DRIVER: 'Conductor:',
          PASSENGER: 'Pasajero:',
          REPORTED_INFO: 'Información del usuario reportado',
          REPORTER_INFO: 'Información del usuario reportante',
          NAME: 'Nombre:',
          SURNAME: 'Apellidos:',
          PHONE: 'Teléfono:',
          EMAIL: 'Correo electrónico:',
          ROLE: 'Rol:',
          USER_ID: 'Id usuario:',
        },
      },
      RIDES: {
        SEARCH_PLACEHOLDER: 'Buscar por nombre, email o teléfono',
        FROM: 'Desde',
        TO: 'Hasta',
        ALL_PROVIDERS: 'Todos los proveedores',
        ALL_STATES: 'Todos los estados',
        INCIDENT_FILTER: 'Solo incidencias de cobro',
        COL_DATE: 'Fecha',
        COL_USER: 'Usuario',
        COL_PROVIDER: 'Proveedor',
        COL_ROUTE: 'Trayecto',
        COL_AMOUNT: 'Importe',
        COL_STATE: 'Estado',
        COL_ACTIONS: 'Acciones',
        SCHEDULED_FOR: 'Programado: {{date}}',
        EMPTY: 'No hay rides con estos filtros',
        ERROR: 'No se pudieron cargar los rides',
        NOT_FOUND: 'El ride no existe',
        RETRY: 'Reintentar',
        PREVIOUS: 'Anterior',
        NEXT: 'Siguiente',
        PAGINATION: 'Mostrando {{shown}} de {{total}} rides',
        BACK: 'Volver a rides',
        DETAIL_TITLE: 'Detalle del ride',
        BACK_TO_LIST: 'Volver al listado',
        LOADING: 'Cargando el ride…',
        COPY_ID: 'Copiar ID',
        ID_COPIED: 'ID copiado',
        NO_FIELDS: 'Sin datos',
        RAW_TITLE: 'Datos completos',
        RAW_SUB: 'Tal como los envía el proveedor (JSON).',
        RAW_SHOW: 'Ver datos completos',
        RAW_HIDE: 'Ocultar',
        SECTION_SUB: {
          SUMMARY: 'Proveedor, producto, fechas e identificadores del viaje.',
          ROUTE: 'Origen, destino, conductor, vehículo y valoración.',
          AMOUNTS: 'Tarifa del proveedor, comisión, cupón e importe final.',
          BILLING: 'Pago del usuario, liquidación e incidencias de cobro.',
          CANCELLATION: 'Datos de la cancelación que envía el proveedor.',
          RECEIPT: 'Datos del recibo que envía el proveedor.',
        },
        NO_PAYMENT: 'Sin pago registrado',
        STATE: {
          SCHEDULED: 'Programado',
          REQUESTED: 'Solicitado',
          ACCEPTED: 'Aceptado',
          ARRIVING: 'En camino',
          ARRIVED: 'Conductor en el punto',
          IN_PROGRESS: 'En curso',
          COMPLETED: 'Completado',
          NO_DRIVERS: 'Sin conductores',
          CANCELLED_BY_RIDER: 'Cancelado por el usuario',
          CANCELLED_BY_DRIVER: 'Cancelado por el conductor',
          FAILED: 'Fallido',
        },
        INCIDENT: {
          DEFERRED_CHARGE_DEBT: 'Deuda: cobro fallido',
          RECEIPT_MANUAL_REVIEW: 'Recibo en revisión manual',
        },
        SECTION: {
          SUMMARY: 'Resumen',
          ROUTE: 'Trayecto y conductor',
          AMOUNTS: 'Importes',
          BILLING: 'Cobro',
          CANCELLATION: 'Cancelación',
          RECEIPT: 'Recibo del proveedor',
        },
        FIELD: {
          USER: 'Usuario',
          PRODUCT: 'Producto',
          CREATED_AT: 'Creado',
          SCHEDULED_AT: 'Programado para',
          ACCEPTED_AT: 'Aceptado',
          UPDATED_AT: 'Última actualización',
          PROVIDER_TRIP_ID: 'ID del viaje en el proveedor',
          PROVIDER_PRODUCT_ID: 'ID del producto en el proveedor',
          PICKUP: 'Origen',
          DROPOFF: 'Destino',
          DRIVER: 'Conductor',
          VEHICLE: 'Vehículo',
          RATING: 'Valoración',
          PROVIDER_FARE: 'Tarifa del proveedor',
          COMMISSION: 'Comisión',
          FARE: 'Tarifa estimada',
          PROVIDER_FINAL: 'Importe final del proveedor',
          FINAL_COMMISSION: 'Comisión final',
          FINAL: 'Importe final',
          COUPON: 'Cupón',
          PAYMENT: 'Pago',
          REFUNDED: 'Reembolsado',
          SETTLEMENT_REFUNDED: 'Devuelto en la liquidación',
          SETTLEMENT_APPLIED_AT: 'Liquidación aplicada',
          DEFERRED_CHARGE: 'Cobro diferido fallido',
          ATTEMPTS: 'Intentos',
          RECEIPT_FALLBACK: 'Recibo pendiente desde',
          ALERTED_AT: 'Alerta de revisión manual',
          RIDE_ID: 'ID del ride',
        },
      },
      TRAVEL_LIST: {
        RANGE_7: 'Rango: 7 días',
        RANGE_30: 'Rango: 30 días',
        RANGE_90: 'Rango: 90 días',
        RANGE_365: 'Rango: 1 año',
        RANGE_ALL: 'Rango: todo',
        KM_ANY: 'Km: cualquiera',
        KM_LT: 'Km: menos de {{km}}',
        KM_GT: 'Km: más de {{km}}',
        TYPE_RECURRING: 'Rutina',
        TYPE_PUNCTUAL: 'Puntual',
        TYPE_FLEET: 'Taxi/VTC',
        TAB_ALL: 'Todos',
        TAB_RECURRING: 'De rutina',
        TAB_PUNCTUAL: 'Puntuales',
        TAB_FLEET: 'Taxi/VTC',
        STATUS_PENDING: 'Pendiente',
        STATUS_ONGOING: 'En curso',
        STATUS_IN_REVIEW: 'En revisión',
        APP_SHOWS_VERIFYING: "En la app: «Verificando»",
        APP_VERIFYING_HINT: "Verificado, pero el conductor aún no ha cobrado (retraso de caja). Hasta que cobre, la app muestra «Verificando» al conductor y a los pasajeros.",
        STATUS_REINFORCED_REVIEW: 'En revisión reforzada',
        STATUS_VERIFIED: 'Verificado',
        STATUS_UNREALIZED: 'No verificado',
        STATUS_CANCELLED: 'Cancelado',
        VERIF_SHARED: 'Compartido',
        VERIF_SHARED_H3: 'Compartido (H3)',
        VERIF_BLUETOOTH: 'Bluetooth',
        VERIF_TEMPORAL: 'Temporal',
        VERIF_NONE: 'Sin verificar',
        FILTER_TYPE_ALL: 'Tipo: todos',
        FILTER_STATUS_ALL: 'Estado: todos',
        FILTER_VERIFICATION_ALL: 'Verificación: todas',
        FILTER_COMPANY_ALL: 'Empresa: todas',
        FILTER_RUNNER_ALL: 'Corredor: todos',
        SEARCH_PLACEHOLDER: 'Buscar por ID, usuario, match...',
        SEARCH_ARIA: 'Buscar viajes',
        ARIA_DATE_RANGE: 'Rango de fechas',
        ARIA_TRIP_TYPE: 'Tipo de viaje',
        ARIA_STATUS: 'Estado del viaje',
        ARIA_VERIFICATION: 'Método de verificación',
        ARIA_DISTANCE: 'Distancia',
        ARIA_COMPANY: 'Empresa',
        ARIA_RUNNER: 'Corredor',
        ARIA_IDENTITY: 'Identidad',
        UNVERIFIED_IDENTITY_FILTER: 'Sin identidad verificada',
        LOADING_ARIA: 'Cargando viajes',
        COL_ID: 'ID',
        COL_DATE: 'Fecha',
        COL_ROUTE: 'Ruta',
        COL_KM: 'Km',
        COL_TYPE: 'Tipo',
        COL_DRIVER: 'Conductor',
        COL_PASSENGERS: 'Pasajeros',
        COL_VERIFICATION: 'Verificación',
        COL_PRICE: 'Precio',
        COL_PRICE_RECEIVED: 'Precio recibido',
        COL_STATUS: 'Estado',
        COL_ACTIONS: 'Acciones',
        LOAD_ERROR: 'No se ha podido cargar el listado de viajes.',
        EXPORT_ERROR: 'No se ha podido exportar el listado.',
        CSV_FILE_PREFIX: 'viajes',
        RETRY: 'Reintentar',
        EMPTY: 'No hay viajes que coincidan con los filtros.',
        UNVERIFIED_TOOLTIP: 'Algún participante hizo el viaje sin la identidad verificada',
        UNVERIFIED_BADGE: 'Sin identidad',
        CASH_DELAY_TITLE: 'Retraso de caja: el conductor no tiene este importe en su saldo hasta el {{date}} a las {{time}}. La app no lo anuncia.',
        CASH_DELAY_LABEL: 'Abono por caja: {{date}} {{time}}',
        CASH_DELAY_DAYS_LABEL: 'Caja · día {{day}}/{{total}} · {{date}}',
        CASH_DELAY_DUE_LABEL: 'Caja · día {{day}}/{{total}} · se abona en unos minutos',
        REINFORCED_HOLD_TITLE: 'Verificación reforzada: el conductor recibe este viaje en su saldo el {{date}} a las {{time}}. Si sale de la reforzada antes, se le abona en la próxima pasada (cada 10 min).',
        REINFORCED_HOLD_LABEL: 'Se abona el {{date}}',
        REINFORCED_HOLD_DAYS_LABEL: 'Día {{day}}/{{total}} · se abona el {{date}}',
        REINFORCED_HOLD_DUE_LABEL: 'Día {{day}}/{{total}} · se abona en unos minutos',
        PAGINATION: 'Mostrando {{shown}} de {{total}} viajes',
        PREVIOUS: 'Anterior',
        NEXT: 'Siguiente',
        PANEL_ALL_TITLE: 'Todos los viajes',
        PANEL_ALL_SUB: 'De rutina, puntuales y en taxi/VTC. Pulsa un viaje para ver quién iba en el coche; con la flecha › abres su detalle.',
        PANEL_RECURRING_TITLE: 'Viajes de rutina',
        PANEL_RECURRING_SUB: 'Trayectos que forman parte de la rutina de los usuarios. Pulsa uno para ver quién iba en el coche; con la flecha › abres su detalle.',
        PANEL_PUNCTUAL_TITLE: 'Viajes puntuales',
        PANEL_PUNCTUAL_SUB: 'Trayectos de un solo día, fuera de la rutina. Pulsa uno para ver quién iba en el coche; con la flecha › abres su detalle.',
        PANEL_FLEET_TITLE: 'Viajes en taxi/VTC',
        PANEL_FLEET_SUB: 'Viajes pedidos en taxi o VTC desde la app. Pulsa uno para ver su detalle.',
        OPEN_TRIP: 'Abrir el viaje',
        DRAWER: {
          EYEBROW: 'Detalle del viaje',
          LOADING: 'Cargando viaje…',
          NOT_FOUND: 'No se ha encontrado el viaje solicitado.',
          TIMEOUT: 'El servidor no ha respondido a tiempo. Inténtalo de nuevo.',
          LOAD_ERROR: 'No se ha podido cargar el detalle del viaje.',
          MARKER_PICKUP: 'Recogida · {{name}}',
          MARKER_DROPOFF: 'Bajada · {{name}}',
          LEGEND_REFERENCE: 'Huella teórica (ruta del conductor)',
          LEGEND_TRACE: 'Huella real (conductor)',
          ORIGIN_DESTINATION: 'Origen / Destino',
          DRIVER: 'Conductor',
          FOOTPRINT: 'Huella',
          NO_DRIVER: 'Sin datos de conductor.',
          PASSENGERS: 'Pasajeros',
          COL_PASSENGER: 'Pasajero',
          COL_VERIFICATION: 'Verificación',
          COL_STATUS: 'Estado',
          COL_PICKUP_DISTANCE: 'Dist. recogida',
          COL_DESTINATION_DISTANCE: 'Dist. destino',
          NO_PASSENGERS: 'Sin pasajeros.',
          TRIP_DATA: 'Datos del trayecto',
          DATE_TIME: 'Fecha y hora',
          DISTANCE_LISTING: 'Distancia (listado)',
          DRIVER_DETOUR: 'Desvío del conductor',
          DURATION: 'Duración',
          PASSENGER_FOOTPRINTS: 'Huellas de pasajeros',
          N_VERIFIED: '{{count}} verificadas',
          N_PENDING: '{{count}} pendientes',
          N_REJECTED: '{{count}} rechazadas',
          WAYPOINTS: 'Waypoints',
          NO_WAYPOINTS: 'Sin waypoints registrados.',
          IDENTIFIER: 'Identificador',
          FOOTPRINT_PENDING: 'Pendiente',
          FOOTPRINT_VERIFIED: 'Verificada',
          FOOTPRINT_REJECTED: 'Rechazada',
          FOOTPRINT_IN_REVIEW: 'En revisión',
          APP_SHOWS_VERIFYING: "En la app: «Verificando»",
          APP_VERIFYING_HINT: "Verificada, pero el conductor aún no ha cobrado. Hasta que cobre, la app muestra «Verificando» al conductor y a los pasajeros.",
          FOOTPRINT_CANCELLED: 'Cancelada',
          STATUS: {
            PENDING: 'Pendiente',
            IN_PROGRESS: 'En curso',
            ONGOING: 'En curso',
            ACCEPTED: 'Aceptado',
            CONFIRMED: 'Confirmado',
            COMPLETED: 'Completado',
            VERIFIED: 'Verificado',
            IN_REVIEW: 'En revisión',
            REJECTED: 'Rechazado',
            CANCELLED: 'Cancelado',
          },
          ACTION: {
            PICKUP: 'Recogida',
            DROPOFF: 'Bajada',
          },
        },
      },
      CORRIDORS_REVIEW: {
        LOAD_CORRIDORS: 'Cargar corredores',
        LOADING: 'Cargando…',
        ADD_ROUTINE: 'Agregar rutina',
        LOAD_POLYLINE: 'Cargar polilínea',
        PROCESSING: 'Procesando…',
        MAP_TITLE: 'Mapa de corredores',
        MAP_SUBTITLE: 'Corredores de pooling, rutinas añadidas y polilíneas cargadas desde archivo.',
        H3_SEARCH_PLACEHOLDER: 'Buscar H3…',
        H3_SEARCH_ARIA: 'Identificador H3',
        SEARCH: 'Buscar',
        SEARCHING: 'Buscando…',
        SHOW_ALL: 'Mostrar todos',
        HIDE_ALL: 'Ocultar todos',
        FIT_ALL: 'Encuadrar todo',
        FIT_ALL_TOOLTIP: 'Ajustar el mapa para ver todos los corredores',
        EMPTY_HINT: 'Pulsa «Cargar corredores» para ver los datos en el mapa',
        LEGEND_LABEL: 'Corredores',
        SHOW_ON_MAP: 'Mostrar en el mapa',
        HIDE_ON_MAP: 'Ocultar en el mapa',
        ADD_ROUTINE_SUB: 'Coordenadas «latitud, longitud» de origen y destino',
        ORIGIN: 'Origen',
        DESTINATION: 'Destino',
        CREATING: 'Creando…',
        CREATE_ROUTE: 'Crear ruta',
        ROUTE_NAME: 'Ruta {{n}}',
        POLYLINE_NAME: 'Polilínea {{id}}',
        INVALID_COORDINATES: 'Formato inválido. Usa: 41.67520306862359, -0.8767050772489519',
        NOT_ENOUGH_POINTS: 'La ruta no devuelve suficientes puntos para pintar.',
        ROUTE_ERROR: 'No se pudo generar la ruta. Revisa coordenadas y endpoint.',
        POLYLINE_NO_COORDINATES: 'No se pudo extraer coordenadas válidas del archivo. Usa: JSON con LineString, JSON con polyline encoded, o solo la polyline encoded.',
        POLYLINE_UNKNOWN_ERROR: 'Error desconocido al cargar el archivo.',
        POLYLINE_READ_ERROR: 'Error al leer el archivo.',
        H3_REQUIRED: 'Por favor, ingresa un identificador H3',
        H3_INVALID: 'El identificador H3 no es válido',
        MAP_UNAVAILABLE: 'El mapa no está disponible. Por favor, intenta de nuevo.',
        H3_PROCESS_ERROR: 'Error al procesar el hexágono H3: {{detail}}',
        UNKNOWN_ERROR: 'Error desconocido',
      },
      POOLING_RUNNERS_ADMIN: {
        ITEMS: 'corredores',
        COL_NAME: 'Nombre',
        COL_DESCRIPTION: 'Descripción',
        COL_COLOR: 'Color',
        COL_CREATED: 'Creado',
        COL_UPDATED: 'Actualizado',
        DETAIL_TITLE: 'Detalles',
        DETAIL_SUBTITLE: 'Datos del corredor y sus paradas. Pulsa una parada para cambiar su orden o habilitarla.',
        BACK: 'Volver',
        BACK_TO_LIST: 'Volver al listado',
        RETRY: 'Reintentar',
        EDIT: 'Editar',
        DETAILS_TITLE: 'Detalles del corredor',
        STOPS_TITLE: 'Paradas',
        STOPS_COUNT: '{{count}} parada(s)',
        COL_ORDER: 'Orden',
        COL_LOCALITY: 'Localidad',
        COL_ADDRESS: 'Dirección',
        COL_TYPE: 'Tipo',
        COL_COORDINATES: 'Coordenadas',
        NO_STOPS: 'Este corredor no tiene paradas asociadas',
        EDIT_RUNNER_TITLE: 'Editar corredor',
        EDIT_STOP_TITLE: 'Editar parada',
        NAME_PLACEHOLDER: 'Nombre del corredor',
        NAME_REQUIRED: 'El nombre es obligatorio',
        NAME_MAXLENGTH: 'El nombre no puede superar los {{max}} caracteres',
        DESCRIPTION_PLACEHOLDER: 'Descripción del corredor',
        DESCRIPTION_MAXLENGTH: 'La descripción no puede superar los {{max}} caracteres',
        PICK_COLOR: 'Elegir color',
        COLOR_REQUIRED: 'El color es obligatorio',
        COLOR_INVALID: 'El color debe ser un valor hexadecimal válido (#RRGGBB)',
        ORDER_PLACEHOLDER: 'Orden de la parada',
        ORDER_REQUIRED: 'El orden es obligatorio',
        ORDER_MIN: 'El orden debe ser mayor o igual a 0',
        ENABLED: 'Habilitada',
        SAVE: 'Guardar',
        SAVING: 'Guardando...',
        LOAD_ERROR: 'Error al cargar los datos del corredor',
        LOAD_ERROR_SWAL: 'No se pudieron cargar los datos del corredor',
        STOPS_LOAD_ERROR: 'No se han podido cargar las paradas.',
        SAVE_SUCCESS: 'Corredor actualizado correctamente',
        SAVE_ERROR: 'No se pudo actualizar el corredor',
        STOP_SAVE_SUCCESS: 'Parada actualizada correctamente',
        STOP_SAVE_ERROR: 'No se pudo actualizar la parada',
      },
      FOOTPRINT_STATISTICS: {
        TITLE: 'Captura de localización',
        SUBTITLE: 'Medias móviles de puntos por día y precisión del GPS en cada periodo (hasta ayer).',
        HELP_LINK: '¿Qué son estas métricas?',
        EXPAND: 'Expandir',
        COLLAPSE: 'Colapsar',
        POINTS_PER_DAY: 'Puntos/día',
        POINTS_PER_DAY_UNIT: 'puntos/día',
        ACCURACY_3_DAYS: 'Precisión (últimos 3 días)',
        AVG_ERROR_METERS: 'metros de error promedio',
        CHANGE_VS_WEEK: 'Cambio vs última semana',
        POINTS_VARIATION: 'Variación de puntos/día',
        CHART_TITLE: 'Tendencia de datos y precisión',
        CHART_QUESTION: '¿Cuántos puntos se capturan al día y con qué precisión, según el periodo? Del más largo (izquierda) al más reciente (derecha).',
        SERIES_ACCURACY_POSITION: 'Precisión (posición)',
        SERIES_ACCURACY_SPEED: 'Precisión (velocidad)',
        BY_PERIOD_ARIA: '{{series}} por periodo',
        VIEW_DATA: 'Ver los datos',
        PERIOD: 'Período',
        NO_DATA: 'No hay datos de ningún periodo.',
        SUMMARY_BY_PERIOD: 'Resumen por período',
        ACCURACY_POS_SHORT: 'Precisión (pos)',
        ACCURACY_SPEED_SHORT: 'Precisión (vel)',
        VS_PREVIOUS_PERIOD: 'Frente al periodo anterior de la lista',
        STATUS_GOOD: 'Bien',
        STATUS_WARNING: 'Atención',
        STATUS_CRITICAL: 'Crítico',
        INSIGHT: '{{period}}: {{points}} puntos al día, con {{accuracy}} m de error medio de posición',
        INSIGHT_SAME: '; igual que la última semana.',
        INSIGHT_MORE: '; un {{pct}} % más que la última semana.',
        INSIGHT_LESS: '; un {{pct}} % menos que la última semana.',
        PERIODS: {
          LAST_3_DAYS: 'Últimos 3 días',
          LAST_WEEK: 'Última semana',
          LAST_15_DAYS: 'Últimos 15 días',
          LAST_MONTH: 'Último mes',
          LAST_2_MONTHS: 'Últimos 2 meses',
          LAST_QUARTER: 'Último trimestre',
          LAST_4_MONTHS: 'Últimos 4 meses',
          LAST_5_MONTHS: 'Últimos 5 meses',
          LAST_6_MONTHS: 'Últimos 6 meses',
        },
        PERIODS_SHORT: {
          LAST_3_DAYS: '3 días',
          LAST_WEEK: 'semana',
          LAST_15_DAYS: '15 días',
          LAST_MONTH: 'mes',
          LAST_2_MONTHS: '2 meses',
          LAST_QUARTER: 'trimestre',
          LAST_4_MONTHS: '4 meses',
          LAST_5_MONTHS: '5 meses',
          LAST_6_MONTHS: '6 meses',
        },
      },
      FOOTPRINT: {
        ITEMS: 'usuarios',
        RAW_FOOTPRINT: 'Huella bruta',
        RAW_FOOTPRINT_TOOLTIP: 'Ver huella bruta de usuarios',
        SEARCH_PLACEHOLDER: 'Buscar nombre o email',
        REMOVE_FILTER: 'Quitar {{label}}',
        OPEN_CALENDAR: 'Abrir calendario',
        CLEAR: 'Limpiar',
        COL_NAME: 'Nombre',
        COL_SURNAME: 'Apellidos',
        COL_EMAIL: 'Email',
        COL_LAST_FOOTPRINT: 'Última huella',
        COL_LAST_SEGMENT: 'Último segmento',
        BACK: 'Volver',
        USER: 'Usuario',
        SEARCH_USER: 'Buscar usuario...',
        NO_RESULTS: 'Sin resultados',
        FROM_LOCAL: 'Desde (fecha y hora local)',
        TO_LOCAL: 'Hasta (fecha y hora local)',
        SHOWN: 'Mostrado: {{date}}',
        LOADING: 'Cargando…',
        LOAD_DATA: 'Cargar datos',
        EMPTY_MAP: 'Carga datos de un usuario para visualizar su huella bruta en el mapa',
        ERROR_LOADING_USERS: 'Error al cargar usuarios',
        SELECT_USER: 'Selecciona un usuario',
        SELECT_BOTH_DATES: 'Selecciona ambas fechas y horas',
        CHECK_RANGE: 'Revisa el intervalo',
        RANGE_INVALID: 'La fecha/hora de inicio no puede ser mayor que la de fin',
        NO_DATA_TEXT: 'No hay datos disponibles para el período seleccionado',
        LOADED_POINTS: 'Se cargaron {{count}} puntos de huella bruta',
        ERROR_LOADING_DATA: 'Error al cargar datos',
        DETAILS_TITLE: 'Usuario-Huella',
        DETAILS_EXPORT_CSV: 'Exportar usuario completo CSV',
        DETAILS_SELECT_DATE: 'Selecciona fecha:',
        DETAILS_PHONE_STATUS: 'Estado del teléfono',
        DETAILS_DATA: 'Datos',
        DETAILS_CREATED: 'Creación',
        DETAILS_UPDATED: 'Modificación',
        DETAILS_PREVIOUS: '← Anterior',
        DETAILS_NEXT: 'Siguiente →',
        DETAILS_ITEM_OF: 'Elemento {{n}} de {{total}} elementos totales',
        DETAILS_NO_DATA_FOR_DATE: 'No hay datos disponibles para la fecha seleccionada.',
      },
      MATCH_CONFIG_VARIABLES: {
        TITLE: 'Configuraciones de match',
        SUB: 'Cada fila es una configuración del emparejamiento. Pulsa el lápiz para editar un valor: Intro guarda y Esc cancela.',
        LOADING: 'Cargando…',
        LOAD_ERROR: 'No se han podido cargar las variables de match.',
        LOAD_ERROR_TITLE: 'No se han podido cargar las variables',
        RETRY: 'Reintentar',
        EMPTY: 'No hay configuraciones de match.',
        RELOAD: 'Recargar',
        UPDATED: 'Actualizado',
        EDIT_FIELD: 'Editar {{field}}',
        SAVE: 'Guardar',
        SAVING: 'Guardando…',
        SAVED: 'Guardado',
        FOOTER_ONE: 'Mostrando {{count}} de {{total}} configuración',
        FOOTER_OTHER: 'Mostrando {{count}} de {{total}} configuraciones',
        CONFIRM_TITLE: 'Cambiar {{field}}',
        CONFIRM_TEXT: 'Configuración {{id}}: de {{from}} a {{to}}.',
        CONFIRM_BUTTON: 'Sí, guardar',
        SAVE_ERROR_TITLE: 'No se ha podido guardar el cambio',
        INVALID_TITLE: 'Valor inválido',
        INVALID_SELECT: 'Selecciona un valor válido.',
        INVALID_EMPTY: 'El valor no puede estar vacío.',
        INVALID_NUMBER: 'Introduce un número válido antes de guardar.',
        INVALID_INTEGER: 'Este campo solo admite números enteros.',
        GENERIC_ERROR: 'No se pudo completar la operación.',
        LEGEND: 'Leyenda',
        LEGEND_SUB: 'Descripción funcional de las variables mostradas en la tabla.',
        SHOW_GUIDE: 'Ver guía',
        HIDE_GUIDE: 'Ocultar guía',
        LEGEND_ITEMS: {
          ALGORITHM: 'Indica qué algoritmo de matching aplica esta fila de configuración: <code class="bo-code">\'v1\'</code> (legacy) o <code class="bo-code">\'v2\'</code> (nuevo).<br /><br />Detalles:<br />- El algoritmo activo es global: en cuanto existe alguna fila con <code class="bo-code">algorithm = \'v2\'</code>, todo el sistema pasa a usar v2<br />- v1 usa todas sus filas de configuración (ordenadas por <code class="bo-code">order</code>); v2 usa únicamente la primera fila con <code class="bo-code">algorithm = \'v2\'</code>',
          H3_RESOLUTION_START: 'Es el nivel de resolución H3 utilizado para comparar los puntos de inicio (origen) de la ruta del conductor y el pasajero durante el matching.<br /><br />Detalles:<br />- <code class="bo-code">h3_resolution_start = 8</code> -> Hexágonos de ~500 metros<br />- <code class="bo-code">h3_resolution_start = 6</code> -> Hexágonos de ~10 km<br />- <code class="bo-code">h3_resolution_start = 4</code> -> Hexágonos de ~150 km',
          H3_KRING_START: 'Es el número de anillos (k-ring) alrededor del hexágono H3 de inicio que también se aceptan como coincidentes al comparar puntos de origen. Aumentar este valor amplía la tolerancia geográfica más allá del hexágono exacto.',
          H3_RESOLUTION_END: 'Es el nivel de resolución H3 utilizado para comparar los puntos de destino (final) de la ruta del conductor y el pasajero durante el matching.',
          H3_KRING_END: 'Es el número de anillos (k-ring) alrededor del hexágono H3 de destino que también se aceptan como coincidentes al comparar puntos finales. Aumentar este valor amplía la tolerancia geográfica más allá del hexágono exacto.',
          H3_RESOLUTION_POLYLINE: 'Es el nivel de resolución H3 utilizado para extraer hexágonos H3 a lo largo de todo el trayecto (polyline) de ambas rutas para calcular el solapamiento (overlap) entre ellas.',
          H3_KRING_ROUTE: 'Es el número de anillos (k-ring) alrededor de cada hexágono H3 del trayecto que se incluyen al calcular el solapamiento (overlap) entre las polylines del conductor y el pasajero. Aumentar este valor hace más permisivo el cálculo de overlap.',
          DURATION_DELTA: 'Es el máximo tiempo adicional permitido en segundos que puede añadirse a la duración de viaje del conductor cuando recoge a un pasajero. Si el tiempo extra es menor que este umbral, el match se acepta.',
          DISTANCE_DELTA: 'Es un multiplicador porcentual que define el máximo aumento relativo permitido en la duración del viaje. Si el tiempo nuevo es menos de <code class="bo-code">distance_delta</code> veces el tiempo original, el match se acepta.<br /><br />Detalles (importante: el nombre es engañoso):<br />- A pesar de llamarse "<code class="bo-code">distance_delta</code>", NO se refiere a distancia en metros, sino a un umbral de porcentaje<br />- Se valida con la lógica: <code class="bo-code">newDuration / baseDuration &lt; distance_delta</code><br />- Es un factor multiplicador, típicamente entre 1.0 y 1.5',
          DELAY_THRESHOLD: 'Es el máximo retraso permitido en segundos entre la hora real en que el conductor recoge/deja al pasajero y la hora esperada por el pasajero. Si la diferencia es menor que este umbral, el match se acepta.<br /><br />Detalles:<br />- Compara dos tiempos:<br />- Hora real de pickup/dropoff: Calculada a partir del tiempo de viaje del conductor (duración OSRM) + delays<br />- Hora esperada por el pasajero: Su horario de salida/llegada deseado<br />- Si la diferencia es &lt;= <code class="bo-code">delay_threshold</code> segundos en AMBOS casos (pickup y dropoff), el match se acepta',
          EXTENDED_DELAY_THRESHOLD: 'Es el margen de retraso holgado (en segundos) usado en el lado flexible de la ventana horaria, complementando a <code class="bo-code">delay_threshold</code> (margen ajustado del lado comprometido por el usuario).<br /><br />Detalles:<br />- Si se deja vacío (null), se usa <code class="bo-code">delay_threshold</code> en ambos lados, manteniendo el comportamiento simétrico anterior<br />- Al salir: margen ajustado hacia atrás, margen holgado hacia adelante (p.ej. salir más tarde)<br />- Al llegar: margen holgado hacia atrás, margen ajustado hacia adelante (p.ej. llegar antes)',
          DEPARTURE_MARGIN_SECONDS: 'Es el margen de tiempo permitido antes de la salida del conductor para que un pasajero sea considerado compatible. Define una ventana de tiempo temprana donde se aceptan pasajeros.<br /><br />Detalles:<br />- Establece cuántos segundos ANTES de que el conductor salga, se pueden aceptar pasajeros<br />- Se valida con la lógica: <code class="bo-code">riderDepartureTime &gt;= driverDepartureTime - departure_margin_seconds</code><br />- Crea una ventana flexible de compatibilidad temporal',
          ARRIVAL_MARGIN_SECONDS: 'Es el margen de tiempo permitido después de la llegada del conductor para que un pasajero sea considerado compatible. Define una ventana de tiempo tardía donde se aceptan pasajeros.<br /><br />Detalles:<br />- Establece cuántos segundos DESPUÉS de que el conductor llegue, se pueden aceptar pasajeros<br />- Se valida con la lógica: <code class="bo-code">riderArrivalTime &lt;= driverArrivalTime + arrival_margin_seconds</code><br />- Crea una ventana flexible de compatibilidad temporal (en dirección opuesta a <code class="bo-code">departure_margin_seconds</code>)',
          RADIUS_METERS: 'Define el radio geográfico de búsqueda (en metros) usado al hacer matching entre riders y conductores.<br /><br />Detalles:<br />- Al buscar rutas de conductores compatibles para un rider, solo se consideran aquellas cuyos puntos de origen/destino estén dentro de ese radio desde las coordenadas del rider<br />- Es una restricción geográfica que limita los matches a conductores cercanos',
        },
      },
      PAYOUT_REVIEWS: {
        TIME: {
          NOW: 'ahora',
          AGO: 'hace {{value}}',
          IN: 'en {{value}}',
        },
        LEVEL: {
          HIGH: 'Fraude probable',
          MEDIUM: 'Revisar',
          LOW: 'Bajo',
        },
        HOLD: {
          REINFORCED: 'Verificación reforzada',
          CASH_DELAY: 'Retraso de caja',
        },
        DELAY: {
          INSTANT: 'al momento',
          HOURS: '{{value}} h',
          DAY: '{{value}} día',
          DAYS: '{{value}} días',
        },
        DEADLINE: {
          PAID_AUTO: 'Aprobada automáticamente',
          PAID_RECOVERY: 'Pagada (pago recuperado)',
          VERIFIED_BY: 'Verificada por {{name}}',
          REJECTED_BY: 'Rechazada por {{name}}',
          PREAPPROVED_PAYS: 'Aprobada de antemano por {{name}} · se paga {{when}}',
          PREAPPROVED_NEXT_CRON: 'Aprobada de antemano por {{name}} · se pagará en el próximo cron',
          SCHEDULED: 'Programada · se puede pagar {{when}}',
          OVERDUE_OVER_LIMIT: 'Plazo vencido · requiere decisión (supera el tope)',
          NEEDS_DECISION: 'Requiere decisión · plazo {{when}}',
          OVERDUE_NEXT_CRON: 'Plazo vencido · se pagará en el próximo cron',
          AUTO_PAY: 'Auto-pago {{when}}',
        },
        STRIPE_ERRORS: {
          NO_TRANSFERS: 'La cuenta de Stripe del conductor no puede recibir transferencias: le falta activar la capacidad de transferencias (transfers) en Stripe.',
          INSUFFICIENT_FUNDS: 'No hay saldo suficiente en Stripe para hacer la transferencia.',
          NO_ACCOUNT: 'La cuenta de Stripe del conductor no existe o ya no está conectada.',
          RESTRICTED: 'La cuenta de Stripe del conductor está restringida y no puede recibir pagos.',
          BANK_INVALID: 'La cuenta bancaria del conductor en Stripe no es válida o está cerrada.',
          RATE_LIMIT: 'Stripe ha recibido demasiadas peticiones seguidas. Inténtalo de nuevo en unos minutos.',
          GENERIC: 'Stripe rechazó la operación.',
        },
        // Pestaña «Retiradas» de la ficha de usuario (la misma tabla, filtrada).
        USER: {
          TAB: 'Retiradas',
          EMPTY_TITLE: 'Este usuario no tiene retiradas en revisión',
        },
        LIST: {
          HEADER_NOTE: 'Sin decisión en {{hours}} h se pagan solas las de hasta {{amount}}; las que lo superan esperan aquí.',
          KPIS_ARIA: 'Indicadores de retiradas',
          KPI_PENDING: 'Pendientes',
          KPI_PENDING_HINT: 'Esperan revisión o su pago automático',
          KPI_IN_TABLE: 'En la tabla',
          KPI_SEE_IN_TABLE: 'Ver en la tabla',
          KPI_OVERDUE: 'Con plazo vencido',
          KPI_OVERDUE_HINT: 'Pasaron {{hours}} h sin decisión',
          KPI_OVERDUE_HINT_NO_META: 'Pasaron las horas de margen sin decisión',
          KPI_OVERDUE_ACTION: 'Revisar cuanto antes',
          NONE: 'Ninguna',
          KPI_OVER_LIMIT: 'Superan el tope',
          KPI_OVER_LIMIT_HINT: 'Más de {{amount}}: no se pagan solas',
          KPI_OVER_LIMIT_HINT_NO_META: 'Más del tope: no se pagan solas',
          KPI_OVER_LIMIT_ACTION: 'Requieren decisión',
          KPI_DECIDED: 'Decididas hoy',
          KPI_DECIDED_HINT: 'Aprobadas o rechazadas hoy',
          STATUS_ARIA: 'Estado',
          TABS: {
            PENDING: 'Pendientes',
            DECIDED: 'Resueltas',
            ALL: 'Todas',
          },
          PANEL: {
            PENDING_TITLE: 'Retiradas pendientes',
            PENDING_SUBTITLE: 'Esperan una decisión. Pulsa una para ver su análisis de riesgo.',
            DECIDED_TITLE: 'Retiradas decididas',
            DECIDED_SUBTITLE: 'Ya pagadas o rechazadas. Pulsa una para ver su detalle.',
            ALL_TITLE: 'Todas las retiradas',
            ALL_SUBTITLE: 'Pendientes y decididas. Pulsa una para ver su detalle.',
          },
          SEARCH_PLACEHOLDER: 'Buscar por nombre, email, DNI o teléfono',
          SEARCH_ARIA: 'Buscar retiradas',
          SORT_ARIA: 'Orden',
          SORT: {
            RELEASE: 'Orden: plazo más próximo',
            RISK: 'Orden: mayor riesgo',
            AMOUNT: 'Orden: mayor importe',
            CREATED: 'Orden: más recientes',
          },
          REFRESH: 'Actualizar',
          LOADING: 'Cargando retiradas',
          COLS: {
            USER: 'Usuario',
            AMOUNT: 'Importe',
            REQUESTED: 'Solicitada',
            DEADLINE: 'Plazo',
            STATUS: 'Estado',
            RISK: 'Riesgo',
            SIGNALS: 'Señales',
            DECISION: 'Decisión',
            OPEN: 'Abrir',
          },
          ERROR: 'Error',
          RETRY: 'Reintentar',
          EMPTY_TITLE: 'Nada pendiente',
          EMPTY_TEXT: 'No hay retiradas en este filtro.',
          OVER_LIMIT: 'supera el tope',
          STRIPE_ORIGINAL: 'Mensaje original de Stripe: {{message}}',
          ANALYZING: 'Analizando…',
          ANALYSIS_FAILED: 'Análisis fallido',
          TRIPS_KM_ONE: '{{count}} viaje · {{km}} km',
          TRIPS_KM_OTHER: '{{count}} viajes · {{km}} km',
          FIXED_IP: 'IP fija {{pct}}',
          SHARED_IP: 'Pasajeros misma IP {{pct}}',
          APPROVE_SCHEDULED_TIP: 'La deja aprobada: se paga sola cuando llegue su fecha',
          PAY_NOW_TIP: 'Paga la retirada en Stripe ahora',
          APPROVE: 'Aprobar',
          VERIFY: 'Verificar',
          REJECT_TIP: 'Devuelve el importe a su wallet',
          REJECT: 'Rechazar',
          PAID: 'Pagada',
          REJECTED: 'Rechazada',
          APPROVED: 'Aprobada',
          PAYOUT_PAID: 'Pagada en el banco',
          PAYOUT_FAILED: 'Devuelta por el banco',
          PAYOUT_CANCELED: 'Cancelada en Stripe',
          PAYOUT_SENT: 'Enviada al banco',
          PAGINATION: 'Mostrando {{shown}} de {{total}} retiradas',
          PREV: 'Anterior',
          NEXT: 'Siguiente',
          LOAD_ERROR: 'No se pudieron cargar las retiradas.',
          TOAST_PREAPPROVED: 'Retirada de {{amount}} aprobada de antemano: se paga sola {{date}}.',
          TOAST_PAID: 'Retirada de {{amount}} pagada a {{name}}.',
          REJECT_TITLE: 'Rechazar {{amount}} de {{name}}',
          REJECT_TEXT: 'El importe vuelve a su wallet. No se paga nada en Stripe. El motivo es opcional y solo lo ve el equipo.',
          REJECT_PLACEHOLDER: 'Motivo (opcional): p. ej. IP fija en todos los viajes, saltos GPS…',
          REJECT_ARIA: 'Motivo opcional',
          REJECT_CONFIRM: 'Rechazar retirada',
          CANCEL: 'Cancelar',
          REJECTING: 'Rechazando…',
          ALREADY_DECIDED: 'Ya decidida',
          DECIDED_BY_OTHER: 'Otra persona decidió antes.',
          DECIDED_BY_NAME: '{{message}} Decidida por {{name}}.',
          STRIPE_REJECTED_TITLE: 'Stripe no aceptó el pago',
          STILL_PENDING: 'La retirada sigue pendiente.',
          STRIPE_ERROR_STILL_PENDING: '{{error}} La retirada sigue pendiente.',
          DECISION_ERROR: 'No se pudo aplicar la decisión',
          NO_JUMPS: 'Sin saltos',
          JUMPS_ONE: '{{count}} salto · {{detail}}',
          JUMPS_OTHER: '{{count}} saltos · {{detail}}',
          JUMP_KM_KMH: '{{km}} km a {{kmh}} km/h',
        },
        DETAIL: {
          BREADCRUMB_ARIA: 'Ruta de navegación',
          DETAIL: 'Detalle',
          LOADING: 'Cargando retirada',
          BACK: 'Volver',
          VIEW_PROFILE: 'Ver ficha',
          DNI: 'DNI {{value}}',
          SIGNUP: 'Alta {{date}}',
          APPROVE_SCHEDULED_TIP: 'Todavía no se puede pagar: queda aprobada y se paga sola en su fecha',
          PREAPPROVE: 'Aprobar de antemano',
          VERIFY_AND_PAY: 'Verificar y pagar',
          DECIDED_AUTO: 'automáticamente',
          DECIDED_BY: 'por {{name}}',
          REQUESTED_AT: 'solicitada {{when}} · {{date}}',
          SCHEDULED_FOR: 'Programada por {{reason}} · se puede pagar desde {{date}}',
          CASH_DELAY: 'Retraso de caja {{delay}}',
          CASH_DELAY_FIRST: '(de sus primeras)',
          CASH_PREVIOUS_ONE: '{{count}} retirada previa por {{amount}}',
          CASH_PREVIOUS_OTHER: '{{count}} retiradas previas por {{amount}}',
          CASH_LAST: 'la anterior {{delay}}',
          CASH_LAST_LATE: 'la anterior {{delay}}, llegó tarde',
          PREAPPROVED_BY: 'Aprobada de antemano por {{name}} · {{date}}',
          NO_FLAGS: 'Sin señales de fraude en el periodo.',
          ANALYZING: 'Analizando viajes, IPs y huella…',
          NOTE: 'Nota:',
          STRIPE: 'Stripe:',
          STRIPE_ERROR: 'Error de Stripe:',
          KPIS_ARIA: 'Indicadores de la retirada',
          K_TRIPS: 'Viajes como conductor',
          K_TRIPS_HINT: 'En el periodo analizado',
          K_TRIPS_DELTA: '{{km}} km · {{hours}} h · {{days}} días',
          K_PER_DAY: 'Viajes por día activo',
          K_PER_DAY_HINT: 'Media de los días con viajes',
          K_PER_DAY_DELTA: 'máx. {{count}} en un día',
          K_MAX_DAY: 'Máximo de viaje en un día',
          K_MAX_DAY_HINT: 'Horas conduciendo el día con más viajes',
          K_OVER_4H: 'Más de 4 h',
          K_NORMAL: 'Normal',
          K_FIXED_IP: 'Viajes con IP fija',
          K_FIXED_IP_HINT: 'IP de hogar u oficina, no móvil',
          K_FIXED_IP_DELTA: '{{fixed}} de {{total}} con datos de IP',
          K_SHARED: 'Pasajeros en su IP',
          K_SHARED_HINT: 'Todos los pasajeros con la IP del conductor',
          K_SHARED_DELTA: '{{shared}} de {{total}} con datos · alguno: {{any}}',
          K_JUMPS: 'Saltos GPS imposibles',
          K_JUMPS_HINT: 'Más de 10 km y 130 km/h entre puntos',
          K_JUMPS_DELTA: 'máx. {{km}} km · {{kmh}} km/h',
          K_NONE: 'Ninguno',
          MONEY_TITLE: 'Dinero',
          MONEY_NOTE: 'no influye en la puntuación',
          MONEY_REQUESTED: 'Pide retirar',
          MONEY_EARNED_PERIOD: 'Generado en el periodo',
          MONEY_WALLET: 'En la wallet ahora',
          MONEY_WITHDRAWN: 'Retirado a banco (histórico)',
          MONEY_WITHDRAWN_COUNT: '· {{count}} retiradas',
          MONEY_EARNED_TOTAL: 'Generado total',
          MONEY_REVIEWS: 'Revisiones previas',
          MONEY_REVIEWS_VALUE: '{{approved}} pagadas · {{rejected}} rechazadas',
          RIDERS_TITLE: 'Pasajeros que ha llevado',
          RIDERS_COUNT: '{{count}} distintos',
          RIDER_TRIPS_ONE: '{{count}} viaje · {{amount}}',
          RIDER_TRIPS_OTHER: '{{count}} viajes · {{amount}}',
          RIDER_SAME_IP: 'misma IP {{same}}/{{total}}',
          RIDER_NEVER_DRIVES: 'nunca conduce',
          RIDER_SAME_WEEK: 'alta misma semana',
          NO_RIDERS: 'Ningún pasajero confirmado en el periodo.',
          MAP_TITLE: 'Huella GPS del periodo',
          MAP_POINTS: 'Puntos',
          MAP_LINE: 'Recorrido',
          MAP_JUMPS: 'Saltos',
          MAP_COLOR_TRIPS: 'Colorear viajes',
          MAP_FIT: 'Ver todo',
          MAP_LOADING: 'Cargando huella…',
          MAP_FOOTER: '{{kept}} puntos pintados de {{total}} leídos ({{from}} → {{to}}) · recorrido {{km}} km',
          MAP_TRUNCATED: 'huella recortada a los últimos 60 días del periodo',
          JUMPS_TITLE: 'Saltos GPS imposibles',
          JUMPS_NOTE: '> 10 km entre dos puntos consecutivos a > 130 km/h · cuanto más km y más km/h, más claro',
          J_FROM: 'Desde',
          J_TO: 'Hasta',
          J_KM: 'Km',
          J_KMH: 'Km/h',
          J_SECONDS: 'Segundos',
          J_SHOW: 'Ver en el mapa',
          TRIPS_TITLE: 'Viajes como conductor',
          TRIPS_NOTE: '{{reason}} · {{from}} → {{to}} · clic en un viaje para verlo en el mapa',
          T_START: 'Inicio',
          T_ROUTINE: 'Rutina',
          T_DURATION: 'Duración',
          T_RIDERS: 'Pasajeros',
          T_DRIVER_IP: 'IP del conductor',
          T_SHARED: 'Pasajeros en su IP',
          T_EARNS: 'Cobra',
          OVERLAP: 'solape {{pct}} %',
          RIDER_SAME: 'misma IP',
          RIDER_OTHER: 'otra IP',
          RIDER_NO_IP: 'sin datos de IP',
          NO_RIDERS_TRIP: 'Sin pasajeros',
          DETAIL_LINK: 'Detalle',
          NO_TRIPS: 'Sin viajes terminados como conductor en el periodo.',
          IPS_TITLE: 'IPs vistas durante los viajes',
          IPS_RESOLVING: 'resolviendo rDNS desde el navegador…',
          IPS_NOTE: 'fija = rDNS de operador de hogar/oficina o misma IP ≥ 3 días · móvil (CGNAT) cambia entre días',
          I_IP: 'IP',
          I_TYPE: 'Tipo',
          I_DETAIL: 'Detalle',
          I_TRIPS: 'Viajes',
          I_DAYS: 'Días',
          I_USERS: 'Usuarios',
          I_DRIVER: 'conductor',
          I_RDNS_PENDING: 'rDNS pendiente',
          COMPUTED: 'Informe calculado {{when}} ({{date}}).',
          RECOMPUTE: 'Recalcular',
          ANALYSIS_FAILED_TEXT: 'El análisis falló: {{error}}',
          RETRY_ANALYSIS: 'Reintentar análisis',
          NOT_FOUND: 'Esta retirada no existe.',
          LOAD_ERROR: 'No se pudo cargar la retirada.',
          TRACK_NOT_READY: 'La huella aún no está lista.',
          TRACK_ERROR: 'No se pudo cargar la huella.',
          TOAST_PREAPPROVED: 'Aprobada de antemano: se pagan {{amount}} solos {{date}}.',
          TOAST_PAID: 'Pagados {{amount}} a {{name}}.',
          REJECT_TITLE: 'Rechazar {{amount}}',
          REJECT_TEXT: 'El importe vuelve a la wallet del usuario. No se paga nada en Stripe. El motivo es opcional y solo lo ve el equipo.',
          REJECT_PLACEHOLDER: 'Motivo (opcional)',
          RECOMPUTE_ERROR: 'No se pudo recalcular',
          PERIOD: {
            LAST_PAYOUT: 'desde su último cobro',
            FIRST_TRIP: 'desde su primer viaje (nunca había cobrado)',
            SIGNUP: 'desde su alta',
          },
          IP_KIND: {
            HOSTING: 'Hosting / VPN',
            FIXED: 'Fija',
            FIXED_PROBABLE: 'Fija (probable)',
            MOBILE: 'Móvil',
            UNKNOWN: 'Desconocida',
          },
          TRIP_IP: {
            NO_DATA: 'Sin datos',
            FIXED_ALL: 'IP fija toda la ruta',
            FIXED_MANY: 'IPs fijas',
            MOBILE: 'Móvil',
            ONE_UNKNOWN: 'Una IP (desconocida)',
            MANY: '{{count}} IPs',
          },
          DURATION_RATIO: '{{pct}} % del plan',
        },
        MAP: {
          DURING_TRIP: 'Durante un viaje',
          OUT_OF_TRIP: 'Fuera de viaje',
          SELECTED: 'Seleccionado',
          IMPOSSIBLE_JUMP: 'Salto imposible',
          JUMP_TOOLTIP: '{{km}} km en {{seconds}} s',
          JUMP_TOOLTIP_KMH: '{{km}} km en {{seconds}} s · {{kmh}} km/h',
        },
      },
      PARTNER_PANEL: {
        COMMON: {
          CLOSE: 'Cerrar',
          CANCEL: 'Cancelar',
          SAVE: 'Guardar',
          SAVING: 'Guardando…',
          RETRY: 'Reintentar',
          OK: 'Aceptar',
          PREVIOUS: 'Anterior',
          NEXT: 'Siguiente',
          ACTION_ERROR: 'No se ha podido completar la acción. Inténtalo de nuevo.',
        },
        SPLIT: {
          LABEL: 'Reparto a la bolsa de la empresa',
          VALUE: '{{n}} % a la bolsa de la empresa',
          ALL_PARTNER: 'Todo para {{partner}}',
          ALL_WALLET: 'Todo a la bolsa',
        },
        BILLING_MODE: {
          LABEL: 'Quién factura',
          WAIIS: 'WAIIS factura a la empresa',
          PARTNER: '{{partner}} factura a la empresa',
          PARTNER_HINT: 'WAIIS le factura a {{partner}} la bolsa',
          LOCKED: 'Quién factura solo cambia en la renovación. Lo cambia WAIIS.',
          SCHEDULED: 'Desde la renovación: {{option}}',
          NO_AMOUNT_NOTE: 'Sin importe no se guarda el plan: quién factura se elige después en «Contrato y precio».',
          LIST_WAIIS: 'Factura WAIIS',
          LIST_PARTNER: 'Factura {{partner}}',
        },
        STATUS: {
          INVITED: 'Invitación enviada',
          NONE: '—',
        },
        COMPANIES: {
          TITLE: 'Empresas de {{name}}',
          SUBTITLE: 'Tus empresas: su adopción, su plan anual y lo que les falta. Haz clic en una fila para ver su ficha.',
          NEW_COMPANY: 'Nueva empresa',
          EXPORT: 'Exportar CSV',
          EXPORT_ERROR: 'No se ha podido exportar.',
          KPIS_LABEL: 'Indicadores de tus empresas',
          KPI_COMPANIES: 'Empresas',
          KPI_COMPANIES_HINT: '{{active}} activas · {{trial}} en prueba',
          KPI_REGISTERED: 'Empleados registrados',
          KPI_REGISTERED_HINT: '{{percent}} % de {{declared}} en plantilla',
          KPI_REGISTERED_HINT_NONE: 'de {{declared}} en plantilla',
          KPI_TRIPS: 'Viajes compartidos · {{month}}',
          KPI_CO2: 'CO₂e evitado · {{month}}',
          KPI_CO2_VALUE: '{{value}} t',
          KPI_CONTRACTED: 'Contratado al año',
          KPI_CONTRACTED_SUB: 'Empresas activas',
          KPI_CONTRACTED_HINT: '{{wallet}} a bolsas',
          KPIS_ERROR: 'No se han podido cargar los indicadores.',
          ENDING_ONE: 'Una empresa acaba la prueba pronto',
          ENDING_OTHER: '{{n}} empresas acaban la prueba pronto',
          ENDING_ITEM: '{{name}} · acaba el {{date}} ({{days}} días)',
          ENDING_ITEM_ONE_DAY: '{{name}} · acaba el {{date}} (1 día)',
          PREPARE_CONTRACT: 'Preparar contrato',
          SEARCH_PLACEHOLDER: 'Buscar por nombre o CIF…',
          SEARCH_LABEL: 'Buscar empresas',
          FILTER_ALL: 'Todas',
          FILTER_ACTIVE: 'Activas',
          FILTER_TRIAL: 'En prueba',
          FILTER_LOCKED: 'Bloqueadas',
          FILTER_PENDING: 'Pendientes',
          FILTER_NONE: 'Sin estado',
          FILTER_STATUS_LABEL: 'Estado',
          FILTER_MANAGER: 'Gestor',
          FILTER_MANAGER_ALL: 'Gestor: todos',
          CLEAR_FILTERS: 'Limpiar filtros',
          TABLE_TITLE: 'Tus empresas',
          COL_COMPANY: 'Empresa',
          COL_MANAGER: 'Gestor',
          COL_HEADCOUNT: 'Plantilla',
          COL_REGISTERED: 'Registro',
          COL_TRIPS: 'Viajes ({{month}})',
          COL_PLAN: 'Plan anual',
          COL_STATUS: 'Estado',
          COL_ACTIONS: 'Acciones',
          PLAN_YEAR: '{{amount}} / año',
          PLAN_WALLET: '{{wallet}} a bolsa · {{monthly}}/mes',
          PLAN_NONE: 'Sin plan anual',
          PLAN_DRAFT: 'Sin activar',
          PLAN_PENDING_PAYMENT: 'Pago pendiente',
          PLAN_PENDING_INVOICE: 'Factura pendiente',
          NO_MANAGER: 'Sin gestor',
          EMPTY: 'No hay empresas con estos filtros',
          LOAD_ERROR: 'No se han podido cargar las empresas.',
          ACTION_DASHBOARD: 'Ver su dashboard',
          ACTION_CONTRACT: 'Contrato y precio',
          ACTION_DETAIL: 'Abrir la ficha',
          FOOT: 'Mostrando {{shown}} de {{total}} empresas',
          CREATED_PRICE_ERROR: 'La empresa se ha creado, pero su precio no se ha podido guardar. Ponlo en «Contrato y precio».',
        },
        CREATE: {
          TITLE: 'Nueva empresa',
          SUBTITLE: 'Le invitamos al momento: el administrador recibe un correo para entrar.',
          SUBTITLE_REQUEST: 'Con los datos de la solicitud de {{company}}.',
          SECTION_COMPANY: 'Empresa',
          SECTION_ADMIN: 'Administrador de la empresa',
          SECTION_PRICE: 'Precio y prueba',
          LEGAL_NAME: 'Empresa (razón social)',
          TAX_ID: 'CIF',
          CITY: 'Ciudad',
          EMPLOYEES: 'Nº de empleados',
          MANAGER: 'Gestor',
          MANAGER_HINT: 'Un Partner admin de tu equipo.',
          ADMIN_NAME: 'Nombre y apellidos',
          ADMIN_EMAIL: 'Correo',
          ADMIN_EMAIL_HINT: 'Le llegará la invitación para entrar.',
          ADMIN_PHONE: 'Teléfono',
          PRICE_SUMMARY: 'Bolsa de la empresa {{wallet}} al año · {{monthly}} cada mes',
          ERROR_REQUIRED: 'Campo obligatorio',
          ERROR_EMAIL: 'Escribe un email válido',
          ERROR_EMPLOYEES: 'Escribe un número mayor que 0.',
          ERROR_AMOUNT: 'Escribe un importe mayor que 0.',
          ERROR_SAVE: 'No se ha podido crear la empresa. Inténtalo de nuevo.',
          SUBMIT: 'Crear y enviar invitación',
          CREATING: 'Creando…',
          DONE_INVITED: 'Empresa creada. Invitación enviada a {{email}}',
          DONE_LINKED: 'Empresa creada. {{email}} ya puede entrar como administrador',
        },
        CONTRACT: {
          CLOSE_PERIOD: {
            BUTTON: 'Cerrar el periodo hoy',
            TITLE: 'Cerrar el periodo hoy',
            TEXT: 'El periodo en curso del plan acaba hoy en vez del {{date}} y se abre la renovación con lo programado (quién factura, importe y reparto). La bolsa deja de recibir los meses que faltaban. Devolver o compensar lo que no se ha asignado se hace a mano.',
            CONFIRM: 'Cerrar el periodo',
            CANCEL: 'Cancelar',
            DONE: 'Periodo cerrado. La renovación está abierta.',
            ERROR: 'No se ha podido cerrar el periodo. Inténtalo de nuevo.',
          },
          AMOUNT: 'Importe anual',
          AMOUNT_HINT: '€ al año · IVA aparte',
          TRIAL_MONTHS: 'Meses de prueba',
          TRIAL_UNCHANGED: 'Sin cambiar',
          TRIAL_HINT: 'Meses de prueba gratis desde el alta.',
          TRIAL_ENDS: 'Ahora la prueba acaba el {{date}}.',
          TRIAL_LOCKED: 'Con el plan activo, la prueba ya no se cambia.',
          SPLIT: 'Reparto',
          PRICE_TITLE: 'Precio anual',
          PRICE_SUB: 'Lo que paga la empresa al año y qué parte va a su bolsa.',
          ACTIVE_NOTE: 'El plan está activo: el reparto cambia desde el mes siguiente y el importe, en la renovación.',
          SCHEDULED_SPLIT: 'Programado: {{n}} % a la bolsa desde el {{date}}.',
          SCHEDULED_AMOUNT: 'En la renovación: {{amount}}.',
          SUMMARY_TITLE: 'Resumen',
          SUMMARY_EMPTY: 'Escribe el importe anual para ver el reparto entre {{partner}} y la bolsa.',
          SUMMARY_PLAN: 'Plan anual',
          SUMMARY_PARTNER: 'Para {{partner}}',
          SUMMARY_WALLET: 'Bolsa de la empresa',
          SUMMARY_MONTHLY: 'Bolsa cada mes · acumulable',
          SAVED: 'Precio guardado',
          SAVED_ACTIVE: 'El reparto cambia desde el mes siguiente; el importe, en la renovación.',
          SAVE_ERROR: 'No se ha podido guardar el precio.',
          ERROR_NO_AMOUNT: 'Escribe el importe anual.',
          LOAD_ERROR: 'No se ha podido cargar el plan anual.',
          CHECK_TITLE: 'Para activar el plan',
          CHECK_NOTE: 'Lo rellenas tú con el cliente. Él solo ve el resultado en su dashboard.',
          STEP_BILLING: 'Datos de facturación',
          STEP_BILLING_TEXT: 'Los da la empresa al pagar en Stripe; el panel no recibe su estado.',
          STEP_PAYMENT: 'Pago',
          STEP_PAYMENT_TEXT: 'Con el enlace de pago de Stripe: tarjeta, SEPA o transferencia.',
          STEP_CONTRACT: 'Contrato',
          STEP_CONTRACT_TEXT: 'Lo cierra la empresa al pagar el plan; el panel no recibe su estado.',
          GENERATE_LINK: 'Generar enlace de pago',
          LINK_NEEDS_PRICE: 'Guarda antes el precio.',
          COPY_LINK: 'Copiar enlace de pago',
          LINK_COPIED: 'Enlace copiado',
          LINK_EXPIRES: 'Vale hasta el {{date}}.',
          LINK_ERROR: 'No se ha podido generar el enlace de pago.',
          PAYMENT_IN_PROGRESS: 'El pago está en curso.',
          STATE_DONE: 'Hecho',
          STATE_PENDING: 'Pendiente',
          STATE_ON_PAYMENT: 'Al pagar',
          INVOICE_TITLE: 'Factura de WAIIS a {{partner}}',
          INVOICE_NOTE: 'WAIIS le factura a {{partner}} la bolsa de la empresa. La empresa no paga nada ni lo ve en su dashboard.',
          STEP_PARTNER_PAYMENT: 'Pago de {{partner}}',
          STEP_PARTNER_PAYMENT_TEXT: '{{partner}} paga por transferencia con los datos de la factura de Stripe.',
          GENERATE_INVOICE: 'Generar factura',
          VIEW_INVOICE: 'Ver factura',
          INVOICE_DUE: 'Vence el {{date}}.',
          INVOICE_WALLET: 'La bolsa de {{company}} empieza cuando {{partner}} pague esta factura.',
          INVOICE_ERROR: 'No se ha podido generar la factura.',
        },
        SUMMARY: {
          FUNNEL_TITLE: 'Adopción de la plantilla',
          FUNNEL_SUB: '{{percent}} % de {{total}} en plantilla',
          FUNNEL_REGISTERED: 'Registrados',
          FUNNEL_ROUTINE: 'Con rutina',
          FUNNEL_SHARED: 'Viaje compartido',
          FUNNEL_PERCENT_TIP: 'Sobre los registrados',
          TRIPS_TITLE: 'Viajes compartidos por mes',
          NO_TRIPS: 'Sin viajes todavía',
          CONTACT_TITLE: 'Contacto',
          ADMIN: 'Administrador',
          EMAIL: 'Correo',
          PHONE: 'Teléfono',
          MANAGER: 'Gestor del partner',
        },
        EMPLOYEES: {
          ADD: 'Añadir empleados',
          EXPORT: 'Exportar CSV',
          EXPORT_ERROR: 'No se ha podido exportar la plantilla.',
          ADD_TITLE: 'Añadir empleados',
          NOTE: 'Las altas las haces tú. La empresa solo ve la lista.',
          OFFICE: 'Sede',
          NO_OFFICES: 'Crea antes una sede en la pestaña «Sedes».',
          BY_EMAIL: 'Por correo',
          EMAILS: 'Correos de los empleados',
          EMAILS_PLACEHOLDER: 'ana@empresa.es, pere@empresa.es',
          EMAILS_HINT: 'Separados por comas o en líneas. La invitación sale al momento.',
          SEND: 'Enviar invitaciones',
          BY_CSV: 'O sube un CSV',
          CSV_FILE: 'Fichero CSV',
          TEMPLATE: 'Descargar la plantilla de ejemplo',
          UPLOAD: 'Subir CSV',
          SENT_ONE: '1 invitación enviada a la plantilla de {{company}}',
          SENT_OTHER: '{{n}} invitaciones enviadas a la plantilla de {{company}}',
          SKIPPED: 'Ya estaban en la plantilla: {{emails}}.',
          CSV_DONE: 'CSV subido a la plantilla de {{company}}',
          ERROR_NO_EMAILS: 'Escribe al menos un correo.',
          ERROR_EMAILS: 'Revisa estos correos: {{emails}}',
          ERROR_SAVE: 'No se han podido dar de alta. Inténtalo de nuevo.',
        },
        OFFICES: {
          CREATE: 'Crear sede',
          CREATE_TITLE: 'Crear sede',
          CREATE_SUB: 'Elige la dirección del autocompletado: sin ella no se puede crear.',
          NAME: 'Nombre de la sede',
          ADDRESS: 'Dirección',
          ADDRESS_PLACEHOLDER: 'Empieza a escribir la dirección…',
          ADDRESS_HINT: 'Elige una dirección de la lista.',
          ADDRESS_OK: 'Dirección elegida · {{city}}',
          CONTACT: 'Contacto de la sede',
          CONTACT_NAME: 'Nombre',
          CONTACT_EMAIL: 'Correo',
          CONTACT_PHONE: 'Teléfono',
          CREATED: '«{{name}}» creada',
          ERROR_SAVE: 'No se ha podido crear la sede. Inténtalo de nuevo.',
        },
        DATA: {
          TITLE: 'Datos de la empresa',
          SUBTITLE: 'Lo que ve la empresa en su espacio. El correo de acceso del administrador no se cambia aquí.',
          TRADE_NAME: 'Nombre comercial',
          LEGAL_NAME: 'Razón social',
          TAX_ID: 'CIF',
          CITY: 'Ciudad',
          EMPLOYEES: 'Nº de empleados',
          MANAGER: 'Gestor',
          MANAGER_HINT: 'Solo un Partner admin de tu equipo.',
          ADMIN_TITLE: 'Administrador',
          ADMIN_NAME: 'Nombre',
          ADMIN_EMAIL: 'Correo de acceso',
          ADMIN_EMAIL_HINT: 'No se cambia: para otro administrador, invítalo.',
          CHANGE_ADMIN: 'Cambiar administrador',
          CHANGE_ADMIN_NOTE: 'Invitamos al nuevo administrador. El anterior conserva su acceso.',
          NEW_ADMIN_EMAIL: 'Correo del nuevo administrador',
          INVITE_ADMIN: 'Invitar al nuevo administrador',
          ADMIN_INVITED: 'Invitación enviada a {{email}}',
          ADMIN_LINKED: '{{email}} ya puede entrar como administrador',
          ADMIN_ERROR: 'No se ha podido cambiar el administrador.',
          SAVE: 'Guardar cambios',
          SAVED: 'Datos guardados',
          NO_CHANGES: 'No hay cambios que guardar.',
          FIX_FIELDS: 'Revisa los campos obligatorios.',
          SAVE_ERROR: 'No se han podido guardar los datos.',
        },
        FOLLOWUP: {
          CONTACT_TITLE: 'Contacto',
          COPY_EMAIL: 'Copiar email',
          EMAIL_COPIED: 'Email copiado',
          NOTES_TITLE: 'Notas de seguimiento',
          NOTES_SUB: 'Lo que hablas con la empresa. WAIIS también las ve.',
          NEW_NOTE: 'Escribe una nota…',
          ADD: 'Añadir',
          EMPTY: 'Sin notas todavía',
          LOAD_ERROR: 'No se han podido cargar las notas.',
          SAVE_ERROR: 'No se ha podido guardar la nota.',
          SYSTEM: 'Sistema',
          UNKNOWN_AUTHOR: 'Usuario',
        },
        WALLET: {
          BAG_TITLE: 'Bolsa de {{month}} · 1/12 del plan anual',
          BAG_SUB: 'Lo que no se gasta se acumula para el mes siguiente.',
          MONTHLY: '{{amount}} cada mes del plan anual',
          AVAILABLE: 'Saldo disponible en la cartera: {{amount}}',
          INACTIVE_TITLE: 'Se activa con el contrato',
          INACTIVE_TEXT: 'Durante la prueba no hay bolsa: empieza con el contrato.',
          MOVES_TITLE: 'Movimientos del mes',
          MOVES_EMPTY: 'Sin movimientos este mes.',
          MOVES_ERROR: 'No se han podido cargar los movimientos.',
          LOAD_ERROR: 'No se ha podido cargar la cartera.',
        },
      },
      PARTNER_REQUESTS: {
        TABS_LABEL: 'Estado de la solicitud',
        TAB_NEW: 'Nuevas',
        TAB_CONTACTED: 'Contactadas',
        TAB_CREATED: 'Alta creada',
        TAB_DISCARDED: 'Descartadas',
        TITLE_TAB_NEW: 'Solicitudes nuevas',
        TITLE_TAB_CONTACTED: 'Solicitudes contactadas',
        TITLE_TAB_CREATED: 'Solicitudes con alta creada',
        TITLE_TAB_DISCARDED: 'Solicitudes descartadas',
        INTRO: 'Empresas que han llegado al umbral de un partner al registrarse. Las gestiona el partner; aquí ves todas, de todos.',
        COL_RECEIVED: 'Recibida',
        COL_COMPANY: 'Empresa',
        COL_PARTNER: 'Partner',
        COL_EMPLOYEES: 'Empleados',
        COL_CONTACT: 'Contacto',
        COL_ORIGIN: 'Origen',
        COL_ACTIONS: 'Acciones',
        ORIGIN_SIGNUP: 'Registro',
        EMPTY: 'No hay solicitudes en este estado.',
        LOAD_ERROR: 'No se han podido cargar las solicitudes.',
        RETRY: 'Reintentar',
        FOOT: 'Mostrando {{shown}} de {{total}} solicitudes',
        REASSIGN: 'Reasignar',
        REASSIGN_TITLE: 'Reasignar la solicitud',
        REASSIGN_CURRENT: 'Ahora es de {{partner}}.',
        REASSIGN_TO: 'Nuevo partner',
        REASSIGN_HINT: 'La solicitud pasa al panel del partner nuevo y deja de salir en el del actual.',
        REASSIGN_CONFIRM: 'Reasignar',
        REASSIGNING: 'Reasignando…',
        REASSIGN_ERROR: 'No se ha podido reasignar la solicitud.',
        CREATE_COMPANY: 'Crear empresa',
        DISCARD: 'Descartar',
        PARTNER_SUBTITLE: 'Empresas grandes que han pedido WAIIS contigo al registrarse: contáctalas y crea su empresa.',
        PARTNER_INTRO: 'Elige una solicitud para ver sus datos y lo que puedes hacer con ella.',
        EMPTY_NEW_PARTNER: 'Estás al día. Las nuevas solicitudes aparecerán aquí.',
        DETAIL_TITLE: 'Datos del registro de {{company}}',
        DETAIL_TAX_ID: 'CIF',
        DETAIL_EMAIL: 'Correo',
        DETAIL_PHONE: 'Teléfono',
        DETAIL_REASON: 'Motivo del descarte',
        CREATE_FROM_REQUEST: 'Crear empresa con estos datos',
        MARK_CONTACTED: 'Marcar contactada',
        RESTORE: 'Recuperar solicitud',
        DISCARD_TITLE: '¿Por qué la descartas?',
        DISCARD_TEXT: 'Le avisamos por correo de que no seguís adelante.',
        DISCARD_CONFIRM: 'Descartar solicitud',
        DISCARD_REASON_SIZE: 'No encaja por tamaño',
        DISCARD_REASON_OTHER_PROVIDER: 'Ya trabaja con otro proveedor',
        DISCARD_REASON_NO_RESPONSE: 'No responde',
        DISCARD_REASON_DUPLICATE: 'Duplicada',
        CONTACTED: '{{company}} pasa a contactadas',
        DISCARDED: '{{company}} descartada',
        RESTORED: '{{company}} vuelve a nuevas',
      },
      PARTNERS: {
        USERS: {
          TITLE: 'Usuarios del partner',
          SUBTITLE: 'Quién entra al panel de {{partner}}: Partner admin (gestiona) y Partner usuario (solo consulta).',
          NOTE: 'Los gestiona {{partner}} desde su panel.',
        },
        PAYOUT: {
          TITLE: 'Plazo del abono de la bonificación CAE',
          NOTE: 'Lo fija {{partner}} desde su panel.',
        },
        BILLING: {
          TITLE: 'Facturación',
          SUBTITLE: 'Cliente de Stripe al que WAIIS factura a {{partner}} y liquidación del plan anual.',
          CUSTOMER_TITLE: 'Cliente de Stripe',
          CUSTOMER_TEXT: 'Cliente al que WAIIS factura la bolsa de las empresas en las que {{partner}} factura.',
          CUSTOMER_ID: 'Id del cliente en Stripe',
          SAVE: 'Guardar',
          NAME: 'Nombre en Stripe',
          EMAIL: 'Correo en Stripe',
          NO_CUSTOMER: 'Sin cliente de Stripe: no se le puede facturar.',
          SAVED: 'Cliente de Stripe de {{partner}} guardado',
          STRIPE_UNAVAILABLE: 'No se ha podido contactar con Stripe. Inténtalo de nuevo.',
          SAVE_ERROR: 'No se ha podido guardar el cliente de Stripe.',
          LOAD_ERROR: 'No se ha podido cargar el cliente de Stripe.',
          SETTLEMENT_TITLE: 'Liquidación del plan anual',
          SETTLEMENT_TEXT: 'Por empresa y periodo: lo cobrado, lo que fue a la bolsa y lo que corresponde a {{partner}}.',
          FROM: 'Desde',
          TO: 'Hasta',
          DOWNLOAD: 'Descargar CSV',
          DATES_HINT: 'Fecha de cobro, ambos días incluidos.',
          SETTLEMENT_HELP: 'En las filas cobradas por Connect se paga la «Diferencia», no la «Parte del partner». La «Bolsa no asignada» es a devolver o compensar.',
          DOWNLOAD_ERROR: 'No se ha podido descargar la liquidación.',
        },
        TABS: {
          DATA: 'Datos y acceso',
          LARGE: 'Grandes cuentas',
          DEFAULTS: 'Precios y meses de prueba',
          SECTIONS: 'Qué ve la empresa',
          USERS: 'Usuarios del partner',
          PAYOUT: 'Abono a conductores',
          BILLING: 'Facturación',
        },
        SETTINGS_ERROR: 'No se ha podido cargar la configuración del partner.',
        LARGE: {
          TITLE: 'Grandes cuentas',
          SUBTITLE: 'Si {{partner}} recibe las empresas grandes que se registran en WAIIS y a quién se avisa.',
          FLAG: 'Partner de grandes cuentas',
          THRESHOLD: 'Umbral de empleados',
          THRESHOLD_HINT: 'Las empresas con más de este número de empleados envían una solicitud al partner en vez de crear su espacio.',
          FROM_NOW: 'Se aplica a los registros a partir de ahora.',
          THRESHOLD_INVALID: 'Escribe un número entero mayor que 0.',
          EMAILS: 'Correos de aviso',
          EMAILS_HINT: 'Reciben cada solicitud nueva. Sin ninguno, solo le llega a WAIIS.',
          ADD_EMAIL: 'Añadir',
          REMOVE_EMAIL: 'Quitar {{email}}',
          EMAIL_INVALID: 'Escribe un correo válido.',
          SAVE: 'Guardar',
          SAVED: 'Grandes cuentas de {{partner}} guardadas',
          OK: 'Aceptar',
          SAVE_ERROR: 'No se han podido guardar las grandes cuentas.',
        },
        DEFAULTS: {
          TITLE: 'Precios y meses de prueba',
          SUBTITLE: 'Lo que reciben por defecto las empresas nuevas de {{partner}}.',
          NOTE: 'Los fija {{partner}} desde su panel.',
          WALLET: 'Reparto por defecto · {{percent}} % a la bolsa',
          TRIAL_MONTHS: 'Meses de prueba gratis por defecto · {{months}}',
        },
        ADMINS: {
          TITLE: 'Partner admin',
          SUBTITLE: 'Quién administra {{partner}}: ve y gestiona sus empresas e invita a su equipo. Se asigna por invitación: le llega un correo, válido 7 días, y pasa a ser Partner admin al aceptarlo.',
          COL_PERSON: 'Persona',
          COL_STATUS: 'Estado',
          COL_DATE: 'Fecha',
          COL_ACTIONS: 'Acciones',
          STATUS_ACTIVE: 'Activo',
          STATUS_PENDING: 'Invitación pendiente',
          STATUS_EXPIRED: 'Invitación caducada',
          SINCE: 'Desde {{date}}',
          EXPIRES_ON: 'Caduca {{date}}',
          EXPIRED_ON: 'Caducó {{date}}',
          EMPTY: 'Todavía no tiene Partner admin. Invita a alguien abajo.',
          LOAD_ERROR: 'No se han podido cargar los Partner admin.',
          EMAIL: 'Asignar Partner admin',
          EMAIL_PLACEHOLDER: 'nombre@empresa.com',
          EMAIL_INVALID: 'Escribe un email válido.',
          EMAIL_HINT: 'Le enviaremos la invitación a este email.',
          INVITE: 'Enviar invitación',
          INVITING: 'Enviando…',
          INVITED: 'Invitación enviada a {{email}}.',
          INVITE_ERROR: 'No se ha podido enviar la invitación.',
          RESEND: 'Reenviar invitación',
          RESENT: 'Invitación reenviada a {{email}}.',
          ACTION_ERROR: 'No se ha podido completar la acción.',
          REMOVE: 'Quitar Partner admin',
          REMOVE_TITLE: 'Quitar Partner admin',
          REMOVE_TEXT: '{{name}} dejará de administrar {{partner}}.',
          REMOVING: 'Quitando…',
          REMOVED: 'Quitado',
          CANCEL: 'Cancelar invitación',
          CANCEL_TITLE: 'Cancelar invitación',
          CANCEL_TEXT: 'El enlace que le llegó a {{email}} dejará de valer.',
          CANCELLING: 'Cancelando…',
          CANCELLED: 'Cancelada',
          KEEP: 'Volver',
        },
        TUTORS_COUNT: 'Tutores: {{count}}',
        CREATE: {
          TUTOR_EMAIL: 'Primer tutor (Partner admin)',
          TUTOR_EMAIL_HINT: 'Le llegará una invitación por email, válida 7 días, para unirse al partner. No se crea ninguna cuenta hasta que la acepte.',
          SECTIONS_NOTE: 'Sus empresas ven las secciones que configures en «Qué ve la empresa»; hasta entonces, todas ocultas.',
          SUBTITLE: 'Con el alta se invita a su primer Partner admin. Lo demás se configura en sus pestañas.',
          SLUG: 'Identificador',
          SLUG_HINT: 'Minúsculas, números y guiones. Se usa en la marca de sus correos y no se cambia después.',
        },
        DATA: {
          SAVE: 'Guardar datos',
          SAVING: 'Guardando…',
          SAVED: 'Datos del partner guardados.',
          TITLE: 'Datos de {{partner}}',
          SUBTITLE: 'Nombre y logo para la marca compartida, y quién lo administra.',
          NAME: 'Nombre',
          LOGO: 'Logo',
          NO_LOGO: 'Sin logo',
          UPLOADING: 'Subiendo…',
          CHANGE_LOGO: 'Cambiar',
        },
        SECTIONS: {
          TITLE: 'Qué ve cada empresa en su dashboard',
          SUBTITLE: 'Se aplica igual a todas las empresas de {{partner}}. Limita a sus admins y a los de sus sedes; {{partner}} siempre lo ve todo.',
          COL_SECTION: 'Sección',
          COL_ACCESS: 'Qué ve la empresa',
          MODE_NORMAL: 'Normal',
          MODE_READONLY: 'Solo lectura',
          MODE_HIDDEN: 'Oculta',
          MANAGED_BY: 'gestiona {{partner}}',
          RETRY: 'Reintentar',
          DISCARD_TITLE: 'Descartar los cambios de secciones de {{partner}}',
          DISCARD_TEXT: 'Los cambios que no has aplicado se pierden.',
          DISCARD_CONFIRM: 'Descartar',
          DISCARD_CANCEL: 'Seguir editando',
          ERROR_APPLY_ALL: 'No se han podido aplicar las secciones. No ha cambiado ninguna empresa.',
          ERROR_FORBIDDEN_ALL: 'Solo un administrador de WAIIS puede aplicar secciones a todas las empresas de un partner.',
          ERROR_PARTNER_NOT_FOUND: 'Este partner ya no existe.',
          WALLET: 'Cartera',
          SAVE: 'Guardar',
          SAVED: 'Se aplica al momento a todas las empresas de {{partner}}.',
        },
      },
      PARTNER_PAYMENTS: {
        SUBTITLE: 'Condiciones de abono a conductores en los viajes de las empresas vinculadas a {{name}}.',
        SCOPE: 'Todas las empresas de {{name}}',
        TERMS_TITLE: 'Plazo del abono de la bonificación CAE',
        TERMS_SUB: 'Días naturales desde la fecha del viaje hasta el abono en la wallet del conductor.',
        DAYS: '{{days}} días',
        EXAMPLE_TRIP: 'Viaje del {{date}}, abono el',
        TERMS_ERROR: 'No se ha podido cargar el plazo.',
        LAST_CHANGE: 'Última modificación: {{date}}',
        DISCARD: 'Descartar',
        SAVE: 'Guardar cambios',
        SAVING: 'Guardando…',
        SAVED: 'Guardado',
        SAVE_ERROR: 'No se ha podido guardar el plazo.',
        CALENDAR_TITLE: 'Calendario de abonos',
        CALENDAR_SUB: 'Bonificaciones CAE pendientes de abono.',
        PENDING_AMOUNT: 'Importe pendiente',
        NEXT_PAYOUT: 'Próximo abono',
        COL_PAYOUT_DATE: 'Fecha de abono',
        COL_AMOUNT: 'Importe',
        TODAY: 'Hoy',
        EMPTY: 'No hay abonos pendientes.',
        CALENDAR_ERROR: 'No se ha podido cargar el calendario de abonos.',
        TAB_DEFAULTS: 'Precio anual y bolsa',
        TAB_PAYOUT: 'Abono a conductores',
        DEFAULTS_TITLE: 'Precio anual y bolsa',
        DEFAULTS_SUB: 'Lo que se propone a cada empresa nueva. Cada empresa puede tener luego su propio precio.',
        DEFAULTS_ERROR: 'No se han podido cargar los valores por defecto.',
        DEFAULT_SPLIT: 'Reparto por defecto',
        DEFAULT_TRIAL: 'Meses de prueba gratis para empresas nuevas',
        DEFAULT_TRIAL_HINT: 'No cambia las pruebas que ya están en marcha.',
        SIMULATOR: 'Importe anual acordado',
        SIMULATOR_PLACEHOLDER: 'Ej.: 12000',
        DEFAULTS_SAVED: 'Valores por defecto guardados',
        DEFAULTS_SAVE_ERROR: 'No se han podido guardar los valores por defecto.',
        PAYOUTS: 'Abonos',
        SCHEDULED: 'El plazo de {{days}} días vale desde el {{date}}.',
        RETRY: 'Reintentar',
      },
      PARTNER_USERS: {
        TITLE: 'Usuarios de {{name}}',
        TITLE_GENERIC: 'Usuarios',
        SUBTITLE: 'Las personas de {{name}} con acceso al dashboard. Solo el Partner admin puede invitar o quitar gente.',
        INVITE: 'Invitar usuario',
        COL_USER: 'Usuario',
        COL_ROLE: 'Rol',
        COL_STATUS: 'Estado',
        ACTIONS: 'Acciones',
        YOU: '(tú)',
        ROLE_ADMIN: 'Partner admin',
        ROLE_USER: 'Partner usuario',
        STATUS_ACTIVE: 'Activo',
        STATUS_INVITED: 'Invitación pendiente',
        TODAY: 'Hoy',
        YESTERDAY: 'Ayer',
        LOAD_ERROR: 'No se han podido cargar los usuarios.',
        RETRY: 'Reintentar',
        EMPTY: 'Todavía no hay nadie con acceso.',
        RESEND: 'Reenviar invitación',
        REMOVE: 'Quitar acceso',
        REMOVE_TEXT: '{{name}} dejará de poder entrar al dashboard de {{partner}}.',
        RESENT: 'Invitación reenviada a {{email}}.',
        INVITED: 'Invitación enviada a {{email}}.',
        ACTION_ERROR: 'No se ha podido completar la acción.',
        INVITE_TITLE: 'Invitar usuario',
        INVITE_SUB: 'Le llegará un correo con un enlace, válido 7 días, para unirse al equipo de {{name}}.',
        EMAIL: 'Email',
        EMAIL_PLACEHOLDER: 'nombre@empresa.com',
        EMAIL_INVALID: 'Escribe un email válido.',
        ROLE: 'Rol',
        INVITE_ERROR: 'No se ha podido enviar la invitación.',
        CANCEL: 'Cancelar',
        SEND: 'Enviar invitación',
        SENDING: 'Enviando…',
        CANCEL_INVITE: 'Cancelar invitación',
        CANCEL_INVITE_TITLE: 'Cancelar invitación',
        CANCEL_INVITE_TEXT: 'El enlace que le llegó a {{email}} dejará de valer.',
        CANCELLING_INVITE: 'Cancelando…',
        CANCELLED_INVITE: 'Invitación cancelada',
        COL_COMPANIES: 'Empresas a cargo',
        COL_LAST_ACCESS: 'Último acceso',
        NAME: 'Nombre',
        NAME_REQUIRED: 'Escribe su nombre.',
        ROLE_ADMIN_HINT: 'Crea empresas, fija precios e invita a usuarios',
        ROLE_USER_HINT: 'Solo consulta empresas y datos',
        MAKE_ADMIN: 'Cambiar rol a Partner admin',
        MAKE_USER: 'Cambiar rol a Partner usuario',
        REMOVE_ASK: '¿Quitar el acceso a {{name}}?',
        REMOVE_CONFIRM: 'Sí, quitar acceso',
        REMOVED_NAME: '{{name}} ya no tiene acceso.',
        ROLE_ASK: '¿Pasar a {{name}} a {{role}}?',
        ROLE_TEXT: '{{name}} pasará a ser {{role}} de {{partner}}.',
        ROLE_CONFIRM: 'Cambiar rol',
        ROLE_CHANGED: '{{name}} ahora es {{role}}.',
        REASSIGN_TO: '¿A qué Partner admin pasan sus {{n}} empresas?',
        REASSIGN_LABEL: 'Nuevo gestor',
        REASSIGN_NONE: 'No hay otro Partner admin: invita a uno antes.',
      },
      COMPANIES: {
        CREATE: {
          TITLE: 'Nueva empresa',
          SUBTITLE: 'Se crea su espacio y se invita a su administrador por correo.',
          SUBTITLE_REQUEST: 'Con los datos de la solicitud: elige quién la gestiona en el partner.',
          CLOSE: 'Cerrar',
          SECTION_COMPANY: 'Empresa',
          SECTION_ADMIN: 'Administrador',
          SECTION_PARTNER: 'Partner',
          LEGAL_NAME: 'Razón social',
          TAX_ID: 'CIF',
          CITY: 'Ciudad',
          EMPLOYEES: 'Nº de empleados',
          ADMIN_NAME: 'Nombre y apellidos',
          ADMIN_EMAIL: 'Correo del administrador',
          ADMIN_EMAIL_PLACEHOLDER: 'nombre@empresa.com',
          ADMIN_EMAIL_HINT: 'Le llegará una invitación para entrar al dashboard de la empresa.',
          PARTNER: 'Partner',
          PARTNER_WAIIS: 'WAIIS (por defecto)',
          PARTNER_NOTE: 'Si eliges un partner, la empresa aparece en su panel y hereda sus precios, meses de prueba gratis y permisos.',
          MANAGER: 'Gestor del partner',
          MANAGER_HINT: 'El Partner admin que llevará la empresa.',
          ERROR_REQUIRED: 'Este campo es obligatorio.',
          ERROR_EMAIL: 'Escribe un correo válido.',
          ERROR_EMPLOYEES: 'Indica al menos 1 empleado.',
          ERROR_MANAGER: 'Elige el gestor de la empresa.',
          ERROR_SAVE: 'No se ha podido crear la empresa.',
          CANCEL: 'Cancelar',
          SUBMIT: 'Crear empresa',
          CREATING: 'Creando…',
          DONE_INVITED: 'Empresa creada. Invitación enviada a {{email}}',
          DONE_LINKED: 'Empresa creada. {{email}} ya puede entrar como administrador',
          DONE_OK: 'Aceptar',
        },
        ONBOARDING: {
          GRAN_DAY: 'Día',
          GRAN_WEEK: 'Semana',
          GRAN_MONTH: 'Mes',
          HINT_DAY: 'Últimos 30 días',
          HINT_WEEK: 'Últimas 12 semanas',
          HINT_MONTH: 'Últimos 12 meses',
          IN_PERIOD_DAY: 'los últimos 30 días',
          IN_PERIOD_WEEK: 'las últimas 12 semanas',
          IN_PERIOD_MONTH: 'los últimos 12 meses',
          INSIGHT_ALL_DONE: 'todas han completado el onboarding',
          INSIGHT_ONE_PENDING: '1 sigue pendiente de activar',
          INSIGHT_N_PENDING: '{{n}} siguen pendientes de activar',
          INSIGHT_ONE: '{{n}} alta en {{period}}; {{pending}}.',
          INSIGHT_OTHER: '{{n}} altas en {{period}}; {{pending}}.',
          TILE_UNSEEN: 'Nuevas sin revisar',
          TILE_UNSEEN_SUB: 'últimos 90 días',
          TILE_UNSEEN_HINT: 'Aún no has abierto su ficha',
          TILE_ALL_REVIEWED: 'Todo revisado',
          TILE_TODAY: 'Altas hoy',
          TILE_TODAY_HINT: '{{n}} en los últimos 30 días',
          TILE_WEEK: 'Altas esta semana',
          TILE_WEEK_HINT: 'Desde el lunes',
          TILE_MONTH: 'Altas este mes',
          TILE_MONTH_HINT: '{{n}} pendientes de activar (90 días)',
          TITLE: 'Altas en onboarding',
          SUBTITLE: 'Empresas que han empezado el alta en WAIIS. Las nuevas sin revisar se resaltan en azul en el listado.',
          GRANULARITY: 'Granularidad',
          LOADING: 'Cargando altas…',
          KPIS_LABEL: 'Indicadores de altas',
          VIEW_IN_TABLE: 'Ver en la tabla',
          BY_DAY: 'Altas por día',
          BY_WEEK: 'Altas por semana',
          BY_MONTH: 'Altas por mes',
          CHART_Q: '{{period}} · {{n}} altas',
          LEGEND_DONE: 'Onboarding completado',
          LEGEND_PENDING: 'Pendiente de activar',
          EMPTY: 'No hay altas en este periodo.',
          TIP_DONE: 'Completado:',
          TIP_PENDING: 'Pendiente:',
          TIP_TOTAL: 'Total:',
          VIEW_DATA: 'Ver los datos',
          COL_PERIOD: 'Periodo',
          COL_DONE: 'Completado',
          COL_PENDING: 'Pendiente',
        },
        INCENTIVES_TAB: {
          READ_ONLY: 'Vista de solo lectura. Las campañas se configuran y envían desde el dashboard de la empresa.',
          MANAGE: 'Gestionar incentivos',
          LOADING: 'Cargando incentivos…',
          LOCKED: 'El módulo de incentivos no está incluido en el plan actual de esta empresa.',
          VIEW_PLAN: 'Ver plan de la empresa',
          SEGMENTS_LABEL: 'Empleados por segmento a incentivar',
          CAMPAIGNS_TITLE: 'Campañas de incentivos',
          NO_CAMPAIGNS: 'Todavía no se ha enviado ninguna campaña.',
          LAST_CAMPAIGNS: 'Últimas {{shown}} de {{total}} campañas.',
          COL_RECIPIENTS: 'Destinatarios',
          COL_COMMITTED: 'Comprometido',
          COL_THRESHOLD: 'Umbral inactividad',
          COL_DETAIL: 'Detalle',
          DAYS: '{{n}} días',
          ONE_OFFICE: 'Solo una sede',
          ERROR_LOAD: 'No se ha podido cargar la información de incentivos.',
          SEG_NOT_REGISTERED: 'Sin registrar',
          SEG_NOT_REGISTERED_HINT: 'Empleados en plantilla que aún no se han dado de alta en la app',
          SEG_DNI: 'DNI pendiente',
          SEG_DNI_HINT: 'Registrados sin verificar la identidad',
          SEG_NO_TRIPS: 'Sin viajes',
          SEG_NO_TRIPS_HINT: 'Registrados que todavía no han compartido ningún viaje',
          SEG_INACTIVE: 'Inactivos',
          SEG_INACTIVE_HINT: 'Sin viajes en los últimos {{n}} días',
          ST_IN_PROGRESS: 'En curso',
          ST_COMPLETED: 'Completada',
          ST_CANCELLED: 'Cancelada',
          ST_SCHEDULED: 'Programada',
          ST_SENT: 'Enviada',
          ST_FAILED: 'Fallida',
        },
        TRAVELS_TAB: {
          LAST_DAYS: 'Últimos {{n}} días',
          OFFICE_ALL: 'Sede: todas',
          SEARCH_PLACEHOLDER: 'Buscar por conductor, pasajero o dirección…',
          SEARCH_LABEL: 'Buscar viaje',
          RANGE: 'Rango',
          REPORT: 'Informe de viajes',
          COL_ROUTE: 'Ruta',
          COL_DRIVER: 'Conductor',
          COL_PASSENGERS: 'Pasajeros',
          COL_AMOUNT: 'Importe',
          LOADING: 'Cargando viajes…',
          EMPTY: 'No hay viajes de empleados de esta empresa en el rango seleccionado.',
          ERROR_LOAD: 'No se han podido cargar los viajes.',
          FOOT: 'Mostrando <b>{{shown}}</b> de <b>{{total}}</b> viajes',
        },
        PMST_TAB: {
          TITLE: 'Plan de Movilidad Sostenible al Trabajo',
          SUBTITLE: 'Obligatorio para empresas de más de 200 empleados. El cuestionario se rellena por empresa y por sede.',
          OPEN: 'Abrir PMST en el dashboard',
          ENABLED: 'PMST activado por la empresa',
          DISABLED: 'PMST desactivado por la empresa',
          OFFICES_DONE: '{{done}} de {{total}} con el cuestionario completo',
          NO_OFFICES: 'Sin sedes dadas de alta.',
          INACTIVE: '· inactiva',
          DOCS_TITLE: 'Documentos e informes',
          DOCS_SUB: 'Ficheros PMST subidos por la empresa o por WAIIS.',
          LOADING_DOCS: 'Cargando documentos…',
          COL_DOCUMENT: 'Documento',
          COL_UPLOADED: 'Subido',
          EMPTY: 'No hay documentos PMST para esta empresa.',
          DOWNLOAD: 'Descargar',
          DOWNLOAD_DOC: 'Descargar documento',
          ERROR_LOAD: 'No se han podido cargar los documentos PMST.',
          ERROR_DOWNLOAD: 'No se ha podido descargar el documento.',
          QUESTIONNAIRE_DONE: 'Cuestionario completo',
          QUESTIONNAIRE_PENDING: 'Cuestionario pendiente',
        },
        OFFICES_TAB: {
          COUNT_ONE: 'sede dada de alta',
          COUNT_OTHER: 'sedes dadas de alta',
          DECLARED: '· {{n}} declaradas en el alta',
          MANAGE: 'Gestionar sedes en el dashboard',
          EMPTY: 'Esta empresa no tiene sedes dadas de alta.',
          NOT_APPLICABLE: 'No aplica',
          VIEW_EMPLOYEES: 'Ver empleados de la sede',
          VIEW_OFFICE: 'Ver sede',
        },
        EMPLOYEES_TAB: {
          SEARCH_PLACEHOLDER: 'Buscar empleado, email, DNI o departamento…',
          SEARCH_LABEL: 'Buscar empleado',
          OFFICE_ALL: 'Sede: todas',
          STATUS_ALL: 'Estado: todos',
          FILTER_REGISTERED: 'Registrados',
          FILTER_PENDING: 'Pendientes de registro',
          FILTER_INACTIVE: 'Inactivos',
          MANAGE: 'Gestionar en el dashboard',
          COL_DEPARTMENT: 'Departamento',
          COL_APP: 'App',
          LOADING: 'Cargando empleados…',
          ERROR_LOAD: 'No se han podido cargar los empleados.',
          EMPTY_FILTERED: 'Ningún empleado coincide con los filtros.',
          EMPTY: 'Esta empresa aún no tiene empleados dados de alta.',
          VIEW_EMPLOYEE: 'Ver empleado',
          FOOT: 'Mostrando <b>{{shown}}</b> de <b>{{total}}</b> empleados',
          ST_INACTIVE: 'Inactivo',
          ST_REGISTERED: 'Registrado',
          ST_PENDING: 'Pendiente',
          ST_PENDING_HINT: 'Aún no se ha registrado en la app',
          LINKED: 'Vinculado',
          LINKED_HINT: 'Cuenta de la app vinculada',
          NOT_LINKED: 'Sin vincular',
          STATUS_CODE: {
            activo: 'Activo',
            con_rutina: 'Con rutina',
            vinculado: 'Vinculado',
            inactivo: 'Inactivo',
            pendiente: 'Pendiente',
            rechazado: 'Rechazado',
          },
        },
        DATA_TAB: {
          TITLE: 'Datos de la empresa',
          SUBTITLE: 'Identidad fiscal, persona de contacto y dirección. Los cambios se guardan al momento.',
          SEC_IDENTITY: 'Identidad',
          TRADE_NAME: 'Nombre comercial',
          LEGAL_NAME: 'Razón social',
          TAX_ID: 'CIF / NIF',
          SECTOR: 'Sector',
          OPTIONAL: 'Opcional',
          SEC_CONTACT: 'Persona de contacto',
          NAME: 'Nombre',
          SEC_FISCAL: 'Dirección fiscal',
          CITY: 'Ciudad',
          POSTAL_CODE: 'Código postal',
          SEC_STATUS: 'Estado',
          ACTIVE: 'Empresa activa',
          PMST_ENABLED: 'PMST activado',
          STATUS_HELP: 'Una empresa inactiva deja de aparecer en la app para sus empleados. Desactivar el PMST oculta la sección de Plan de Movilidad en su dashboard.',
          DISCARD: 'Descartar',
          SAVING: 'Guardando…',
          SAVE: 'Guardar cambios',
          INVITE_TITLE: 'Código de invitación',
          INVITE_SUB: 'Con él los empleados vinculan su cuenta de la app a la empresa.',
          CODE_COPIED: 'Código copiado',
          COPY_CODE: 'Copiar código',
          NO_CODE: 'Sin código generado.',
          INVITE_LINK: 'Enlace de vinculación',
          PLAN: 'Plan',
          PLAN_BILLING: 'Plan y facturación',
          PLAN_MANAGED_BY_WAIIS: 'El plan lo gestiona WAIIS. Para cambiarlo, escríbenos.',
          PARTNER: 'Partner',
          PARTNER_READ_ONLY: 'Solo lo cambia WAIIS',
          SETTINGS_LINK: 'Logo, administradores y contrato',
          FIX_FIELDS: 'Revisa los campos marcados antes de guardar.',
          NO_CHANGES: 'No hay cambios que guardar.',
          SAVED: 'Datos guardados.',
          SAVE_ERROR: 'No se han podido guardar los datos.',
          NO_PLAN_ASSIGNED: 'Sin plan asignado',
          PLAN_ACTIVE: 'activo',
          PLAN_EXPIRED: 'caducado',
          PLAN_CANCELLED: 'cancelado',
          PLAN_UNTIL: ' · hasta {{date}}',
          ERR_REQUIRED: 'Obligatorio',
          ERR_EMAIL: 'Email no válido',
          ERR_PATTERN: 'Formato no válido',
          ERR_TOO_LONG: 'Demasiado largo',
          ERR_CIF: 'CIF/NIF no válido',
          ERR_INVALID: 'Valor no válido',
        },
        DETAIL: {
          TAB_EMPLOYEES: 'Empleados',
          TAB_OFFICES: 'Sedes',
          TAB_TRIPS: 'Viajes',
          TAB_INCENTIVES: 'Incentivos',
          TAB_PMST: 'PMST / informes',
          TAB_DATA: 'Datos',
          ERROR_NOT_FOUND: 'No se ha encontrado la empresa.',
          ERROR_FORBIDDEN: 'No tienes permiso para ver esta empresa.',
          ERROR_LOAD: 'No se ha podido cargar la empresa.',
          KPI_REGISTERED: 'Empleados registrados',
          KPI_REGISTERED_HINT: '{{total}} en plantilla · {{active}} activos',
          KPI_CARPOOLING: 'En carpooling (mes)',
          KPI_SHARED_TRIPS: 'Viajes compartidos (mes)',
          KPI_CO2: 'CO₂e evitado (mes)',
          META_TAX_ID: 'CIF {{value}}',
          TRIAL_ENDS: 'Prueba · acaba el {{date}}',
          TRIAL_END_CHANGE: 'Cambiar fin de la prueba',
          TAB_SUMMARY: 'Resumen',
          TAB_CONTRACT: 'Contrato y precio',
          TAB_WALLET: 'Cartera',
          TAB_FOLLOWUP: 'Seguimiento',
          PARTNER_KPI_REGISTERED_HINT: '{{percent}} % de {{total}} en plantilla',
          PARTNER_KPI_TRIPS_CHANGE: '{{percent}} % frente al mes anterior',
          PARTNER_KPI_CO2_TOTAL: 'CO₂e evitado desde el alta',
          PARTNER_TRIAL_NOTE: 'La prueba acaba el {{date}} · quedan {{days}} días.',
          PARTNER_TRIAL_NOTE_MISSING: 'La prueba acaba el {{date}} · quedan {{days}} días. Falta {{items}}.',
          PARTNER_RESENT: 'Invitación reenviada a {{email}}',
          PARTNER_CALL: 'Llamar',
          PARTNER_WRITE: 'Escribir',
          PARTNER_RESEND: 'Reenviar invitación',
          PARTNER_DASHBOARD: 'Ver su dashboard',
          PARTNER_GO_CONTRACT: 'Ir al contrato',
          PARTNER_KPI_TONS: '{{value}} t',
          TRIAL_END_LABEL: 'Último día de la prueba',
          TRIAL_END_HINT: 'Tiene que ser posterior a hoy. Si la empresa estaba bloqueada, vuelve a la prueba.',
          TRIAL_END_SAVE: 'Guardar',
          TRIAL_END_SAVING: 'Guardando…',
          TRIAL_END_ERROR: 'No se ha podido cambiar la fecha de fin de la prueba.',
          TOPUP_LIMIT: 'Límite de la bolsa mensual',
          TOPUP_LIMIT_GENERAL: 'General: {{max}} €',
          TOPUP_LIMIT_CUSTOM: 'Propio de esta empresa: {{max}} €',
          TOPUP_LIMIT_LABEL: 'Límite nuevo, en euros al mes',
          TOPUP_LIMIT_HINT: 'Puede ser mayor o menor que el general. El importe ya guardado por la empresa no cambia.',
          TOPUP_LIMIT_SAVE: 'Guardar',
          TOPUP_LIMIT_SAVING: 'Guardando…',
          TOPUP_LIMIT_RESET: 'Volver al general',
          TOPUP_LIMIT_LOADING: 'Cargando el límite…',
          TOPUP_LIMIT_LOAD_ERROR: 'No se ha podido leer el límite de la bolsa.',
          TOPUP_LIMIT_ERROR: 'No se ha podido guardar el límite de la bolsa.',
          META_PLAN: 'Plan {{value}}',
          BACK: 'Volver a empresas',
          BREADCRUMB: 'Ruta de navegación',
          COMPANIES: 'Empresas',
          LOADING: 'Cargando la empresa…',
          BACK_TO_LIST: 'Volver al listado',
          EDIT: 'Editar',
          ENTER_DASHBOARD: 'Entrar en el dashboard',
          ENTER_DASHBOARD_TOOLTIP: 'Ver el dashboard tal y como lo ve la empresa',
          CONTACT_PERSON: 'Persona de contacto',
          KPIS_LABEL: 'Indicadores del mes en curso',
          TABS_LABEL: 'Sección de la empresa',
        },
        COMMON: {
          RETRY: 'Reintentar',
          PREVIOUS: 'Anterior',
          NEXT: 'Siguiente',
          PREV_PAGE: 'Página anterior',
          NEXT_PAGE: 'Página siguiente',
          CLEAR_FILTERS: 'Limpiar filtros',
          LOADING: 'Cargando…',
          ACTIONS: 'Acciones',
          STATUS: 'Estado',
          PER_PAGE: '{{n}} por página',
          SHOWING: 'Mostrando {{shown}} de {{total}}',
          VS_PREV_MONTH: '{{trend}} vs mes anterior',
          EMPLOYEE: 'Empleado',
          OFFICE: 'Sede',
          OFFICES: 'Sedes',
          EMPLOYEES: 'Empleados',
          PLAN: 'Plan',
          DATE: 'Fecha',
          EMAIL: 'Email',
          PHONE: 'Teléfono',
          ADDRESS: 'Dirección',
          CONTACT: 'Contacto',
          TOTAL: 'Total',
        },
        FORMAT: {
          STATUS_PRE_LAUNCH: 'Antes de empezar',
          STATUS_TRIAL: 'En prueba',
          STATUS_TRIAL_DAYS: 'En prueba · {{n}} días',
          STATUS_LOCKED: 'Bloqueada',
          STATUS_ACTIVE: 'Activa',
          MISSING: 'falta {{items}}',
          MISSING_NONE: 'lista',
          MISSING_BILLING: 'datos de facturación',
          MISSING_PAYMENT_METHOD: 'método de pago',
          MISSING_CONTRACT: 'contrato',
          MISSING_ANNUAL_PLAN: 'plan anual',
          MISSING_PAYMENT: 'pago',
          MISSING_INVOICE: 'pago de la factura',
          PLAN_FREEMIUM: 'Freemium',
          PLAN_INCENTIVES: 'Incentivos',
          NO_PLAN: 'Sin plan',
          NOT_AVAILABLE: 'Dato no disponible',
          SUB_ACTIVE: 'Suscripción activa',
          PLAN_EXPIRED: '{{plan}} · caducado',
          SUB_EXPIRED: 'Suscripción caducada',
          PLAN_CANCELLED: '{{plan}} · cancelado',
          SUB_CANCELLED: 'Suscripción cancelada',
          PMST_NOT_REQUESTED: 'No solicitado',
          PMST_NOT_REQUESTED_HINT: 'La empresa no ha activado el PMST',
          COMPLETED: 'Completado',
          PMST_COMPLETED_HINT: 'Cuestionario PMST completo en empresa y sedes',
          PENDING: 'Pendiente',
          PMST_PENDING_HINT: 'Cuestionario PMST sin completar',
          ACTIVE: 'Activa',
          INACTIVE: 'Inactiva',
        },
        LIST: {
          NEW_COMPANY: 'Nueva empresa',
          ENDING_TITLE: '{{n}} pruebas acaban pronto con datos pendientes',
          ENDING_TITLE_ONE: 'Una prueba acaba pronto con datos pendientes',
          ENDING_DAYS_LEFT: 'quedan {{n}} días',
          ENDING_DAYS_LEFT_ONE: 'queda 1 día',
          SHOULD_BE_PARTNER: '¿Debería ser {{partner}}? +{{threshold}} empleados',
          SHOULD_BE_PARTNER_SHORT: '¿Debería ser {{partner}}?',
          DEGRADED_NOTE: 'El backend de este entorno aún no expone el listado con agregados ({{endpoint}}): sedes, empleados, viajes y plan aparecen vacíos y el filtro por plan está desactivado.',
          VIEW: 'Vista',
          TAB_COMPANIES: 'Empresas',
          TAB_DATA: 'Datos',
          SEARCH_PLACEHOLDER: 'Buscar empresa, CIF, contacto o ciudad…',
          SEARCH_LABEL: 'Buscar empresa',
          NEW_UNSEEN: 'Nuevas sin revisar',
          NEW_UNSEEN_TOOLTIP: 'Empresas dadas de alta en los últimos 90 días que aún no has abierto',
          COL_SIGNUP: 'Alta',
          COL_COMPANY: 'Empresa',
          COL_TRIPS_MONTH: 'Viajes (mes)',
          LOADING_COMPANIES: 'Cargando empresas',
          EMPTY_NEW: 'No hay empresas nuevas sin revisar. ¡Todo al día!',
          EMPTY_FILTERED: 'Ninguna empresa coincide con los filtros.',
          EMPTY: 'Todavía no hay empresas registradas.',
          NEW_PILL: 'Nueva',
          NEW_PILL_TOOLTIP: 'Alta reciente que aún no has abierto',
          ENTER_DASHBOARD: 'Entrar en el dashboard de la empresa',
          EDIT_DATA: 'Editar datos',
          VIEW_DETAIL: 'Ver ficha',
          PER_PAGE_LABEL: 'Empresas por página',
          FOOT: 'Mostrando {{shown}} de {{total}} empresas',
          FILTER_STATUS_ALL: 'Estado: todos',
          FILTER_PMST_ALL: 'PMST: todas',
          FILTER_PLAN_ALL: 'Plan: todos',
          COL_PARTNER: 'Partner',
          FILTER_PARTNER_ALL: 'Partner: todos',
          CHANGE_PARTNER: 'Cambiar partner',
          CHANGE_PARTNER_CONSEQUENCES: 'Los permisos y lo que ve la empresa cambian al momento. El plan, la bolsa, el contrato y la prueba se cierran a mano: la empresa queda pendiente de completar su cuenta con {{partner}}.',
          PARTNER_TITLE: 'Empresas de {{name}}',
          PARTNER_SUBTITLE: 'Las empresas que has dado de alta con WAIIS. Haz clic en una fila para ver su ficha, o usa el ojo para entrar en su dashboard tal y como lo ve la empresa.',
          PARTNER_VIEW_NOTE: 'Estás viendo solo las empresas de <strong>{{name}}</strong>.',
          ERROR_FORBIDDEN: 'No tienes permiso para ver el listado de empresas.',
          ERROR_LOAD: 'No se ha podido cargar el listado de empresas.',
          TITLE_NEW: 'Empresas nuevas sin revisar',
          TITLE_ACTIVE: 'Empresas activas',
          TITLE_PRE_LAUNCH: 'Empresas antes de empezar',
          TITLE_TRIAL: 'Empresas en prueba',
          TITLE_LOCKED: 'Empresas bloqueadas',
          TITLE_ALL: 'Todas las empresas',
          SUB_NEW: 'Altas de los últimos 90 días que aún no has abierto.',
          SUB_PMST: 'PMST {{value}}',
          SUB_NO_PLAN: 'sin plan',
          SUB_PLAN: 'plan {{value}}',
          SUB_SEARCH: 'búsqueda «{{value}}»',
          SUB_FILTERED: 'Filtrado por {{filters}}.',
          SUB_DEFAULT: 'Empresas clientes con sus sedes, empleados, viajes del mes y plan.',
          AGO_TODAY: 'hoy',
          AGO_YESTERDAY: 'ayer',
          AGO_DAYS: 'hace {{n}} días',
          AGO_WEEKS: 'hace {{n}} semanas',
          AGO_MONTHS: 'hace {{n}} meses',
          AGO_ONE_YEAR: 'hace 1 año',
          AGO_YEARS: 'hace {{n}} años',
        },
      },
      MATCH_LIST: {
        ALL: 'Todos',
        ITEMS: 'matchs',
        COL_DRIVER: 'Conductor',
        COL_ROUTINE: 'Rutina',
        COL_ROUTE_DATE: 'Fecha de ruta',
        COL_PASSENGERS: 'Pasajeros',
        COL_CREATED: 'Creado',
        FILTER_STATUS: 'Estado',
        FILTER_DRIVER: 'Conductor',
        FILTER_DATE_FROM: 'Fecha desde',
        FILTER_DATE_TO: 'Fecha hasta',
        REMOVE_FILTER: 'Quitar {{label}}',
        OPEN_CALENDAR: 'Abrir calendario',
        CLEAR: 'Limpiar',
        STATUS: {
          INITIAL: 'Inicial',
          CONFIRMED: 'Confirmado',
          ONGOING: 'En curso',
          PENDING: 'Pendiente',
          ACCEPTED: 'Aceptado',
          REJECTED: 'Rechazado',
          CANCELLED: 'Cancelado',
          EXPIRED: 'Expirado',
        },
      },
      MATCH: {
        TITLE: 'Detalle del match',
        SUBTITLE: 'Conductor, pasajeros y trayecto del match, con sus mapas.',
        BACK: 'Volver',
        LOADING: 'Cargando match...',
        LOAD_ERROR: 'No se ha podido cargar el match.',
        BACK_TO_LIST: 'Volver al listado',
        RETRY: 'Reintentar',
        DRIVER: 'Conductor',
        PASSENGERS_ONE: '{{count}} pasajero',
        PASSENGERS_OTHER: '{{count}} pasajeros',
        CREATED: 'Creado',
        UPDATED: 'Actualizado',
        DRIVER_ROUTE: 'Ruta del conductor',
        ROUTINE: 'Rutina',
        SCHEDULES: 'Horarios',
        COL_TYPE: 'Tipo',
        COL_ORIGINAL_ROUTE: 'Ruta original',
        COL_MATCH: 'Match',
        DEPARTURE: 'Salida',
        ARRIVAL: 'Llegada',
        POINTS: 'Puntos',
        ORIGIN: 'Origen',
        DESTINATION: 'Destino',
        PICKUP: 'Pickup',
        DROPOFF: 'Dropoff',
        DROPOFF_X: 'Dropoff (X)',
        COPY_COORDINATES: 'Copiar coordenadas',
        COORDINATES_COPIED: 'Coordenadas copiadas',
        COPY_ORIGIN_ARIA: 'Copiar coordenadas de origen',
        COPY_DESTINATION_ARIA: 'Copiar coordenadas de destino',
        VIEW_ORIGIN: 'Ver origen en el mapa',
        VIEW_DESTINATION: 'Ver destino en el mapa',
        VIEW_DRIVER_ORIGIN_ARIA: 'Ver origen del conductor en el mapa',
        VIEW_DRIVER_DESTINATION_ARIA: 'Ver destino del conductor en el mapa',
        DRIVER_MAP_CAPTION: 'Mapa de la ruta original del conductor con origen y destino.',
        PASSENGERS_TITLE: 'Pasajeros asociados',
        PASSENGERS_LINKED_ONE: '{{count}} pasajero vinculado al match.',
        PASSENGERS_LINKED_OTHER: '{{count}} pasajeros vinculados al match.',
        NO_PASSENGERS: 'Este match no tiene pasajeros vinculados.',
        REFRAME_PASSENGER: 'Reencuadrar origen y destino',
        REFRAME_PASSENGER_ARIA: 'Reencuadrar origen y destino del pasajero en el mapa',
        ORDER: 'Orden {{order}}',
        COPY_PAX_ORIGIN_ARIA: 'Copiar coordenadas de origen del pasajero',
        FOCUS_PAX_ORIGIN_ARIA: 'Enfocar origen del pasajero en el mapa',
        COPY_PAX_DESTINATION_ARIA: 'Copiar coordenadas de destino del pasajero',
        FOCUS_PAX_DESTINATION_ARIA: 'Enfocar destino del pasajero en el mapa',
        COPY_PAX_PICKUP_ARIA: 'Copiar coordenadas de pickup del pasajero',
        VIEW_PICKUP: 'Ver pickup en el mapa',
        FOCUS_PAX_PICKUP_ARIA: 'Enfocar pickup del pasajero en el mapa',
        EDIT_PICKUP: 'Editar pickup en el mapa',
        EDIT_PICKUP_ARIA: 'Editar pickup del pasajero',
        COPY_PAX_DROPOFF_ARIA: 'Copiar coordenadas de dropoff del pasajero',
        VIEW_DROPOFF: 'Ver dropoff en el mapa',
        FOCUS_PAX_DROPOFF_ARIA: 'Enfocar dropoff del pasajero en el mapa',
        EDIT_DROPOFF: 'Editar dropoff en el mapa',
        EDIT_DROPOFF_ARIA: 'Editar dropoff del pasajero',
        PASSENGER_MAP_CAPTION: 'Mapa del trayecto del pasajero con origen, destino, pickup y dropoff cuando existan.',
        CLICK_MAP_PICKUP: 'Haz click en el mapa para seleccionar el punto de pickup.',
        CLICK_MAP_DROPOFF: 'Haz click en el mapa para seleccionar el punto de dropoff.',
        WAYPOINTS: 'Waypoints',
        WAYPOINTS_COUNT_ONE: '{{count}} punto en el trayecto.',
        WAYPOINTS_COUNT_OTHER: '{{count}} puntos en el trayecto.',
        REFRAME_ALL: 'Reencuadrar todos los puntos',
        REFRAME_ALL_ARIA: 'Reencuadrar todos los waypoints en el mapa',
        REFRAME: 'Reencuadrar',
        COL_TIME: 'Hora',
        COL_POINT: 'Punto',
        COL_ACTIONS: 'Acciones',
        FOCUS_WAYPOINT_ARIA: 'Enfocar waypoint {{n}} en el mapa',
        VIEW_THIS_POINT: 'Ver este punto en el mapa',
        NO_ADDRESS: 'Sin dirección',
        COORDINATES: 'Coordenadas',
        DISTANCE_FROM_PREVIOUS: 'Distancia desde el punto anterior',
        COPY_WAYPOINT_ARIA: 'Copiar coordenadas del waypoint',
        VIEW_POINT: 'Ver punto en el mapa',
        VIEW_WAYPOINT_ARIA: 'Ver waypoint en el mapa',
        WAYPOINTS_MAP_CAPTION: 'Mapa interactivo del trayecto con zoom y desplazamiento.',
        MAP_LOAD_ERROR: 'No se ha podido cargar el mapa.',
        MAP_LOADING: 'Cargando mapa…',
        DRIVER_ORIGIN: 'Origen del conductor',
        DRIVER_DESTINATION: 'Destino del conductor',
        MARKER_WAYPOINT: 'Waypoint {{n}}',
        SAVE_POINT_TITLE: 'Guardar {{point}}',
        SAVE_POINT_QUESTION: '¿Quieres guardar este punto de {{point}} para esta ruta?',
        POINT_PICKUP: 'pickup',
        POINT_DROPOFF: 'dropoff',
        SAVE: 'Guardar',
        SAVING: 'Guardando…',
        SAVED: 'Guardado',
        SAVE_ERROR_TITLE: 'No se pudo guardar el punto',
        SAVE_ERROR_TEXT: 'El backend no aceptó la actualización.',
        STATUS: {
          PENDING_DRIVER: 'Pendiente del conductor',
          CONFIRMED_DRIVER: 'Confirmado por el conductor',
          PENDING_PASSENGER: 'Pendiente del pasajero',
          PASSENGER_CONFIRMED: 'Confirmado por el pasajero',
          INITIAL: 'Inicial',
          CONFIRMED: 'Confirmado',
          ONGOING: 'En curso',
          CANCELLED: 'Cancelado',
          REJECTED: 'Rechazado',
        },
        WAYPOINT_ACTIONS: {
          START: 'Inicio',
          END: 'Fin',
          PICKUP: 'Recogida',
          DROPOFF: 'Bajada',
        },
      },
      FACE_VERIFICATION: {
        SETTINGS: {
          TITLE: 'Verificación facial',
          PAGE: {
            NOTE_TITLE: 'Cuándo se pide la verificación facial',
            NOTE_TEXT: 'La verificación facial solo la pide la evaluación de fraude a mitad de viaje, al finalizar el trayecto. Con el interruptor general desactivado no se pide a nadie. Los umbrales de Rekognition fijan cuándo se da por superada y la referencia, contra qué foto se compara. Todo se guarda junto con el botón del final.',
            GENERAL_SUB: 'Activa o desactiva la verificación facial para todos los usuarios',
            THRESHOLDS_SUB: 'Confianza mínima de liveness y de similitud para dar la verificación por superada',
            REFERENCE_SUB: 'Contra qué foto se compara la cara del usuario en cada verificación',
            LOADING: 'Cargando los ajustes',
          },
          GENERAL_TITLE: 'Interruptor general',
          KILL_SWITCH_WARNING: 'Interruptor de emergencia: al desactivarlo, nadie estará obligado a pasar la verificación facial.',
          ENABLED_LABEL: 'Verificación facial activada',
          THRESHOLDS_TITLE: 'Umbrales de Rekognition',
          LIVENESS_THRESHOLD_LABEL: 'Umbral de confianza de liveness',
          LIVENESS_THRESHOLD_HINT: 'Número entre 0 y 100 (se admiten decimales)',
          SIMILARITY_THRESHOLD_LABEL: 'Umbral de similitud',
          SIMILARITY_THRESHOLD_HINT: 'Número entre 0 y 100 (se admiten decimales)',
          REFERENCE_TITLE: 'Referencia de la comparación',
          REFERENCE_TECALIS_LABEL: 'Selfie de Tecalis',
          REFERENCE_TECALIS_HINT: 'Siempre contra la selfie que Tecalis verificó contra el documento',
          REFERENCE_ENROLLMENT_LABEL: 'Captura tras fallos cercanos',
          REFERENCE_ENROLLMENT_HINT: 'Primero contra la selfie de Tecalis; al sumar varios fallos cercanos se guarda la imagen de la prueba de vida y desde entonces se compara contra ella',
          ENROLLMENT_MIN_SIMILARITY_LABEL: 'Similitud mínima de un fallo cercano',
          ENROLLMENT_MIN_SIMILARITY_HINT: 'Número entre 0 y 100 (se admiten decimales). Una selfie de Tecalis sin cara detectable también cuenta',
          ENROLLMENT_ATTEMPTS_LABEL: 'Fallos cercanos para guardar la captura',
          ENROLLMENT_ATTEMPTS_HINT: 'Número entero entre 1 y 10, contando todos los viajes del usuario',
          UPDATED_AT_LABEL: 'Última modificación',
          DISABLE_CONFIRM_TITLE: '¿Desactivar la verificación facial?',
          DISABLE_CONFIRM_TEXT: 'Nadie estará obligado a pasar la verificación facial hasta que se vuelva a activar.',
          CONFIRM: 'Confirmar',
          CANCEL: 'Cancelar',
          SAVE: 'Guardar',
          SAVING: 'Guardando…',
          SAVED: 'Ajustes guardados',
          ERROR_TITLE: 'Error',
          ERROR_LOAD: 'No se pudieron cargar los ajustes',
          ERROR_SAVE: 'No se pudieron guardar los cambios',
          ERROR_FORBIDDEN: 'No tienes permiso para realizar esta acción',
          ACCEPT: 'Aceptar',
          VALIDATION: {
            REQUIRED: 'Este campo es obligatorio',
            INTEGER: 'El valor debe ser un número entero',
            RANGE: 'El valor debe estar entre 0 y 100',
            ATTEMPTS_RANGE: 'El valor debe estar entre 1 y 10',
          },
        },
      },
      RIDES_CONFIG: {
        SETTINGS: {
          PAGE: {
            NOTE_TITLE: 'VTC se guarda al confirmarlo; el resto, con «Guardar»',
            NOTE_TEXT: 'El interruptor de VTC pide confirmación y se aplica en cuanto confirmas. Catálogo de productos, comisión, penalización y ajustes se guardan juntos con el botón del final.',
            VTC_TITLE: 'Disponibilidad de VTC',
            VTC_SUB: 'Muestra u oculta el botón de pedir ride en la app para todos los usuarios',
            ESTIMATES_TITLE: 'Presentación de opciones',
            ESTIMATES_SUB: 'Cómo muestra la app las opciones de VTC y taxi al estimar un ride',
            PRODUCTS_TITLE: 'Catálogo de productos',
            PRODUCTS_SUB: 'Qué productos ve el rider al estimar un ride',
            FEES_TITLE: 'Comisión y cancelación',
            FEES_SUB: 'Comisión que se cobra en cada ride y penalización si se cancela',
            ADJUSTMENTS_TITLE: 'Ajustes con el importe real',
            ADJUSTMENTS_SUB: 'Corrigen la penalización o el cobro con lo que factura el proveedor',
            LOADING: 'Cargando los ajustes',
          },
          TITLE: 'Ajustes de rides',
          VTC_LABEL: 'VTC habilitado',
          VTC_HINT: 'Controla la disponibilidad global de rides VTC en la app',
          VTC_CONFIRM_TITLE: '¿Estás seguro?',
          VTC_DISABLE_TEXT: 'Al deshabilitar VTC se ocultará el botón de pedir ride en la app para todos los usuarios',
          VTC_ENABLE_TEXT: 'Al habilitar VTC el botón de pedir ride volverá a mostrarse en la app',
          VTC_SAVED: 'VTC actualizado',
          ESTIMATES_LABEL: 'Modo de presentación',
          ESTIMATES_HINT: 'Todas muestra cada opción disponible. Mejores opciones solo muestra la más económica y la más rápida.',
          ESTIMATES_ALL: 'Todas las opciones',
          ESTIMATES_BEST_OPTIONS: 'Solo la más económica y la más rápida',
          ESTIMATES_SAVED: 'Presentación actualizada',
          ERROR_FORBIDDEN: 'No tienes permiso para cambiar la presentación de opciones',
          CONFIRM: 'Confirmar',
          CANCEL: 'Cancelar',
          RIDE_PRODUCTS_ENABLED_LABEL: 'Productos WAIIS en estimaciones',
          RIDE_PRODUCTS_ENABLED_HINT: 'Encendido: se muestran los productos WAIIS y, para cada uno, el proveedor más barato. Apagado: se muestra el listado real de productos de cada proveedor visible (p. ej. para certificaciones).',
          COMMISSION_ENABLED_LABEL: 'Cobrar comisión',
          COMMISSION_PERCENT_LABEL: '% comisión',
          COMMISSION_PERCENT_HINT: 'Porcentaje entre 0 y 100 (dos decimales)',
          CANCELLATION_PENALTY_LABEL: '% penalización por cancelación',
          CANCELLATION_PENALTY_HINT: 'Porcentaje entre 0 y 100',
          REAL_FEE_ADJUSTMENT_LABEL: 'Ajuste por tarifa real',
          REAL_FEE_ADJUSTMENT_HINT: 'Recalcular la penalización con la cuota real del proveedor',
          REAL_FEE_ADJUSTMENT_ENABLED_AT_LABEL: 'Se aplica a viajes creados desde',
          RECEIPT_ADJUSTMENT_LABEL: 'Ajuste por recibo en viajes completados',
          RECEIPT_ADJUSTMENT_HINT: 'Conciliar la diferencia con el importe cobrado cuando llegue el recibo del proveedor',
          RECEIPT_ADJUSTMENT_ENABLED_AT_LABEL: 'Se aplica a viajes creados desde',
          ADJUSTMENT_NEVER_ENABLED: 'Nunca activado',
          SAVE: 'Guardar',
          SAVING: 'Guardando…',
          SAVED: 'Ajustes guardados',
          ERROR_TITLE: 'Error',
          ERROR_LOAD: 'No se pudieron cargar los ajustes',
          ERROR_SAVE: 'No se pudieron guardar los cambios',
          ACCEPT: 'Aceptar',
          VALIDATION: {
            REQUIRED: 'Este campo es obligatorio',
            RANGE: 'El valor debe estar entre 0 y 100',
          },
        },
        GUEST_PHONES: {
          PAGE: {
            SUBTITLE: 'Números del pool de invitados. Puedes activarlos, editarlos o borrarlos.',
            FOOTER: 'Mostrando {{shown}} de {{total}} teléfonos',
            LOADING: 'Cargando teléfonos',
            ACTIVE_ON: 'Activo',
            ACTIVE_OFF: 'Inactivo',
            SAVING: 'Guardando…',
            RETRY: 'Reintentar',
            MODAL_SECTION: 'Número del invitado',
            DELETING: 'Borrando…',
            DELETED: 'Borrado',
            ERROR_LOAD: 'No se pudieron cargar los teléfonos',
            ERROR_TOGGLE: 'No se pudo cambiar el estado del teléfono',
            ERROR_DELETE: 'No se pudo borrar el teléfono',
          },
          TITLE: 'Teléfonos de invitados',
          EMPTY: 'No hay teléfonos configurados',
          TABLE: {
            PHONE_NUMBER: 'Teléfono',
            ACTIVE: 'Activo',
            ACTIONS: 'Acciones',
          },
          ACTIONS: {
            ADD: 'Añadir',
            EDIT: 'Editar',
            DELETE: 'Borrar',
            CANCEL: 'Cancelar',
            SAVE: 'Guardar',
            ACCEPT: 'Aceptar',
          },
          MODAL: {
            CREATE_TITLE: 'Nuevo teléfono invitado',
            EDIT_TITLE: 'Editar teléfono invitado',
          },
          FORM: {
            PHONE_NUMBER: 'Teléfono',
            PHONE_PLACEHOLDER: '+34600000000',
            PHONE_HINT: 'Formato E.164: prefijo internacional con + (p. ej. +34600000000)',
          },
          VALIDATION: {
            PHONE_REQUIRED: 'El teléfono es obligatorio',
            PHONE_FORMAT: 'Formato inválido: usa E.164 (+ y 7–15 dígitos)',
          },
          DELETE: {
            TITLE: '¿Borrar teléfono?',
            TEXT: 'Se eliminará {{phone}} del pool de invitados',
            CONFIRM: 'Sí, borrar',
          },
          ERROR: {
            TITLE: 'Error',
          },
        },
        PROVIDER_ROUTING: {
          TITLE: 'Enrutado por etiqueta',
          PAGE: {
            SUBTITLE: 'Cada regla indica el proveedor que ve un usuario con esa etiqueta.',
            FOOTER: 'Mostrando {{shown}} de {{total}} reglas',
            LOADING: 'Cargando reglas',
            RETRY: 'Reintentar',
            SAVING: 'Guardando…',
            DELETING: 'Borrando…',
            DELETED: 'Borrado',
            ERROR_LOAD: 'No se pudieron cargar las reglas',
            ERROR_SWITCH: 'No se pudo cambiar el interruptor',
            ERROR_DELETE: 'No se pudo borrar la regla',
            MODAL_SECTION: 'Regla',
          },
          SWITCH: {
            TITLE: 'Enrutado activo',
            LABEL: 'Enrutar por etiqueta',
            HINT: 'Con el interruptor encendido, un usuario etiquetado solo ve en estimates el proveedor de su regla.',
            SAVED_ON: 'Enrutado activado',
            SAVED_OFF: 'Enrutado desactivado',
          },
          EMPTY: 'No hay reglas configuradas',
          TABLE: {
            TAG: 'Etiqueta',
            PROVIDER: 'Proveedor',
            USERS: 'Usuarios',
            ACTIONS: 'Acciones',
          },
          ACTIONS: {
            ADD: 'Añadir regla',
            EDIT: 'Editar',
            DELETE: 'Borrar',
            CANCEL: 'Cancelar',
            SAVE: 'Guardar',
            ACCEPT: 'Aceptar',
            CLOSE: 'Cerrar',
          },
          USERS: {
            TITLE: 'Usuarios de la regla',
            OPEN: 'Ver los usuarios de la etiqueta {{tag}}',
            SEARCH_PLACEHOLDER: 'Buscar por nombre o email',
            LOADING: 'Cargando usuarios',
            NAME: 'Nombre',
            EMAIL: 'Email',
            ERROR_LOAD: 'No se pudieron cargar los usuarios',
            EMPTY: 'Ningún usuario tiene esta etiqueta',
            EMPTY_SEARCH: 'Ningún usuario coincide con la búsqueda',
            FOOTER: 'Mostrando {{shown}} de {{total}} usuarios',
            PREVIOUS: 'Anterior',
            NEXT: 'Siguiente',
          },
          MODAL: {
            CREATE_TITLE: 'Nueva regla',
            EDIT_TITLE: 'Editar regla',
          },
          FORM: {
            TAG: 'Etiqueta',
            TAG_PLACEHOLDER: 'uber',
            TAG_HINT: 'Letras, números, punto, guion y guion bajo. No se puede cambiar después.',
            PROVIDER: 'Proveedor',
          },
          VALIDATION: {
            TAG_REQUIRED: 'La etiqueta es obligatoria',
            TAG_FORMAT: 'Solo letras, números, «.», «_» y «-»',
            PROVIDER_REQUIRED: 'Elige un proveedor',
          },
          DELETE: {
            TITLE: '¿Borrar regla?',
            TEXT: 'Se eliminará la regla de la etiqueta {{tag}}',
            CONFIRM: 'Sí, borrar',
          },
        },
        PROVIDERS: {
          TITLE: 'Proveedores y mapeo de productos',
          RIDE_PRODUCTS: {
            TITLE: 'Productos WAIIS',
            HELP: 'Son los productos que ve el rider. Cada proveedor mapea uno de sus productos reales a cada producto WAIIS; el estimado muestra el proveedor más barato de los mapeados.',
            ADD: 'Añadir producto WAIIS',
            MOVE_UP: 'Subir',
            MOVE_DOWN: 'Bajar',
            TABLE: {
              ORDER: 'Orden',
              PRODUCT: 'Producto',
              VISIBLE: 'Visible',
              ACTIONS: 'Acciones',
            },
            MODAL: {
              NEW_TITLE: 'Nuevo producto WAIIS',
              EDIT_TITLE: 'Editar producto WAIIS',
              SECTION_DATA: 'Datos del producto',
              KEY: 'Clave',
              KEY_HELP: 'Identificador interno en minúsculas, números y guiones (p. ej. go, premium-xl). No se puede cambiar después.',
              DISPLAY_NAME: 'Nombre',
              IMAGE: 'Imagen',
              IMAGE_HELP: 'URL del icono que ve el rider',
              DESCRIPTION: 'Descripción',
              DESCRIPTION_HELP: 'Opcional, por idioma. Solo se guardan los idiomas con texto.',
              VISIBLE: 'Visible',
            },
            VALIDATION: {
              KEY_REQUIRED: 'La clave es obligatoria',
              KEY_FORMAT: 'Solo minúsculas, números y guiones (máximo 50 caracteres)',
              DISPLAY_NAME_REQUIRED: 'El nombre es obligatorio',
            },
            CONFIRM: {
              DELETE_TITLE: '¿Eliminar producto WAIIS?',
              DELETE_TEXT: 'Se eliminará "{{product}}" definitivamente',
            },
            ERROR: {
              IN_USE: 'No se puede eliminar: todavía hay fichas que lo mapean en {{providers}}',
            },
          },
          ROUTE: {
            TITLE: 'Ruta de muestra para descubrir productos',
            HELP: 'Los proveedores solo revelan sus productos al estimar un trayecto, y el catálogo cambia según la ciudad. Elige origen y destino en la ciudad que quieras consultar: la ruta se guarda para todo el equipo.',
            PICKUP: 'Origen',
            DROPOFF: 'Destino',
          },
          DISCOVER: {
            BUTTON: 'Descubrir productos del proveedor',
            ADD_TAG: 'Usar esta clave: ',
            PLACEHOLDER: 'Escribe la clave o descubre los productos del proveedor',
            EMPTY: 'Sin productos descubiertos todavía',
            CAPACITY: '{{capacity}} plazas',
            MAPPED_TO: 'Ya mapeado a {{product}}',
            MAPPED_HIDDEN: 'Mapeado y oculto',
            REFRESH: 'Volver a consultar al proveedor',
            ROUTE_USED: 'Ruta de muestra: {{pickup}} → {{dropoff}}',
            NO_ROUTE: 'Configura la ruta de muestra en la página de proveedores para descubrir productos',
            ERROR: {
              DISABLED: 'El proveedor está deshabilitado en el servidor',
              UNAVAILABLE: 'El proveedor no está disponible ahora mismo',
              GENERIC: 'No se pudieron descubrir los productos del proveedor',
            },
          },
          ACTIONS: {
            ADD_PRODUCT: 'Añadir producto',
            SAVE: 'Guardar',
            CANCEL: 'Cancelar',
            ACCEPT: 'Aceptar',
            EDIT: 'Editar',
            DELETE: 'Eliminar',
            SAVING: 'Guardando…',
            DELETING: 'Eliminando…',
            DELETED: 'Eliminado',
            RETRY: 'Reintentar',
          },
          FORM: {
            DISPLAY_NAME: 'Nombre personalizado',
            VISIBLE: 'Visible',
          },
          EMPTY: {
            PRODUCTS: 'Este proveedor no tiene productos mapeados todavía',
            RIDE_PRODUCTS: 'No hay productos WAIIS configurados',
          },
          FOOT: {
            RIDE_PRODUCTS: 'Mostrando {{count}} de {{total}} productos WAIIS',
            PRODUCTS: 'Mostrando {{count}} de {{total}} productos',
          },
          TABLE: {
            PRODUCT_KEY: 'Producto del proveedor',
            RIDE_PRODUCT: 'Producto WAIIS',
            VISIBLE: 'Visible',
            ACTIONS: 'Acciones',
          },
          MODAL: {
            NEW_PRODUCT: 'Nuevo producto',
            EDIT_PRODUCT: 'Editar producto',
            PRODUCT_KEY: 'Producto del proveedor',
            PRODUCT_KEY_HELP: 'Nombre exacto del producto en el proveedor (p. ej. UberX, Standard)',
            RIDE_PRODUCT: 'Producto WAIIS',
            RIDE_PRODUCT_PLACEHOLDER: 'Selecciona un producto WAIIS',
            VISIBLE: 'Visible',
          },
          VALIDATION: {
            PRODUCT_KEY_REQUIRED: 'El producto del proveedor es obligatorio',
            RIDE_PRODUCT_REQUIRED: 'El producto WAIIS es obligatorio',
          },
          CONFIRM: {
            DELETE_PRODUCT_TITLE: '¿Eliminar producto?',
            DELETE_PRODUCT_TEXT: 'Se eliminará "{{product}}" definitivamente',
          },
          ERROR: {
            TITLE: 'Error',
            LOAD: 'No se han podido cargar los proveedores',
            REORDER: 'No se ha podido cambiar el orden',
            VISIBILITY: 'No se ha podido cambiar la visibilidad',
            DELETE: 'No se ha podido eliminar',
            SAVE_PROVIDER: 'No se ha podido guardar el proveedor',
            LOAD_ROUTE: 'No se ha podido cargar la ruta de muestra',
            SAVE_ROUTE: 'No se ha podido guardar la ruta de muestra',
          },
          SUCCESS: {
            PROVIDER_SAVED: 'Proveedor guardado',
          },
        },
      },
      POIS: {
        TITLE: 'POIs',
        SUBTITLE: 'Puntos de recogida / dejada',
        REVIEW_TAB: 'Revisar',
        UPLOAD_TAB: 'Subir',
        TOTAL: 'POIs totales',
        BY_CATEGORY: 'Por categoría',
        BUS_STOP: 'Paradas de bus',
        TRAIN_STATION: 'Estaciones de tren',
        METRO_STATION: 'Estaciones de metro',
        ZEBRA_CROSSING: 'Pasos de cebra',
        STREET_CORNER: 'Esquinas',
        LOCAL_BUSINESS: 'Negocios locales',
        LOAD_IN_VIEW: 'Cargar POIs de esta vista',
        LOADING: 'Cargando…',
        SHOWING: 'Mostrando {{count}} POIs',
        TRUNCATED:
          'Mostrando los primeros {{limit}} POIs — haz zoom para verlos todos.',
        NO_POIS: 'No hay POIs en esta vista.',
        FILTERS: 'Categorías',
        UPLOAD_TITLE: 'Subir POIs',
        UPLOAD_HELP:
          'Array JSON de {osm_id, category, name, lat, lng}. La subida reemplaza todo el conjunto por diff.',
        SELECT_FILE: 'Seleccionar fichero JSON',
        UPLOAD_BTN: 'Subir',
        UPLOADING: 'Subiendo…',
        IMPORT_RUNNING: 'Ya hay una subida en curso.',
        IMPORT_QUEUED: 'Subida encolada.',
        UPLOAD_ERROR: 'La subida ha fallado.',
        PROGRESS_TITLE: 'Progreso de la subida',
        STATUS: 'Estado',
        PROCESSED: 'Procesados',
        STAGED: 'Insertados',
        DELETED: 'Borrados',
        FAILED: 'Fallidos',
        STATUS_IDLE: 'Inactivo',
        STATUS_QUEUED: 'En cola',
        STATUS_PARSING: 'Parseando fichero',
        STATUS_RESYNCING: 'Recalculando relaciones',
        STATUS_COMPLETED: 'Completado',
        STATUS_FAILED: 'Fallido',
      },
      TRIP_MAP: {
        SHOW_HEXAGONS: 'Mostrar Hexágonos',
        H3_RESOLUTION: 'Resolución H3:',
        POINT_DETAILS: 'Detalles del punto',
        SELECT_TRIP: 'Selecciona un viaje para ver el mapa',
        LOADING: 'Cargando mapa',
        POINT: 'Punto',
        MOBILITY: 'Movilidad',
        NOT_CLASSIFIED: 'Sin clasificar',
        CLASSIFIED_AS: 'Clasificado como:',
        CLASSIFY_GROUP: 'Clasificar grupo de puntos',
        RESET: 'Restablecer',
        START: 'Inicio',
        END: 'Fin',
        ACTIVITY: 'Actividad',
        MISCELLANEOUS: 'Miscelánea',
        CONFIRM: 'Confirmar',
        TAGS: {
          VEHICLE: 'Vehículo',
          BICYCLE: 'Bicicleta',
          WALKING: 'Caminando',
          BUS: 'Autobús',
          SUBWAY: 'Metro',
          MOTORCYCLE: 'Moto',
          OTHER: 'Otro',
        },
        MISC: {
          HOME: 'Casa',
          WORK: 'Trabajo',
          JAM: 'Atasco',
          STOPOVER: 'Parada',
          OTHER: 'Otro',
        },
        SAVING: 'Guardando',
        SAVED: 'Cambios guardados con éxito',
        ERROR_ASSIGNING_TAG:
          'Error al asignar la etiqueta. Por favor, inténtalo de nuevo.',
        ERROR_LOADING_DATA:
          'Error al cargar los datos del viaje. Por favor, inténtalo de nuevo.',
        REVISION_STATUS: 'Estado de la revisión',
        PENDING: 'Pendiente',
        MULTISELECT_INSTRUCTION:
          'Mantén pulsada la tecla Shift + Click para seleccionar múltiples puntos',
        SELECT_ALL: 'Seleccionar todo',
        ALL_POINTS: 'Todos los puntos',
        DATE: 'Fecha',
        MOVING: 'En movimiento',
        MOVING_YES: 'Sí',
        MOVING_NO: 'No',
        SPEED: 'Velocidad',
        ODOMETER: 'Odómetro',
        START_TIME: 'Hora de Inicio',
        END_TIME: 'Hora de Fin',
        SELECTION_OPTIONS: 'Opciones de Selección',
        SELECT_BY_RANGE: 'Seleccionar por Rango de Horario',
        ENTER_START_TIME: 'Hora de inicio (HH:mm)',
        ENTER_END_TIME: 'Hora de fin (HH:mm)',
        SELECT: 'Seleccionar',
        CANCEL: 'Cancelar',
        NO_POINTS_IN_RANGE:
          'No se encontraron puntos en el rango seleccionado.',
        FILTER_POINTS: 'Filtrar puntos',
        ALL: 'Todos',
        NONE: 'Ninguno',
        SHOW_VISIBLE_MAP_H3: 'Mostrar H3 del mapa visible',
        AVAILABLE_RANGE: 'Rango disponible: {{start}} - {{end}}',
        START_BEFORE_END: 'La hora de inicio debe ser anterior a la de fin',
        RANGE_BETWEEN: 'El rango debe estar entre {{start}} y {{end}}',
        HEX_POINTS: '{{count}} puntos',
        LONG_ADDRESS: 'Dirección completa',
        COORDINATES: 'Coordenadas',
        RAW_POINT_DATA: 'Datos en bruto del punto',
        TIME: 'Hora',
        EVENT: 'Evento',
        CONFIDENCE: 'Confianza',
        ACCURACY: 'Precisión',
        ALTITUDE: 'Altitud',
        HEADING: 'Rumbo',
        ORDER: 'Orden',
        NOT_AVAILABLE: 'N/D',
      },
      TRIP_REVIEW: {
        SELECTED_DATE: 'Fecha seleccionada',
        NO_TRIPS_FOR_DAY: 'No hay viajes para este día',
        NO_DATA_FOR_USER: 'No hay datos para este usuario',
        VERIFY_USER_EXISTS: 'Verifica que el usuario exista o selecciona otro.',
        LOADING: 'Cargando',
        STATUS_REVIEWED: 'Revisado',
        STATUS_NOT_REVIEWED: 'No revisado',
        ROUTINE_TRIP: 'Viaje rutinario',
        REVIEW_STATUS_PENDING: 'Pendiente',
        REVIEW_STATUS_REVIEWED: 'Revisado',
        REVIEW_STATUS_FRAUDULENT: 'Fraudulento',
        REVIEW_STATUS_ERRONEOUS: 'Erróneo',
        CLASSIFICATION_SAVE_SUCCESS: 'Clasificación guardada con éxito',
        CLASSIFICATION_SAVE_ERROR:
          'Error al guardar la clasificación. Inténtalo de nuevo.',
        BACK: 'Volver',
        SEARCH_USER_PLACEHOLDER: 'Buscar usuario…',
        SEARCH_USER_ARIA: 'Buscar usuario por nombre o correo',
        SEARCH_SHOWING: 'Mostrando {{shown}} de {{total}} coincidencias. Afina la búsqueda para ver el resto.',
        SEARCHING: 'Buscando…',
        NO_RESULTS: 'Sin resultados',
        SEARCH_ERROR: 'No se ha podido buscar. Inténtalo de nuevo.',
        LOAD_USER_ERROR: 'No se ha podido cargar la ficha de este usuario. Inténtalo de nuevo más tarde.',
        LOAD_CALENDAR_ERROR: 'No se ha podido cargar el calendario de este usuario. Inténtalo de nuevo más tarde.',
        COPY_ID: 'Copiar ID',
        ID_COPIED: 'ID copiado',
        COPY_ID_ERROR: 'No se ha podido copiar el ID',
        SHOW_MORE_TRIPS: 'Ver más viajes',
        UNKNOWN: 'Desconocido',
        NOT_LINKED: 'Sin vincular',
        EDIT_LINKED_SEGMENTS: 'Editar segmentos vinculados',
        EDIT_SEGMENTS: 'Editar segmentos',
        PREVIOUS_SEGMENT: 'Segmento anterior',
        NEXT_SEGMENT: 'Segmento siguiente',
        UNSAVED_CHANGES: 'Hay cambios sin guardar.',
        SAVING: 'Guardando…',
        SAVE: 'Guardar',
        SAVE_SEGMENTS_ERROR: 'No se han podido guardar los segmentos vinculados.',
      },
      MATCH_REVIEW: {
        DRIVER: 'Conductor',
        RIDERS: 'Pasajeros',
        PASSENGER: 'Pasajero',
        VERIFY: 'Verificar',
        SELECT_DRIVER: 'Selecciona un conductor',
        SELECT_PASSENGER: 'Selecciona un pasajero',
        DRIVER_DATA: 'Datos del Conductor',
        PASSENGER_DATA: 'Datos del Pasajero',
        ROUTE_MAP: 'Mapa de Ruta',
        NO_DATA: 'Sin datos disponibles',
        ENTER_ROUTINE_IDS:
          'Ingresa los IDs de rutina del conductor y pasajero para ver las rutas en el mapa',
        LOADED: 'Cargado',
        USER: 'Usuario',
        DISTANCE: 'Distancia',
        DURATION: 'Duración',
        PRICE: 'Precio',
        LOADING: 'Cargando',
        SHOW_HEXAGONS: 'Mostrar Hexágonos',
        SHOW_MAP_HEXAGONS: 'Ver todos los hexágonos del mapa',
        SHOW_POLYLINE: 'Ver polilínea',
        ADD_DRIVER: 'Añadir conductor',
        ADD_RIDER: 'Añadir pasajero',
        SELECT_ROUTINE: 'Haz click aquí para agregar una rutina',
        ROUTE_SELECTOR: 'Selector de ruta',
        NAME: 'Nombre',
        LOCATIONS: 'Ubicaciones',
        ERROR_LOADING_ROUTE: 'Error cargando ruta',
        SELECT_ROUTE_DETAILS: 'Selecciona una ruta para ver los detalles',
        COPY_PHP_PAYLOAD: 'Copiar payload PHP',
        COPY_PHP_PAYLOAD_HINT: 'Copia los datos de la rutina como array PHP',
        COPIED: 'Copiado',
        CENTER: 'Centrar',
        H3_RESOLUTION: 'Resolución H3',
        HEXAGON_POINTS: 'Puntos para Hexágonos',
        SIGNIFICANT_POINTS: 'Puntos Significativos',
        ALL_POINTS: 'Todos los Puntos',
        ERROR: 'Error',
        MAPS_LOAD_ERROR: 'Error al cargar Google Maps',
        ENTER_DRIVER_ID: 'Por favor ingresa una ID de rutina del conductor',
        ENTER_PASSENGER_ID: 'Por favor ingresa una ID de rutina del pasajero',
        ERROR_VERIFYING: 'Error al verificar la rutina del {{type}}',
        PICKUP: 'Recogida {{type}}',
        ORIGIN: 'Origen {{type}}',
        DROPOFF: 'Dejada {{type}}',
        DESTINATION: 'Destino {{type}}',
        DRIVER_TEXT: 'conductor',
        PASSENGER_TEXT: 'pasajero',
        COORDINATES: '{{lat}}, {{lng}}',
        H3_INDEX: 'Índice H3 (Res {{res}})',
        LOADING_ROUTINE: 'Cargando rutina...',
        UNKNOWN_ERROR: 'Error desconocido',
        INFO: 'Información',
        SEARCH_RADIUS: 'Radio de Búsqueda',
        RADIUS_PLACEHOLDER: 'Radio en metros',
        FOUND: 'Se encontraron',
        INTEREST_POINTS: 'puntos de interés',
        NO_POINTS_FOUND:
          'No se encontraron puntos de interés en el radio especificado',
        ERROR_FETCHING_POINTS: 'Error al obtener los puntos de interés',
        SEARCH_INTEREST_POINTS: 'Buscar puntos de interés',
        CANCEL_SEARCH: 'Cancelar búsqueda',
        CLEAN_INTEREST_POINTS: 'Limpiar puntos de interés',
        LOAD_FROM_FILE: 'Cargar desde archivo',
        PROCESS_COMPLETE: 'Proceso completado',
        CONFIRM: 'Confirmar',
        MAP_SUB: 'Polilíneas, puntos y hexágonos H3 de las rutinas elegidas en las tablas de abajo.',
        H3_ROUTINE: 'H3 rutina',
        H3_ALL: 'Todos los H3',
        POI_CLICK_HINT: 'Haz clic en el mapa para buscar alrededor de ese punto.',
        LEGEND: 'Leyenda',
        SHARED_H3: 'Hexágono amarillo con borde verde: H3 compartido entre rutinas',
        POI_LEGEND: 'Etiqueta amarilla: estación de bus o tren (se ve con zoom 13 o más)',
        DRIVERS: 'Conductores',
        DRIVERS_SUB: 'Rutinas de conductor que se dibujan en el mapa. Pulsa una fila para ver su detalle.',
        RIDERS_SUB: 'Rutinas de pasajero que se dibujan en el mapa, con su recogida y dejada. Pulsa una fila para ver su detalle.',
        LOAD_FROM_FILE_HINT: 'Cargar rutinas desde archivo',
        ROUTINE: 'Rutina',
        POLYLINE: 'Polilínea',
        ORIGIN_DESTINATION: 'Origen / Destino',
        PICKUP_DROPOFF: 'Pickup / Dropoff',
        TOGGLE_POLYLINE: 'Mostrar u ocultar la polilínea en el mapa',
        TOGGLE_PINS: 'Mostrar u ocultar origen y destino en el mapa',
        TOGGLE_SPECIAL: 'Mostrar u ocultar recogida y dejada en el mapa',
        CENTER_ON_ROUTE: 'Centrar mapa en esta ruta',
        REMOVE_DRIVER: 'Eliminar conductor',
        REMOVE_RIDER: 'Eliminar pasajero',
        EXPAND: 'Ver u ocultar el detalle',
        DAY: 'Día',
        DEPARTURE: 'Salida',
        ARRIVAL: 'Llegada',
        SCHEDULE: 'Horario',
        COPY_ADDRESS: 'Copiar dirección',
        COPY_COORDS: 'Copiar coordenadas',
        ROUTINE_LOAD_FAILED: 'No se ha podido cargar la rutina',
        FILE_NOT_TXT: 'Selecciona un archivo .txt',
        FILE_NO_IDS: 'El archivo no contiene routineIds válidos',
        FILE_PROCESS_ERROR: 'No se ha podido procesar el archivo',
        FILE_READ_ERROR: 'No se ha podido leer el archivo',
        LOAD_DRIVERS_TITLE: 'Cargar {{count}} conductores',
        LOAD_RIDERS_TITLE: 'Cargar {{count}} pasajeros',
        LOAD_ROUTINES_TEXT: 'Se verificará cada rutina y se añadirá a la tabla y al mapa.',
        PROCESSED_OK: 'Se han procesado {{count}} rutinas correctamente.',
        ERRORS_FOUND: 'Errores encontrados ({{count}}):',
        DAY_N: 'Día {{n}}',
        OUTBOUND: 'Ida',
        RETURN: 'Vuelta',
        UNKNOWN_DAY: 'Desconocido',
        ROUTE_POINT: 'Punto de la ruta',
        FILE_EMPTY: 'El archivo está vacío',
        POI_TYPE_BUS_STATION: 'Estación de bus',
        POI_TYPE_TRAIN_STATION: 'Estación de tren',
      },
      SUPPORT_CHAT: {
        TRIP_CHAT_FALLBACK: 'Chat de trayecto',
        NAMES_AND: '{{names}} y {{last}}',
        TITLE: 'Chat de Soporte',
        LIST_TITLE: 'Chats de Soporte',
        NO_CHATS: 'No se encontraron conversaciones de soporte.',
        SEND: 'Enviar',
        SELECT_CHAT: 'Selecciona un chat',
        SELECT_CHAT_DESC:
          'Selecciona una conversación del listado para ver los mensajes',
        LOADING_MORE: 'Cargando mensajes anteriores...',
        YOU_SUPPORT: 'Tú (Soporte)',
        NO_MESSAGES: 'Sin mensajes',
        IMAGE_MSG: '[Imagen]',
        TODAY: 'Hoy',
        YESTERDAY: 'Ayer',
        SEARCH_PLACEHOLDER: 'Buscar por nombre, ID o mensaje...',
        CLEAR_SEARCH: 'Limpiar búsqueda',
        NO_RESULTS: 'Ninguna conversación coincide con la búsqueda.',
        LOAD_ERROR: 'No se han podido cargar los datos.',
        RETRY: 'Reintentar',
        LOADING_MORE_CHATS: 'Cargando más conversaciones...',
        LOAD_MORE: 'Cargar más',
        ALL_LOADED: 'No hay más conversaciones',
        CONVERSATION_START: 'Inicio de la conversación',
        CLOSE_TAB: 'Cerrar pestaña',
        CLOSE_ALL: 'Cerrar todas',
        VIEW_PROFILE: 'Ver usuario',
        MARK_AS_UNREAD: 'Marcar como no leído',
        MARK_AS_READ: 'Marcar como leído',
        PENDING_REPLY_HINT: 'Pendiente de responder',
        PENDING_REPLY_ERROR: 'No se ha podido actualizar el aviso de pendiente de responder',
        SEND_HINT: 'Enter para enviar · Shift+Enter para salto de línea',
        TABS_HINT: 'Cada chat se abre en una pestaña: puedes volver a cualquier conversación anterior sin perder el hilo.',
        IMAGE_UNAVAILABLE: 'Imagen no disponible',
        SEARCH_INDEXING: 'Indexando todas las conversaciones...',
        SEARCH_SCOPE_ALL: 'Buscando en todas las conversaciones',
        ATTACH_IMAGE: 'Adjuntar imagen',
        DROP_IMAGE: 'Suelta la imagen para enviarla',
        IMAGE_SENDING: 'Enviando imagen...',
        IMAGE_TOO_LARGE: 'La imagen es demasiado grande. El máximo son 4 MB.',
        IMAGE_INVALID_TYPE: 'Ese fichero no es una imagen.',
        IMAGE_UPLOAD_ERROR: 'No se ha podido enviar la imagen. Inténtalo de nuevo.',
        CLOSE_IMAGE: 'Cerrar imagen',
        LOCATION_SHARED: 'Ubicación compartida',
        EDIT: 'Editar',
        DELETE: 'Borrar',
        SAVE: 'Guardar',
        CANCEL: 'Cancelar',
        EDITED: '(editado)',
        EDIT_HINT: 'Enter para guardar · Esc para cancelar',
        DELETE_CONFIRM: '¿Borrar este mensaje? No se puede deshacer.',
        EDIT_ERROR: 'No se ha podido editar el mensaje. Inténtalo de nuevo.',
        DELETE_ERROR: 'No se ha podido borrar el mensaje. Inténtalo de nuevo.',
        TRIP_CARD_MSG: 'Trayecto no verificado',
        CAPTURE_ATTEMPT_MSG: 'Intento de captura',
        CAPTURE_ATTEMPT_ROW_SCREENSHOT: 'Ha intentado hacer una captura',
        CAPTURE_ATTEMPT_ROW_RECORDING: 'Ha intentado grabar la pantalla',
        CAPTURE_ATTEMPT_SCREENSHOT: '{{name}} ha intentado hacer una captura de pantalla en el chat «{{chat}}»',
        CAPTURE_ATTEMPT_RECORDING: '{{name}} ha intentado grabar la pantalla en el chat «{{chat}}»',
        CAPTURE_ATTEMPT_UNKNOWN_CHAT: 'desconocido',
        TRIP_CHAT_LABEL: 'Chat grupal de trayecto',
        COMPANY_TAG: 'Empresa - {{name}}',
        TRIP_CHAT_TITLE_PREFIX: 'Chat grupal',
        VIEW_PARTICIPANTS: 'Ver participantes',
        GO_TO_TRIP: 'Ir al detalle del viaje',
        TRIP_DATE: 'Fecha',
        TRIP_TYPE: 'Tipo de viaje',
        TRIP_TYPE_routine: 'Rutinario',
        TRIP_TYPE_punctual: 'Puntual',
        TRIP_DRIVER: 'Conductor',
        CLOSE_INCIDENT: 'Cerrar incidencia',
        CLOSE_INCIDENT_CONFIRM: 'El chat desaparecerá de la app para los participantes. Podrás seguir viéndolo aquí y reabrirla cuando haga falta.',
        CLOSE_INCIDENT_ERROR: 'No se ha podido cerrar la incidencia. Inténtalo de nuevo.',
        CLOSE_INCIDENT_DONE: 'Incidencia cerrada y archivada',
        INCIDENT_CLOSED: 'Incidencia cerrada',
        INCIDENT_CLOSED_HINT: 'Esta incidencia está cerrada. Ya no se pueden enviar mensajes.',
        REOPEN_INCIDENT: 'Reabrir incidencia',
        REOPEN_INCIDENT_CONFIRM: 'El chat volverá a estar disponible en la app y se podrán enviar mensajes de nuevo.',
        REOPEN_INCIDENT_ERROR: 'No se ha podido reabrir la incidencia. Inténtalo de nuevo.',
        NEW_MESSAGES_BELOW: '{{count}} mensajes nuevos',
        BACK_TO_LIST: 'Volver al listado',
        MORE_ACTIONS: 'Más acciones',
        INBOX: {
          TAB_UNREAD: 'No leídos',
          TAB_ALL: 'Todos',
          TAB_GROUPS: 'Grupos',
          FILTER: 'Ordenar',
          ORDER: 'Orden',
          COMPANY: 'Empresa',
          COMPANY_ALL: 'Todas',
          COMPANY_CLEAR: 'Quitar el filtro de empresa',
          COMPANY_FILTER: 'Filtrar por empresa',
          COMPANY_FILTER_EMPTY: 'Ninguna conversación de empresa en esta pestaña',
          COMPANY_SEARCH: 'Buscar empresa…',
          COMPANY_NONE: 'Ninguna empresa coincide',
          ORDER_OLDEST: 'Más antiguo primero',
          ORDER_NEWEST: 'Más reciente primero',
          WAITING_FOR: 'Esperando respuesta desde hace {{time}}',
          YOU_PREFIX: 'Tú:',
          CHIP_CLOSED: 'Cerrada',
          CHIP_RESOLVED: 'Finalizada',
          DONE_SECTION: 'Finalizadas',
          EMPTY_unread: 'No hay nada sin leer.',
          EMPTY_all: 'No hay conversaciones.',
          EMPTY_groups: 'No hay chats de trayecto.',
          EMPTY_TAG: 'No hay conversaciones con este tema.',
        },
        PEEK: {
          SHOW: 'Leer sin abrir',
          HIDE: 'Ocultar y marcar como leído',
          HINT: 'Al ocultarlo queda marcado como leído',
          MARK_READ: 'Marcar como leído',
          REPLY: 'Responder',
          EMPTY: 'No hay mensajes del usuario que mostrar.',
          ERROR: 'No se ha podido cargar la vista previa.',
          READ_ERROR: 'No se ha podido marcar como leído. Inténtalo de nuevo.',
        },
        TAGS: {
          trip: 'Trayecto',
          payments: 'Pagos',
          payouts: 'Retiradas',
          cae: 'CAE',
          price: 'Precio',
          referrals: 'Referidos',
          app: 'App',
          account: 'Cuenta',
        },
        TAG_FILTER: 'Filtrar por tema',
        TAG_FILTER_ALL: 'Todos los temas',
        TAG_FILTER_SHOW: 'Mostrar temas',
        TAG_FILTER_HIDE: 'Ocultar temas',
        TAG_FILTER_CLEAR: 'Quitar el filtro de tema',
        TAG_FILTER_EMPTY: 'Ninguna conversación de esta pestaña tiene tema',
        TAG_SCROLL_PREV: 'Temas anteriores',
        TAG_SCROLL_NEXT: 'Más temas',
        TAG_ADD: 'Tema',
        TAG_MENU_TITLE: 'Tema de la conversación',
        TAG_ACCEPT: 'Confirmar',
        TAG_REMOVE: 'Quitar tema',
        TAG_SUGGESTED_HINT: 'Tema sugerido a partir del último mensaje. Confírmalo para guardarlo.',
        TAG_AUTO_HINT: 'Automático: es un chat de trayecto',
        TAGS_ERROR: 'No se ha podido guardar el tema. Inténtalo de nuevo.',
        RESOLVE: {
          FINISH: 'Finalizar',
          REOPEN: 'Reabrir',
          UNDO: 'Deshacer',
          DONE_ONE: 'Conversación finalizada',
          DONE_MANY: '{{count}} conversaciones finalizadas',
          REOPENED: 'Conversación reabierta',
          ERROR: 'No se ha podido finalizar. Revisa la conexión o los permisos e inténtalo de nuevo.',
          REOPEN_ERROR: 'No se ha podido reabrir. Revisa la conexión o los permisos e inténtalo de nuevo.',
          STALE_BANNER: '{{count}} conversaciones sin actividad en +30 días.',
          STALE_BANNER_ONE: '1 conversación sin actividad en +30 días.',
          STALE_DISMISS: 'Ocultar aviso',
          STALE_ACTION: 'Finalizarlas',
          BULK_TITLE: '¿Finalizar {{count}} conversaciones?',
          BULK_CONFIRM: 'Pasarán a «Finalizadas». Si el usuario vuelve a escribir, volverán solas a «No leídos». La app no cambia para el usuario.',
          BULK_ACTION: 'Finalizar',
        },
        COMPOSER: {
          PLACEHOLDER: 'Escribe un mensaje…',
          HINT: 'Enter para enviar · Shift+Enter para salto de línea · «/» con el mensaje vacío para respuestas rápidas',
          QUICK_REPLIES: 'Respuestas rápidas',
          DISMISS: 'Cerrar aviso',
        },
        QUICK_REPLIES: {
          TITLE: 'Respuestas rápidas',
          SEARCH: 'Buscar por título, categoría o texto...',
          LANGUAGE: 'Idioma de la respuesta',
          LOCAL_FALLBACK: 'No se han podido cargar las respuestas: se muestran las de reserva.',
          NO_CA: 'Sin versión en catalán: se insertará en castellano',
          EMPTY: 'Ninguna respuesta coincide con la búsqueda.',
          KEYS_HINT: '↑↓ moverse · Enter insertar · Esc cerrar',
          MANAGE: 'Gestionar respuestas',
        },
        CONTEXT: {
          TITLE: 'Usuario',
          TOGGLE: 'Mostrar u ocultar los datos del usuario',
          CLOSE: 'Cerrar panel',
          OPEN_PROFILE: 'Abrir ficha',
          GROUP_HINT: 'Pulsa un participante para ver sus datos de pago.',
          NO_PARTICIPANTS: 'Sin participantes.',
          UPDATED_AT: 'Actualizado a las {{time}}',
          LOADING: 'Cargando...',
          REFRESH: 'Actualizar',
          USER_ERROR: 'No se han podido cargar los datos de pago.',
          USER_NOT_FOUND: 'Este usuario no existe en este entorno.',
          PAYMENTS: 'Pagos',
          PAYMENT_STATUS: {
            OK: 'Al día',
            WARNING: 'Aviso',
            BLOCKED: 'Bloqueado',
            CANCELLED: 'Cancelado',
            UNKNOWN: 'Sin datos',
          },
          REASON: 'Motivo',
          CARD_EXPIRED: 'Caducada',
          CARD_EXPIRES_SOON: 'Caduca pronto',
          OTHER_CARDS: '+{{n}} tarjetas',
          NO_CARDS: 'Sin tarjetas guardadas',
          NO_CUSTOMER: 'Nunca ha añadido una tarjeta',
          STRIPE_UNAVAILABLE: 'Stripe no responde: datos incompletos.',
          PAYOUTS: 'Cobros',
          BANK_ACCOUNT: 'Cuenta bancaria',
          PAYOUT_LOCAL_ONLY: 'Stripe no responde: se muestran los datos guardados.',
          BALANCE: 'Saldo',
          WALLET: 'Monedero',
          CREDITS: 'Créditos',
        },
      },
      SUPPORT_TOOLS: {
        PAYMENTS: {
          TAB: 'Pagos',
          TITLE: 'Pagos',
          SUBTITLE: 'Tarjetas con las que paga como pasajero y cuenta en la que cobra como conductor. Se consulta Stripe en vivo.',
          REFRESH: 'Actualizar',
          RETRY: 'Reintentar',
          LOAD_ERROR: 'No se ha podido cargar la información de pagos.',
          CARDS_TITLE: 'Como pasajero · tarjetas',
          PAYOUT_TITLE: 'Como conductor · cobros',
          PAYMENT_STATUS: 'Estado de pago',
          STATUS: {
            ok: 'Al día',
            warning: 'Aviso',
            blocked: 'Bloqueado',
            cancelled: 'Cancelado',
            unknown: 'Sin datos',
          },
          REASONS: {
            card_expiring: 'Tarjeta a punto de caducar',
            card_expired: 'Tarjeta caducada',
            method_removed: 'Ha quitado el método de pago',
            charge_failed: 'Cobro fallido',
            hold_failed: 'Caución rechazada',
            debt_paid: 'Deuda pagada',
            method_added: 'Ha añadido un método de pago',
            wallet_topup: 'Recarga de saldo',
            retry_succeeded: 'Reintento de cobro correcto',
            grace_period_exceeded: 'Periodo de gracia agotado',
            manual_override: 'Cambio manual',
          },
          FUNDING: {
            credit: 'Crédito',
            debit: 'Débito',
            prepaid: 'Prepago',
            unknown: 'Tipo desconocido',
          },
          EXPIRES: 'Caduca {{date}}',
          DEFAULT: 'Predeterminada',
          EXPIRES_SOON: 'Caduca pronto',
          EXPIRED: 'Caducada',
          GRACE_PERIOD: 'En periodo de gracia',
          GRACE_PERIOD_UNTIL: 'En periodo de gracia hasta el {{date}}',
          NO_CARDS: 'Sin tarjetas',
          NO_CUSTOMER: 'Sin cliente de Stripe',
          STRIPE_UNAVAILABLE_CARDS: 'Stripe no ha respondido: ahora mismo no se pueden mostrar las tarjetas. Prueba a actualizar en un momento.',
          LOCAL_SOURCE_NOTE: 'Stripe no ha respondido: estos datos salen de nuestra base de datos y pueden no estar al día.',
          UNKNOWN: 'Desconocido',
          BANK_ACCOUNTS: 'Cuentas bancarias',
          NO_BANK_ACCOUNTS: 'Sin cuentas bancarias',
          BANK_UNKNOWN: 'Banco desconocido',
          REASON_OTHER: 'Otro motivo',
          PAYOUT_OK: 'Puede cobrar',
          PAYOUT_BLOCKED: 'No puede cobrar',
          PAYOUT_NOT_STARTED: 'Aún no ha dado de alta los cobros',
          PAYOUT_UNVERIFIED: 'Sin comprobar en Stripe',
          PAYOUT_RECEIVES_IN: 'Recibe sus retiradas en {{bank}} •••• {{last4}}.',
          PAYOUT_NO_BANK: 'Todavía no tiene ninguna cuenta bancaria registrada.',
          PAYOUT_NOT_STARTED_TEXT: 'No ha empezado el alta de cobros en la app, así que todavía no puede retirar lo que gana como conductor.',
          PAYOUT_COMPLETE_ONBOARDING: 'Tiene que completar el alta de cobros en la app.',
          PAYOUT_WAIT_VERIFICATION: 'Stripe está revisando sus datos: por ahora no tiene que hacer nada.',
          PAYOUT_STRIPE_ASKS: 'Stripe le pide:',
          PAYOUT_STRIPE_WILL_ASK: 'Stripe le pedirá pronto:',
          REQ_GROUPS: {
            personal: 'Datos personales (nombre, fecha de nacimiento, dirección, teléfono…)',
            document: 'Documento de identidad',
            bank: 'Cuenta bancaria',
            tos: 'Aceptar las condiciones de Stripe',
            business: 'Datos de la actividad',
            other: 'Otros datos',
          },
          DISABLED_REASONS: {
            past_due: 'Stripe pidió datos y el plazo ha vencido',
            pending_verification: 'Stripe está verificando los datos',
            rejected: 'Stripe ha rechazado la cuenta',
            under_review: 'En revisión por Stripe',
            other: 'Bloqueada por Stripe',
          },
          BANK_STATUS: {
            new: 'Nueva',
            validated: 'Validada',
            verified: 'Verificada',
            verification_failed: 'Verificación fallida',
            errored: 'Con errores',
          },
        },
        SOLUTIONS: {
          TITLE: 'Cómo solucionarlo',
          COPY: 'Copiar mensaje para el usuario',
          INSERT: 'Insertar en el chat',
          COPIED: 'Copiado',
          COPY_ERROR: 'No se ha podido copiar: el texto queda seleccionado para copiarlo a mano.',
          ACCOUNT_ID: 'Id de la cuenta',
          COPY_ID: 'Copiar id',
          OPEN_CHAT: 'Abrir chat con el mensaje',
          NO_CHAT_HINT: 'Este usuario todavía no tiene chat de soporte: copia el mensaje y envíaselo por otra vía.',
          CHECKING_CHAT: 'Comprobando si tiene chat de soporte…',
          OPEN_CHAT_ERROR: 'No se ha podido abrir el chat de soporte. Inténtalo de nuevo.',
          STEPS: {
            ASK_ADD_BANK: 'Pídele que añada su cuenta bancaria desde la app: Mi cartera → Métodos de pago y cobro → Cobro → Añadir método de cobro.',
            SEND_MESSAGE: 'Puedes enviarle el mensaje de abajo.',
            LEGACY_REPLACEABLE: 'Su cuenta de cobro es del sistema antiguo y está incompleta. Al añadir una cuenta bancaria desde la app, se sustituye sola.',
            LEGACY_HAS_BALANCE: 'Su cuenta antigua tiene saldo en Stripe y no se puede sustituir sola.',
            NOTIFY_DEV_WITH_ID: 'Avisa a desarrollo y pásale el id de la cuenta.',
            REVIEW_PERSONAL: 'Pídele que revise sus datos personales en Perfil y que vuelva a añadir su cuenta bancaria.',
            IF_PERSISTS_DEV: 'Si sigue igual, avisa a desarrollo.',
            NOTHING_TO_DO: 'No hay que hacer nada: Stripe está revisando sus datos.',
            RE_ADD_BANK: 'Pídele que añada de nuevo su cuenta bancaria desde la app.',
            ASK_NEW_CARD: 'Pídele que añada una tarjeta nueva: Mi cartera → Métodos de pago y cobro → Pago → Añadir método de pago.',
            WARN_EXPIRING: 'Avísale de que su tarjeta caduca pronto y de que puede añadir una nueva antes.',
            DEBT: 'Tiene un cobro pendiente y la cuenta bloqueada: pídele que pulse «Actualizar método de pago» en el aviso de la app y añada una tarjeta válida. La deuda se cobra sola.',
          },
        },
        SNIPPETS_CONFIG: {
          MENU: 'Respuestas del soporte',
          BREADCRUMB: 'Configuración',
          BREADCRUMB_ARIA: 'Ruta de navegación',
          TITLE: 'Respuestas y recordatorios del soporte',
          DESCRIPTION: 'Textos que el equipo de soporte inserta desde el chat. Arrastra las filas para cambiar el orden en el que aparecen.',
          NEW: 'Nuevo texto',
          TAB_REPLIES: 'Respuestas rápidas',
          TAB_REMINDERS: 'Recordatorios',
          SEARCH_PLACEHOLDER: 'Buscar por título, texto o categoría...',
          REORDER_DISABLED: 'Borra la búsqueda para poder reordenar',
          LOADING: 'Cargando...',
          LOAD_ERROR: 'No se han podido cargar los textos.',
          RETRY: 'Reintentar',
          EMPTY_REPLIES: 'Todavía no hay respuestas rápidas.',
          EMPTY_REMINDERS: 'Todavía no hay recordatorios.',
          NO_RESULTS: 'Ningún texto coincide con la búsqueda.',
          COL_ORDER: 'Orden',
          COL_LABEL: 'Título',
          COL_BODY: 'Texto',
          COL_CATEGORY: 'Categoría',
          COL_USES: 'Usos',
          COL_ACTIVE: 'Activo',
          COL_ACTIONS: 'Acciones',
          DRAG: 'Arrastrar para reordenar',
          EDIT: 'Editar',
          DELETE: 'Borrar',
          NEW_TITLE: 'Nuevo texto',
          EDIT_TITLE: 'Editar texto',
          KIND_REPLY: 'Respuesta rápida',
          KIND_REMINDER: 'Recordatorio',
          FIELD_LABEL: 'Título',
          FIELD_CATEGORY: 'Categoría',
          CATEGORY_PLACEHOLDER: 'Ej.: Pagos, CAE...',
          CATEGORY_NONE: 'Sin categoría',
          CATEGORY_NEW: '+ Nueva categoría…',
          CATEGORY_NEW_PLACEHOLDER: 'Nombre de la nueva categoría',
          CATEGORY_BACK: 'Elegir de la lista',
          FIELD_BODY: 'Texto',
          FIELD_BODY_ES: 'Texto en castellano',
          FIELD_BODY_CA: 'Texto en catalán (opcional)',
          FIELD_ACTIVE: 'Activo',
          PLACEHOLDER_HINT: 'Al insertar la respuesta, <code>{nombre}</code> (castellano) y <code>{nom}</code> (catalán) se sustituyen por el nombre de pila del usuario.',
          REQUIRED: 'Campo obligatorio',
          PREVIEW: 'Vista previa',
          PREVIEW_EMPTY: 'Escribe el texto para ver cómo quedará.',
          SAVE: 'Guardar',
          CANCEL: 'Cancelar',
          CREATED: 'Texto creado',
          SAVED: 'Cambios guardados',
          DELETED: 'Texto borrado',
          DELETE_TITLE: 'Borrar texto',
          DELETE_TEXT: '«{{label}}» dejará de aparecer en el chat de soporte.',
          DELETE_CONFIRM: 'Sí, borrar',
          ERROR_SAVE: 'No se han podido guardar los cambios. Se ha deshecho el cambio.',
          ERROR_DELETE: 'No se ha podido borrar. Se ha restaurado el texto.',
          ERROR_REORDER: 'No se ha podido guardar el orden. Se ha restaurado el anterior.',
          SAVING: 'Guardando…',
          ACCEPT: 'Aceptar',
          SECTION_CONTENT: 'Contenido',
        },
      },
      ECONOMIC_DASHBOARD: {
        DETAIL_ROUTE: 'ruta {{id}}',
        HOLD: {
          REASON: {
            reinforced_verification: 'Reforzada',
            cash_delay: 'Caja',
          },
          DAYS: 'día {{day}}/{{total}}',
          UNTIL: 'hasta el {{date}}',
          DUE_TRANSFER: 'día {{day}}/{{total}} · se abona en unos minutos',
          DUE_PAYOUT: 'día {{day}}/{{total}} · pendiente de revisión',
          TITLE: 'Retenido hasta el {{date}}',
        },
        TITLE: 'Dashboard económico',
        SUBTITLE: 'Retiradas de los conductores, saldo en Stripe y lo que queda por pagar. Todos los importes, en euros.',
        EXPORT_CSV: 'Exportar movimientos (CSV)',
        EXPORTING: 'Exportando…',
        EXPORT_ERROR: 'No se ha podido exportar el CSV',
        FORBIDDEN: 'No tienes permiso para esto: falta la operación {{operation}}',
        HELP: {
          trip_charge: 'Lo que se cobra al pasajero por un viaje.',
          user_charge: 'Cargo al usuario: una recarga de cartera u otro cargo (hoy no se pueden distinguir).',
          negative_balance_charge: 'Cobro para dejar a cero el saldo negativo de un usuario.',
          trip_transfer: 'Pago del viaje al conductor, desde la cartera del pasajero.',
          trip_commission: 'Lo que se queda WAIIS de cada viaje.',
          driver_payout: 'El conductor pasa dinero de su cartera a su cuenta bancaria.',
          instant_payout: 'Retirada instantánea: el conductor recibe el dinero en minutos, con comisión.',
          instant_payout_fee: 'Comisión que cobra WAIIS por una retirada instantánea.',
          instant_payout_refund: 'Devolución a la cartera de una retirada instantánea que falló (importe y comisión).',
          cae_discount: 'Bonificación por Certificados de Ahorro Energético (CAE) de un viaje ya hecho.',
          manual_adjustment: 'Corrección hecha a mano por un administrador (abono o retirada).',
          referral_bonus: 'Bonus por invitar a alguien que hace su primer viaje.',
          corporate_ride_reclaim: 'Cobro al empleado de un viaje de empresa rechazado: pasa de su cartera a la de la empresa.',
          corporate_ride_reclaim_topup: 'Recarga con la tarjeta del empleado para cubrir un viaje de empresa rechazado.',
          PAYOUT_PAID: 'Stripe confirmó el pago en el banco del conductor.',
          PAYOUT_PENDING: 'Enviada a Stripe sin confirmar, o en revisión manual.',
          PAYOUT_FAILED: 'Stripe no pudo pagarla, o se rechazó en la revisión.',
          PAYOUT_REFUNDED: 'Falló y el dinero volvió a la cartera del conductor.',
          CHARGE_COMPLETED: 'El cobro al pasajero se hizo bien.',
          CHARGE_PENDING: 'El cobro aún no está confirmado.',
          CHARGE_FAILED: 'El cobro al pasajero falló: es dinero que no entró.',
          CHARGE_REFUNDED: 'Se cobró y luego se devolvió al pasajero.',
        },
        STATS: {
          FOLD_HIDE: 'Ocultar detalle',
          FOLD_SHOW: 'Ver detalle',
          INSIGHT_FLOWS_NEG: 'En {{range}}, los pasajeros pagaron {{in}} con tarjeta y los conductores retiraron {{out}} a su banco: salieron {{net}} más de los que entraron.',
          INSIGHT_FLOWS_POS: 'En {{range}}, los pasajeros pagaron {{in}} con tarjeta y los conductores retiraron {{out}} a su banco: entraron {{net}} más de los que salieron.',
          FLOWS_TIP_OUT: 'Retirado por conductores',
          FLOWS_TIP_IN: 'Pagado por pasajeros',
          FLOWS_TOTAL: 'Total',
          FLOWS: 'Dinero que entra y sale de WAIIS',
          FLOWS_Q_hour: 'Entra: lo que pagan los pasajeros con tarjeta (viajes y recargas de cartera), que llega a la cuenta de Stripe de WAIIS. Sale: lo que los conductores retiran de su cartera a su banco. Por hora, sin fallidos ni reembolsados.',
          FLOWS_Q_day: 'Entra: lo que pagan los pasajeros con tarjeta (viajes y recargas de cartera), que llega a la cuenta de Stripe de WAIIS. Sale: lo que los conductores retiran de su cartera a su banco. Por día, sin fallidos ni reembolsados.',
          FLOWS_Q_week: 'Entra: lo que pagan los pasajeros con tarjeta (viajes y recargas de cartera), que llega a la cuenta de Stripe de WAIIS. Sale: lo que los conductores retiran de su cartera a su banco. Por semana, sin fallidos ni reembolsados.',
          FLOWS_IN: 'Entra · pagos de pasajeros',
          FLOWS_OUT: 'Sale · retiradas de conductores',
          FLOWS_NET: 'Diferencia',
          FLOWS_PERIOD: 'Periodo',
          FLOWS_TABLE: 'Ver los datos',
          FLOWS_WEEK_OF: 'semana del {{date}}',
          FLOWS_TRUNCATED: 'Datos parciales: hay más de 1.000 movimientos en este rango y solo se suman los más recientes. Elige un rango más corto.',
          INSIGHT_PAYOUTS: 'Se pagaron {{paid}} de {{total}} retiradas ({{pct}}).',
          INSIGHT_PAYOUTS_FAILED: '{{n}} fallaron o se rechazaron: revisa la tabla filtrando por {{concept}}.',
          INSIGHT_CHARGES_FAILED: '1 de cada {{n}} cobros de viaje no se cobró ({{pct}}): es dinero que no entró.',
          INSIGHT_CHARGES_OK: 'Todos los cobros de viaje se cobraron o siguen en curso.',
          INSIGHT_CONCEPT: 'Lo más frecuente es {{label}}: {{pct}} de los movimientos.',
          INSIGHT_MANUAL: '{{n}} ajustes manuales ({{pct}}): muchas correcciones hechas a mano.',
          INSIGHT_NO_REFERRALS: 'Ningún bonus por referido en este periodo.',
          SHOW_IN_TABLE: 'Ver en la tabla',
          HELP: 'Qué significa',
          SHOW: 'Ver estadísticas',
          HIDE: 'Ocultar estadísticas',
          TITLE: 'Estadísticas de movimientos',
          SUBTITLE: 'Datos del rango de la tabla: {{range}}',
          PAYOUTS: 'Retiradas por estado',
          PAYOUTS_Q: '¿Se está pagando a los conductores?',
          PAYOUTS_TOTAL: '{{count}} retiradas · {{valid}} sin fallidas ni rechazadas',
          PAYOUT_PAID: 'Pagadas',
          PAYOUT_PENDING: 'Pendientes',
          PAYOUT_FAILED: 'Fallidas o rechazadas',
          PAYOUT_REFUNDED: 'Devueltas a la cartera',
          INSTANT_PAYOUTS: 'Retiradas instantáneas por estado',
          INSTANT_PAYOUTS_Q: '¿Llegan las retiradas instantáneas a los conductores?',
          INSTANT_PAYOUTS_TOTAL: '{{count}} retiradas instantáneas · {{valid}} sin fallidas ni rechazadas',
          CHARGES: 'Cobros de viaje por estado',
          CHARGES_Q: '¿Se están cobrando los viajes a los pasajeros?',
          CHARGES_TOTAL: '{{count}} cobros',
          CHARGE_COMPLETED: 'Cobrados',
          CHARGE_PENDING: 'Pendientes',
          CHARGE_FAILED: 'Impagados',
          CHARGE_REFUNDED: 'Reembolsados',
          BY_CONCEPT: 'Qué movimientos hay',
          BY_CONCEPT_Q: 'Cuántos movimientos de cada concepto, de más a menos',
          TOTAL: '{{count}} movimientos',
          EMPTY: 'Sin movimientos en este rango',
          LOADING: 'Calculando estadísticas…',
          ERROR: 'No se han podido cargar las estadísticas',
        },
        KPI: {
          PAYOUTS_24H: 'Retiradas · últimas 24 h',
          PAYOUTS_24H_HINT: 'Retiradas de conductores',
          PAYOUTS_24H_DETAIL: '{{count}} retiradas',
          PAYOUTS_24H_UNCONFIRMED: '{{count}} sin confirmar',
          PAYOUTS_MONTH: 'Retiradas · último mes',
          PAYOUTS_MONTH_HINT: 'Últimos 30 días',
          PAYOUTS_MONTH_DETAIL: '{{count}} retiradas',
          VS_PREVIOUS: '{{pct}} vs mes anterior',
          STRIPE: 'Saldo disponible en Stripe',
          STRIPE_HINT: 'Pendiente: {{pending}}',
          UPDATED_JUST_NOW: 'Actualizado ahora',
          UPDATED_MINUTES: 'Actualizado hace {{n}} min',
          UPDATED_HOURS: 'Actualizado hace {{n}} h',
          UPDATED_ON: 'Actualizado el {{date}}, {{time}}',
          NO_STRIPE_MOVEMENTS: 'Sin movimientos',
          PENDING: 'Pendiente de pagar',
          PENDING_HINT: 'Saldo retirable en wallets + retiradas creadas',
          COVERED: 'Cubierto: Stripe = {{ratio}}× lo pendiente',
          NOT_COVERED: 'No cubierto: faltan {{missing}}',
          STRIPE_UNAVAILABLE: 'No disponible',
          ERROR: 'No se han podido cargar los indicadores',
        },
        MOVEMENTS: {
          SEARCH: 'Buscar concepto, usuario o referencia…',
          NO_MATCH: 'Ningún movimiento de esta página coincide con «{{q}}»',
          CLEAR_SEARCH: 'Borrar búsqueda',
          SEARCH_SERVER: 'Buscando en todos los movimientos por {{filters}}',
          TITLE: 'Movimientos recientes',
          SUBTITLE: 'Cada viaje genera dos movimientos internos: el pago del pasajero al conductor y la comisión de WAIIS. Los cobros con Stripe y las retiradas son entradas y salidas reales de dinero.',
          CLEAR: 'Limpiar filtros',
          SHOWING: 'Mostrando {{count}} de {{total}} movimientos',
          PREV: 'Anterior',
          NEXT: 'Siguiente',
          LOADING: 'Cargando movimientos…',
          EMPTY: 'No hay movimientos con estos filtros',
          ERROR: 'No se han podido cargar los movimientos',
          RETRY: 'Reintentar',
          DELETED_USER: 'Usuario eliminado',
        },
        COLUMNS: {
          DATE: 'Fecha',
          MOVEMENT: 'Movimiento',
          USER: 'Usuario',
          COUNTERPARTY: 'Contraparte',
          TYPE: 'Tipo',
          MEDIUM: 'Medio',
          AMOUNT: 'Importe',
          STATUS: 'Estado',
        },
        FILTERS: {
          TYPE_ALL: 'Tipo: todos',
          CONCEPT_ALL: 'Concepto: todos',
          MEDIUM_ALL: 'Medio: todos',
          STATUS_ALL: 'Estado: todos',
          RANGE: 'Rango: {{range}}',
        },
        TYPE: {
          inbound: 'Entrada',
          outbound: 'Salida',
          internal: 'Interno',
        },
        MEDIUM: {
          stripe: 'Stripe',
          balance: 'Saldo',
          manual: 'Manual',
        },
        STATUS: {
          completed: 'Completado',
          paid: 'Pagado',
          pending: 'Pendiente',
          failed: 'Impagado',
          refunded: 'Reembolsado',
          held: 'Retenido',
        },
        RANGE: {
          '24h': '24 horas',
          '7d': '7 días',
          '30d': '30 días',
          '90d': '90 días',
        },
        CONCEPT: {
          trip_charge: 'Cobro del viaje',
          user_charge: 'Cargo al usuario',
          negative_balance_charge: 'Cobro por saldo negativo',
          trip_transfer: 'Pago al conductor',
          trip_commission: 'Comisión WAIIS',
          driver_payout: 'Retirada a conductor',
          instant_payout: 'Retirada instantánea',
          instant_payout_fee: 'Comisión de retirada instantánea',
          instant_payout_refund: 'Devolución de retirada instantánea',
          cae_discount: 'Bonificación CAE',
          manual_adjustment: 'Ajuste manual',
          referral_bonus: 'Bonus por referido',
          corporate_ride_reclaim: 'Viaje de empresa rechazado',
          corporate_ride_reclaim_topup: 'Recarga por viaje de empresa rechazado',
        },
      },
      RECLAMATIONS: {
        PANEL: {
          ALL_TITLE: 'Todas las reclamaciones',
          ALL_SUBTITLE: 'Pendientes y procesadas. Pulsa una para ver su detalle.',
          PENDING_TITLE: 'Reclamaciones pendientes',
          PENDING_SUBTITLE: 'Aún sin procesar. Pulsa una para revisarla.',
          PROCESSED_TITLE: 'Reclamaciones procesadas',
          PROCESSED_SUBTITLE: 'Ya revisadas por el equipo. Pulsa una para ver su detalle.',
        },
        SHOWING: 'Mostrando {{shown}} de {{total}} reclamaciones',
        DETAIL: {
          BREADCRUMB_ARIA: 'Ruta de navegación',
          DETAIL: 'Detalle',
          BACK: 'Volver a reclamaciones',
          LOADING: 'Cargando reclamación…',
          RETRY: 'Reintentar',
          PROCESSED: 'Procesada',
          PENDING: 'Pendiente',
          REOPEN: 'Reabrir',
          MARK_PROCESSED: 'Marcar como procesada',
          RECEIVED: 'Recibida',
          UPDATED: 'actualizada {{date}}',
          PERSON: 'Persona',
          VIEW_PROFILE: 'Ver ficha',
          NO_PERSON: 'Sin datos de la persona.',
          MANAGER: 'Gestor asignado',
          UNASSIGNED: 'Sin asignar',
          MANAGER_HINT: 'Asignar o quitar gestor se hace desde el listado de reclamaciones.',
          CONTENT_TITLE: 'Qué cuenta la persona',
          ENRICHED_TITLE: 'Contexto enriquecido del agente',
          NEEDS_REVIEW: 'Requiere revisión · {{value}}',
          DIAGNOSIS: 'Diagnóstico',
          PROBABLE_CAUSE: 'Causa probable',
          PROPOSED_RESOLUTION: 'Resolución propuesta',
          CONVERSATION_SUMMARY: 'Resumen de la conversación',
          SENTIMENT: 'Sentimiento reportado',
          NO_ENRICHED_TITLE: 'Sin contexto enriquecido',
          NO_ENRICHED_TEXT: 'Este ticket no tiene contexto enriquecido: o no lo creó el agente de soporte, o backend todavía no expone estos campos a backoffice (ver <code>specs/reclamation-detail-backend-brief.md</code>).',
          RELATED: 'Elementos relacionados',
          TRIP: 'Trayecto',
          OPEN: 'Abrir',
          ASSIGNMENT: 'Asignación',
          PAYMENT: 'Pago',
          LOAD_ERROR: 'No se ha podido cargar la reclamación.',
          UPDATE_ERROR: 'No se ha podido actualizar el estado.',
          DOMAIN: {
            VALIDATION: 'Validación',
            CAE: 'CAE',
            CANCELLATION: 'Cancelación',
            PAYMENT: 'Pago',
            CREDITS: 'Créditos',
            ACCOUNT: 'Cuenta',
          },
          OUTCOME: {
            RESOLVED: 'Resuelto por el agente',
            RESOLVED_WITH_REPORT: 'Resuelto con informe · requiere confirmación',
            ESCALATED_WRITE_REQUIRED: 'Escalado · requiere una acción manual',
            ESCALATED_DATA_MISMATCH: 'Escalado · datos no coinciden',
            ESCALATED_PRIORITY: 'Escalado · prioridad alta',
            ESCALATED_RECURRENCE: 'Escalado · incidencia recurrente',
            ESCALATED_NO_DATA: 'Escalado · sin datos suficientes',
          },
          PRIORITY: {
            P0: 'P0 · crítica',
            P1: 'P1 · alta',
            P2: 'P2 · media',
            P3: 'P3 · baja',
          },
        },
        TITLE: 'Reclamaciones',
        SEARCH_PLACEHOLDER: 'Buscar reclamaciones...',
        TABS: {
          ALL: 'Todas',
          PENDING: 'Pendientes',
          PROCESSED: 'Procesadas',
        },
        STATE: {
          LOADING: 'Cargando reclamaciones',
          LOADING_HINT: 'Solicitando el listado con los filtros seleccionados.',
          ERROR: 'No se ha podido cargar el listado de reclamaciones.',
          EMPTY: 'Sin resultados',
          EMPTY_HINT: 'No hay reclamaciones que coincidan con los filtros.',
        },
        PAGINATION: {
          PREVIOUS: 'Anterior',
          NEXT: 'Siguiente',
          OF: 'de',
        },
        COLUMNS: {
          TITLE: 'Título',
          CATEGORY: 'Categoría',
          SUBCATEGORY: 'Subcategoría',
          STATUS: 'Estado',
          USER: 'Usuario',
          DATE: 'Fecha',
        },
        STATUS: {
          PENDING: 'Pendiente',
          PROCESSED: 'Procesada',
        },
        FILTERS: {
          CATEGORY_ALL: 'Categoría: todas',
          SUBCATEGORY_ALL: 'Subcategoría: todas',
          CLEAR_ALL: 'Limpiar filtros',
          TITLE: 'Filtros',
          APPLY: 'Aplicar filtros',
          CLEAR: 'Limpiar',
          ALL: 'Todos',
          USER_ID: 'ID Usuario',
        },
        MODAL: {
          CLASSIFICATION: 'Clasificación',
          TITLE: 'Detalle de reclamación',
          CONTENT: 'Contenido',
          USER_SECTION: 'Usuario',
          USER_NAME: 'Nombre',
          USER_EMAIL: 'Email',
          USER_PHONE: 'Teléfono',
          USER_ROLE: 'Rol',
          VIEW_USER: 'Ver ficha de usuario',
          NO_USER: 'Datos de usuario no disponibles',
          METADATA: 'Metadatos',
          CREATED_AT: 'Creada',
          UPDATED_AT: 'Actualizada',
        },
        ACTIONS: {
          RETRY: 'Reintentar',
          OPEN: 'Abrir',
          SAVE: 'Guardar',
          SAVING: 'Guardando...',
          CANCEL: 'Cancelar',
          ACCEPT: 'Aceptar',
          MARK_PROCESSED: 'Marcar procesada',
          REOPEN: 'Reabrir',
          VIEW_DETAIL: 'Ver detalle completo',
        },
        SUCCESS: {
          TITLE: 'Correcto',
          UPDATED: 'La reclamación se ha actualizado correctamente',
        },
        ERROR: {
          TITLE: 'Error',
        },
        VALIDATION: {
          TITLE_REQUIRED: 'El título es obligatorio',
          CONTENT_REQUIRED: 'El contenido es obligatorio',
          SUBCATEGORY_REQUIRES_CATEGORY:
            'La subcategoría requiere una categoría seleccionada',
        },
        INACTIVE_CODE: 'Inactivo',
      },
      RECLAMATION_TAXONOMY: {
        BREADCRUMB_ARIA: 'Ruta de navegación',
        LOADING_SUBCATEGORIES: 'Cargando subcategorías',
        TITLE: 'Taxonomía de reclamaciones',
        FORM: {
          UNCHANGED: 'Cambia el código para poder guardar',
          CODE: 'Código (identificador)',
          CODE_PLACEHOLDER: 'ej. no_show',
          CODE_HINT: 'Solo minúsculas, números y guiones bajos (snake_case).',
          PREVIEW: 'Vista previa',
        },
        DETAIL: {
          EDIT_CATEGORY: 'Editar categoría',
          SUBCATEGORIES: 'Subcategorías',
        },
        MODAL: {
          NEW_CATEGORY: 'Nueva categoría',
          NEW_SUBCATEGORY: 'Nueva subcategoría',
        },
        ACTIONS: {
          RETRY: 'Reintentar',
          BACK: 'Volver al listado',
          NEW_CATEGORY: 'Nueva categoría',
          NEW_SUBCATEGORY: 'Añadir subcategoría',
          SAVE: 'Guardar',
          SAVING: 'Guardando...',
          CANCEL: 'Cancelar',
          ACCEPT: 'Aceptar',
          DELETE: 'Eliminar',
          DELETING: 'Eliminando...',
          DELETED: 'Eliminada',
          DELETE_CATEGORY: 'Eliminar categoría',
        },
        EMPTY: {
          CATEGORIES: 'No hay categorías configuradas.',
          CREATE_FIRST: 'Crear primera categoría',
          SUBCATEGORIES: 'Esta categoría no tiene subcategorías.',
        },
        SUCCESS: {
          CATEGORY_CREATED: 'Categoría creada correctamente',
          CATEGORY_UPDATED: 'Categoría actualizada correctamente',
          CATEGORY_DELETED: 'Categoría eliminada correctamente',
          SUBCATEGORY_CREATED: 'Subcategoría creada correctamente',
          SUBCATEGORY_DELETED: 'Subcategoría eliminada correctamente',
        },
        ERROR: {
          LOAD_CATEGORIES: 'No se han podido cargar las categorías.',
          LOAD_SUBCATEGORIES: 'No se han podido cargar las subcategorías.',
          LOAD_CATEGORY: 'No se ha podido cargar la categoría.',
          TITLE: 'Error',
          NOT_FOUND: 'Categoría no encontrada',
        },
        VALIDATION: {
          CODE_REQUIRED: 'El código es obligatorio',
          CODE_FORMAT: 'Formato inválido. Usa snake_case (ej. no_show)',
          CODE_MAX_LENGTH: 'El código no puede superar 255 caracteres',
        },
        CONFIRM: {
          DELETE_SUBCATEGORY_TITLE: '¿Eliminar subcategoría?',
          DELETE_SUBCATEGORY_TEXT:
            'Se eliminará «{{label}}» (<code>{{code}}</code>). Las reclamaciones existentes conservan su clasificación, pero no podrá usarse en reclamaciones nuevas.',
          DELETE_CATEGORY_TITLE: '¿Eliminar categoría?',
          DELETE_CATEGORY_TEXT:
            'Se eliminarán «{{label}}» (<code>{{code}}</code>) y <strong>todas sus subcategorías</strong>. No se puede deshacer desde el dashboard; las reclamaciones existentes conservan su clasificación.',
        },
      },
      TAGS: {
        SAVE: 'Guardar',
        SAVING: 'Guardando…',
        DISABLED: 'Desactivada',
        PICK_COLOR: 'Elegir color',
        CLEAR_COLOR: 'Quitar color',
        SAVE_ERROR: 'No se ha podido guardar la etiqueta',
        DELETE_ERROR: 'No se ha podido eliminar la etiqueta',
        TITLE: 'Etiquetas',
        ADD: 'Añadir Etiqueta',
        EDIT: 'Editar Etiqueta',
        NAME: 'Nombre',
        TSOFT_NAME: 'Nombre TSoft',
        CATEGORY: 'Categoría',
        COLOR: 'Color',
        SUCCESS_CREATE: 'Etiqueta creada correctamente',
        SUCCESS_UPDATE: 'Etiqueta actualizada correctamente',
        SUCCESS_DELETE: 'Etiqueta eliminada correctamente',
        CONFIRM_DELETE: '¿Estás seguro de que deseas eliminar esta etiqueta?',
        SEARCH: 'Buscar etiqueta',
        ACTIONS: 'Acciones',
        WAIT: 'Espera..',
        ENABLED: 'Activada',
        ENABLE_TAG: 'Activar etiqueta',
        CATEGORIES: {
          ACTIVITY: 'Actividad',
          GENERAL: 'Generales',
          MISC: 'Miscelánea',
        },
        SUCCESS: '¡Éxito!',
        ERROR: 'Error',
        CONFIRM: 'Aceptar',
        CANCEL: 'Cancelar',
        ITEMS: 'etiquetas',
      },
      ROLES: {
        TITLE: 'Roles',
        ADD: 'Añadir Rol',
        EDIT: 'Editar Rol',
        NAME: 'Nombre',
        CREATED_AT: 'Fecha Creación',
        UPDATED_AT: 'Fecha Edición',
        SUCCESS_CREATE: 'Rol creado correctamente',
        SUCCESS_UPDATE: 'Rol actualizado correctamente',
        SUCCESS_DELETE: 'Rol eliminado correctamente',
        CONFIRM_DELETE: '¿Estás seguro de que deseas eliminar este rol?',
        SEARCH: 'Buscar rol',
        ACTIONS: 'Acciones',
        WAIT: 'Espera..',
        SUCCESS: '¡Éxito!',
        ERROR: 'Error',
        CONFIRM: 'Aceptar',
        CANCEL: 'Cancelar',
        ITEMS: 'roles',
      },
      AUTHORIZATION: {
        TITLE: 'Autorización',
        BACK_TO_ROLES: 'Volver a Roles',
        ROLES: {
          TITLE: 'Roles',
          ADD: 'Añadir Rol',
          EDIT: 'Editar Rol',
          NAME: 'Nombre',
          CREATED_AT: 'Fecha Creación',
          UPDATED_AT: 'Fecha Edición',
          SUCCESS_CREATE: 'Rol creado correctamente',
          SUCCESS_UPDATE: 'Rol actualizado correctamente',
          SUCCESS_DELETE: 'Rol eliminado correctamente',
          CONFIRM_DELETE: '¿Estás seguro de que deseas eliminar este rol?',
          SEARCH: 'Buscar rol',
          PANEL_SUB:
            'Roles que pueden tener los usuarios del backoffice. Edítalos o abre sus acciones, permisos y páginas.',
          MODAL_SUB: 'El nombre con el que aparece el rol al asignarlo.',
          ACTIONS: 'Acciones',
          VIEW_ACTIONS: 'Ver Acciones',
          VIEW_PERMISSIONS: 'Ver Permisos',
          VIEW_PAGES: 'Ver Páginas',
          WAIT: 'Espera..',
          SUCCESS: '¡Éxito!',
          ERROR: 'Error',
          CONFIRM: 'Aceptar',
          CANCEL: 'Cancelar',
        },
        ACTIONS: {
          ITEMS: 'acciones',
          TITLE: 'Acciones',
          ADD: 'Añadir Acción',
          EDIT: 'Editar Acción',
          ACTION: 'Acción',
          CREATED_AT: 'Fecha Creación',
          UPDATED_AT: 'Fecha Edición',
          SUCCESS_CREATE: 'Acción creada correctamente',
          SUCCESS_UPDATE: 'Acción actualizada correctamente',
          SUCCESS_DELETE: 'Acción eliminada correctamente',
          CONFIRM_DELETE: '¿Estás seguro de que deseas eliminar esta acción?',
          SEARCH: 'Buscar acción',
          WAIT: 'Espera..',
          SUCCESS: '¡Éxito!',
          ERROR: 'Error',
          CONFIRM: 'Aceptar',
          CANCEL: 'Cancelar',
        },
        ROLES_PERMISSIONS: {
          ITEMS: 'permisos',
          TITLE: 'Permisos',
          ADD: 'Añadir Permiso',
          EDIT: 'Editar Permiso',
          OPERATION_ID: 'Operación',
          DESCRIPTION: 'Descripción',
          SELECT_OPERATION: 'Selecciona una operación...',
          CREATE_MODAL_TITLE: 'Crear Permiso',
          EDIT_MODAL_TITLE: 'Editar Permiso',
          CREATED_AT: 'Fecha Creación',
          UPDATED_AT: 'Fecha Edición',
          SUCCESS_CREATE: 'Permiso creado correctamente',
          SUCCESS_UPDATE: 'Permiso actualizado correctamente',
          SUCCESS_DELETE: 'Permiso eliminado correctamente',
          CONFIRM_DELETE: '¿Estás seguro de que deseas eliminar este permiso?',
          SEARCH: 'Buscar permiso',
          WAIT: 'Espera..',
          SUCCESS: '¡Éxito!',
          ERROR: 'Error',
          CONFIRM: 'Aceptar',
          CANCEL: 'Cancelar',
        },
        ROLES_PAGES: {
          ITEMS: 'páginas',
          TITLE: 'Páginas',
          ADD: 'Añadir Página',
          EDIT: 'Editar Página',
          PAGE_TAG: 'Página',
          CREATED_AT: 'Fecha Creación',
          UPDATED_AT: 'Fecha Edición',
          SUCCESS_CREATE: 'Página creada correctamente',
          SUCCESS_UPDATE: 'Página actualizada correctamente',
          SUCCESS_DELETE: 'Página eliminada correctamente',
          CONFIRM_DELETE: '¿Estás seguro de que deseas eliminar esta página?',
          SEARCH: 'Buscar página',
          WAIT: 'Espera..',
          SUCCESS: '¡Éxito!',
          ERROR: 'Error',
          CONFIRM: 'Aceptar',
          CANCEL: 'Cancelar',
        },
        USER_ROLE_CORPORATIONS: {
          TITLE: 'Asignaciones de Roles a Usuarios',
          ADD: 'Nuevo',
          SEARCH: 'Buscar asignación',
          USER: 'Usuario',
          ROLE: 'Rol',
          TYPE: 'Tipo de Asignación',
          CORPORATION: 'Empresa',
          OFFICE: 'Oficina',
          OFFICE_LABEL: 'Oficina de Empresa',
          TYPE_AUTO_HINT:
            'El Tipo de Asignación se establece automáticamente según el rol seleccionado.',
          PANEL_SUB:
            'Cada fila es un usuario con un rol, y la empresa o sede donde lo tiene.',
          MODAL_SUB:
            'Elige el usuario y su rol; la empresa o sede, si el rol la necesita.',
          LOADING: 'Cargando...',
          COL_USER: 'Usuario',
          COL_EMAIL: 'Correo',
          COL_ROLE: 'Rol',
          COL_TYPE: 'Tipo',
          COL_CORP_OFFICE: 'Empresa/Oficina',
          DELETE_CONFIRM_BTN: 'Eliminar',
          DELETE_CANCEL_BTN: 'Cancelar',
          CREATED_AT: 'Fecha Creación',
          UPDATED_AT: 'Fecha Edición',
          REQUIRED_TEXT: 'Elige el usuario y el rol.',
          DUPLICATE_TITLE: 'Asignación repetida',
          DUPLICATE_TEXT: 'Este usuario ya tiene esta asignación.',
          CREATE_ERROR: 'No se ha podido crear la asignación.',
          DELETE_ERROR: 'No se ha podido eliminar la asignación.',
          LOAD_ERROR: 'No se han podido cargar los datos.',
          SUCCESS_CREATE: 'Asignación creada correctamente',
          SUCCESS_DELETE: 'Asignación eliminada correctamente',
          DELETE_CONFIRM:
            '¿Estás seguro de que deseas eliminar esta asignación?',
          WAIT: 'Espera..',
          SUCCESS: '¡Éxito!',
          ERROR: 'Error',
          CONFIRM: 'Aceptar',
          CANCEL: 'Cancelar',
          ITEMS: 'asignaciones de roles',
        },
      },
      CRUD: {
        PROCESSING: 'Cargando...',
        EMPTY_TABLE: 'No hay datos disponibles en la tabla',
        INFO: 'Mostrando _START_ a _END_ de _TOTAL_ registros',
        INFO_EMPTY: 'Mostrando 0 a 0 de 0 registros',
        INFO_FILTERED: '(filtrado de _MAX_ registros totales)',
        LENGTH_MENU: 'Mostrar _MENU_ registros',
        LOADING_RECORDS: 'Cargando...',
        ZERO_RECORDS: 'No se encontraron registros coincidentes',
        SEARCH: 'Buscar:',
        ACTIONS: 'Acciones',
        PREVIOUS: 'Anterior',
        NEXT: 'Siguiente',
        SHOWING: 'Mostrando {{count}} de {{total}} {{items}}',
        ITEMS: 'registros',
        DELETE: 'Eliminar',
        DELETING: 'Eliminando…',
        DELETED: 'Eliminado',
        DELETE_ERROR: 'No se ha podido eliminar',
        CONFIRM_DELETE_TITLE: '¿Está seguro?',
        CONFIRM_DELETE_TEXT: 'Esta acción desactiva el recurso seleccionado',
        ROW_VIEW: 'Ver',
        ROW_EDIT: 'Editar',
        ROW_DELETE: 'Borrar',
        ROW_LINK: 'Vincular',
      },
      TERMS_CONDITIONS: {
        TITLE: 'Términos y Condiciones de Uso',
        TAB_DASHBOARD: 'Dashboard',
        TAB_APP: 'App',
        CURRENT_VERSION: 'Versión vigente actualizada el',
        NO_VERSION: 'Sin versión vigente — crea la primera versión',
        SAVING: 'Guardando…',
        SAVE: 'Guardar cambios',
        LOADING: 'Cargando contenido…',
        PLACEHOLDER: 'Escribe aquí los términos y condiciones...',
        SUCCESS_SAVE: 'Cambios guardados correctamente',
        ERROR_ACTIVATE: 'Error al activar la versión',
        ERROR_SAVE: 'Error al guardar los cambios',
        NOTE_TITLE: 'Guardar es publicar',
        NOTE_TEXT: 'Cada guardado crea una versión nueva y pasa a ser la vigente. El panel y la app tienen cada uno su propio texto: elige la pestaña antes de editar.',
        EMPTY_HINT: 'Escribe el texto para poder guardar',
      },
      CONTRACT_TEMPLATES: {
        TITLE: 'Plantilla de contrato',
        CURRENT_VERSION: 'Versión vigente actualizada el',
        HASH: 'Hash:',
        NO_VERSION: 'Sin versión vigente — crea la primera versión',
        SAVING: 'Guardando…',
        SAVE: 'Guardar cambios',
        LOADING: 'Cargando contenido…',
        PLACEHOLDER: 'Escribe aquí la plantilla de contrato...',
        SUCCESS_SAVE: 'Cambios guardados correctamente',
        ERROR_ACTIVATE: 'Error al activar la versión',
        ERROR_SAVE: 'Error al guardar los cambios',
        NOTE_TITLE: 'Guardar es publicar',
        NOTE_TEXT: 'Cada guardado crea una versión nueva y pasa a ser la vigente: con ella se genera el contrato de cada empresa. Lo que va entre corchetes, como [Razón social del Cliente], lo rellena el sistema con los datos de la empresa: no lo cambies.',
        EDITOR_TITLE: 'Texto de la plantilla',
        EMPTY_HINT: 'Escribe el texto para poder guardar',
      },
      DATA_PROCESSING_AGREEMENT: {
        TITLE: 'Contrato de encargo de tratamiento (DPA)',
        CURRENT_VERSION: 'Versión vigente actualizada el',
        NO_VERSION: 'Sin versión vigente — crea la primera versión',
        PUBLISH_HINT: 'Al guardar se crea una versión nueva y se publica: sustituye a la vigente para todas las altas de empresa posteriores.',
        SOFT_BREAK_HINT: 'Dentro de una celda, Enter crea otra celda: usa Mayús+Enter para saltar de línea. Tabulando en la última celda se añade una fila.',
        SAVING: 'Guardando…',
        SAVE: 'Guardar y publicar',
        LOADING: 'Cargando contenido…',
        PLACEHOLDER: 'Escribe aquí el contrato de encargo de tratamiento...',
        SUCCESS_SAVE: 'Contrato de encargo guardado y publicado correctamente',
        ERROR_LOAD: 'Error al cargar el contrato de encargo',
        ERROR_ACTIVATE: 'La versión se creó pero no se pudo publicar',
        ERROR_SAVE: 'Error al guardar los cambios',
        NOTE_TITLE: 'Guardar es publicar',
        EDITOR_TITLE: 'Texto del contrato',
        EMPTY_HINT: 'Escribe el texto para poder guardar',
        INSERT_TABLE: 'Insertar tabla',
        TABLE_COLUMNS: '{{count}} columnas',
        CELL_BACKGROUND: 'Fondo de celda',
        CELL_BG_PEACH: 'Melocotón (etiquetas)',
        CELL_BG_LIGHT_BLUE: 'Azul claro',
        CELL_BG_NAVY: 'Azul marino (cabecera)',
        CELL_BG_GREY: 'Gris',
        CELL_BG_NONE: 'Sin fondo',
        TABLE_COLUMN: '{{count}} columna',
      },
      LABELS: {
        SAVE: 'Guardar',
        SEARCH: 'Buscar etiqueta',
        ADD: 'Añadir etiqueta',
        EDIT: 'Editar etiqueta',
        NAME: 'Nombre',
        NAME_PLACEHOLDER: 'Ej. VIP',
        NAME_MAX_LENGTH: 'El nombre no puede superar los 255 caracteres',
        CODE: 'Código',
        CODE_PLACEHOLDER: 'Ej. vip',
        CODE_HINT:
          'Identificador estable de la etiqueta: minúsculas sin acentos, números y guiones bajos. Se propone a partir del nombre y puedes cambiarlo.',
        CODE_INVALID:
          'Solo minúsculas sin acentos, números y guiones bajos, empezando por una letra',
        CODE_MAX_LENGTH: 'El código no puede superar los 100 caracteres',
        APPLIES_TO: 'Se aplica a',
        APPLIES_TO_OPTIONS: {
          ALL: 'Usuarios y rutas',
          USER: 'Usuarios',
          POOLING_ROUTE: 'Rutas de pooling',
        },
        APPLIES_TO_HINT:
          'Decide en qué fichas puede asignarse la etiqueta. "Usuarios y rutas" la deja disponible en las dos.',
        CANCEL: 'Cancelar',
        CONFIRM: 'Aceptar',
        WAIT: 'Guardando…',
        SUCCESS: 'Correcto',
        SUCCESS_CREATE: 'Se ha creado correctamente la etiqueta',
        SUCCESS_UPDATE: 'Se ha actualizado correctamente la etiqueta',
        SUCCESS_DELETE: 'Se ha eliminado correctamente la etiqueta',
        ERROR: 'Error',
        SAVE_ERROR: 'No se ha podido guardar la etiqueta',
        DELETE_ERROR: 'No se ha podido eliminar la etiqueta',
        NOT_FOUND: 'La etiqueta ya no existe. Actualiza el listado.',
        LOAD_ERROR: 'No se han podido cargar las etiquetas',
        UNKNOWN_ERROR:
          'No se ha podido completar la operación. Inténtalo de nuevo.',
        ITEMS: 'etiquetas',
      },
      VALORATION_LABELS: {
        SEARCH: 'Buscar etiqueta',
        ADD: 'Añadir etiqueta',
        EDIT: 'Editar etiqueta',
        NAME: 'Nombre',
        NAME_MAX_LENGTH: 'El nombre no puede superar los 255 caracteres',
        ROLE: 'Rol',
        ROLES: {
          BOTH: 'Ambos',
          DRIVER: 'Conductor',
          RIDER: 'Pasajero',
        },
        POSITIVE_NAME: 'Etiqueta positiva',
        POSITIVE_NAME_PLACEHOLDER: 'Ej. Coche limpio',
        NEGATIVE_NAME: 'Etiqueta negativa',
        NEGATIVE_NAME_PLACEHOLDER: 'Ej. Coche sucio',
        PAIR_HINT:
          'Las etiquetas van siempre en pareja: los votos en contra de la positiva son las veces que se recibe la negativa. Se crean las dos a la vez y la pareja no se puede cambiar después.',
        CANCEL: 'Cancelar',
        CONFIRM: 'Aceptar',
        WAIT: 'Guardando…',
        SUCCESS: 'Correcto',
        SUCCESS_CREATE: 'Se ha creado correctamente la etiqueta de valoración',
        SUCCESS_UPDATE:
          'Se ha actualizado correctamente la etiqueta de valoración',
        SUCCESS_DELETE:
          'Se ha eliminado correctamente la etiqueta de valoración',
        ERROR: 'Error',
        ITEMS: 'etiquetas de valoración',
        SAVE: 'Guardar',
        SAVE_ERROR: 'No se ha podido guardar la etiqueta',
        DELETE_ERROR: 'No se ha podido eliminar la etiqueta',
        NOT_FOUND: 'La etiqueta ya no existe. Actualiza el listado.',
        LOAD_ERROR: 'No se han podido cargar los datos de la etiqueta',
        UNKNOWN_ERROR:
          'No se ha podido completar la operación. Inténtalo de nuevo.',
      },
      FRAUD_RULES: {
        NOTE_TITLE: 'Estos avisos ayudan a priorizar, no toman la decisión final',
        NOTE_TEXT: 'El sistema reúne indicios y explica qué ha detectado. Una persona debe revisar el contexto antes de bloquear una cuenta o retener un pago.',
        LOADING: 'Cargando las reglas',
        LOAD_ERROR: 'No se han podido cargar las reglas del modelo.',
        SAVE_ERROR: 'No se han podido guardar las reglas.',
        RETRY: 'Reintentar',
        RULES_TITLE: 'Cómo se generan los avisos',
        RULES_SUB: 'Comportamientos que hacen que un viaje necesite revisión',
        RULES_UNUSED: "Ahora mismo no se usan: el modelo del equipo de datos no los lee y no cambian ningún aviso. Se guardan solo como referencia.",
        MAX_SPEED: 'Velocidad máxima plausible (km/h)',
        MAX_GPS_JUMP: 'Salto GPS máximo entre puntos (m)',
        MAX_TRIPS_DEVICE: 'Máx. trayectos/día por dispositivo',
        NO_SHOWS: 'No-shows para marcar riesgo',
        NON_ELIGIBLE: 'Umbral transporte no elegible',
        COLLISION: 'Umbral colusión / baja independencia',
        SPOOFING: 'Umbral location spoofing',
        MANUAL_REVIEW: 'Umbral a revisión manual',
        MIN_ZERO: 'Debe ser 0 o más.',
        RANGE_ERROR: 'Debe estar entre 0 y 1.',
        RANGE_HINT: 'Entre 0 y 1.',
        NOTICE_TITLE: 'Aviso de verificación reforzada',
        NOTICE_SUB_1: 'Texto que ve el conductor en el detalle del trayecto mientras su cuenta está en verificación reforzada.',
        NOTICE_SUB_2: 'se sustituye por los días de plazo configurados.',
        REQUIRED: 'El texto es obligatorio.',
        REINFORCED_TITLE: "Verificación reforzada",
        REINFORCED_SUB: "Cuándo entra una cuenta en verificación reforzada y qué le pasa mientras está en ella.",
        AUTO_ENABLED: "Poner en verificación reforzada automáticamente por score",
        AUTO_HINT: "Se aplica cada vez que el equipo de datos carga una score nueva. La lista blanca nunca entra.",
        AUTO_MIN_SCORE: "Score mínima",
        SCORE_RANGE: "Entre 0 y 100.",
        TRIP_DELAY: "Días hasta abonar el viaje al conductor",
        WITHDRAWAL_DELAY: "Días que espera una retirada",
        DAYS_RANGE: "Entre 0 y 90 días.",
        MIN_PAYOUT: "Mínimo para retirar (€)",
        FREE_INVITE: "En verificación reforzada puede seguir invitando a coste 0",
        FREE_INVITE_HINT: "Desmarcado, nadie en reforzada puede dar ni canjear viajes a coste 0. «Reforzada + sin coste 0» lo bloquea siempre.",
        SWITCH_ON: "Activada",
        SWITCH_OFF: "Desactivada",
        SWITCH_TURN_ON: "Activar",
        SWITCH_TURN_OFF: "Desactivar",
        CANCEL: "Cancelar",
        CONFIRM_WORD: "CONFIRMAR",
        CONFIRM_TYPE: "Para seguir, escribe {{word}}.",
        AUTO_OFF_CONFIRM_TITLE: "¿Desactivar la reforzada automática?",
        AUTO_OFF_CONFIRM_TEXT: "Las scores nuevas dejarán de poner a nadie en verificación reforzada. Quien ya está en reforzada sigue igual. Se guarda al momento.",
        AUTO_ON_CONFIRM_TITLE: "¿Activar la reforzada automática?",
        AUTO_ON_CONFIRM_TEXT: "Cada score nueva igual o mayor que {{score}} pondrá esa cuenta en verificación reforzada (salvo la lista blanca). Se guarda al momento.",
        FREE_INVITE_OFF_CONFIRM_TITLE: "¿Bloquear el coste 0 en reforzada?",
        FREE_INVITE_OFF_CONFIRM_TEXT: "Nadie en verificación reforzada podrá dar ni canjear viajes a coste 0, desde ya. La app lo lee del mismo valor. Se guarda al momento.",
        FREE_INVITE_ON_CONFIRM_TITLE: "¿Permitir el coste 0 en reforzada?",
        FREE_INVITE_ON_CONFIRM_TEXT: "Quien esté en verificación reforzada podrá volver a invitar a coste 0 (salvo «Reforzada + sin coste 0»). Se guarda al momento.",
        BACK: "Volver a Fraude",
        LAST_CHANGE: "Último cambio: {{by}} · {{when}}",
        SOMEONE: "Automático",
        SAVE_CARD: "Guardar",
        NEVER_CHANGED: "Último cambio: todavía no se ha cambiado nunca desde el backoffice (valores por defecto).",
        REVIEW_DAYS: "Avisar de revisar la score cada (días)",
        REVIEW_DAYS_HINT: "Pasados estos días sin guardar la score, Fraude lo avisa en rojo.",
        SAVED: 'Guardado',
        FIX_FIELDS: 'Revisa los campos marcados para poder guardar',
        SAVING: 'Guardando…',
        SAVE: 'Guardar reglas',
      },
      APP_ANNOUNCEMENT: {
        GO_VARIABLES: "Ver variables",
        NOTE_TITLE: "Cada persona ve el comunicado una vez",
        NOTE_TEXT: "La app enseña el comunicado hasta que se pulsa el botón y recuerda su identificador. <b>Guardar cambios</b> mantiene el identificador (para corregir erratas): quien ya lo aceptó no lo vuelve a ver. <b>Publicar como comunicado nuevo</b> crea otro identificador y lo vuelve a ver todo el mundo.",
        LOADING: "Cargando el comunicado…",
        LOAD_ERROR: "No se ha podido cargar el comunicado.",
        RETRY: "Reintentar",
        VISIBILITY_TITLE: "Visibilidad",
        VISIBILITY_SUB: "Interruptor de la variable APP_ANNOUNCEMENT_ENABLED. Se guarda al momento.",
        SHOW: "Mostrar comunicado",
        CURRENT_ID: "Comunicado publicado:",
        NO_ID: "Todavía no se ha publicado ningún comunicado.",
        STATE_ON: "Visible en la app",
        STATE_OFF: "Oculto",
        ENABLE: "Activar",
        DISABLE: "Desactivar",
        CONTENT_TITLE: "Textos",
        CONTENT_SUB: "El castellano es obligatorio. En catalán e inglés, si no hay título, la app enseña la versión en castellano.",
        NO_ANNOUNCEMENT: "Todavía no hay ningún comunicado guardado.",
        INVALID_STORED: "El valor guardado de APP_ANNOUNCEMENT no es un comunicado válido. Al guardar se sustituirá por estos textos.",
        LANGUAGE: "Idioma",
        LANG_ES: "Castellano",
        LANG_CA: "Catalán",
        LANG_EN: "Inglés",
        LANG_HAS_ERRORS: "Hay campos por corregir en este idioma",
        FALLBACK_HINT: "Sin texto en este idioma: la app enseñará la versión en castellano.",
        FIELD_TITLE: "Título",
        TITLE_REQUIRED: "Escribe un título o un texto en castellano.",
        FIELD_BODY: "Texto",
        BODY_PLACEHOLDER: "Escribe el texto del comunicado…",
        BODY_HELP: "Títulos, negrita, cursiva, subrayado, listas y <b>color destacado</b> (negrita en morado). Las imágenes, los enlaces y los estilos pegados se quitan.",
        BODY_HELP_HTML: "HTML del cuerpo. Solo se guardan <code>p</code>, <code>br</code>, <code>strong</code>, <code>em</code>, <code>u</code>, <code>h2</code>, <code>h3</code>, <code>ul</code>, <code>ol</code>, <code>li</code> y <code>&lt;span class=\"ql-color-accent\"&gt;</code>; el resto de etiquetas y atributos se quitan al guardar.",
        VIEW_HTML: "Ver HTML",
        VIEW_EDITOR: "Ver editor",
        ACCENT_COLOR: "Color destacado",
        FIELD_CTA: "Texto del botón",
        PREVIEW_TITLE: "Vista previa",
        PREVIEW_SUB: "Así se verá en la app.",
        PREVIEW_THEME: "Tema de la vista previa",
        PREVIEW_LIGHT: "Claro",
        PREVIEW_DARK: "Oscuro",
        COPY_HINT: "Lo que escribas en castellano se copia solo al catalán y al inglés. Si quieres una versión propia en otro idioma, entra en su pestaña y cámbiala.",
        LINKED_HINT: "Copiado del castellano: se actualiza solo. Si lo cambias aquí, pasa a ser una versión propia de este idioma.",
        OWN_HINT: "Versión propia de este idioma: ya no se copia del castellano.",
        RELINK: "Volver a copiar del castellano",
        UNSAVED: "Hay cambios sin guardar",
        NOT_PUBLISHED: "Comunicado sin publicar",
        FIX_FIELDS: "Revisa los campos marcados para poder guardar",
        PUBLISH_NEW: "Publicar como comunicado nuevo",
        SAVE_HINT: "Mantiene el comunicado actual: quien ya lo aceptó no lo vuelve a ver.",
        SAVE: "Guardar cambios",
        SAVING: "Guardando…",
        SAVED: "Comunicado guardado",
        ERROR_SAVE: "No se ha podido guardar el comunicado",
        ERROR_TOGGLE: "No se ha podido cambiar la visibilidad del comunicado",
        PUBLISH_NEW_TITLE: "Publicar como comunicado nuevo",
        PUBLISH_NEW_TEXT_ON: "Se crea un comunicado nuevo y lo volverán a ver todos los usuarios al abrir la app, también quienes ya aceptaron el anterior.",
        PUBLISH_NEW_TEXT_OFF: "Se crea un comunicado nuevo. Cuando lo actives, lo verán todos los usuarios, también quienes ya aceptaron el anterior.",
        PUBLISH_NEW_CONFIRM: "Publicar",
        PUBLISHED_DONE: "Publicado",
        CANCEL: "Cancelar",
        ACCEPT: "Aceptar",
        ENABLE_NEEDS_SAVE: "Guarda el comunicado antes de activarlo",
        ENABLE_TITLE: "Mostrar el comunicado",
        ENABLE_TEXT: "Lo verán al abrir la app los usuarios que todavía no lo hayan aceptado.",
        ENABLE_TEXT_DIRTY: "Lo verán al abrir la app los usuarios que todavía no lo hayan aceptado, con los textos guardados: los cambios sin guardar no se enseñan.",
        DISABLE_TITLE: "Ocultar el comunicado",
        DISABLE_TEXT: "Nadie lo verá al abrir la app hasta que lo vuelvas a activar.",
        ENABLED_DONE: "Activado",
        DISABLED_DONE: "Desactivado",
      },
      CONFIG_VARIABLES: {
        MODAL_CREATE: 'Agregar variable de configuración',
        MODAL_EDIT: 'Editar variable de configuración',
        SECTION_VARIABLE: 'Variable',
        FIELD_NAME: 'Nombre de la variable',
        NAME_PLACEHOLDER: 'ej: app_version',
        NAME_REQUIRED: 'El nombre es obligatorio (mínimo 3 caracteres; solo letras, números, guiones y guiones bajos)',
        FIELD_VALUE: 'Valor',
        VALUE_PLACEHOLDER: 'ej: 1.0.0',
        VALUE_REQUIRED: 'El valor es obligatorio',
        FIELD_DESCRIPTION: 'Descripción',
        DESCRIPTION_PLACEHOLDER: 'Descripción de la variable',
        FREE_TRIPS: {
          TITLE: 'Empresas con coste 0',
          HINT: 'Los empleados vinculados a la empresa viajan como pasajeros a coste 0 en cualquier trayecto de esos días (fechas incluidas).',
          SELECT_COMPANY: 'Selecciona una empresa',
          COMPANY: 'Empresa',
          FROM: 'Desde',
          TO: 'Hasta',
          ADD: 'Añadir empresa',
          REMOVE: 'Quitar',
          EMPTY: 'Ninguna empresa con coste 0.',
          INCOMPLETE: 'Elige la empresa y las dos fechas (la final no puede ser anterior a la inicial): si no, no se aplica.',
          INVALID: 'El valor guardado no se puede leer; al guardar se sustituirá por el de aquí.',
        },
        SECTION_CLASSIFICATION: 'Clasificación',
        FIELD_CATEGORY: 'Categoría',
        SELECT_CATEGORY: 'Seleccionar categoría',
        CATEGORY_REQUIRED: 'La categoría es obligatoria',
        FIELD_STATUS: 'Estado',
        ACTIVE: 'Activa',
        CREATE: 'Crear',
        SAVE: 'Guardar',
        SAVING: 'Guardando…',
        ACTIVATE_LOGS: 'Activar logs',
        ADD_TOOLTIP: 'Agregar nueva variable',
        ADD: 'Agregar variable',
        PANEL_TITLE: 'Variables de configuración',
        PANEL_SUB: 'Cada fila es una variable con su valor, su categoría y si está activa. Pulsa el lápiz para editarla.',
        LOADING: 'Cargando…',
        COL_NAME: 'Nombre',
        COL_VALUE: 'Valor',
        COL_DESCRIPTION: 'Descripción',
        COL_CATEGORY: 'Categoría',
        COL_ACTIVE: 'Activa',
        COL_ACTIONS: 'Acciones',
        LOAD_ERROR: 'No se han podido cargar las variables de configuración.',
        RELOAD_ERROR: 'No se han podido recargar las variables de configuración.',
        RETRY: 'Reintentar',
        YES: 'Sí',
        NO: 'No',
        EDIT: 'Editar',
        DELETE: 'Eliminar',
        SHOW: 'Mostrar',
        PER_PAGE: 'Registros por página',
        RECORDS: 'registros',
        TTL_LABEL: 'Tiempo de vida (segundos)',
        TTL_PLACEHOLDER: 'ej: 3600',
        TTL_HINT: 'Indica cuántos segundos estarán activos los logs',
        ACTIVATE: 'Activar',
        ACTIVATING: 'Activando…',
        DT_SEARCH: 'Buscar:',
        DT_LENGTH_MENU: 'Mostrar _MENU_ registros',
        DT_ZERO_RECORDS: 'No se encontraron registros',
        DT_INFO_EMPTY: 'Mostrando 0 de 0 variables',
        DT_INFO_FILTERED: '(filtrado de _MAX_ variables totales)',
        DT_FIRST: 'Primero',
        DT_LAST: 'Último',
        DT_NEXT: 'Siguiente',
        DT_PREVIOUS: 'Anterior',
        DT_INFO: 'Mostrando {{shown}} de {{total}} variables',
        DELETE_TITLE: 'Eliminar variable de configuración',
        DELETE_TEXT: 'Se eliminará la variable «{{name}}».',
        DELETE_CONFIRM: 'Sí, eliminar',
        DELETING: 'Eliminando…',
        DELETED: 'Eliminada',
        DELETE_ERROR: 'No se ha podido eliminar la variable',
        CREATED: 'Variable de configuración creada correctamente',
        CREATE_ERROR: 'No se ha podido crear la variable',
        UPDATED: 'Variable de configuración actualizada correctamente',
        UPDATE_ERROR: 'No se ha podido actualizar la variable',
        GENERIC_ERROR: 'Se ha producido un error. Inténtalo de nuevo.',
        TTL_INVALID_TITLE: 'Valor no válido',
        TTL_INVALID_TEXT: 'Introduce un valor mayor que 0',
        LOGS_ACTIVATED: 'Logs activados durante {{seconds}} segundos',
        LOGS_ERROR: 'No se han podido activar los logs',
      },
      COUPONS: {
        SHARED: {
          CLEAR: 'Limpiar',
          REMOVE_FILTER: 'Quitar {{label}}',
          SAVING: 'Guardando…',
        },
        GIFT_CARDS: {
          ADD: 'Añadir cupón',
          SEARCH_PLACEHOLDER: 'Buscar cupón',
          SEARCH_LABEL: 'Buscar cupón',
          ITEMS: 'cupones',
          PROVIDER: 'Proveedor',
          PROVIDER_REQUIRED: 'El proveedor es obligatorio',
          NAME: 'Nombre del cupón',
          NAME_REQUIRED: 'El nombre es obligatorio',
          IMAGE: 'Imagen del cupón',
          IMAGE_REQUIRED: 'La imagen es obligatoria al crear un cupón',
          PREVIEW: 'Previsualización',
          DESCRIPTION: 'Descripción',
          DESCRIPTION_REQUIRED: 'La descripción es obligatoria',
          EXPIRATION: 'Caducidad',
          EXPIRATION_REQUIRED: 'La fecha de caducidad es obligatoria',
          CREDIT_VALUE: 'Valor en créditos',
          CREDIT_VALUE_REQUIRED: 'El valor en créditos es obligatorio',
          EURO_VALUE: 'Valor en €',
          EURO_VALUE_REQUIRED: 'El valor en euros es obligatorio',
          STATUS: 'Estado',
          STATUS_REQUIRED: 'El estado es obligatorio',
          ACTIVE: 'Activo',
          INACTIVE: 'Inactivo',
          COL_COUPON: 'Cupón',
          COL_PROVIDER: 'Proveedor',
          COL_EXPIRATION: 'Caducidad',
          COL_CREDIT_VALUE: 'Valor en créditos',
          COL_EURO_VALUE: 'Valor en €',
          COL_STATUS: 'Estado',
          COL_INSTRUCTIONS: 'Link instrucciones',
          OPEN: 'Abrir',
          EDIT_TITLE: 'Editar cupón',
          CREATE_TITLE: 'Crear cupón',
          UPDATED: 'Tarjeta regalo modificada correctamente',
          CREATED: 'Tarjeta regalo creada correctamente',
          SAVE_ERROR: 'No se ha podido guardar la tarjeta regalo',
        },
        CODES: {
          ADD: 'Añadir código',
          SEARCH_PLACEHOLDER: 'Buscar código',
          SEARCH_LABEL: 'Buscar código',
          ITEMS: 'códigos',
          COUPON: 'Cupón',
          COUPON_REQUIRED: 'El cupón es obligatorio',
          CODE: 'Código',
          CODE_REQUIRED: 'El código es obligatorio',
          INSTRUCTIONS: 'Instrucciones',
          URL_INVALID: 'Introduce una URL válida',
          ASSIGN_TO: 'Asignar a',
          IMPORT_TITLE: 'Importar CSV por cupón',
          IMPORT_SELECT_COUPON: 'Selecciona un cupón',
          IMPORT_SELECT_FILE: 'Selecciona un archivo',
          IMPORT_FILE_REQUIRED: 'El archivo es obligatorio',
          IMPORT: 'Importar',
          STATUS_ALL: 'Todos',
          STATUS_AVAILABLE: 'Disponible',
          STATUS_EXPIRED: 'Caducado',
          STATUS_USED: 'Usado',
          COL_CODE: 'Código',
          COL_INSTRUCTIONS: 'Instrucciones',
          COL_PROVIDER: 'Proveedor',
          COL_COUPON: 'Cupón',
          COL_EXPIRATION: 'Caducidad',
          COL_ASSIGNMENT: 'Fecha de asignación',
          COL_USER: 'Usuario',
          EDIT_TITLE: 'Editar código',
          VIEW_TITLE: 'Detalles del código',
          CREATE_TITLE: 'Crear código',
          UPDATED: 'Código modificado correctamente',
          CREATED: 'Código creado correctamente',
          SAVE_ERROR: 'No se ha podido guardar el código',
          IMPORTED: 'Códigos importados correctamente',
          IMPORT_ERROR: 'No se han podido importar los códigos',
          IMPORT_ERROR_TEXT: 'Ha ocurrido un error en la importación de códigos',
        },
        PROVIDERS: {
          ADD: 'Añadir proveedor',
          SEARCH_PLACEHOLDER: 'Buscar',
          SEARCH_LABEL: 'Buscar proveedor',
          ITEMS: 'proveedores',
          LOGO: 'Logotipo',
          NAME: 'Proveedor',
          NAME_REQUIRED: 'El nombre es obligatorio',
          NAME_MIN: 'El nombre debe tener al menos 4 letras',
          CONTACT: 'Contacto',
          EMAIL_REQUIRED: 'El email es obligatorio',
          EMAIL_INVALID: 'El email no es válido',
          LOADING: 'Cargando...',
          COL_PROVIDER: 'Proveedor',
          COL_TOTAL_COUPONS: 'Total cupones',
          COL_CONTACT: 'Contacto',
          EDIT_TITLE: 'Editar proveedor',
          CREATE_TITLE: 'Crear proveedor',
          UPDATED: 'Proveedor modificado correctamente',
          CREATED: 'Proveedor creado correctamente',
          SAVE_ERROR: 'No se ha podido guardar el proveedor',
        },
        PROMO_CODES: {
          ITEMS: 'códigos promocionales',
          KIND_APP: 'Promoción en la app',
          KIND_CAMPAIGN: 'Código de campaña',
          LOADING_DETAIL: 'Cargando el código promocional…',
          LOAD_DETAIL_ERROR: 'No se ha podido cargar el código promocional. Cierra el formulario y vuelve a intentarlo; no se ha guardado nada.',
          GUIDE_TITLE: '¿Qué tipo de promoción vas a configurar?',
          GUIDE_SUB: 'Guía: promoción en la app o código de campaña, con un ejemplo de cada una.',
          GUIDE_SHOW: 'Ver guía',
          GUIDE_HIDE: 'Ocultar guía',
          GUIDE_APP_TEXT: 'El usuario la ve en «Promociones» y la activa con el botón «Aplicar», sin escribir ningún código.',
          GUIDE_APP_EXAMPLE: 'Ejemplo: 5€ en el primer viaje Taxi/VTC',
          GUIDE_APP_1: 'Tipo <b>Absoluto</b>, valor <b>5</b>',
          GUIDE_APP_2: 'Aplica a <b>solo Taxi / VTC</b> (sin Carpooling)',
          GUIDE_APP_3: 'Nº de viajes <b>1</b>: un viaje con descuento',
          GUIDE_APP_4: 'Máx. viajes completados <b>0</b>: solo usuarios que aún no han hecho ningún viaje de Taxi/VTC',
          GUIDE_APP_5: 'Viajes que cuentan: <b>Solo los tipos a los que aplica</b> (los viajes de carpooling no cuentan)',
          GUIDE_APP_6: '<b>Visible en la app</b> activado · zona si hace falta',
          GUIDE_APP_7: 'Textos en es/en/ca (el título en español es obligatorio)',
          GUIDE_APP_HINT: 'Al elegir <b>Visible en la app</b>, los campos vacíos se rellenan con esta configuración. Puedes cambiarlos.',
          GUIDE_CAMPAIGN_TEXT: 'Solo funciona si el usuario escribe el código en «Tengo un código promocional». No aparece en la tarjeta «Aplicar».',
          GUIDE_CAMPAIGN_EXAMPLE: 'Ejemplo: VERANO10, 10% en 3 viajes',
          GUIDE_CAMPAIGN_1: 'Elige <b>Solo con código</b>',
          GUIDE_CAMPAIGN_2: 'Código: el que se reparte (<b>VERANO10</b>)',
          GUIDE_CAMPAIGN_3: 'Fechas de la campaña',
          GUIDE_CAMPAIGN_4: 'Tipo y valor (<b>Porcentaje 10</b>) y descuento máx/uso',
          GUIDE_CAMPAIGN_5: 'Nº de viajes (<b>3</b>): obligatorio en porcentaje',
          GUIDE_CAMPAIGN_6: 'Aplica a <b>Carpooling</b> (los códigos de campaña no pueden ser de Taxi/VTC)',
          GUIDE_CAMPAIGN_HINT: 'Las demás condiciones y los textos son de las promociones visibles en la app. En la app se muestra con el código como título.',
          GUIDE_NOTE: 'La diferencia está en <b>«¿Cómo la consigue el usuario?»</b>: visible en la app = se activa con un botón; solo con código = hay que escribirlo.',
          HOW_TITLE: '¿Cómo la consigue el usuario?',
          SECTIONS: 'Secciones del código promocional',
          TAB_DISCOUNT: 'Descuento',
          CODE: 'Código',
          CODE_HINT_APP: 'La app no lo muestra, pero sigue funcionando si alguien lo escribe en «Tengo un código promocional» (con las mismas reglas). El título visible va en «En la app».',
          CODE_HINT_CAMPAIGN: 'Es lo que escribe el usuario para canjearlo.',
          START_DATE: 'Fecha inicio',
          START_DATE_REQUIRED: 'La fecha de inicio es obligatoria',
          END_DATE: 'Fecha fin',
          END_DATE_HINT: 'Vacío = no caduca',
          DATES_HINT: 'Empieza a las 00:00 del día de inicio y caduca a las 00:00 del día de fin: el último día con descuento es el anterior a la fecha fin.',
          TYPE: 'Tipo',
          TYPE_REQUIRED: 'El tipo es obligatorio',
          VALUE: 'Valor',
          VALUE_REQUIRED: 'El valor es obligatorio',
          VALUE_MIN: 'El valor mínimo permitido es 0',
          VALUE_MAX: 'El valor máximo permitido es {{max}}',
          FREE_TRIPS: 'Nº de trayectos gratis',
          FREE_TRIPS_REQUIRED: 'El número de trayectos es obligatorio',
          MAX_PER_USE: 'Descuento máx/uso',
          MAX_PER_USE_REQUIRED: 'El descuento máx/uso es obligatorio',
          MAX_PER_USE_MIN: 'No puede ser negativo',
          MAX_PER_USE_MAX: 'No puede superar el valor del cupón ({{limit}} €)',
          MAX_PER_USE_HINT: 'Tope que se descuenta en cada viaje. 0 = sin límite.',
          NUM_ROUTES: 'Nº de viajes',
          NUM_ROUTES_TIP: 'Cuántos viajes con descuento tiene cada usuario. En porcentaje es obligatorio: sin él el cupón se canjea pero no descuenta nunca.',
          NUM_ROUTES_PLACEHOLDER: 'Ej. 3',
          NO_LIMIT: 'Sin límite',
          NUM_ROUTES_REQUIRED: 'En porcentaje hay que indicar en cuántos viajes descuenta',
          NUM_ROUTES_MIN: 'Mínimo 1 viaje',
          NUM_ROUTES_MAX_ONE: 'Con «Máx. viajes completados» = {{completed}} solo puede usarse en {{count}} viaje',
          NUM_ROUTES_MAX: 'Con «Máx. viajes completados» = {{completed}} solo puede usarse en {{count}} viajes',
          NUM_ROUTES_HINT: 'Es el número que ve el usuario en «Te quedan N viajes con descuento».',
          NUM_ROUTES_FIRST_TRIP: 'Primer viaje: un solo viaje con descuento (la regla se comprueba en cada viaje).',
          APPLIES_TO: 'Aplica a',
          CAMPAIGN_ONLY_CARPOOLING: 'Los códigos de campaña solo pueden ser de Carpooling.',
          REMOVED_VTC: 'Este código tenía Taxi / VTC, que ya no se permite en códigos de campaña. Revisa «Aplica a» antes de guardar.',
          APPLIES_TO_REQUIRED: 'Selecciona al menos un tipo de viaje',
          APP_PROMO_NEEDS_VTC: 'Una promoción visible en la app tiene que incluir Taxi / VTC: la app solo las muestra en viajes bajo demanda.',
          TAB_CONDITIONS: 'Condiciones',
          FIRST_TRIP_RULES_ONLY_VTC: '«Máx. viajes completados» y «Viajes que cuentan» (reglas de primer viaje) solo están disponibles cuando «Aplica a» es solo Taxi / VTC.',
          MAX_COMPLETED: 'Máx. viajes completados',
          MAX_COMPLETED_TIP: 'Solo pueden usarla usuarios con como mucho este número de viajes hechos. 0 = primer viaje. Vacío = cualquiera.',
          NO_RESTRICTION: 'Sin restricción',
          MAX_COMPLETED_HINT: 'Requisito para poder usarla: cuántos viajes puede llevar hechos el usuario como máximo. Ej.: 0 = solo quien todavía no ha hecho ningún viaje. Este número no aparece en la app.',
          TRIPS_COUNTED: 'Viajes que cuentan',
          TRIPS_COUNTED_TIP: 'Qué viajes se cuentan para «Máx. viajes completados». Con «Solo los tipos a los que aplica», el carpooling no cuenta para una promo de Taxi/VTC.',
          TRIPS_COUNTED_ALL: 'Todos los viajes',
          TRIPS_COUNTED_APPLICABLE: 'Solo los tipos a los que aplica',
          ZONE: 'Zona',
          ZONE_TIP: 'Solo descuenta si el origen del viaje está dentro. En la app se muestra como «Válido en».',
          ANYWHERE: 'Cualquier sitio',
          LEGACY_ZONE: 'Esta zona ya no es una zona de promoción. Se conserva si no la cambias; si eliges otra, ya no podrás volver a ella.',
          ZONE_NO_PERMISSION: 'No tienes permiso para cambiar la zona.',
          ZONE_ONLY_VTC: 'La zona solo está disponible cuando «Aplica a» es solo Taxi / VTC.',
          TAB_APP: 'En la app',
          APP_TEXTS_HINT: 'Se muestran en la tarjeta «Aplicar», el detalle y «Aplicado».',
          TEXTS_LANGUAGE: 'Idioma de los textos',
          TITLE_LANG: 'Título ({{lang}})',
          TITLE_PLACEHOLDER: '5€ de descuento en tu primer viaje con Taxi/VTC',
          DETAILS: 'Detalles',
          APPLIES_TO_TEXT: 'Aplica a (texto)',
          EMPTY_TEXT_DELETES: 'Dejar un texto vacío lo borra.',
          STATUS_ALL: 'Todos',
          ACTIVE: 'Activo',
          INACTIVE: 'Inactivo',
          TYPE_ABSOLUTE: 'Absoluto',
          TYPE_PERCENTAGE: 'Porcentaje',
          TYPE_BALANCE: 'Saldo',
          TYPE_FREE_TRIPS: 'Trayectos gratis',
          SELECT_ALL: 'Seleccionar todos',
          TRIP_VTC_ALL: 'Taxi / VTC (todos los proveedores)',
          TRIP_VTC: 'Taxi / VTC',
          TRIP_CARPOOLING: 'Carpooling',
          CODE_ONLY: 'Solo con código',
          CODE_ONLY_HINT: 'Lo escribe en «Tengo un código promocional»',
          SHOW_IN_APP: 'Visible en la app',
          SHOW_IN_APP_HINT: 'La activa con «Aplicar», sin escribir el código',
          COL_CODE: 'Código',
          COL_START_DATE: 'Fecha inicio',
          COL_END_DATE: 'Fecha fin',
          COL_VALUE: 'Valor',
          COL_FREE_TRIPS: 'Número de trayectos gratis',
          COL_MAX_PER_USE: 'Descuento máx/uso',
          COL_TYPE: 'Tipo de cupón',
          COL_STATUS: 'Estado',
          DELETE_ERROR_TITLE: 'No se puede eliminar',
          DELETE_IN_USE: 'Este código ya lo han aplicado o usado usuarios, así que no se puede eliminar. Para que deje de usarse, edítalo y pon como fecha fin la de hoy.',
          DELETE_ERROR: 'No se ha podido eliminar el código promocional. Inténtalo de nuevo.',
          EDIT_TITLE: 'Editar código promocional',
          CREATE_TITLE: 'Crear código promocional',
          TITLE_ES_REQUIRED: 'Para mostrarla en la app hace falta el título en español',
          TITLE_EQUALS_CODE: 'El título no puede ser igual al código: la app no mostraría la promoción',
          UPDATED: 'Código promocional modificado correctamente',
          CREATED: 'Código promocional creado correctamente',
          SAVE_ERROR: 'No se ha podido guardar el código promocional',
          VALUE_HELP_ABSOLUTE: 'Importe total del cupón. Se gasta viaje a viaje hasta agotarse.',
          VALUE_HELP_BALANCE: 'Saldo que se carga al usuario.',
          VALUE_HELP_PERCENTAGE: 'Porcentaje que se descuenta de cada viaje.',
        },
      },
      ADMIN_HOME_MAP: {
        ROUTINES_24H: 'Rutinas en las últimas 24 h',
        LOAD_ERROR: 'No se han podido cargar los viajes recientes',
        ZOOM_IN: 'Acercar',
        ZOOM_OUT: 'Alejar',
      },
      ADMIN_FUNNEL: {
        DATE_RANGE_ERROR: 'La fecha de inicio no puede ser posterior a la fecha de fin',
        LOAD_ERROR: 'Error al cargar los datos',
        PDF_CATEGORY: 'Categoría',
        PDF_VALUE: 'Valor',
      },
    },
    COMPANY: {
      PARKINGS: {
        COMMON: {
          BACK: 'Volver',
          BACK_TO_LIST: 'Volver al listado',
          RETRY: 'Reintentar',
          LOADING: 'Cargando...',
          BREADCRUMB: 'Ruta de navegación',
          CANCEL: 'Cancelar',
          SAVE: 'Guardar',
          SAVE_CHANGES: 'Guardar cambios',
          SAVING: 'Guardando…',
          ACCEPT: 'Aceptar',
          ACTIVE: 'Activo',
          ACTIVE_F: 'Activa',
          INACTIVE_F: 'Inactiva',
          YES: 'Sí',
          NO: 'No',
          ALL_F: 'Todas',
          ALL_M: 'Todos',
          REMOVE_FILTER: 'Quitar {{label}}',
          OPEN_CALENDAR: 'Abrir calendario',
          SELECT_DATE_TIME: 'Selecciona fecha y hora',
          PREFERENCES: 'Preferencias',
          IMPORT_UNAVAILABLE: 'Importación no disponible',
          IMPORT_UNAVAILABLE_TEXT: 'La importación masiva por CSV todavía no está disponible. No se ha guardado ningún dato.',
          NOT_ASSIGNED: 'No asignado',
          TOTAL: 'Total',
          TOTAL_COLON: 'Total:',
          VIEW_DATA: 'Ver los datos',
        },
        FIELDS: {
          SPACE: 'Plaza',
          TYPE: 'Tipo',
          LOCATION: 'Ubicación',
          OFFICE: 'Sede',
          USER: 'Usuario',
          ROLE: 'Rol',
          PLATE: 'Matrícula',
          SHIFT: 'Turno',
          SHIFT_N: 'Turno {{n}}',
          DAYS: 'Días',
          RESERVED_DAYS: 'Días reservados',
          ASSIGNED_DAYS: 'Días asignados',
          SHARING: 'Compartiendo',
          CREDIT: 'Crédito',
          EXPIRY: 'Caducidad',
          START_DATE: 'Fecha inicio',
          END_DATE: 'Fecha fin',
          STATUS: 'Estado',
          REASON: 'Razón',
          RESERVATION: 'Reserva',
          DAY: 'Día',
        },
        ERRORS: {
          OFFICE_REQUIRED: 'La sede es obligatoria',
          USER_REQUIRED: 'El usuario es obligatorio',
          PLATE_REQUIRED: 'La matrícula es obligatoria',
          SHIFT_REQUIRED: 'El turno es obligatorio',
          DAYS_REQUIRED: 'Los días son obligatorios',
          SPACE_NAME_REQUIRED: 'El nombre de la plaza es obligatorio',
          TYPE_REQUIRED: 'El tipo de plaza es obligatorio',
          LOCATION_REQUIRED: 'La ubicación es obligatoria',
          REASON_REQUIRED: 'El motivo es obligatorio',
          SPACE_REQUIRED: 'La plaza de parking es obligatoria',
          COUPON_REQUIRED: 'El valor del cupón es obligatorio',
        },
        DAYS: {
          MON: 'Lunes',
          TUE: 'Martes',
          WED: 'Miércoles',
          THU: 'Jueves',
          FRI: 'Viernes',
          SAT: 'Sábado',
          SUN: 'Domingo',
        },
        SHIFT_STATUS: {
          BUSY: 'Ocupado',
          FREE: 'Libre',
        },
        ROLES: {
          DRIVER: 'Conductor',
          PASSENGER: 'Pasajero',
        },
        SPACE_TYPES: {
          GENERAL: 'General',
          ELECTRIC: 'Coche eléctrico',
          MOTORBIKE: 'Moto',
          TRUCK: 'Camión',
          VIP: 'VIP',
          ZONE: 'Zona {{n}}',
        },
        SPACES: {
          CREATE: 'Crear plaza de parking',
          SEARCH: 'Buscar plaza de parking',
          ITEMS: 'plazas de parking',
          EDIT_TITLE: 'Editar plaza de parking',
          CREATE_TITLE: 'Crear plaza de parking',
          CREATE_SUBTITLE: 'Da de alta una plaza de parking en una sede.',
          SPACE_LABEL: 'Plaza {{name}}',
          DETAIL: 'Detalle',
          SAVED_EDIT: 'Plaza de parking modificada correctamente',
          SAVED_CREATE: 'Plaza de parking creada correctamente',
          SAVE_ERROR: 'No se ha podido guardar la plaza de parking',
          LOADING: 'Cargando la plaza de parking',
          DATA_TITLE: 'Datos de la plaza',
          DATA_SUB: 'Sede a la que pertenece, nombre, tipo y dónde está.',
          PREFS_SUB: 'Solo las plazas activas se pueden reservar.',
          CREATE_BTN: 'Crear plaza',
          NOT_FOUND: 'No se ha encontrado la plaza de parking.',
          LOAD_ERROR: 'No se ha podido cargar la plaza de parking.',
          RESERVATIONS: 'Reservas',
          RESERVATIONS_SUB: 'Quién tiene reservada esta plaza, en qué turno, qué días y entre qué fechas.',
          RESERVATIONS_ERROR: 'No se han podido cargar las reservas.',
          NO_RESERVATIONS: 'Esta plaza no tiene reservas.',
          RESERVATIONS_FOOT: 'Mostrando {{shown}} de {{total}} reservas',
        },
        RESERVATIONS: {
          CREATE: 'Reservar plaza de parking',
          SEARCH: 'Buscar plaza de parking',
          ITEMS: 'reservas de parking',
          EDIT_TITLE: 'Editar reserva',
          CREATE_TITLE: 'Crear reserva',
          FORM_SUBTITLE: 'Quién reserva, en qué fechas y qué plaza ocupa.',
          SAVED_EDIT: 'Reserva modificada correctamente',
          SAVED_CREATE: 'Reserva creada correctamente',
          SAVE_ERROR: 'No se ha podido guardar la reserva',
          MISSING_FIELDS: 'Faltan campos obligatorios',
          MISSING_FIELDS_TEXT: 'Completa todos los campos obligatorios antes de continuar.',
          WHO_TITLE: 'Quién reserva',
          WHO_SUB: 'Tipo de usuario, sede y datos de la persona.',
          USER_TYPE: 'Tipo de usuario',
          EMPLOYEE: 'Empleado',
          EMPLOYEE_HINT: 'Persona de una sede: eliges la sede y el empleado; su matrícula sale de su ficha.',
          GUEST: 'Usuario invitado',
          GUEST_SHORT: 'Invitado',
          GUEST_HINT: 'Persona externa: escribes su nombre y su matrícula.',
          DATES_TITLE: 'Fechas y motivo',
          DATES_SUB: 'Desde cuándo y hasta cuándo se reserva la plaza, y por qué.',
          REASON: 'Motivo de la reserva',
          REASON_PLACEHOLDER: 'Escribe el motivo aquí...',
          SPACE_TITLE: 'Plaza',
          SPACE_SUB: 'Asignación automática o elección manual de la plaza.',
          SPACE_SELECTION: 'Selección de plaza',
          AUTOMATIC: 'Automático',
          MANUAL: 'Manual',
          LOADING_SPACES: 'Cargando plazas…',
          LOAD_SPACES: 'Cargar plazas disponibles',
          SPACES_COUNT: 'Plazas: {{n}}',
          SELECT_SPACE: 'Selecciona una plaza',
          PICK_SPACE_TO_SAVE: 'Elige una plaza para poder guardar',
          DETAIL_TITLE: 'Detalles de la reserva',
          DETAIL_SUB: 'Quién tiene la plaza, cuál es y en qué fechas.',
          NOT_FOUND: 'No se ha encontrado la reserva.',
          LOAD_ERROR: 'No se ha podido cargar la reserva.',
          OCCUPANCY_INDEX: 'Índice de ocupación',
          PERIOD: 'Periodo',
          START: 'Inicio',
          END: 'Fin',
          REASON_TITLE: 'Motivo',
        },
        CREDITS: {
          CREATE: 'Asignar cupón de crédito de parking',
          SEARCH: 'Buscar usuario',
          ITEMS: 'créditos de parking',
          EDIT_TITLE: 'Editar crédito de parking',
          CREATE_TITLE: 'Parking público - Asignar crédito',
          CREATE_SUBTITLE: 'Elige la persona, la sede, los días y el cupón de crédito.',
          SAVED_EDIT: 'Crédito de parking modificado correctamente',
          SAVED_CREATE: 'Crédito de parking asignado correctamente',
          SAVE_ERROR: 'No se ha podido guardar el crédito de parking',
          PERSON_TITLE: 'Persona',
          PERSON_SUB: 'A quién se asigna el crédito, con qué rol y qué vehículo.',
          PARKING_TITLE: 'Parking',
          PARKING_SUB: 'Sede, turno y días en los que puede usar el parking.',
          CREDIT_TITLE: 'Crédito',
          CREDIT_SUB: 'Valor del cupón y periodo en el que es válido.',
          COUPON_VALUE: 'Valor del cupón',
          CREDITS_WORD: 'créditos',
          PREFS_SUB: 'Si el crédito está activo.',
          NOT_FOUND: 'No se ha encontrado el crédito de parking.',
          LOAD_ERROR: 'No se ha podido cargar el crédito de parking.',
          GENERAL_INFO: 'Información general',
          OCCUPANCY_TITLE: 'Ocupación del parking',
          OCCUPANCY_SUB: 'Días y turno en los que usa el parking.',
          OCCUPANCY: 'Ocupación',
          ENTRY: 'Entrada',
          EXIT: 'Salida',
          USAGE_TITLE: 'Uso/asistencia del crédito',
          PAID_PARKING: 'Parking de pago',
          USED: 'Usado',
          NOT_USED: 'No usado',
          UNKNOWN: 'Desconocido',
          USED_COLON: 'Usado:',
          NOT_USED_COLON: 'No usado:',
          NO_USAGE: 'No hay datos de uso.',
          CREDITS_COL: 'Créditos',
          USAGE_INSIGHT: 'Se ha usado el {{pct}} % de los créditos de estos {{days}} días.',
          USAGE_LIST_TITLE: 'Uso de créditos de parking',
          USAGE_LIST_SUB: 'Cada día con su crédito y si se usó.',
          USAGE_ITEMS: 'días',
        },
      },
      INCENTIVE_STEPS: {
        OBJECTIVES: {
          PROFILE: 'Completar perfil',
          ROUTINE: 'Crear primera rutina',
          REQUEST: 'Enviar petición',
          MATCH: 'Hacer match',
          TRAVEL: 'Realizar primer viaje',
        },
        CREDIT_TYPES: {
          CREDITS: 'Créditos WAIIS',
          TRAVEL: 'Viajes gratis',
          DISCOUNT: 'Descuentos en trayectos',
          BONUS: 'Bonificación mensual acumulable',
          EMPLOYEE: 'Bonificación por referir compañeros',
          SHARED: 'Bonificación coche compartido con compañeros',
        },
      },
      INCENTIVES_LIST: {
        SEARCH: 'Buscar',
        CREATE: 'Crear incentivo',
        EDIT: 'Editar incentivo',
        COL_TYPE: 'Tipo',
        COL_FUNNEL_OBJECTIVE: 'Objetivo del funnel',
        COL_USERS_REACHED: 'Usuarios alcanzados',
        COL_START_END_DATE: 'Fecha inicio / fin',
        COL_INCENTIVE_TYPE: 'Tipo de incentivo',
        COL_CONVERSIONS: 'Conversiones',
        COL_STATUS: 'Estado',
        BONUS_PERCENTAGE_PER_TRIP: 'Porcentaje por trayecto',
        BONUS_FIXED_PER_TRIP: 'Importe fijo por trayecto',
        BONUS_TOTAL: 'Bonificación total',
      },
      INCENTIVES_ADOPTION: {
        ERROR_TITLE: 'No se ha podido guardar la campaña',
        WHAT_TITLE: '¿Qué son los incentivos?',
        WHAT_TEXT: 'Son recompensas y recordatorios que tu empresa puede activar para motivar a la plantilla a utilizar WAIIS: desde un aviso por email hasta saldo de bienvenida en la app. Elige la mejor acción para cada fase de adopción de tus empleados.',
        CAMPAIGN_TITLE: 'Configura la campaña de incentivos',
        ACTIVE: 'Activada',
        INACTIVE: 'Desactivada',
        EMPLOYEES: 'empleados',
        EMPLOYEE: 'empleado',
        WHAT_TO_SEND: '¿Qué envías a este grupo?',
        SEND_EMAIL: 'Enviar correo',
        SEND_CREDIT: 'Enviar crédito a la app',
        NO_COST: 'Sin coste',
        CUSTOM_AMOUNT: 'Importe personalizado por empleado',
        STAGE_COST: 'Coste de esta etapa',
        PER_EMPLOYEE_X: 'por empleado',
        EMAIL_SEND: 'Envío por correo',
        STAGE_DISABLED: 'Etapa desactivada · no se envía',
        TOTAL_CAMPAIGN_COST: 'Coste total estimado de la campaña',
        SEND_CAMPAIGN: 'Enviar campaña',
        DAYS: 'días',
        INACTIVITY_THRESHOLD: 'Umbral de inactividad',
        INACTIVITY_SAVE_ERROR: 'No se pudo guardar el umbral de inactividad.',
        SENT_TITLE: '¡Campaña enviada!',
        SENT_TEXT_COST: '{{count}} incentivos encolados. Se han cargado {{cost}} € a la wallet corporativa.',
        SENT_TEXT_FREE: '{{count}} incentivos encolados. Sin coste.',
        INSUFFICIENT_BALANCE_TITLE: 'Saldo insuficiente',
        INSUFFICIENT_BALANCE_TEXT: 'La empresa no tiene saldo suficiente para cubrir el coste de la campaña. Recarga la wallet antes de reintentar.',
        GO_TO_WALLET: 'Ir a la wallet',
        SEND_ERROR: 'No se pudo enviar la campaña. Revisa los datos e inténtalo de nuevo.',
        NOT_REGISTERED: 'No se han registrado',
        NOT_REGISTERED_DESC: 'Empleados que aún no tienen cuenta WAIIS vinculada. Envíales un recordatorio por correo para que se den de alta.',
        PENDING_DNI: 'No se han verificado el DNI',
        PENDING_DNI_DESC: 'Empleados con cuenta creada pero con verificación de identidad pendiente. Puedes enviarles un correo de aviso o un crédito de bienvenida.',
        NO_TRIPS: 'No han realizado viajes',
        NO_TRIPS_DESC: 'Empleados registrados y verificados que aún no han hecho ningún trayecto. Motívales con un correo o con crédito en su app.',
        SEG_INACTIVE: 'Inactivos',
        SEG_INACTIVE_DESC: 'Empleados que en su día usaron WAIIS pero llevan más del umbral configurado sin actividad. Reactívales con un recordatorio o un incentivo.',
        PAGE_NAME: 'Incentivos',
        ALL_OFFICES: 'Todos los centros',
        HISTORY_TITLE: 'Historial de campañas',
        HISTORY_EMPTY: 'No hay campañas enviadas aún.',
        HISTORY_STATUS_SENT: 'Enviada',
        HISTORY_STATUS_IN_PROGRESS: 'En curso',
        HISTORY_STATUS_COMPLETED: 'Completada',
        HISTORY_STATUS_CANCELLED: 'Cancelada',
        SEND_CONFIRM_TITLE: '¿Estás seguro de que quieres enviar la campaña?',
        SEND_CONFIRM_TEXT: 'Se lanzarán {{segments}} campaña(s) para {{recipients}} empleados, con {{cost}} € comprometidos de la wallet.',
        SEND_CONFIRM_OK: 'Enviar',
        SENT_SEGMENT_OK: '{{count}} empleados · {{amount}} € comprometidos',
        EMPTY_SEGMENT_ERROR: 'No hay empleados a los que enviar: el segmento está vacío o ya están en otra campaña activa.',
        FEATURE_LOCKED: 'El plan de la empresa no incluye incentivos.',
        CAMPAIGN_NOT_CANCELLABLE: 'La campaña ya está cerrada y no se puede cancelar.',
        RECIPIENT_NOT_CANCELLABLE: 'El empleado ya no está pendiente y no se puede cancelar.',
        DETAIL_COMMITTED: 'Comprometido',
        DETAIL_PAID: 'Abonado',
        RECIPIENTS_TITLE: 'Empleados de la campaña',
        GROUP_CAMPAIGNS: 'Campañas del grupo',
        SEND_SCOPE_ALL: 'Se enviará a los empleados de todas las sedes',
        SEND_SCOPE_OFFICE: 'Se enviará solo a los empleados de {{office}}',
        SEGMENT_UNKNOWN: 'Varios segmentos',
        DETAIL_COMPLETED: 'Completados',
        CANCEL_GROUP: 'Cancelar grupo',
        GROUP_NOT_CANCELLABLE: 'El grupo no tiene ninguna campaña viva que cancelar.',
        CANCEL_GROUP_CONFIRM_TITLE: '¿Cancelar el grupo completo?',
        CANCEL_GROUP_CONFIRM_TEXT: 'Se cancelarán las {{count}} campañas que siguen vivas y se liberará su importe comprometido. Lo ya cobrado no se ve afectado.',
        CANCEL_GROUP_CONFIRM_OK: 'Cancelar grupo',
        CANCEL_GROUP_OK_TITLE: 'Grupo cancelado',
        CANCEL_GROUP_OK_TEXT: '{{count}} campañas canceladas · {{amount}} € liberados.',
        CANCEL_CHILD_CONFIRM_TEXT: 'Se cancelará la campaña de «{{segment}}» y sus {{count}} empleados pendientes.',
        OFFICE: 'Sede',
        SEGMENT_IN_PROGRESS: '{{count}} ya en otra campaña activa',
        RECIPIENTS_EMPTY: 'Todavía no hay empleados en esta campaña.',
        RECIPIENT_EMPLOYEE: 'Empleado',
        RECIPIENT_PAID_AT: 'Abonado el',
        RECIPIENT_STATUS_PENDING: 'Pendiente',
        RECIPIENT_STATUS_COMPLETED: 'Completado',
        RECIPIENT_STATUS_CANCELLED: 'Cancelado',
        CANCEL_REASON_MANUAL: 'Cancelado manualmente',
        CANCEL_REASON_CAMPAIGN: 'Campaña cancelada',
        CANCEL_REASON_UNLINKED: 'Empleado dado de baja',
        CANCEL_CAMPAIGN: 'Cancelar campaña',
        CANCEL_RECIPIENT: 'Cancelar',
        CANCEL_CONFIRM_BACK: 'Volver',
        CANCEL_CAMPAIGN_CONFIRM_TITLE: '¿Cancelar la campaña completa?',
        CANCEL_CAMPAIGN_CONFIRM_TEXT: 'Se cancelarán los {{count}} empleados que siguen pendientes y se liberará su importe comprometido. Los que ya han cobrado no se ven afectados.',
        CANCEL_CAMPAIGN_CONFIRM_OK: 'Cancelar campaña',
        CANCEL_CAMPAIGN_OK_TITLE: 'Campaña cancelada',
        CANCEL_CAMPAIGN_OK_TEXT: 'Se han liberado {{amount}} € comprometidos.',
        CANCEL_RECIPIENT_CONFIRM_TITLE: '¿Cancelar este empleado?',
        CANCEL_RECIPIENT_CONFIRM_TEXT: 'Se cancelará el incentivo de {{email}} y se liberará su importe.',
        CANCEL_RECIPIENT_CONFIRM_OK: 'Cancelar empleado',
        CLOSE: 'Cerrar',
        HISTORY_STATUS_SCHEDULED: 'Programada',
        HISTORY_STATUS_FAILED: 'Fallida',
        HISTORY_DETAIL_TITLE: 'Detalle de campaña',
        HISTORY_DATE: 'Fecha de creación',
        HISTORY_STATUS: 'Estado',
        HISTORY_SENT_AT: 'Fecha de envío',
        HISTORY_SEND_AT: 'Fecha programada',
        HISTORY_RECIPIENTS: 'Destinatarios',
        HISTORY_COST: 'Coste total',
        HISTORY_FAILURE_REASON: 'Motivo del fallo',
        HISTORY_SCHEDULED_INFO: 'Campaña programada — aún no ha sido procesada.',
        HISTORY_SEGMENT: 'Segmento',
        HISTORY_CHANNEL: 'Canal',
        HISTORY_AMOUNT: 'Importe / empleado',
      },
      INCENTIVE_FORM: {
        SELECTION: 'Selección',
        PREVIOUS: 'Anterior',
        CONTINUE: 'Continuar',
        SAVE: 'Guardar',
        SUCCESS_TITLE: '¡Correcto!',
        UPDATED_SUCCESS: 'Incentivo actualizado correctamente',
        CREATED_SUCCESS: 'Incentivo creado correctamente',
        ERROR_TITLE: 'Error',
        EDIT_TITLE: 'Editar incentivo',
        CREATE_TITLE: 'Crear incentivo',
        TABS: {
          OBJECTIVES: 'Objetivos',
          TYPES: 'Tipos',
          ACTIVATION: 'Activación',
          DURATION: 'Duración',
          COMMUNICATION: 'Comunicación',
          BONUSES: 'Bonificaciones',
        },
      },
      INCENTIVE_DETAILS: {
        BACK: 'Volver',
        TITLE: 'Detalles del incentivo',
        TYPE: 'Tipo',
        OBJECTIVE: 'Objetivo',
        INCENTIVE_TYPE: 'Tipo de incentivo',
        ACTIVATION: 'Activación',
        START_END_DATE: 'Fecha inicio / fin',
        COMMUNICATION: 'Comunicación',
        BASIC_INFO: 'Información básica',
        BONUS_TYPE: 'Tipo de bonificación',
        AMOUNT: 'Importe',
      },
      SUSTAINABILITY: {
        REPORT_TITLE: 'Informe de sostenibilidad',
        REPORT_DETAILS: 'Detalles del informe',
        REPORT_SUB: 'Datos reales de uso, actualizados cada mes.',
        REPORT_SUB_SAMPLE: 'Datos de ejemplo: así se vería con tu plantilla en marcha.',
        PERIOD: 'Periodo:',
        CO2_AVOIDED_IN: 'CO₂e evitado en {{period}}',
        CO2_AVOIDED_DESC: 'CO₂e evitadas por el carpooling de tus empleados en {{period}}.',
        ACCUMULATED: 'Acumulado {{year}} · {{range}}',
        ACCUMULATED_SUB: 'CO₂e evitadas en lo que va de año',
        ACCUMULATED_FOOT: 'Total del año, independiente del mes seleccionado.',
        IMPACT_EQUIVALENCES: 'Equivalencias de impacto',
        TREES_YEAR: '{{n}} árboles/año',
        TREES_DESC: 'Equivalente a lo que absorberían en un año.',
        KM: '{{n}} km',
        KM_DESC: 'Recorridos en solitario que se han evitado.',
        OCCUPANTS: '{{n}} ocupantes',
        OCCUPANTS_DESC: 'Media de personas por vehículo compartido.',
        TITLE: 'Sostenibilidad',
        ALL_OFFICES: 'Todos los centros',
        MOCK: 'Mock',
        MOCK_ACTIVE: 'Mock Activo',
        SELECT_MONTH_YEAR: 'Seleccionar mes y año',
        TOTAL_CARBON_FOOTPRINT: 'Huella de Carbono Total',
        COMPANY_WORKERS: 'Trabajadores de la Empresa',
        SUM_EMISSIONS_GENERATED: 'Suma de las emisiones generadas',
        SUSTAINABLE_MOBILITY_SAVINGS: 'Ahorro de Movilidad Sostenible',
        THIS_MONTH_SAVED: 'Este mes has ahorrado',
        EQUIVALENT_TREES: '<strong>{{count}} árboles</strong> plantados',
        EQUIVALENT_FLIGHTS:
          '<strong>{{count}} vuelos</strong> Madrid-Barcelona evitados',
        EQUIVALENT_LED_HOURS:
          '<strong>{{hours}} horas</strong> de bombilla LED encendida',
        EQUIVALENT_MOBILE_CHARGES:
          '<strong>{{charges}} cargas</strong> de móvil completas',
        FOOTPRINT_BY_OFFICE: 'Huella por Oficina',
        EMISSIONS_BY_WORK_CENTER: 'Emisiones por centro de trabajo',
        FOOTPRINT_BY_DEPARTMENT: 'Huella por Departamento',
        EMISSIONS_BY_DEPARTMENT: 'Emisiones por departamento',
        NO_DATA: 'No hay datos disponibles para este período',
        MONTHLY_ECONOMIC_COST: 'Coste Económico Mensual',
        ESTIMATED_TRIPS: 'Estimado de los trayectos',
        TRAVEL_ALONE: 'Viajan solos',
        CARPOOL: 'Comparten coche',
        PEOPLE_COUNT: '<strong>{{count}} personas</strong>',
        TOTAL_COST: 'Coste total: <strong>{{cost}} €</strong>',
        AVERAGE_COST_MONTH:
          'Coste medio: <strong class="text-warning">{{cost}} €/mes</strong>',
        CARBON_FOOTPRINT: 'Huella de Carbono',
        MONTHLY_ESTIMATED: 'Estimada mensualmente',
        TOTAL_EMISSIONS_MONTHLY:
          'Emisiones totales: <strong>{{emissions}} kg CO₂/mes</strong>',
        EMISSIONS_PER_PERSON:
          'Emisiones por persona: <strong class="text-info">{{emissions}} kg/persona</strong>',
        FOOTPRINT_BY_WORKER: 'Huella por Trabajador',
        INDIVIDUAL_EMISSIONS_LINKED:
          'Emisiones individuales vinculadas a trayectos realizados',
        SEARCH_BY_WORKER: 'Buscar por trabajador',
        WORKER: 'Trabajador',
        DISTANCE_TRAVELED: 'Distancia recorrida',
        TRANSPORT_MODE: 'Modo de transporte utilizado',
        EMISSION_FACTOR: 'Factor de emisión aplicado',
        EMISSION_SAVINGS: 'Ahorro de emisiones',
      },
      TRAVEL: {
        ALL: 'Todos',
        MOCK: 'Mock',
        MOCK_ACTIVE: 'Mock Activo',
        SELECT_MONTH_YEAR: 'Selecciona mes y año',
        TRAVELS: 'Viajes',
        DISTANCE_DURATION_BY_USER: 'Distancia y duración por usuario',
        ROUTINES_CREATED: 'Rutinas creadas',
        TRAVEL_HOURS: 'Viajes por hora del día',
        TRAVEL_DAYS: 'Viajes por día de la semana',
        KM_WITH_PASSENGER: 'Km recorridos con ≥1 pasajero',
        AVG_PASSENGERS_PER_CAR: 'Media de pasajeros por coche',
        USER_ADDRESSES: 'Direcciones de los usuarios',
        NO_DATA: 'No hay datos disponibles',
        LOADING: 'Cargando...',
        // Descripciones de estadísticas
        DRIVERS: 'Conductores',
        PASSENGERS: 'Pasajeros',
        // Columnas de tabla de viajes
        DATE: 'Fecha',
        DRIVER: 'Conductor',
        PASSENGER: 'Pasajero',
        PRICE: 'Precio',
        DESTINATION: 'Destino',
        // Columnas de tabla de distancia y duración
        NAME: 'Nombre',
        AVERAGE_DISTANCE: 'Distancia Media',
        AVERAGE_DURATION: 'Duración Media',
        TRIPS: 'Viajes',
        // Columnas de tabla de rutinas
        ORIGIN: 'Origen',
        ROUTINES: 'Rutinas',
        USERS: 'Usuarios',
        // Etiquetas de gráficas
        HOURS: 'Horas',
        DAY: 'Día',
        // Mensajes de DataTables
        INFO: 'Mostrando _START_ a _END_ de _TOTAL_ registros',
        INFO_EMPTY: 'Mostrando 0 a 0 de 0 registros',
        INFO_FILTERED: '(filtrado de _MAX_ registros totales)',
        // Días de la semana
        MONDAY: 'Lunes',
        TUESDAY: 'Martes',
        WEDNESDAY: 'Miércoles',
        THURSDAY: 'Jueves',
        FRIDAY: 'Viernes',
        SATURDAY: 'Sábado',
        SUNDAY: 'Domingo',
      },
      FUNNEL: {
        ERROR_DATE_RANGE: 'La fecha de inicio no puede ser mayor que la fecha de fin',
        ERROR_LOAD: 'Error al cargar los datos',
        PDF_CATEGORY: 'Categoría',
        PDF_VALUE: 'Valor',
        TITLE: 'Funnel',
        COMPANY_FALLBACK: 'Empresa',
        MOCK: 'Datos de prueba',
        MOCK_ACTIVE: 'Datos de prueba (activo)',
        OFFICE: 'Sede:',
        ALL_OFFICES: 'Todos los centros',
        START_DATE: 'Fecha de inicio:',
        END_DATE: 'Fecha de fin:',
        LOAD: 'Cargar',
        LOADING: 'Cargando...',
        COMPARATIVE: 'Comparativa',
        LEGEND_GLOBAL: 'Global',
        LEGEND_COMMERCIAL: 'Comercial',
        LEGEND_COMPANY: 'Empresa',
        FILTER_GLOBAL: 'Global',
        FILTER_COMMERCIAL: 'Comercial',
        FILTER_COMPANY: 'Empresa',
        PRESETS: {
          LAST_7_DAYS: 'Últimos 7 días',
          LAST_30_DAYS: 'Últimos 30 días',
          LAST_90_DAYS: 'Últimos 90 días',
          THIS_YEAR: 'Este año',
          CUSTOM: 'Rango personalizado',
        },
        STAGES: {
          REGISTERED: 'Registrados',
          LINKED: 'Vinculados',
          WITH_ROUTINE: 'Con rutina',
          REQUEST_SENT_OR_RECEIVED: 'Petición enviada o recibida',
          SHARING: 'Compartiendo',
          TRIP_COMPLETED: 'Viaje realizado',
          SHARED_TRIP: 'Viaje compartido',
          RECURRENT: 'Recurrentes',
          TOTAL_USERS: 'Total usuarios',
          TOTAL_USERS_WITH_ROUTINE: 'Total usuarios con rutina',
          TOTAL_USERS_ROUTINE_COMPLETED: 'Total usuarios con rutina completada',
          TOTAL_USERS_ROUTINE_SHARED_COMPLETED:
            'Total usuarios con rutina compartida completada',
        },
        STAGE_HINTS: {
          '0': 'Empleados dados de alta',
          '1': 'Han creado una ruta recurrente',
          '2': 'Han completado al menos un viaje (solo o compartido)',
          '3': 'Han compartido al menos un viaje',
          '4': '3 o más viajes compartidos',
        },
        BASE: 'base {{percent}}',
        VS_PREVIOUS_MONTH: 'vs periodo ant.',
        DROP: 'caída',
        EMPLOYEES: 'empleados',
        BIGGEST_LOSS: 'mayor pérdida',
        COMING_SOON: 'Próximamente',
        NO_DATA: 'No hay datos de funnel para el periodo seleccionado.',
        MANAGE_INCENTIVES: 'Gestionar incentivos',
        SEND_COMMUNICATION: 'Enviar comunicación a este grupo',
        INSIGHT: {
          TITLE: 'El mayor abandono está entre «{{from}}» y «{{to}}» (−{{percentage}}).',
          DESCRIPTION:
            'Es el punto exacto donde conviene activar incentivos: solo {{converted}} de los {{base}} empleados que ya pasaron por esta etapa llegan a {{toStage}}. Convertir a este grupo es la palanca más rentable para subir la adopción de uso.',
        },
      },
      COMMON: {
        GENERATING_PDF: 'Generando PDF, por favor espera...',
        LOADING: 'Cargando...',
        ACCEPT: 'Aceptar',
        CANCEL: 'Cancelar',
        SAVE: 'Guardar',
        FILTERS: 'Filtros',
        CLOSE: 'Cerrar',
        SELECT_DATE: 'Selecciona una fecha',
        APPLY_FILTERS: 'Aplicar filtros',
        CLEAR: 'Limpiar',
        EXPORT_CSV: 'Exportar CSV',
        IMPORT_CSV: 'Importar CSV',
        ACTIVE: 'Activo',
        WAIT: 'Espera..',
        BASIC_INFO: 'Información básica',
        FISCAL_ADDRESS: 'Dirección Fiscal',
        ADDRESS: 'Dirección',
        CITY: 'Ciudad',
        POSTAL_CODE: 'Código postal',
        OFFICE_NAME: 'Nombre de la sede',
        OFFICE_NAME_REQUIRED: 'El nombre fiscal es requerido',
        CONTACT_PERSON: 'Persona de contacto',
        CONTACT_PERSON_REQUIRED: 'La persona de contacto es requerida',
        CONTACT_PHONE: 'Telefono de contacto',
        CONTACT_PHONE_REQUIRED: 'El telefono es requerido',
        CONTACT_EMAIL: 'Email de contacto',
        CONTACT_EMAIL_REQUIRED: 'El email es requerido',
        ADDRESS_REQUIRED: 'La dirección es requerida',
        CITY_REQUIRED: 'La ciudad es requerida',
        POSTAL_CODE_REQUIRED: 'El código postal es requerido',
        USER: 'Usuario',
        USER_REQUIRED: 'Usuario es requerido',
        LICENSE_PLATE: 'Matrícula',
        LICENSE_PLATE_REQUIRED: 'La matricula es requerido',
        OFFICE: 'Sede',
        OFFICE_REQUIRED: 'Sede es requerido',
        SHIFT: 'Turno',
        SHIFT_REQUIRED: 'El turno es requerido',
        RESERVED_DAYS: 'Dias Reservados',
        RESERVED_DAYS_REQUIRED: 'Los días son requeridos',
        START_DATE: 'Fecha Inicio',
        END_DATE: 'Fecha Fin',
        DATETIME_PLACEHOLDER: 'Selecciona fecha y hora',
        CORRECT: 'Correcto',
        ERROR_BANG: 'Error!',
      },
      PARKING_REPORT: {
        WEEK_N: 'Semana {{n}}',
        TOTAL_PARKING_SPACES: 'Total plazas parking',
        AVAILABLE_SPACES: 'Plazas disponibles',
        OCCUPIED_SPACES: 'Plazas ocupadas',
        SELECT_MONTH_YEAR: 'Selecciona mes y año',
        OWN_COMPANY_PARKING: 'Parking propio empresa',
        OCCUPATION: 'Ocupación',
        DAY: 'Día',
        WEEK: 'Semana',
        MONTH: 'Mes',
        PAID_PARKING: 'Parking de pago',
        CREDIT_USE_AND_COST: 'Uso y coste de crédito',
        PARKING_SPACES_USAGE: 'Uso de las plazas de parking',
        TOTAL_PARKING_SPACES_LABEL: 'Total plazas de parking',
        PARKING_SPACES_ALLOCATION: 'Asignación de plazas de parking',
        TOTAL_USERS: 'Total usuarios',
        MORNING_SHIFT: 'Turno mañana',
        AFTERNOON_SHIFT: 'Turno tarde',
        PARKING_CREDIT: 'Crédito Parking',
        SHARED: 'Compartido',
        INDIVIDUAL: 'Individual',
        USERS_WITH_ALLOCATED_SPACES: 'Usuarios con plazas asignadas',
        USERS_WITHOUT_ALLOCATED_SPACES: 'Usuarios sin plazas asignadas',
      },
      USAGE_REPORT: {
        USAGE: 'Uso',
        ALL_CENTERS: 'Todos los centros',
        LAST_7_DAYS: 'Últimos 7 días',
        LAST_30_DAYS: 'Últimos 30 días',
        LAST_90_DAYS: 'Últimos 90 días',
        LAST_YEAR: 'Último año',
        TOP_CARPOOLERS: 'Top carpoolers del periodo',
        TOP_CARPOOLERS_SUBTITLE:
          'El #1 es quien más km ha conducido con pasajeros, detectado automáticamente por la app.',
        EMPLOYEE: 'EMPLEADO',
        OFFICE: 'SEDE',
        KM_WITH_PASSENGERS: 'KM CON PASAJEROS',
        KM_DRIVEN_TOTAL: 'KM CONDUCIDOS (TOTAL)',
        TRIPS: 'TRAYECTOS',
        KM: 'km',
        LOADING: 'Cargando estadísticas...',
        LOAD_ERROR_TEXT: 'No se han podido cargar las estadísticas',
        LOAD_ERROR_MESSAGE: 'Error al cargar las estadísticas de uso',
        ACTIVE_USERS_BREAKDOWN: 'Desglose de usuarios activos',
        DAU: 'Usuarios activos hoy (DAU)',
        WAU: 'Activos esta semana (WAU)',
        MAU: 'Activos este mes (MAU)',
        SHARED_TRIPS_MONTH: 'Trayectos compartidos este mes',
        ACTIVE_USERS_PERIOD: 'Activos en el periodo',
        SHARED_TRIPS_PERIOD: 'Trayectos compartidos en el periodo',
        ACTIVE_USERS: 'Usuarios activos',
        DRIVERS: 'Conductores',
        PASSENGERS: 'Pasajeros',
        COMPLETED_TRIPS: 'Trayectos realizados',
      },
      CONVERSION_REPORT: {
        ROUTE_OUTBOUND: 'Ida',
        ROUTE_RETURN: 'Vuelta',
        ROUTE_ROUND_TRIP: 'Ida y vuelta',
        SELECT_MONTH_YEAR: 'Selecciona mes y año',
        INDICATORS: 'Indicadores',
        INDICATOR: 'INDICADOR',
        INTERPRETATION: 'INTERPRETACIÓN',
        NUMBER_OF_USERS: 'NÚMERO USUARIOS',
        SMART_SURVEY: 'Encuesta inteligente',
        RESPONSES_BY_INDICATOR: 'Respuestas según indicador',
        MOST_COMMON_REASONS: 'Razones mas comunes para no compartir vehículo',
        STATS: {
          ACTIVE_USERS: 'Usuarios activos',
          CONVERSION_RATE_CARPOOLING: 'Tasa de conversión a carpooling',
          AVG_DAYS_FIRST_MATCH: 'Media de días hasta el primer match',
          REJECTED_MATCHES: 'Matches rechazados',
        },
        INDICATORS_LIST: {
          REJECTS_ALL_MATCHES: 'Rechaza todos los matches',
          NEVER_CREATES_TRIPS: 'Nunca crea trayectos',
          LIVES_IN_AREA_WITHOUT_USERS: 'Vive en zona sin otros usuarios cerca',
          USERS_WITH_WORST_RATINGS: 'Usuarios con peores ratings',
          USERS_WITH_COMPLAINTS: 'Usuarios con quejas',
          USERS_WITH_LOW_ROUTINE_LOYALTY: 'Usuarios con baja fidelidad en rutina',
          USERS_WITHOUT_PERMISSIONS: 'Usuarios sin permisos activados',
          USERS_WITH_HIGH_CANCELLATION: 'Usuarios alta tasa de cancelación',
        },
        INTERPRETATIONS: {
          DISTRUST_LACK_OF_INTEREST: 'Desconfianza / falta de interés',
          DOES_NOT_UNDERSTAND_UTILITY: 'No entiende la utilidad o interfaz poco clara',
        },
        RESPONSES: {
          SCHEDULE_CHANGES: 'Mis horarios cambian mucho',
          NOBODY_NEARBY: 'Nadie cerca de mi zona',
          PREFER_ALONE: 'Prefiero ir solo',
          DID_NOT_KNOW: 'No sabía que podía hacerlo',
          OTHER_REASON: 'Otro motivo',
        },
        REASONS: {
          VERY_SHY: 'Soy muy tímid@',
          NOT_CONVENIENT: 'No me viene bien',
          CHILDREN_TO_SCHOOL: 'Debo llevar a mis hijos al colegio',
          UNCOMFORTABLE_WITH_STRANGER: 'Me da apuro no conocer al acompañante',
          OTHER_REASONS: 'Otros motivos',
        },
        USERS_LABEL: 'usuarios',
      },
      USER_LIST: {
        EMPLOYEES: 'Empleados',
        STAFF: 'Plantilla',
        GROUPS: 'Grupos',
        COMING_SOON: 'Próximamente',
        ALL_CENTERS: 'Todos los centros',
        LAST_7_DAYS: 'Últimos 7 días',
        LAST_30_DAYS: 'Últimos 30 días',
        LAST_90_DAYS: 'Últimos 90 días',
        LAST_YEAR: 'Último año',
        DECLARED_STAFF: 'Plantilla declarada',
        REGISTERED_IN_WAIIS: 'Vinculados en WAIIS',
        REGISTRATION_OF_STAFF: 'Registro (de la plantilla)',
        ACTIVE_IN_USE_CARPOOLING: 'Activos en uso (carpooling)',
        SEARCH_NAME_OR_EMAIL: 'Buscar nombre o email',
        UPLOAD_CSV: 'Subir CSV',
        ADD_MANUAL: 'Añadir manual',
        LINK_USERS: 'Vincular usuarios',
        ADD_INVITE_EMPLOYEES: 'Añadir empleados',
        PARTNER_MANAGED_CHIP: 'Altas gestionadas por {{partner}}',
        PARTNER_EMPTY_TITLE: 'Tu plantilla aparecerá aquí',
        PARTNER_EMPTY_TEXT: '{{partner}} da de alta a tus empleados. Aquí verás quién se registra y quién usa la app.',
        ADD_INVITE_EMPLOYEES_MODAL_TITLE: 'Añadir o invitar empleados',
        CREATE_USER: 'Crear usuario',
        ALL: 'Todos',
        ACTIVE: 'Activo',
        REGISTERED: 'Registrado',
        UNREGISTERED: 'Sin registrar',
        STATUS_WITH_ROUTINE: 'Con rutina',
        STATUS_LINKED: 'Vinculado',
        STATUS_INACTIVE_FILTER: 'Inactivo',
        STATUS_PENDING: 'Pendiente de aceptar',
        STATUS_REJECTED: 'Rechazado',
        EMPLOYEE_GROUPS: 'Grupos de empleados',
        EMPLOYEE_GROUPS_SUBTITLE:
          'Organiza empleados y asígnales políticas de ride-hailing por colectivo.',
        CREATE_GROUP: 'Crear grupo',
        GROUP_NAME: 'Nombre del grupo',
        LINKED_POLICIES: 'Políticas vinculadas',
        EDIT: 'Editar',
        DELETE: 'Eliminar',
        ACTIVE_LABEL: 'Activo',
        NAME: 'Nombre',
        SURNAME: 'Apellidos',
        EMAIL: 'Email',
        DEPARTMENT: 'Departamento',
        OFFICE: 'Sede',
        SHIFT: 'Turno',
        FIELD_REQUIRED: 'Este campo es obligatorio',
        EMAIL_FORMAT_ERROR: 'Introduce un email válido, p. ej. nombre@empresa.com',
        DNI: 'DNI',
        PERSONAL_EMAIL: 'Email personal',
        PHONE: 'Teléfono',
        PHONE_FORMAT_ERROR: 'Incluye el prefijo del país, p. ej. +34600000000',
        COMPANY_PHONE: 'Tel. empresa',
        PARKING_PLACE: 'Plaza parking',
        LOADING: 'Cargando...',
        CANCEL: 'Cancelar',
        ACCEPT: 'Aceptar',
        WAIT: 'Espera..',
        IMPORT_CSV_BY_OFFICE: 'Importar CSV por sede',
        LINK_USERS_BY_OFFICE: 'Vincular usuarios por sede',
        CSV_FILE: 'Archivo CSV',
        DOWNLOAD_TEMPLATE: 'Descargar plantilla de ejemplo',
        DOWNLOADING_TEMPLATE: 'Descargando plantilla...',
        IMPORT: 'Importar',
        LINK: 'Vincular',
        EDIT_USER: 'Editar Usuario',
        CREATE_USER_TITLE: 'Crear Usuario',
        COLUMN_EMPLOYEE: 'Empleado',
        EMPTY_FILTERED: 'No hay empleados con ese filtro',
        COLUMN_OFFICE_AREA: 'Sede · Área',
        COLUMN_STATUS: 'Estado',
        STATUS_ACTIVE: 'Activo',
        STATUS_INACTIVE: 'Inactivo',
        SELECT_OFFICE_ALERT: 'Debes seleccionar una sede',
        SEARCH_EMPLOYEE: 'Buscar empleado',
        CLEAR_SEARCH: 'Borrar búsqueda',
        NO_OFFICES: 'No hay sedes disponibles',
        OFFICES_LOAD_ERROR: 'No se han podido cargar las sedes',
        RETRY: 'Reintentar',
        SUCCESS_TITLE: '¡Correcto!',
        USER_UPDATED: '¡Usuario actualizado correctamente!',
        USER_CREATED: '¡Usuario creado correctamente!',
        ERROR_TITLE: 'Error!',
        CONFIRM_BUTTON: 'Aceptar',
        LINK_SUCCESS: 'La vinculación de usuarios se ha realizado correctamente',
        DELETE_SUCCESS: 'El empleado se ha eliminado correctamente',
        IMPORT_SUCCESS: 'La importación de usuarios se ha realizado correctamente',
        LINK_ERROR: 'Ha ocurrido un error en la vinculación de usuarios',
        IMPORT_ERROR: 'Ha ocurrido un error en la importación de usuarios',
        CSV_INVALID_EXTENSION: 'El archivo debe ser un CSV (.csv)',
        CSV_INVALID_HEADERS: 'El archivo no coincide con la plantilla. Descárgala de nuevo y no cambies el nombre ni el orden de las columnas.',
        CSV_MODAL_TITLE: 'Subir CSV',
        CSV_MODAL_SUB: 'Con la plantilla: una fila por empleado. Antes de importar ves cuántas filas valen.',
        CSV_DROP: 'Arrastra aquí tu CSV',
        CSV_DROP_HINT: 'o haz clic para elegirlo. Columnas de la plantilla: name, surname, dni, email, phone, department.',
        CSV_DROP_CHANGE: 'Arrastra otro o haz clic para cambiarlo.',
        CSV_VALID_ROW: '1 fila válida',
        CSV_VALID_ROWS: '{{count}} filas válidas',
        CSV_INVALID_ROW: '1 fila con errores no se importará (línea {{lines}}). Necesita nombre, apellidos, departamento y DNI, correo o teléfono.',
        CSV_INVALID_ROWS: '{{count}} filas con errores no se importarán (líneas {{lines}}). Necesitan nombre, apellidos, departamento y DNI, correo o teléfono.',
        CSV_PREVIEW_NAME: 'Nombre',
        CSV_PREVIEW_EMAIL: 'Correo',
        CSV_MORE_ROWS: '+ {{count}} más',
        CSV_EMPTY: 'El archivo está vacío',
        ITEMS_USERS: 'usuarios',
        ITEMS_EMPLOYEES: 'empleados',
        EMAIL_PLACEHOLDER: 'nombre@empresa.com',
        MOCK_GROUPS: {
          EXECUTIVES: 'Ejecutivos',
          EXECUTIVES_DESC: 'Alta dirección y C-level',
          MANAGERS: 'Managers',
          MANAGERS_DESC: 'Responsables de área y project managers',
          OPERATIONS: 'Operaciones',
          OPERATIONS_DESC: 'Equipo de operaciones y turno de noche',
          GENERAL: 'General',
          GENERAL_DESC: 'Empleados sin grupo específico asignado',
          POLICY_BUSINESS: 'Viajes de negocio',
          POLICY_NIGHT: 'Turno de noche',
          POLICY_COMMUTE: 'Commute diario',
        },
      },
      USER_DETAILS: {
        LOADING: 'Cargando...',
        BACK: 'Volver',
        EMPLOYEES: 'Empleados',
        EMPLOYEE_INFO: 'Información del empleado',
        PAYMENTS: 'Pagos',
        TRIPS: 'Viajes',
        SUCCESS_RATE: 'Porcentaje de éxito',
        COMPLETE_PROFILE: 'Completar perfil',
        PROFILE_DETAILS: 'Detalles del perfil',
        ID: 'ID',
        NAME_AND_SURNAME: 'Nombre y Apellidos',
        DNI: 'DNI',
        EMAIL: 'Email',
        PHONE: 'Teléfono',
        CONTACT_PHONE: 'Teléfono de contacto',
        CONTACT_PHONE_TOOLTIP: 'Número asociado al usuario',
        OFFICE: 'Sede',
        DEPARTMENT: 'Departamento',
        DEPARTMENT_TOOLTIP: 'Departamento de la empresa',
        SHIFT: 'Turno',
        ROLE: 'Rol',
        ORIGIN: 'Origen',
        DESTINATION: 'Destino',
        PARKING: 'Parking',
        LINKED: 'Vinculación',
        ROUTINE_STATUS: 'Estado rutina',
        VERIFIED: 'Verificado',
        UNKNOWN: 'Desconocido',
      },
    },
    USER: {
      INNER: {
        SIGN_OUT: 'Cerrar sesión',
        DASHBOARD_COMPANY: 'Dashboard Empresa',
        DASHBOARD_ADMIN: 'Dashboard Administrador',
        LANGUAGE: 'Idioma',
      },
      TRIPS_COLUMNS: {
        BUTTON: 'Columnas',
        TITLE: 'Columnas visibles',
        ROUTE: 'Trayecto',
        ROLE: 'Rol',
        ROUTINE: 'Rutina',
        STATUS: 'Estado',
        FOOTPRINT: 'Huella',
        FRAUD: 'Fraude',
        HIDDEN_ONE: '1 oculta',
        HIDDEN_MANY: '{{count}} ocultas',
        RESET: 'Restablecer',
      },
    },
    SUPPORT_MESSAGE: {
      SHOW_MESSAGE: 'Ver mensaje',
      HIDE_MESSAGE: 'Ocultar mensaje',
      LANG_LABEL: 'Idioma del mensaje',
      SHOW_ALL: 'Ver todo',
      SHOW_LESS: 'Ver menos',
    },
    PRICING_EXPLAINER: {
      BUTTON: '¿Cómo se calcula?',
      TITLE: 'Cómo se calcula el precio',
      LOADING: 'Cargando valores…',
      ERROR: 'No se han podido cargar los valores actuales.',
      RETRY: 'Reintentar',
      PRICE: 'Precio del viaje: {{perKm}} ct/km hasta 200 km, con un mínimo de {{fixed}} €. A partir de 200 km se suman {{from200}} ct/km (desde 400 km, {{from400}}; desde 600 km, {{from600}}).',
      CAE: 'Bono CAE: {{perKm}} ct/km (máx. 200 km). En viajes sin coste para el pasajero, {{withoutCost}} ct/km. Máximo {{maxTrips}} viajes al día con bono.',
      COMMISSION: 'Comisión WAIIS: {{single}} % en viajes puntuales; {{firstMonth}} % el primer mes de una rutina y {{longTerm}} % después, + IVA {{tax}} % sobre la comisión.',
      FORMULA: 'Paga el pasajero = precio − bono CAE y ayudas + comisión. El conductor recibe el precio del viaje. Si el viaje se queda sin CAE (app competidora o verificación facial no superada), recibe lo que pagan los pasajeros menos la comisión.',
      TIMING: 'Se cobra {{chargeHours}} h antes de la salida del conductor; plazo para pagar hasta {{blockHours}} h antes.',
      THIS_TRIP: 'En este viaje:',
      TRIP_KM: '{{km}}',
      TRIP_PRICE: 'precio {{amount}}',
      TRIP_CAE: 'bono CAE {{amount}}',
      TRIP_COMMISSION_NO_PERCENT: 'comisión {{amount}}',
    },
    // Detalle de un viaje (/travel/:id): pooling-route-detail y su página.
    TRIP_DETAIL: {
      APP_SHOWS_VERIFYING: "En la app: «Verificando»",
      APP_VERIFYING_HINT: "El viaje está verificado, pero el conductor aún no ha cobrado (abono aplazado por retraso de caja o por verificación reforzada). Hasta que cobre, la app les muestra «Verificando» al conductor y a los pasajeros.",
      LOADING: 'Cargando trayecto…',
      RETRY: 'Reintentar',
      ERROR_TIMEOUT: 'El servidor no ha respondido a tiempo. Inténtalo de nuevo.',
      ERROR_LOAD: 'No se ha podido cargar el trayecto.',
      PAGE: {
        BREADCRUMB_ARIA: 'Ruta de navegación',
        PARENT: 'Gestión de actividad',
        TRIPS: 'Viajes',
        TRIP: 'Viaje',
        USERS: 'Usuarios',
        USER: 'Ficha del usuario',
        BACK: 'Volver',
      },
      HEAD: {
        ROUTE_OF: 'Ruta de',
        DATE: 'Fecha',
        DEPARTURE: 'Salida',
        DISTANCE: 'Distancia',
        PARTICIPANTS: 'Participantes',
        COPY_ID: 'Copiar ID',
        ID_COPIED: 'ID copiado',
        SHOW_TECH: 'Ver detalles técnicos',
        HIDE_TECH: 'Ocultar detalles técnicos',
        ZONES: 'Zonas',
        ZONES_TEXT: '0–35 aceptar · 36–55 step-up · 56–74 revisión · 75–100 rechazar',
        DRIVER_ONE: '1 conductor',
        PASSENGERS_ONE: '1 pasajero',
        PASSENGERS_MANY: '{{n}} pasajeros',
      },
      STATUS: {
        pending: 'Pendiente de verificar',
        in_progress: 'En curso',
        completed: 'Completado',
        cancelled: 'Cancelado',
        verified: 'Verificado',
        rejected: 'Rechazado',
        in_review: 'En revisión',
        enhanced_review: 'En revisión',
        SCHEDULED: 'Programado',
      },
      VERDICT: {
        UPCOMING: 'Viaje programado · aún no se ha hecho, se verificará después',
        IN_REVIEW: 'En revisión · el dinero está retenido',
        NEEDS_REVIEW_ONE: 'Necesita revisión · falta verificar a 1 persona',
        NEEDS_REVIEW_MANY: 'Necesita revisión · faltan {{n}} personas por verificar',
        REJECTED_BY_SUPPORT: 'Rechazado por soporte',
        REJECTED_PART_ONE: '1 persona rechazada automáticamente',
        REJECTED_PART_MANY: '{{n}} personas rechazadas automáticamente',
        REJECTED_AUTO: 'Rechazado automáticamente',
        ALL_VERIFIED: 'Todo verificado · no requiere acción',
        VERIFIED_PAYOUT_HELD: 'Verificado · el conductor aún no ha cobrado',
        VERIFIED_PAYOUT_HELD_UNTIL: 'Verificado · el conductor cobra el {{date}}',
      },
      KPI: {
        ARIA: 'Indicadores del viaje',
        VERIFICATION: 'Verificación',
        VERIFICATION_HINT: 'Huella GPS de cada persona del viaje',
        VERIFIED_PEOPLE: 'personas verificadas',
        COPRESENCE: 'Co-presencia',
        COPRESENCE_HINT: 'Solape de las huellas GPS',
        COPRESENCE_LOW: 'baja (menos del 70%)',
        COPRESENCE_OK: 'suficiente',
        RISK: 'Riesgo de fraude',
        RECOMMENDATION: 'Recomendación: {{action}}',
        ZONE_ACCEPT: 'Aceptar',
        ZONE_STEPUP: 'Step-up',
        ZONE_REVIEW: 'Revisión',
        ZONE_REJECT: 'Rechazar',
      },
      RISK: {
        LOW: 'Riesgo bajo',
        MODERATE: 'Riesgo moderado',
        HIGH: 'Riesgo alto',
        VERY_HIGH: 'Riesgo muy alto',
        NOT_CALCULATED: 'Riesgo sin calcular',
        ACTION_ACCEPT: 'Aceptar',
        ACTION_STEPUP: 'Pedir verificación extra',
        ACTION_REVIEW: 'Revisar a mano',
        ACTION_REJECT: 'Rechazar',
      },
      MAP: {
        TITLE: 'Mapa del trayecto y huellas GPS',
        COPRESENCE_BADGE: 'Co-presencia {{value}}',
        COPRESENCE_CAPTION_LOW: 'Co-presencia {{value}} confirmada (<70% → revisión).',
        COPRESENCE_CAPTION_OK: 'Co-presencia {{value}} suficiente (≥70%).',
        LAYER_TRACE: 'Trayecto real (GPS)',
        LAYER_REFERENCE: 'Ruta teórica del conductor emparejado',
        LAYER_FOOTPRINT: 'Huella · {{name}}',
        WINDOW_TITLE: 'Ventana de huella mostrada',
        WINDOW_HINT: 'Acota, por persona, el tramo de la huella GPS ya cargada (±2h del recorrido teórico) que se dibuja en el mapa.',
        SHOW_DETAIL: 'Ver detalle',
        HIDE: 'Ocultar',
        DRIVER_WINDOW_START: 'Inicio de la ventana del conductor',
        DRIVER_WINDOW_END: 'Fin de la ventana del conductor',
        WINDOW_START: 'Inicio de la ventana de {{name}}',
        WINDOW_END: 'Fin de la ventana de {{name}}',
        RESET_WINDOW: 'Restablecer ventana completa',
        ORIGIN: 'Origen',
        DESTINATION: 'Destino',
        PICKUP: 'Recogida · {{name}}',
        DROPOFF: 'Bajada · {{name}}',
        PASSENGER_FALLBACK: 'pasajero',
        LOADING: 'Cargando mapa…',
        LOAD_ERROR: 'No se ha podido cargar el mapa.',
      },
      ROLE: {
        DRIVER: 'Conductor',
        PASSENGER: 'Pasajero',
      },
      UNVERIFIED: {
        TITLE_ONE: 'Falta verificar a 1 persona',
        TITLE_MANY: 'Falta verificar a {{n}} personas',
        TITLE_WHY: 'Por qué no se ha verificado',
        VERIFIED_OK_ONE: '1 persona verificada sin problemas',
        VERIFIED_OK_MANY: '{{n}} personas verificadas sin problemas',
        PENDING_ONE: '1 pendiente',
        PENDING_MANY: '{{n}} pendientes',
        SUPPORT_SAY: 'Si escribe a soporte, dile:',
        COPY_MESSAGE: 'Copiar mensaje',
        MESSAGE_COPIED: 'Mensaje copiado',
        COPY: 'Copiar',
        COPIED: 'Copiado',
        NO_DATA_REASON: 'Todavía no hay datos: la app no ha enviado ubicación o la verificación no se ha ejecutado.',
        OPEN_CHAT: 'Abrir chat',
        OPEN_CHAT_WITH: 'Abrir chat de soporte con {{name}}',
        CHAT_ERROR: 'No se ha podido abrir el chat de soporte. Inténtalo de nuevo.',
      },
      FLAG: {
        RESERVATION_OK: 'La reserva y el horario coinciden',
        RESERVATION_BAD: 'La reserva o el horario no coinciden',
        RESERVATION_NONE: 'Reserva y horario sin datos',
        ORIGIN_OK: 'Llegó al origen previsto',
        ORIGIN_BAD: 'No llegó al origen previsto',
        ORIGIN_NONE: 'Origen sin datos de ubicación',
        DESTINATION_OK: 'Llegó al destino previsto',
        DESTINATION_BAD: 'No llegó al destino previsto',
        DESTINATION_NONE: 'Destino sin datos de ubicación',
        COVERAGE: 'Cobertura de ubicación: {{pct}}%',
        COVERAGE_NONE: 'Cobertura de ubicación sin datos',
      },
      // Motivo de rechazo de la huella (`rejection_reason`), en lenguaje de
      // backoffice. Si llega uno nuevo, se pinta el texto del backend.
      REJECTION_REASON: {
        location_data_missing: 'Sin datos de ubicación durante el viaje',
        origin_not_confirmed: 'Salida no confirmada en el origen',
        destination_not_confirmed: 'Llegada al destino no confirmada',
        location_trace_incomplete: 'Huella de ubicación incompleta',
        route_not_compatible: 'Recorrido no compatible con un viaje en coche',
        copresence_not_confirmed: 'Co-presencia no confirmada',
        multiple_devices: 'Varios móviles a la vez',
        mock_location: 'Ubicación simulada',
        network_failed: 'La red no dejó comprobar la ubicación',
        trip_limit: 'Límite de viajes bonificados alcanzado',
        pattern_review: 'En revisión por un patrón inusual',
        competitor_app: 'App competidora detectada',
        shared_with_riders: 'Viaje con los pasajeros no confirmado',
        shared_with_driver: 'Viaje con el conductor no confirmado',
        location_permission_missing: 'Sin permiso de ubicación',
      },
      VERIFICATION: {
        TITLE: 'Verificación de huella',
        COL_PERSON: 'Persona',
        COL_ROLE: 'Rol',
        COL_METHOD: 'Método',
        COL_REASON: 'Motivo',
        COL_COPRESENCE: 'Co-presencia',
        COL_COMPETITOR: 'App competidora',
        COL_ORIGIN: 'Origen',
        COL_DESTINATION: 'Destino',
        COL_RESULT: 'Resultado',
        DETECTED: 'Detectada',
        NOT_DETECTED: 'No detectada',
        STATE: {
          pending: 'Sin verificar',
          verified: 'Verificado',
          rejected: 'Rechazado',
        },
        COMPETITOR_CHECK: {
          unknown: 'Sin comprobar',
          verified_clean: 'Comprobada, sin apps competidoras',
          detected: 'Comprobada, app competidora detectada',
        },
      },
      // Fraude a mitad de viaje (EvaluateFraudMidTrip) y verificación facial
      FRAUD_DATA: {
        TITLE: 'Señales del equipo de datos',
        SIGNAL_TIP: '{{title}}: {{text}} {{direction}}',
        HIGHER_BETTER: 'Más alto = mejor.',
        HIGHER_WORSE: 'Más alto = peor.',
        COL_SIGNALS: 'Señales',
        COL_COLLUSION_DRIVER: 'Colusión con el conductor',
      },
      FRAUD_MIDTRIP: {
        TITLE: 'Fraude a mitad de viaje',
        FAILURES: 'Sin superar: {{count}}',
        SUMMARY: {
          requested: 'Verificación facial pedida',
          would_request: 'Se habría pedido (sombra)',
          not_sampled: 'Se habría pedido, fuera del sorteo',
          not_requested: 'Evaluado, sin pedir nada',
        },
        HIDDEN_RESULT_HINT: 'El resultado de la verificación facial es el real. La app no se lo enseña a la persona: siempre le dice que la ha superado. El viaje queda en verificación hasta la fecha de «Retenido hasta», la supere o no; entonces no se rechaza: si alguien no la superó, Waiis no financia el CAE de su tramo (si es el conductor, de todo el viaje), como con la app competidora. El pasajero no paga nada más; el conductor cobra solo lo que pagó el pasajero.',
        COL_MODE: 'Modo',
        COL_REASON: 'Motivo',
        COL_RISK: 'Riesgo',
        COL_SIGNALS: 'Señales',
        COL_EVALUATIONS: 'Evaluaciones',
        COL_RELEASE: 'Retenido hasta',
        LAST_EVALUATION: 'última: {{date}}',
        WOULD_HAVE_BEEN: 'Sin sorteo: {{reason}}',
        COL_FACE: 'Verificación facial',
        ERRORS: 'Sin datos de: {{sources}}',
        FIRST_TRIP: '1.er viaje',
        POSSIBLE_FRAUD: 'Posible fraude',
        SIMILARITY: 'Similitud {{value}} %',
        ATTEMPTS: '{{count}} intentos',
        MODE: {
          shadow: 'Sombra',
          enforce: 'Exigir',
        },
        REASON: {
          group_already_requested: 'Ya pedida en este viaje',
          first_trip: 'Primer viaje con posible fraude',
          high_score: 'Riesgo alto',
          cooldown: 'Riesgo alto, pero se pidió hace poco a alguien del coche',
          low_risk: 'Riesgo bajo',
          not_sampled: 'Se habría pedido, pero no salió en el sorteo',
          whitelisted: 'Alguien del coche está en lista blanca: no se pide a nadie',
        },
        FACE: {
          not_requested: 'No pedida',
          pending: 'Pendiente',
          passed: 'Superada',
          failed: 'No superada',
          inconclusive: 'No concluyente',
          no_show: 'No la hizo',
        },
        FACE_REASON: {
          face_mismatch: 'La cara no coincide con la del documento',
          liveness_failed: 'Prueba de vida no superada',
          reference_face_not_detected: 'Sin cara en la selfie del documento',
          liveness_not_completed: 'No terminó la prueba',
          liveness_session_expired: 'La prueba caducó',
          provider_unavailable: 'AWS no respondió',
        },
        SIGNAL: {
          emulator: 'Emulador',
          same_phone_in_group: 'Mismo móvil que otro del coche',
          gps_identical_with_participant: 'GPS idéntico a otro del coche',
          clone_environment: 'App clonada',
          wifi_during_trip: 'En wifi durante el viaje',
          prior_face_failure: 'Verificación facial fallida antes',
          shared_ip_with_participant: 'Misma IP que otro del coche',
          phone_shared_with_other_account: 'Móvil compartido con otra cuenta',
          data_team_score: 'Score del equipo de datos',
          no_sim: 'Sin SIM',
          no_whatsapp: 'Sin WhatsApp',
          no_whatsapp_no_sim: 'Sin WhatsApp ni SIM',
          many_devices: 'Muchos móviles',
          no_life_outside_trips: 'Sin actividad fuera de los viajes',
          rejected_trips: 'Viajes rechazados',
          driver_concentration: 'Casi siempre con este conductor',
          adb_enabled: 'Depuración USB activa',
          collusion_with_participant: 'Colusión alta con otro del coche',
          face_passed_recently: 'Verificación facial superada hace poco (resta)',
          different_ip_from_driver: 'IP distinta de la del conductor (resta)',
        },
      },
      PARTICIPANTS: {
        TITLE: 'Participantes',
        MATCH: 'match',
        COL_PERSON: 'Persona',
        COL_TRIP_TYPE: 'Tipo de viaje',
        COL_ROUTE: 'Origen y destino',
        COL_KM: 'Km',
        COL_COPRESENCE: 'Co-presencia',
        NO_IDENTITY: 'Sin identidad verificada',
        NO_IDENTITY_TIP: 'Hizo este viaje sin la identidad verificada',
        NO_ADDRESS: 'Sin dirección',
        EMPTY: 'Sin pasajeros emparejados.',
      },
      KIND: {
        NONE: 'Sin rutina',
        NONE_HINT: 'El trayecto no está asociado a ninguna rutina',
        ROUTINE: 'Rutina',
        ROUTINE_HINT: 'Trayecto habitual que se repite los días de la rutina',
        PUNCTUAL: 'Puntual',
        PUNCTUAL_HINT: 'Viaje de un día concreto, no se repite',
        LONG_HINT: 'Viaje puntual de larga distancia (más de 200 km) que el pasajero buscó desde la app',
        LONG_NOTE: 'Larga distancia',
      },
      MONEY: {
        BALANCED_TIP: 'Pagan pasajeros + ayudas − comisión = lo que recibe el conductor',
        UNBALANCED_TIP: 'Lo que entra y lo que sale no coinciden',
        PASSENGERS_ONE: '1 pasajero',
        DRIVER_IN_BALANCE: 'En su saldo',
        DRIVER_TO_PAY: 'Verificado, pendiente de abono',
        DRIVER_REJECTED: 'Trayecto no verificado: no cobra',
        DRIVER_HELD_CASH: 'Retraso de caja hasta {{when}}',
        DRIVER_HELD_REINFORCED: 'Retenido por reforzada hasta {{when}}',
        DRIVER_HELD_IDENTITY: 'Retenido hasta que el pasajero verifique su identidad',
        DRIVER_AFTER_TRIP: 'Cobrará tras el viaje',
        DRIVER_PENDING: 'Falta por cobrar {{amount}}',
        BREAKDOWN_SUB: 'Qué paga cada pasajero, qué ayudas tiene y cuánto le llega al conductor.',
        SUM_ARIA: 'Cuenta del dinero del viaje',
        PASSENGERS_PAY: 'Pagan pasajeros',
        MINUS: '−{{amount}}',
        PASSENGERS_TIMES: '{{n}} × {{amount}}',
        DRIVER_TO_VERIFY: 'Pendiente de verificar el trayecto',
        CAE_EXCLUDED: {
          NOTE: 'Sin CAE: {{reason}}',
          REASON: {
            COMPETITOR_APP: 'app competidora',
            COMPETITOR_APP_NAMED: 'app competidora ({{apps}})',
            IDENTITY_NOT_VERIFIED: 'verificación facial no superada',
            OTHER: 'excluido del CAE',
          },
          TIP: {
            COMPETITOR_APP_DRIVER: 'Al conductor le detectamos una app competidora al verificar el viaje. El pasajero mantiene su descuento, pero Waiis no paga el bono CAE: el conductor cobra lo que pagó el pasajero menos la comisión.',
            COMPETITOR_APP_RIDER: 'Al pasajero le detectamos una app competidora al verificar el viaje. Mantiene su descuento, pero Waiis no paga el bono CAE de su tramo: el conductor cobra lo que pagó ese pasajero menos la comisión.',
            IDENTITY_NOT_VERIFIED_DRIVER: 'El conductor no superó la verificación facial. El pasajero mantiene su descuento, pero Waiis no paga el bono CAE: el conductor cobra lo que pagó el pasajero menos la comisión.',
            IDENTITY_NOT_VERIFIED_RIDER: 'El pasajero no superó la verificación facial. Mantiene su descuento, pero Waiis no paga el bono CAE de su tramo: el conductor cobra lo que pagó ese pasajero menos la comisión.',
            OTHER: 'Waiis no paga el bono CAE de este viaje: el conductor cobra lo que pagó el pasajero menos la comisión.',
          },
        },
      },
      RESOLUTION: {
        TITLE: 'Decidir sobre el viaje',
        LAST: 'Última:',
        UPCOMING_NOTE: 'Podrás validar o rechazar este viaje cuando se haya hecho.',
        DECISION: 'Decisión',
        APPLY_TO: 'Aplicar a',
        NOTIFY: 'Aviso al usuario',
        NOTIFY_NONE: 'Sin aviso al usuario',
        NOTIFY_WITH: 'Avisar: {{channel}}',
        CHANNEL: {
          none: 'No avisar',
          push: 'Push',
          email: 'Email',
          push_email: 'Push + Email',
        },
        VERDICT: {
          validate: 'Validado',
          reject: 'Rechazado',
          enhanced_review: 'Puesto en revisión',
        },
        VALIDATE_TITLE: 'Validar',
        VALIDATE_WHAT: 'Das el viaje por bueno, igual que si la verificación automática lo hubiera aprobado.',
        VALIDATE_MONEY: 'En unos 5 minutos el conductor cobra la parte de cada pasajero validado.',
        REJECT_TITLE: 'Rechazar',
        REJECT_WHAT: 'Das el viaje por no hecho: no cuenta como compartido.',
        REJECT_MONEY: 'En unos 5 minutos se devuelve al wallet de cada pasajero rechazado lo que pagó, y el conductor no cobra su parte.',
        CONFIRM_REJECT_ONE: 'Rechazar a 1 participante',
        CONFIRM_REJECT_MANY: 'Rechazar a {{n}} participantes',
        CONFIRM_REVIEW_ONE: 'Poner en revisión a 1 participante',
        CONFIRM_REVIEW_MANY: 'Poner en revisión a {{n}} participantes',
        CONFIRM_VERIFY_ONE: 'Verificar a 1 participante y pagar',
        CONFIRM_VERIFY_MANY: 'Verificar a {{n}} participantes y pagar',
        PROCESSING: 'Procesando…',
        CHECKING: 'Comprobando…',
        PAID: 'Pagado',
        SELECT_ONE: 'Selecciona al menos un participante.',
        APPLIED: '{{verdict}} · aplicado.',
        APPLIED_MANY: '{{verdict}} · aplicado a {{n}} participantes.',
        APPLIED_PARTIAL: '{{verdict}} · aplicado a {{ok}} de {{total}}.',
        FAILED_FOR: 'No se pudo aplicar a: {{names}}.',
        SAVE_ERROR: 'No se ha podido guardar la resolución.',
        VERIFIED_PAID: 'Verificado y pagado: {{names}}.',
        NOT_COMPLETED: 'No se pudo completar: {{names}}.',
        CANCELLED: 'Cancelado: no se ha hecho nada.',
      },
      PAYOUT: {
        CONFIRM_TITLE: 'Verificar y pagar · {{name}}',
        CONFIRM: 'Verificar y pagar',
        CANCEL: 'Cancelar',
        OK: 'OK',
        PARTIAL_TITLE: 'Pago a medias',
        PARTIAL_TEXT: 'Al pasajero ya se le retiraron {{prior}} ({{ref}}), pero ahora el cálculo da {{now}}. No se ha hecho nada: revisa los movimientos a mano.',
        ERROR_TIMEOUT: 'El servidor no ha respondido a tiempo.',
        ERROR_GENERIC: 'No se ha podido completar la operación.',
        ERROR_TITLE: 'Error · {{name}}',
        MISSING_TITLE: 'Faltan datos',
        MISSING_TEXT: 'La ruta del pasajero no tiene importes calculados ni distancia; no se puede calcular el pago.',
        OPTION: '{{label}} · conductor {{amount}}',
        OPTION_RIDER: 'pasajero −{{amount}}',
        ESTIMATE_NOTE: 'Esta ruta no tiene importes calculados: se estima con la tarifa CAE por km del pasajero ({{km}}).',
        RIDER_BALANCE: 'Saldo del pasajero:',
        COMPUTED: 'Importes calculados',
        TO_DRIVER: 'Al conductor:',
        RIDER_SHARE: 'pasajero {{amount}}',
        DEBIT: 'Se retira al pasajero:',
        BALANCE: 'saldo {{balance}}',
        UNCOVERED: 'El pasajero no tiene saldo para su parte ({{amount}}; saldo {{balance}}): solo se paga la CAE.',
        PRODUCT: {
          pvp: 'PVP',
          coste0: 'Coste 0',
        },
        ROUTINE_KIND: {
          routine: 'Rutina',
          punctual: 'Puntual',
        },
      },
    },
    TRIP_CHARGE: {
      COLUMN: 'Cobro',
      FILTER_ALL: 'Cobro: todos',
      FILTER_LABEL: 'Estado del cobro',
      STATUS: {
        scheduled: 'Programado',
        charged: 'Cobrado',
        paid_to_driver: 'Pagado al conductor',
        refunded_to_wallet: 'Devuelto al saldo',
        released: 'Anulado',
        failed: 'Rechazado',
        debt: 'Deuda',
        legacy_hold: 'Retención antigua',
        not_applicable: 'Sin cobro',
      },
      FAILED_LONG: 'Cobro rechazado',
      SCHEDULED_AT: 'Se cobra {{when}}',
      DEADLINE_AT: 'Plazo para pagar {{when}}',
      DRIVER_CHARGED: '{{charged}}/{{total}} cobrados',
      DRIVER_FAILED_ONE: '{{n}} rechazado',
      DRIVER_FAILED_MANY: '{{n}} rechazados',
      DRIVER_PAID: 'Pagado ({{total}})',
      DRIVER_PAID_HELD: 'Abonado {{credited}}/{{total}}',
      DRIVER_PAID_HELD_SUB: '{{n}} pendiente de abonar',
      PAID_HELD_SUB: 'Pendiente de abonar al conductor',
      DRIVER_REFUNDED: 'Devuelto',
      WHEN: {
        TODAY: 'hoy {{time}}',
        TOMORROW: 'mañana {{time}}',
        YESTERDAY: 'ayer {{time}}',
        TODAY_AT: 'hoy a las {{time}}',
        TOMORROW_AT: 'mañana a las {{time}}',
        DATE_AT: 'el {{date}} a las {{time}}',
      },
      FAILURE: {
        NO_CARD: 'No tiene ninguna tarjeta guardada',
        DECLINED: 'La tarjeta ha sido rechazada',
        INSUFFICIENT_FUNDS: 'Fondos insuficientes',
        EXPIRED_CARD: 'Tarjeta caducada',
        INCORRECT_CVC: 'CVC incorrecto',
        AUTHENTICATION_REQUIRED: 'El banco pide confirmar el pago (3D Secure)',
        PROCESSING_ERROR: 'Error del banco al procesar el pago',
        OTHER: 'Otro motivo ({{code}})',
      },
      FRAUD: {
        review: 'En revisión por fraude',
        reinforced_review: 'Verificación reforzada',
        blocked: 'Bloqueado',
      },
      ATTEMPT: 'intento {{n}} de {{max}}',
      ATTEMPT_ONLY: 'intento {{n}}',
      CARD_GENERIC: 'tarjeta',
      ALERT: {
        TITLE: 'A {{name}} no se le ha podido cobrar {{amount}}',
        TITLE_DEBT: '{{name}} tiene pendiente el pago de {{amount}}',
        CARD_ONLY: 'La tarjeta {{card}} se ha rechazado.',
        DEBT: 'WAIIS ya ha pagado al conductor y el pasajero tiene la cuenta bloqueada hasta que pague.',
        CHIP_DEBT: 'Deuda',
        CHIP_DEADLINE: 'Plazo · {{when}}',
        CHIP_DEADLINE_PASSED: 'Plazo vencido · {{when}}',
        CHIP_RETRY: 'Reintento · {{when}}',
        DEADLINE_PASSED: 'El plazo venció {{when}}: se han pausado sus rutinas.',
        NEXT_RETRY: 'Próximo reintento del cobro: {{when}}.',
        NEXT_ATTEMPT: 'Próximo intento: {{when}}.',
        DEADLINE: 'Si no está pagado {{when}}, se pausan sus rutinas.',
      },
      OPEN_CHAT: 'Abrir chat con el mensaje',
      CHAT_ERROR: 'No se ha podido abrir el chat de soporte. Inténtalo de nuevo.',
      AIDS: {
        CAE_BONUS: 'Bono CAE',
        CORPORATION_SUBSIDY: 'Subvención de empresa',
        WAIIS_CONTRIBUTION: 'Aportación WAIIS',
        COUPON: 'Cupón',
        DRIVER_DISCOUNT: 'Descuento del conductor',
      },
      MONEY: {
        TITLE: 'Dinero del viaje',
        HINT: 'Pasa el ratón por un paso para ver qué significa',
        HOW: '¿Cómo se calcula?',
        SUMMARY: {
          PAY: 'Pagan',
          COMMISSION: 'Comisión',
          DRIVER_RECEIVES: 'Recibe el conductor',
          BALANCED: 'Cuadra',
          UNBALANCED: 'Descuadre de {{amount}}',
        },
        COL: {
          PERSON: 'Persona',
          AMOUNT: 'Importe',
          STATUS: 'Estado',
          STEPS: 'Pasos',
        },
        ROLE: {
          PASSENGER: 'Pasajero',
          DRIVER: 'Conductor',
        },
        HOLD_HOURS: '{{n}} h',
        HOLD_DAY: '{{n}} día',
        HOLD_DAYS: '{{n}} días',
        HOLD_SHORT: {
          cash_delay: 'Caja · {{days}}',
          pending_identity: 'Identidad',
        },
        FRAUD_SHORT: {
          review: 'En revisión',
          reinforced_review: 'Reforzada',
          blocked: 'Bloqueado',
        },
        SOURCE: {
          BOTH: 'saldo + tarjeta',
          WALLET: 'saldo',
          CARD: 'tarjeta',
        },
        SPLIT_BOTH: '{{wallet}} de su saldo · {{cardAmount}} de la {{card}}',
        SPLIT_CARD: '{{amount}} de la {{card}}',
        SPLIT_WALLET: '{{amount}} de su saldo',
        REASON: {
          CHARGED: 'Esperando verificación',
          PAID: 'Pagado el {{day}}',
          PAID_HELD: 'Pendiente de abonar al conductor · {{when}}',
          PAID_HELD_NO_DATE: 'Pendiente de abonar al conductor',
          REFUNDED: 'Viaje no verificado',
          RELEASED: 'Viaje anulado',
          SCHEDULED: 'Se cobra el {{when}}',
          DEBT: 'Debe {{amount}}',
          LEGACY: 'Sistema antiguo',
          DRIVER_PENDING: 'Cuando se verifique el viaje',
          DRIVER_IN_BALANCE: 'En su saldo desde el {{day}}',
          DRIVER_IN_BALANCE_NO_DATE: 'Ya en su saldo',
          DRIVER_HELD_CASH: 'Retraso de caja · entra en su saldo {{when}}',
          DRIVER_HELD_CASH_NO_DATE: 'Retraso de caja',
          DRIVER_HELD_REINFORCED: 'Retenido por reforzada · entra en su saldo {{when}}',
          DRIVER_HELD_REINFORCED_NO_DATE: 'Retenido por reforzada',
          DRIVER_HELD_IDENTITY: 'Retenido por identidad · entra en su saldo cuando el pasajero verifique su identidad',
          DRIVER_HELD_IDENTITY_NO_DATE: 'Retenido por identidad',
          DRIVER_RELEASE: 'Se libera el {{day}}',
        },
        DRIVER_STATUS: {
          HELD: 'Retenido',
          PENDING: 'Por recibir',
          IN_BALANCE: 'En su saldo',
        },
        STEP: {
          SCHEDULED: 'Programado',
          CHARGED: 'Retenido',
          FAILED: 'Rechazado',
          DEADLINE: 'Plazo para pagar',
          DEADLINE_PASSED: 'Plazo vencido',
          RETRY: 'Reintento',
          VERIFYING: 'Verificando',
          TO_DRIVER: 'Al conductor',
          REFUNDED: 'Devuelto a su saldo',
          RELEASED: 'Anulado',
          TRIP_DONE: 'Llegada',
          IN_BALANCE: 'En su saldo',
          WITHDRAWABLE: 'Retirable',
          HELD: 'Retenido',
          RELEASE: 'Se libera',
          IN_REVIEW: 'revisión',
          IN_PROGRESS: 'en curso',
          VERIFIED: 'verificado',
          NOT_VERIFIED: 'no verificado',
        },
        TIP: {
          SCHEDULED: 'Se le cobra 24 h antes de que salga el conductor',
          CHARGED: 'El dinero ya ha salido; WAIIS lo guarda hasta verificar el viaje',
          FAILED: 'El banco o Stripe han rechazado el cobro',
          DEADLINE: 'Si no paga antes de esta hora, se pausan sus rutinas',
          DEADLINE_PASSED: 'Ha vencido: sus rutinas están pausadas',
          RETRY: 'Volveremos a intentar el cobro automáticamente',
          VERIFYING: 'Comprobamos con la huella GPS que el viaje se ha hecho',
          TO_DRIVER: 'El dinero pasa al saldo del conductor',
          REFUNDED: 'El viaje no se ha verificado: el dinero vuelve a su saldo de WAIIS',
          RELEASED: 'El cobro se ha anulado: no se le ha cobrado nada',
          TRIP_DONE: 'Hora de llegada del viaje',
          IN_BALANCE: 'El dinero entra en su saldo de la app',
          WITHDRAWABLE: 'Lo puede pasar a su cuenta bancaria',
          HELD_CASH: 'Revisión del pago: el viaje está verificado, pero el dinero no entra en su saldo hasta la fecha indicada (como mucho 2 días)',
          HELD_REINFORCED: 'Verificación reforzada: el dinero no entra en su saldo hasta la fecha indicada',
          HELD_IDENTITY: 'Identidad pendiente: el dinero no entra en su saldo hasta que el pasajero verifique su identidad',
          RELEASE: 'Un pasajero tiene verificación reforzada: el dinero se libera {{days}} días después',
        },
        WRITE: 'Escribirle',
        MORE: 'Ver detalle',
        LEGEND: {
          SHOW: 'Qué significa cada paso',
          COLORS: 'Colores',
          PASSENGER: 'Pasajero',
          DRIVER: 'Conductor',
          BOTH: 'Ambos',
          DOT: {
            done: 'Hecho',
            failed: 'Ha fallado',
            next: 'Ahora',
            todo: 'Pendiente',
          },
          SHORT: {
            SCHEDULED: 'se cobra 24 h antes',
            CHARGED: 'WAIIS guarda el dinero',
            FAILED: 'el banco no ha cobrado',
            DEADLINE: 'si no paga, se pausan rutinas',
            RETRY: 'se vuelve a cobrar solo',
            TO_DRIVER: 'ya es del conductor',
            REFUNDED: 'no verificado, se le devuelve',
            RELEASED: 'no se le cobra nada',
            TRIP_DONE: 'hora de llegada',
            IN_BALANCE: 'ya tiene el dinero',
            RELEASE: 'espera por verificación reforzada',
            WITHDRAWABLE: 'lo puede pasar al banco',
            VERIFYING: 'comprobación con GPS',
            VALIDATED: 'soporte lo da por bueno',
          },
        },
        MANUAL: {
          VALIDATED: 'Validado por soporte',
          VALIDATED_TIP: 'Soporte ha dado el viaje por bueno: el dinero pasa al conductor como si se hubiera verificado solo',
          REASON: 'Validado por soporte',
          REASON_BY: 'Validado por {{name}}',
        },
        TABLE_TOGGLE: 'Ver el desglose en tabla',
        DETAIL: {
          BREAKDOWN: 'Precio {{base}}{{aids}} + comisión {{commission}} = paga {{pays}}',
          TODO_LABEL: '¿Qué tiene que hacer?',
          FROM_PASSENGER: 'De {{name}}: {{amount}}',
          PAYOUTS: 'Ver Pagos',
          NO_DATA: 'Este entorno aún no envía los datos del cobro.',
        },
        TODO: {
          NO: 'Nada.',
          SCHEDULED: 'Nada. Se le cobrará automáticamente {{when}}.',
          SCHEDULED_NO_DATE: 'Nada. Se le cobrará automáticamente 24 h antes de que salga el conductor.',
          CHARGED: 'Nada. WAIIS guarda el dinero hasta que se verifique el viaje.',
          CHARGED_REVIEW: 'Nada. WAIIS guarda el dinero hasta que se resuelva la revisión.',
          REFUNDED: 'Nada. El importe ha vuelto a su saldo de WAIIS.',
          LEGACY: 'Nada. Es un cobro del sistema antiguo (retención en la tarjeta).',
          FAILED: 'Añadir otra tarjeta. Si no lo hace {{when}}, se le pausan las rutinas.',
          FAILED_NO_DEADLINE: 'Añadir otra tarjeta para que se le pueda cobrar.',
          PAY_PENDING: 'Pagar lo pendiente: la deuda se cobra sola al añadir una tarjeta válida.',
          DEBT: 'Añadir una tarjeta válida para pagar lo pendiente y desbloquear la cuenta.',
        },
        PAYMENT_STATUS: 'Estado de pago',
        PAYMENT_STATUS_VALUES: {
          ok: 'Al día',
          warning: 'Aviso',
          blocked: 'Bloqueado',
          cancelled: 'Cancelado',
        },
        VERIFICATION: 'Verificación',
        VERIFICATION_VALUES: {
          NORMAL: 'Normal',
          REVIEW: 'En revisión manual',
          REINFORCED: 'Reforzada: cobra el conductor {{days}} días después',
          REINFORCED_NO_DAYS: 'Reforzada: el conductor cobra más tarde',
          BLOCKED: 'Bloqueado por fraude',
        },
        STRIPE: 'Ver en Stripe',
        RECEIPT: 'Ver recibo',
      },
      ECONOMIC: {
        DRIVER_PAYOUT: 'Pago al conductor',
        COL: {
          PRICE: 'Precio del viaje',
          AIDS: 'Ayudas',
          COMMISSION: 'Comisión WAIIS',
          PAYS: 'Paga el pasajero',
          TO_DRIVER: 'Al conductor',
          RECEIPT: 'Recibo',
          PAYMENT: 'Pago',
          TOTAL: 'Total',
          FREE: 'Sin coste',
          EXPECTED: 'Esperado {{amount}}',
        },
        STATE: {
          PAID: 'Cobrado',
          MISMATCH: 'Diferencia',
          EXPECTED: 'Previsto',
          TO_CHARGE: 'Por cobrar',
        },
        UPCOMING: 'Importes previstos: al pasajero se le cobra 24 h antes de que salga el conductor y el conductor cobra cuando se verifica el viaje',
      },
      SOURCE: {
        WALLET: 'Saldo',
        CARD: 'Tarjeta',
        BANK: 'Cuenta bancaria',
        PAID_ON: 'Pagada el {{date}}',
        PAYOUT: {
          paid: 'Pagada',
          pending: 'Pendiente',
          in_review: 'En revisión',
          failed: 'Fallida',
        },
      },
    },
    ROLE: {
      TOTAL_USERS: 'Total de usuarios con este rol: {{count}}',
      NO_PERMISSIONS: 'Sin permisos asignados...',
      AND_MORE: 'y {{count}} más...',
      VIEW_ROLE: 'Ver rol',
      EDIT_ROLE: 'Editar rol',
      ADD_NEW_ROLE: 'Añadir nuevo rol',
      DETAILS_TITLE: 'Detalles del rol',
      CLOSE: 'Cerrar',
      USER_INFORMATION: 'Información del usuario',
      ROLE_NAME: 'Nombre del rol',
      NAME_REQUIRED: 'El nombre del rol es obligatorio',
      NAME_MINLENGTH: 'El nombre del rol debe tener al menos 4 caracteres',
      DISCARD: 'Descartar',
      SUBMIT: 'Enviar',
      PLEASE_WAIT: 'Espera por favor...',
      USERS_ASSIGNED: 'Usuarios asignados',
      COL_NAME: 'Nombre',
      COL_ROLE: 'Rol',
      COL_LAST_LOGIN: 'Último acceso',
      COL_JOINED_DATE: 'Fecha de alta',
      SUCCESS: '¡Éxito!',
      ERROR: '¡Error!',
      CREATED_SUCCESS: '¡Rol creado correctamente!',
      UPDATED_SUCCESS: '¡Rol actualizado correctamente!',
      CONFIRM: '¡Entendido!',
    },
    PERMISSION: {
      SEARCH: 'Buscar permisos',
      ADD_PERMISSIONS: 'Añadir permisos',
      DETAILS_TITLE: 'Detalles del permiso',
      CLOSE: 'Cerrar',
      USER_INFORMATION: 'Información del usuario',
      NAME: 'Nombre',
      NAME_REQUIRED: 'El nombre del permiso es obligatorio',
      NAME_MINLENGTH: 'El nombre del permiso debe tener al menos 4 caracteres',
      DISCARD: 'Descartar',
      SUBMIT: 'Enviar',
      PLEASE_WAIT: 'Espera por favor...',
      COL_NAME: 'Nombre',
      COL_ASSIGNED_TO: 'Asignado a',
      COL_CREATED_DATE: 'Fecha de creación',
      SUCCESS: '¡Éxito!',
      ERROR: '¡Error!',
      CREATED_SUCCESS: '¡Permiso creado correctamente!',
      UPDATED_SUCCESS: '¡Permiso actualizado correctamente!',
      CONFIRM: '¡Entendido!',
    },
    SHARED: {
      FILTER_SIDEBAR: {
        FILTERS: 'Filtros',
        DATE_PLACEHOLDER: 'Seleccione fecha',
        APPLY: 'Aplicar filtros',
        CLEAR: 'Limpiar',
        CLOSE: 'Cerrar',
      },
      TABLE_EDITABLE: {
        CREATE: 'Crear',
        ACTIONS: 'Acciones',
        SAVING: 'Guardando...',
        SAVE: 'Guardar',
        CANCEL: 'Cancelar',
        EDIT: 'Editar',
        NO_DATA: 'No hay datos disponibles para mostrar',
        SHOWING: 'Mostrando {{shown}} de {{total}}',
        ITEMS: 'registros',
        HINT: 'Pulsa el lápiz para editar una fila y guarda los cambios con ✓.',
        SAVED: 'Guardado',
        SAVE_ERROR: 'No se ha podido guardar',
        CREDITS_TITLE: 'Todos los tipos de crédito',
        CREDITS_ITEMS: 'tipos de crédito',
        COMMISSIONS_TITLE: 'Todas las comisiones',
        COMMISSIONS_ITEMS: 'comisiones',
        COL_ID: 'ID',
        COL_TYPE: 'Tipo',
        COL_DESCRIPTION: 'Descripción',
        COL_VALUE: 'Valor',
      },
      ENTITY_LABELS: {
        TITLE: 'Etiquetas',
        REMOVE_ARIA: 'Quitar etiqueta {{name}}',
        EMPTY: 'Sin etiquetas',
        ADD: 'Añadir etiqueta',
        SEARCH_PLACEHOLDER: 'Buscar o crear etiqueta…',
        SHARED_SCOPE: 'común',
        ALREADY_ASSIGNED: 'Esa etiqueta ya está asignada.',
        NONE_AVAILABLE: 'No hay más etiquetas disponibles.',
        CREATE: 'Crear «{{name}}»',
        ASSIGN_ERROR: 'No se ha podido asignar la etiqueta.',
        NAME_INVALID: 'El nombre debe contener alguna letra o número.',
        CREATE_ERROR: 'No se ha podido crear la etiqueta.',
        REMOVE_ERROR: 'No se ha podido quitar la etiqueta.',
        CATALOG_ERROR: 'No se ha podido cargar el catálogo de etiquetas.',
      },
      QUILL: {
        NORMAL: 'Normal',
        HEADING_1: 'Título 1',
        HEADING_2: 'Título 2',
        HEADING_3: 'Título 3',
        VISIT_URL: 'Abrir enlace:',
        ENTER_LINK: 'Introduce el enlace:',
        EDIT: 'Editar',
        REMOVE: 'Quitar',
        SAVE: 'Guardar',
      },
    },
    LAYOUT: {
      SHOW_SIDEBAR_MENU: 'Mostrar menú lateral',
      SHOW_HEADER_MENU: 'Mostrar menú de cabecera',
      REFRESH_PROFILE: 'Refrescar perfil',
      HIDE_ENV_BAR: 'Ocultar barra de entorno',
    },
    ERROR_PAGES: {
      NOT_FOUND_TITLE: '¡Vaya!',
      NOT_FOUND_TEXT: 'No encontramos esa página.',
      SERVER_TITLE: 'Error del sistema',
      SERVER_TEXT: 'Algo ha ido mal. Vuelve a intentarlo más tarde.',
      HOME: 'Volver al inicio',
    },
  },
};
